webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(330);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(386);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueCharts = __webpack_require__(328);
	
	var _vueCharts2 = _interopRequireDefault(_vueCharts);
	
	var _routes = __webpack_require__(153);
	
	var _store = __webpack_require__(166);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _loader = __webpack_require__(79);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _ravenJs = __webpack_require__(326);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _vue3 = __webpack_require__(322);
	
	var _vue4 = _interopRequireDefault(_vue3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(300);
	
	if (true) {
	  _ravenJs2.default.config('https://ee77a8f6a11046338faa9ea657968771@sentry.io/148993').addPlugin(_vue4.default, _vue2.default).install();
	
	  console.log = function () {
	    return null;
	  };
	}
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueCharts2.default);
	
	var router = new _vueRouter2.default({ routes: _routes.routes, mode: 'history' });
	
	
	router.beforeEach(function (to, from, next) {
	  _loader2.default.mutations[NameSpace.MUTATE_LOADER_STATE](_loader2.default.state, false);
	
	  if (to.name !== 'login' && !JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser'))) {
	    next({ name: 'login' });
	  } else {
	    next();
	  }
	});
	window.eventBus = new _vue2.default();
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  store: _store.store,
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROFILE = exports.PROFILE = 'PROFILE';
	var AUTH_STATE = exports.AUTH_STATE = 'AUTH_STATE';
	var MODAL_CONFIG = exports.MODAL_CONFIG = 'MODAL_CONFIG';
	var LOADER_STATE = exports.LOADER_STATE = 'LOADER_STATE';
	var MODAL_RESPONSE = exports.MODAL_RESPONSE = 'MODAL_RESPONSE';
	var MODAL_CONFIG_DEFAULT = exports.MODAL_CONFIG_DEFAULT = 'MODAL_CONFIG_DEFAULT';
	var STATE_OFFER_NAMES = exports.STATE_OFFER_NAMES = 'STATE_OFFER_NAMES';
	var STATE_GOALS_AND_DISPLAY = exports.STATE_GOALS_AND_DISPLAY = 'STATE_GOALS_AND_DISPLAY';
	var STATE_SELECTED_OFFER_NAME = exports.STATE_SELECTED_OFFER_NAME = 'STATE_SELECTED_OFFER_NAME';
	var STATE_APPROVE_OFFER_SUCCESS = exports.STATE_APPROVE_OFFER_SUCCESS = 'STATE_APPROVE_OFFER_SUCCESS';
	var STATE_REJECT_OFFER_RESULT = exports.STATE_REJECT_OFFER_RESULT = 'STATE_REJECT_OFFER_RESULT';
	var STATE_ZONE_SALE_PRICES = exports.STATE_ZONE_SALE_PRICES = 'STATE_ZONE_SALE_PRICES';
	var STATE_PENDING_APPROVALS = exports.STATE_PENDING_APPROVALS = 'STATE_PENDING_OFFER_APPROVALS';
	var STATE_SELECTED_PENDING_APPROVALS = exports.STATE_SELECTED_PENDING_APPROVALS = 'STATE_SELECTED_PENDING_APPROVALS';
	var SELECTED_DEPARTMENT = exports.SELECTED_DEPARTMENT = 'SELECTED_DEPARTMENT';
	var SELECTED_SUB_DEPARTMENT = exports.SELECTED_SUB_DEPARTMENT = 'SELECTED_SUB_DEPARTMENT';
	var SELECTED_CLASS = exports.SELECTED_CLASS = 'SELECTED_CLASS';
	var SELECTED_SUB_CLASS = exports.SELECTED_SUB_CLASS = 'SELECTED_SUB_CLASS';
	var LANDING_DATA = exports.LANDING_DATA = 'LANDING_DATA';
	var SELECTED_AGG_CELL = exports.SELECTED_AGG_CELL = 'SELECTED_AGG_CELL';
	var SELECTED_OFFER = exports.SELECTED_OFFER = 'SELECTED_OFFER';
	var APPROVE_WITH_CHANGES_OLD = exports.APPROVE_WITH_CHANGES_OLD = 'APPROVE_WITH_CHANGES_OLD';
	var APPROVE_WITH_CHANGES = exports.APPROVE_WITH_CHANGES = 'APPROVE_WITH_CHANGES';
	var AGG_INPUT_FILTER_DATA = exports.AGG_INPUT_FILTER_DATA = 'AGG_INPUT_FILTER_DATA';
	var APPROVE_WITH_CHANGES_RESULT = exports.APPROVE_WITH_CHANGES_RESULT = 'APPROVE_WITH_CHANGES_RESULT';
	var OFFER_DETAILS = exports.OFFER_DETAILS = 'OFFER_DETAILS';
	var BAR_CHART = exports.BAR_CHART = 'BAR_CHART';
	var FORGOT_PASSWORD_STATE = exports.FORGOT_PASSWORD_STATE = 'FORGOT_PASSWORD_STATE';
	var LIFT_SIMULATION = exports.LIFT_SIMULATION = 'LIFT_SIMULATION';
	var WATERFALL_DATA = exports.WATERFALL_DATA = 'WATERFALL_DATA';
	var DOWNLOAD_ERROR = exports.DOWNLOAD_ERROR = 'DOWNLOAD_ERROR';
	var ALL_EMAILS = exports.ALL_EMAILS = 'ALL_EMAILS';
	var EMAIL_SELECTED_BY_SUPERUSER = exports.EMAIL_SELECTED_BY_SUPERUSER = 'EMAIL_SELECTED_BY_SUPERUSER';
	var CALCULATION_FIELDS = exports.CALCULATION_FIELDS = 'CALCULATION_FIELDS';
	var SIMULATION_CHANGES = exports.SIMULATION_CHANGES = 'SIMULATION_CHANGES';
	var UPLOAD_FILE = exports.UPLOAD_FILE = 'UPLOAD_FILE';
	var NAV_BAR_COLLAPSE = exports.NAV_BAR_COLLAPSE = 'NAV_BAR_COLLAPSE';
	var OFFERS = exports.OFFERS = 'OFFERS';
	var OFFER_ITEMS = exports.OFFER_ITEMS = 'OFFER_ITEMS';
	var SELECTED_MERCHANT = exports.SELECTED_MERCHANT = 'SELECTED_MERCHANT';
	
	var AUTH_GETTER = exports.AUTH_GETTER = 'AUTH_GETTER';
	var GET_PROFILE = exports.GET_PROFILE = 'GET_PROFILE';
	var MODAL_CONFIG_GETTER = exports.MODAL_CONFIG_GETTER = 'MODAL_CONFIG_GETTER';
	var GET_LOADER_STATE = exports.GET_LOADER_STATE = 'GET_LOADER_STATE';
	var MODAL_RESPONSE_GETTER = exports.MODAL_RESPONSE_GETTER = 'MODAL_RESPONSE_GETTER';
	var GET_OFFER_NAMES = exports.GET_OFFER_NAMES = 'GET_OFFER_NAMES';
	var GET_GOALS_AND_DISPLAY = exports.GET_GOALS_AND_DISPLAY = 'GET_GOALS_AND_DISPLAY';
	var GET_SELECTED_OFFER_NAME = exports.GET_SELECTED_OFFER_NAME = 'GET_SELECTED_OFFER_NAME';
	var GET_OFFER_DETAILS_DATA = exports.GET_OFFER_DETAILS_DATA = 'GET_OFFER_DETAILS_DATA';
	var GET_OFFER_DETAILS_ERRORS = exports.GET_OFFER_DETAILS_ERRORS = 'GET_OFFER_DETAILS_ERRORS';
	var GET_APPROVE_OFFER_SUCCESS = exports.GET_APPROVE_OFFER_SUCCESS = 'GET_APPROVE_OFFER_SUCCESS';
	var GET_REJECT_OFFER_RESULT = exports.GET_REJECT_OFFER_RESULT = 'GET_REJECT_OFFER_RESULT';
	var GET_ZONE_SALE_PRICES = exports.GET_ZONE_SALE_PRICES = 'GET_ZONE_SALE_PRICES';
	var GET_AGGREGATED_FIX_TABLE = exports.GET_AGGREGATED_FIX_TABLE = 'GET_AGGREGATED_FIX_TABLE';
	var GET_PENDING_AGGREGATED_SCROLLABLE_TABLE = exports.GET_PENDING_AGGREGATED_SCROLLABLE_TABLE = 'GET_PENDING_AGGREGATED_SCROLLABLE_TABLE';
	var GET_PAST_AGGREGATED_SCROLLABLE_TABLE = exports.GET_PAST_AGGREGATED_SCROLLABLE_TABLE = 'GET_PAST_AGGREGATED_SCROLLABLE_TABLE';
	var GET_SELECTED_PENDING_APPROVALS = exports.GET_SELECTED_PENDING_APPROVALS = 'GET_SELECTED_PENDING_APPROVALS';
	var GET_SELECTED_DEPARTMENT = exports.GET_SELECTED_DEPARTMENT = 'GET_SELECTED_DEPARTMENT';
	var GET_SELECTED_SUB_DEPARTMENT = exports.GET_SELECTED_SUB_DEPARTMENT = 'GET_SELECTED_SUB_DEPARTMENT';
	var GET_SELECTED_CLASS = exports.GET_SELECTED_CLASS = 'GET_SELECTED_CLASS';
	var GET_SELECTED_SUB_CLASS = exports.GET_SELECTED_SUB_CLASS = 'GET_SELECTED_SUB_CLASS';
	var GET_LANDING_DATA = exports.GET_LANDING_DATA = 'GET_LANDING_DATA';
	var GET_SELECTED_AGG_DATA = exports.GET_SELECTED_AGG_DATA = 'GET_SELECTED_AGG_DATA';
	var GET_SELECTED_OFFER = exports.GET_SELECTED_OFFER = 'GET_SELECTED_OFFER';
	var GET_APPROVE_WITH_CHANGES = exports.GET_APPROVE_WITH_CHANGES = 'GET_APPROVE_WITH_CHANGES';
	var GET_APPROVE_WITH_CHANGES_OLD = exports.GET_APPROVE_WITH_CHANGES_OLD = 'GET_APPROVE_WITH_CHANGES_OLD';
	var GET_AGG_INPUT_FILTER_DATA = exports.GET_AGG_INPUT_FILTER_DATA = 'GET_AGG_INPUT_FILTER_DATA';
	var GET_APPROVE_WITH_CHANGES_RESULT = exports.GET_APPROVE_WITH_CHANGES_RESULT = 'GET_APPROVE_WITH_CHANGES_RESULT';
	var GET_AGG_INPUT_FILTER_ID = exports.GET_AGG_INPUT_FILTER_ID = 'GET_AGG_INPUT_FILTER_ID';
	var GET_BAR_CHART = exports.GET_BAR_CHART = 'GET_BAR_CHART';
	var GET_BAR_CHART_LEGENDS = exports.GET_BAR_CHART_LEGENDS = 'GET_BAR_CHART_LEGENDS';
	var GET_FORGOT_PASSWORD_STATUS = exports.GET_FORGOT_PASSWORD_STATUS = 'GET_FORGOT_PASSWORD_STATUS';
	var GET_LIFT_SIMULATION = exports.GET_LIFT_SIMULATION = 'GET_LIFT_SIMULATION';
	var GET_LINE_CHART_RADIO = exports.GET_LINE_CHART_RADIO = 'GET_LINE_CHART_RADIO';
	var GET_WATERFALL_DATA = exports.GET_WATERFALL_DATA = 'GET_WATERFALL_DATA';
	var GET_DOWNLOAD_ERROR = exports.GET_DOWNLOAD_ERROR = 'GET_DOWNLOAD_ERROR';
	var GETTER_ALL_EMAILS = exports.GETTER_ALL_EMAILS = 'GETTER_ALL_EMAILS';
	var GETTER_EMAIL_SELECTED_BY_SUPERUSER = exports.GETTER_EMAIL_SELECTED_BY_SUPERUSER = 'GETTER_EMAIL_SELECTED_BY_SUPERUSER';
	var GET_CALCULATION_FIELDS = exports.GET_CALCULATION_FIELDS = 'GET_CALCULATION_FIELDS';
	var GET_SIMULATION_CHANGES = exports.GET_SIMULATION_CHANGES = 'GET_SIMULATION_CHANGES';
	var GETTER_UPLOAD_FILE_RESPONSE = exports.GETTER_UPLOAD_FILE_RESPONSE = 'GETTER_UPLOAD_FILE_RESPONSE';
	var GETTER_CONFIRMATION_MAIL_RESPONSE = exports.GETTER_CONFIRMATION_MAIL_RESPONSE = 'GETTER_CONFIRMATION_MAIL_RESPONSE';
	var CONFIRMATION_MAIL_RESPONSE = exports.CONFIRMATION_MAIL_RESPONSE = 'CONFIRMATION_MAIL_RESPONSE';
	var GET_NAV_BAR_COLLAPSE = exports.GET_NAV_BAR_COLLAPSE = 'GET_NAV_BAR_COLLAPSE';
	var GET_OFFERS = exports.GET_OFFERS = 'GET_OFFERS';
	var GET_OFFER_ITEMS = exports.GET_OFFER_ITEMS = 'GET_OFFER_ITEMS';
	var GET_SELECTED_MERCHANT = exports.GET_SELECTED_MERCHANT = 'GET_SELECTED_MERCHANT';
	
	var AUTH_MUTATION = exports.AUTH_MUTATION = 'AUTH_MUTATION';
	var MUTATE_PROFILE = exports.MUTATE_PROFILE = 'MUTATE_PROFILE';
	var MUTATE_PROFILE_ERROR = exports.MUTATE_PROFILE_ERROR = 'MUTATE_PROFILE_ERROR';
	var CLEAR_AUTH_ERRORS_MUTATION = exports.CLEAR_AUTH_ERRORS_MUTATION = 'CLEAR_AUTH_ERRORS_MUTATION';
	var MODAL_CONFIG_MUTATE = exports.MODAL_CONFIG_MUTATE = 'MODAL_CONFIG_MUTATE';
	var MUTATE_LOADER_STATE = exports.MUTATE_LOADER_STATE = 'MUTATE_LOADER_STATE';
	var MODAL_RESPONSE_MUTATE = exports.MODAL_RESPONSE_MUTATE = 'MODAL_RESPONSE_MUTATE';
	var MUTATE_OFFER_NAMES = exports.MUTATE_OFFER_NAMES = 'MUTATE_OFFER_NAMES';
	var MUTATE_GOALS_AND_DISPLAY = exports.MUTATE_GOALS_AND_DISPLAY = 'MUTATE_GOALS_AND_DISPLAY';
	var MUTATE_SELECTED_OFFER_NAME = exports.MUTATE_SELECTED_OFFER_NAME = 'MUTATE_SELECTED_OFFER_NAME';
	var ADD_OFFER_DETAILS_DATA = exports.ADD_OFFER_DETAILS_DATA = 'ADD_OFFER_DETAILS_DATA';
	var REPORT_ERRORS_IN_OFFER_DETAIL = exports.REPORT_ERRORS_IN_OFFER_DETAIL = 'REPORT_ERRORS_IN_OFFER_DETAIL';
	var MUTATE_APPROVE_OFFER_SUCCESS = exports.MUTATE_APPROVE_OFFER_SUCCESS = 'MUTATE_APPROVE_OFFER_SUCCESS';
	var MUTATE_REJECT_OFFER_RESULT = exports.MUTATE_REJECT_OFFER_RESULT = 'MUTATE_REJECT_OFFER_RESULT';
	var MUTATE_ZONE_SALE_PRICES = exports.MUTATE_ZONE_SALE_PRICES = 'MUTATE_ZONE_SALE_PRICES';
	var MUTATE_PENDING_APPROVALS = exports.MUTATE_PENDING_APPROVALS = 'MUTATE_PENDING_APPROVALS';
	var MUTATE_SELECTED_PENDING_APPROVALS = exports.MUTATE_SELECTED_PENDING_APPROVALS = 'MUTATE_SELECTED_PENDING_APPROVALS';
	var MUTATE_SELECTED_DEPARTMENT = exports.MUTATE_SELECTED_DEPARTMENT = 'MUTATE_SELECTED_DEPARTMENT';
	var MUTATE_SELECTED_SUB_DEPARTMENT = exports.MUTATE_SELECTED_SUB_DEPARTMENT = 'MUTATE_SELECTED_SUB_DEPARTMENT';
	var MUTATE_SELECTED_CLASS = exports.MUTATE_SELECTED_CLASS = 'MUTATE_SELECTED_CLASS';
	var MUTATE_SELECTED_SUB_CLASS = exports.MUTATE_SELECTED_SUB_CLASS = 'MUTATE_SELECTED_SUB_CLASS';
	var MUTATE_LANDING_DATA = exports.MUTATE_LANDING_DATA = 'MUTATE_LANDING_DATA';
	var MUTATE_SELECTED_AGG_DATA = exports.MUTATE_SELECTED_AGG_DATA = 'MUTATE_SELECTED_AGG_DATA';
	var MUTATE_SELECTED_OFFER = exports.MUTATE_SELECTED_OFFER = 'MUTATE_SELECTED_OFFER';
	var MUTATE_APPROVE_WITH_CHANGES = exports.MUTATE_APPROVE_WITH_CHANGES = 'MUTATE_APPROVE_WITH_CHANGES';
	var MUTATE_APPROVE_WITH_CHANGES_OLD = exports.MUTATE_APPROVE_WITH_CHANGES_OLD = 'MUTATE_APPROVE_WITH_CHANGES_OLD';
	var MUTATE_AGG_INPUT_FILTER_DATA = exports.MUTATE_AGG_INPUT_FILTER_DATA = 'MUTATE_AGG_INPUT_FILTER_DATA';
	var MUTATE_APPROVE_WITH_CHANGES_RESULT = exports.MUTATE_APPROVE_WITH_CHANGES_RESULT = 'MUTATE_APPROVE_WITH_CHANGES_RESULT';
	var MUTATE_BAR_CHART = exports.MUTATE_BAR_CHART = 'MUTATE_BAR_CHART';
	var MUTATE_APPROVE_WITH_CHANGES_DATA = exports.MUTATE_APPROVE_WITH_CHANGES_DATA = 'MUTATE_APPROVE_WITH_CHANGES_DATA';
	var MUTATE_AUTH_EXPIRY = exports.MUTATE_AUTH_EXPIRY = 'MUTATE_AUTH_EXPIRY';
	var MUTATE_FORGOT_PASSWORD = exports.MUTATE_FORGOT_PASSWORD = 'MUTATE_FORGOT_PASSWORD';
	var MUTATE_LIFT_SIMULATION = exports.MUTATE_LIFT_SIMULATION = 'MUTATE_LIFT_SIMULATION';
	var MUTATE_WATERFALL_DATA = exports.MUTATE_WATERFALL_DATA = 'MUTATE_WATERFALL_DATA';
	var MUTATE_DOWNLOAD_ERROR = exports.MUTATE_DOWNLOAD_ERROR = 'MUTATE_DOWNLOAD_ERROR';
	var MUTATE_ALL_EMAILS = exports.MUTATE_ALL_EMAILS = 'MUTATE_ALL_EMAILS';
	var MUTATE_EMAIL_SELECTED_BY_SUPERUSER = exports.MUTATE_EMAIL_SELECTED_BY_SUPERUSER = 'MUTATE_EMAIL_SELECTED_BY_SUPERUSER';
	var MUTATE_CALCULATION_FIELDS = exports.MUTATE_CALCULATION_FIELDS = 'MUTATE_CALCULATION_FIELDS';
	var MUTATE_SIMULATION_CHANGES = exports.MUTATE_SIMULATION_CHANGES = 'MUTATE_SIMULATION_CHANGES';
	var UPLOAD_FILE_RESPONSE = exports.UPLOAD_FILE_RESPONSE = 'UPLOAD_FILE_RESPONSE';
	var MUTATE_CONFIRMATION_MAIL_RESPONSE = exports.MUTATE_CONFIRMATION_MAIL_RESPONSE = 'MUTATE_CONFIRMATION_MAIL_RESPONSE';
	var MUTATE_NAV_BAR_COLLAPSE = exports.MUTATE_NAV_BAR_COLLAPSE = 'MUTATE_NAV_BAR_COLLAPSE';
	var MUTATE_OFFERS = exports.MUTATE_OFFERS = 'MUTATE_OFFERS';
	var MUTATE_OFFER_ITEMS = exports.MUTATE_OFFER_ITEMS = 'MUTATE_OFFER_ITEMS';
	var MUTATE_SELECTED_MERCHANT = exports.MUTATE_SELECTED_MERCHANT = 'MUTATE_SELECTED_MERCHANT';
	
	var UPDATE_AUTH_USER_FROM_PROFILE = exports.UPDATE_AUTH_USER_FROM_PROFILE = 'UPDATE_AUTH_USER_FROM_PROFILE';
	var ASYNC_AUTH_ACTION = exports.ASYNC_AUTH_ACTION = 'ASYNC_AUTH_ACTION';
	var ACTION_PROFILE = exports.ACTION_PROFILE = 'ACTION_PROFILE';
	var CLEAR_AUTH_ERRORS_ACTION = exports.CLEAR_AUTH_ERRORS_ACTION = 'CLEAR_AUTH_ERRORS_ACTION';
	var ACTION_DROPDOWN_VALUE = exports.ACTION_DROPDOWN_VALUE = 'ACTION_DROPDOWN_VALUE';
	var GET_USER_FROM_LOCAL_STORAGE = exports.GET_USER_FROM_LOCAL_STORAGE = 'GET_USER_FROM_LOCAL_STORAGE';
	var SET_MODAL_CONFIG_ACTION = exports.SET_MODAL_CONFIG_ACTION = 'SET_MODAL_CONFIG_ACTION';
	var LOADER_SHOW_ACTION = exports.LOADER_SHOW_ACTION = 'LOADER_SHOW_ACTION';
	var SET_MODAL_RESPONSE_ACTION = exports.SET_MODAL_RESPONSE_ACTION = 'SET_MODAL_RESPONSE_ACTION';
	var ACTION_GOALS_AND_DISPLAY = exports.ACTION_GOALS_AND_DISPLAY = 'ACTION_GOALS_AND_DISPLAY';
	var ACTION_FETCH_OFFER_NAMES = exports.ACTION_FETCH_OFFER_NAMES = 'ACTION_FETCH_OFFER_NAMES';
	var ACTION_APPROVE_OFFER = exports.ACTION_APPROVE_OFFER = 'ACTION_APPROVE_OFFER';
	var ACTION_SELECT_OFFER_NAME = exports.ACTION_SELECT_OFFER_NAME = 'ACTION_SELECT_OFFER_NAME';
	var REQUEST_OFFER_DETAILS_DATA = exports.REQUEST_OFFER_DETAILS_DATA = 'REQUEST_OFFER_DETAILS_DATA';
	var ACTION_FETCH_ZONE_SALE_PRICES = exports.ACTION_FETCH_ZONE_SALE_PRICES = 'ACTION_FETCH_ZONE_SALE_PRICES';
	var ACTION_PENDING_APPROVALS = exports.ACTION_PENDING_APPROVALS = 'ACTION_PENDING_APPROVALS';
	var ACTION_SELECTED_PENDING_APPROVALS = exports.ACTION_SELECTED_PENDING_APPROVALS = 'ACTION_SELECTED_PENDING_APPROVALS';
	var SET_SELECTED_DEPARTMENT = exports.SET_SELECTED_DEPARTMENT = 'SET_SELECTED_DEPARTMENT';
	var SET_SELECTED_SUB_DEPARTMENT = exports.SET_SELECTED_SUB_DEPARTMENT = 'SET_SELECTED_SUB_DEPARTMENT';
	var SET_SELECTED_CLASS = exports.SET_SELECTED_CLASS = 'SET_SELECTED_CLASS';
	var SET_SELECTED_SUB_CLASS = exports.SET_SELECTED_SUB_CLASS = 'SET_SELECTED_SUB_CLASS';
	var FETCH_LANDING_DATA = exports.FETCH_LANDING_DATA = 'FETCH_LANDING_DATA';
	var FETCH_SUB_DEPARTMENTS = exports.FETCH_SUB_DEPARTMENTS = 'FETCH_SUB_DEPARTMENTS';
	var FETCH_CLASSES = exports.FETCH_CLASSES = 'FETCH_CLASSES';
	var FETCH_SUB_CLASSES = exports.FETCH_SUB_CLASSES = 'FETCH_SUB_CLASSES';
	var ACTION_SELECTED_AGG_DATA = exports.ACTION_SELECTED_AGG_DATA = 'ACTION_SELECTED_AGG_DATA';
	var FETCH_APPROVE_WITH_CHANGES = exports.FETCH_APPROVE_WITH_CHANGES = 'FETCH_APPROVE_WITH_CHANGES';
	var SUBMIT_OFFER_LOCK = exports.SUBMIT_OFFER_LOCK = 'SUBMIT_OFFER_LOCK';
	var SET_AGG_INPUT_FILTER_DATA = exports.SET_AGG_INPUT_FILTER_DATA = 'SET_AGG_INPUT_FILTER_DATA';
	var ACTION_UPDATE_PET_DEPOT_FUNDING = exports.ACTION_UPDATE_PET_DEPOT_FUNDING = 'ACTION_UPDATE_PET_DEPOT_FUNDING';
	var SET_ZONE_STATE = exports.SET_ZONE_STATE = 'SET_ZONE_STATE';
	var UPDATE_ZONE_STATE = exports.UPDATE_ZONE_STATE = 'UPDATE_ZONE_STATE';
	var ACTION_REJECT_OFFER = exports.ACTION_REJECT_OFFER = 'ACTION_REJECT_OFFER';
	var RESET_FUNCTIONABLE_TO_DEFAULT = exports.RESET_FUNCTIONABLE_TO_DEFAULT = 'RESET_FUNCTIONABLE_TO_DEFAULT';
	var FETCH_BAR_CHART = exports.FETCH_BAR_CHART = 'FETCH_BAR_CHART';
	var RESET_PASSWORD = exports.RESET_PASSWORD = 'RESET_PASSWORD';
	var FETCH_LIFT_SIMULATION = exports.FETCH_LIFT_SIMULATION = 'FETCH_LIFT_SIMULATION';
	var FETCH_WATERFALL_DATA = exports.FETCH_WATERFALL_DATA = 'FETCH_WATERFALL_DATA';
	var ACTION_DOWNLOAD_ALL_DETAILS = exports.ACTION_DOWNLOAD_ALL_DETAILS = 'ACTION_DOWNLOAD_ALL_DETAILS';
	var ACTION_DOWNLOAD_MANUFACTURER_INFO = exports.ACTION_DOWNLOAD_MANUFACTURER_INFO = 'ACTION_DOWNLOAD_MANUFACTURER_INFO';
	var ACTION_DOWNLOAD_PORTAL_GUIDE = exports.ACTION_DOWNLOAD_PORTAL_GUIDE = 'ACTION_DOWNLOAD_PORTAL_GUIDE';
	var ACTION_REMOVE_ITEM_BY_ID = exports.ACTION_REMOVE_ITEM_BY_ID = 'ACTION_REMOVE_ITEM_BY_ID';
	var HARD_RESET_APPROVE_WITH_CHANGES = exports.HARD_RESET_APPROVE_WITH_CHANGES = 'HARD_RESET_APPROVE_WITH_CHANGES';
	var ACTION_ALL_EMAILS = exports.ACTION_ALL_EMAILS = 'ACTION_ALL_EMAILS';
	var SET_EMAIL_SELECTED_BY_SUPERUSER = exports.SET_EMAIL_SELECTED_BY_SUPERUSER = 'SET_EMAIL_SELECTED_BY_SUPERUSER';
	var POST_SIMULATION_CHANGES = exports.POST_SIMULATION_CHANGES = 'POST_SIMULATION_CHANGES';
	var FETCH_CALCULATION_FIELDS = exports.FETCH_CALCULATION_FIELDS = 'FETCH_CALCULATION_FIELDS';
	var RESET_OFFER_DETAILS = exports.RESET_OFFER_DETAILS = 'RESET_OFFER_DETAILS';
	var ACTION_UPLOAD_FILE = exports.ACTION_UPLOAD_FILE = 'ACTION_UPLOAD_FILE';
	var ACTION_RESET_UPLOAD_FILE = exports.ACTION_RESET_UPLOAD_FILE = 'ACTION_RESET_UPLOAD_FILE';
	var ACTION_DOWNLOAD_MERCHANT_TEMPLATE = exports.ACTION_DOWNLOAD_MERCHANT_TEMPLATE = 'ACTION_DOWNLOAD_MERCHANT_TEMPLATE';
	var ACTION_DOWNLOAD_DAX = exports.ACTION_DOWNLOAD_DAX = 'ACTION_DOWNLOAD_DAX';
	var ACTION_SEND_CONFIRMATION_MAIL = exports.ACTION_SEND_CONFIRMATION_MAIL = 'ACTION_SEND_CONFIRMATION_MAIL';
	var ACTION_MISTAKES_IN_UPLOAD_FILE = exports.ACTION_MISTAKES_IN_UPLOAD_FILE = 'ACTION_MISTAKES_IN_UPLOAD_FILE';
	var ACTION_NAV_BAR_COLLAPSE = exports.ACTION_NAV_BAR_COLLAPSE = 'ACTION_NAV_BAR_COLLAPSE';
	var RESET_SELECTED_PENDING_APPROVALS = exports.RESET_SELECTED_PENDING_APPROVALS = 'RESET_SELECTED_PENDING_APPROVALS';
	var RESET_PENDING_APPROVALS = exports.RESET_PENDING_APPROVALS = 'RESET_PENDING_APPROVALS';
	var SET_SELECTED_MERCHANT = exports.SET_SELECTED_MERCHANT = 'SET_SELECTED_MERCHANT';
	var ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS = exports.ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS = 'ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS';

/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RestClient = exports.ParseService = undefined;
	
	var _promise = __webpack_require__(205);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ParseHelper = __webpack_require__(138);
	
	var _ParseHelper2 = _interopRequireDefault(_ParseHelper);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _loader = __webpack_require__(79);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Constants = __webpack_require__(18);
	
	var _ParseObjectToArrayConverter = __webpack_require__(149);
	
	var _ViewKeyToServerKeyMapper = __webpack_require__(100);
	
	var ViewKeyToServerKeyMapper = _interopRequireWildcard(_ViewKeyToServerKeyMapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderSwitch = _loader2.default.mutations[NameSpace.MUTATE_LOADER_STATE].bind(null, _loader2.default.state);
	
	_vue2.default.use(_ParseHelper2.default, {
	  'appId': '74835-54897-3473865-437684',
	  'url': getParseEndpoint(("production"))
	});
	
	function getParseEndpoint(env) {
	  if (env === 'development') {
	    return 'http://104.198.218.85:1337/parse';
	  } else if (env === 'production') {
	    return 'https://pspvendor.impactanalytics.co/parse';
	  }
	}
	
	function errorHelper(errorCode, error) {
	  console.log(errorCode, error);
	  switch (errorCode) {
	    case 100:
	      return 'Cannot establish connection with the server.';
	    case 101:
	      return 'The combination of username and password you provided doesn\'t match with our records.';
	    case 130:
	      return 'Your file could not be uploaded.';
	    case 141:
	      return error.message.message || error.message.error || error;
	    case 209:
	      return 'Your session has expired, please login again.';
	    case 210:
	      return 'You are not authorized to login, please check your credentials or role.';
	    case 205:
	      return error.message.message || error.message.error || error;
	    default:
	      return 'This is an unexpected error. Please try again in a while';
	  }
	}
	
	function cloudRunner(functionName, requestData) {
	  loaderSwitch(true);
	  return new _promise2.default(function (resolve, reject) {
	    RestClient.$parse().Cloud.run(functionName, requestData, {
	      success: function success(response) {
	        loaderSwitch(false);
	        if (response.success) {
	          if (functionName === 'getItemsByOfferId' || functionName === 'getHighLevelOffers' || functionName === 'getAggregatedOffers' || functionName === 'getEditOfferItems' || functionName === 'removeItemById' || functionName === 'approveWithChanges' || functionName === 'updatePetDepotFunding' || functionName === 'approveOffer' || functionName === 'updateZonePrices' || functionName === 'getLiftSimulation' || functionName === 'applySimulationDecision') {
	            resolve(response);
	          } else {
	            console.log('In cloudRunner 1:', response);
	            resolve(response.data);
	          }
	        } else {
	          console.log('In cloudRunner 2:', response);
	          reject(response);
	        }
	      },
	      error: function error(_error) {
	        loaderSwitch(false);
	        console.log('In cloudRunner 3:', _error);
	        reject(errorHelper(_error.code, _error));
	        if (_error.code === 209) {
	          var authState = __webpack_require__(78).default;
	          console.log(authState);
	          var authExpiry = authState.mutations[NameSpace.MUTATE_AUTH_EXPIRY].bind(null, authState.state);
	          localStorage.removeItem('Parse/74835-54897-3473865-437684/currentUser');
	          authExpiry(true);
	        }
	      }
	    });
	  });
	}
	
	function checkNotAuthorize(user) {
	  var userGroup = user.attributes.user_group;
	  if (userGroup) {
	    if (userGroup.indexOf(_Constants.MERCHANT_ROLE) !== -1) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	}
	
	var ParseService = exports.ParseService = {
	  login: function login(username, password) {
	    loaderSwitch(true);
	    return new _promise2.default(function (resolve, reject) {
	      RestClient.$parse().User.logIn(username, password, {
	        success: function success(user) {
	          loaderSwitch(false);
	          if (checkNotAuthorize(user)) {
	            localStorage.clear();
	            reject(errorHelper(210));
	          }
	          resolve(user.attributes);
	        },
	        error: function error(user, _error2) {
	          loaderSwitch(false);
	          reject(errorHelper(_error2.code));
	        }
	      });
	    });
	  },
	  fileUpload: function fileUpload(payload) {
	    var parse = RestClient.$parse();
	    var parseFile = new parse.File(payload.name, payload.file);
	    loaderSwitch(true);
	
	    return new _promise2.default(function (resolve, reject) {
	      parseFile.save({
	        success: function success(object) {
	          ParseService.uploadedOffers({ url: object.url(), period: payload.period }, payload.filterArray).then(function (result) {
	            parseFile = null;
	            loaderSwitch(false);
	            resolve(result);
	          }).catch(function (error) {
	            parseFile = null;
	            loaderSwitch(false);
	            reject(error);
	          });
	        },
	        error: function error(model, _error3) {
	          parseFile = null;
	          loaderSwitch(false);
	          reject(errorHelper(JSON.parse(_error3.responseText || _error3.response)['code'] || _error3.code));
	        }
	      });
	    });
	  },
	  uploadedOffers: function uploadedOffers(data, filterArray) {
	    loaderSwitch(true);
	    return new _promise2.default(function (resolve, reject) {
	      cloudRunner('merchantUpload', data).then(function (response) {
	        loaderSwitch(false);
	        if (Array.isArray(response)) {
	          resolve((0, _ParseObjectToArrayConverter.uploadedOffersResponseHelper)(response, ViewKeyToServerKeyMapper.SubmitOfferTableKeys, filterArray));
	        } else {
	          resolve(response);
	        }
	      }).catch(function (error) {
	        loaderSwitch(false);
	        reject(error);
	      });
	    });
	  },
	  updateProfile: function updateProfile(data) {
	    return cloudRunner('updateProfile', data);
	  },
	  getApproveOffers: function getApproveOffers(data) {
	    return cloudRunner('goalsAndDisplayDetails', data);
	  },
	  getOfferNames: function getOfferNames(data) {
	    return cloudRunner('getOfferNames', data);
	  },
	  approveOffer: function approveOffer(data) {
	    return cloudRunner('approveOffer', data);
	  },
	  rejectOffer: function rejectOffer(data) {
	    return cloudRunner('rejectOffer', data);
	  },
	  getOfferDetails: function getOfferDetails(data) {
	    return cloudRunner('getItemsByOfferId', data);
	  },
	  getLandingData: function getLandingData(data) {
	    return cloudRunner('merchantLandingInit', data);
	  },
	  getSubDepartments: function getSubDepartments(data) {
	    return cloudRunner('getSubDepartments', data);
	  },
	  getClasses: function getClasses(data) {
	    return cloudRunner('getClasses', data);
	  },
	  getSubClasses: function getSubClasses(data) {
	    return cloudRunner('getSubClasses', data);
	  },
	  getHighLevelOffers: function getHighLevelOffers(data) {
	    return cloudRunner('getHighLevelOffers', data);
	  },
	  getAggregatedOffers: function getAggregatedOffers(data) {
	    return cloudRunner('getAggregatedOffers', data);
	  },
	  getEditOfferItems: function getEditOfferItems(data) {
	    return cloudRunner('getEditOfferItems', data);
	  },
	  approveWithChanges: function approveWithChanges(data) {
	    return cloudRunner('approveWithChanges', data);
	  },
	  updatePetDepotFunding: function updatePetDepotFunding(data) {
	    return cloudRunner('updatePetDepotFunding', data);
	  },
	  updateZonePrices: function updateZonePrices(data) {
	    return cloudRunner('updateZonePrices', data);
	  },
	  getGraphData: function getGraphData(data) {
	    return cloudRunner('getGraphData', data);
	  },
	  getLiftSimulation: function getLiftSimulation(data) {
	    return cloudRunner('getLiftSimulation', data);
	  },
	  getWaterFallData: function getWaterFallData(data) {
	    return cloudRunner('getWaterFallData', data);
	  },
	  downloadMerchantAllDetails: function downloadMerchantAllDetails(data) {
	    return cloudRunner('downloadMerchantAllDetails', data);
	  },
	  downloadManufacturerInfo: function downloadManufacturerInfo(data) {
	    return cloudRunner('downloadMerchantManufacturerInfo', data);
	  },
	  downloadTemplateMerchant: function downloadTemplateMerchant(data) {
	    return cloudRunner('downloadTemplateMerchant', data);
	  },
	  downloadNegativeMarginItems: function downloadNegativeMarginItems(data) {
	    return cloudRunner('downloadNegativeMarginItems', data);
	  },
	  downloadDax: function downloadDax(data) {
	    return cloudRunner('createDax', data);
	  },
	  removeItemById: function removeItemById(data) {
	    return cloudRunner('removeItemById', data);
	  },
	  getManufacturersForSuperUser: function getManufacturersForSuperUser(data) {
	    return cloudRunner('getManufacturersForSuperUser', data);
	  },
	  refreshLiftChanges: function refreshLiftChanges(data) {
	    return cloudRunner('refreshLiftChanges', data);
	  },
	  applySimulationDecision: function applySimulationDecision(data) {
	    return cloudRunner('applySimulationDecision', data);
	  },
	  sendFinalConfirmationMails: function sendFinalConfirmationMails(data) {
	    return cloudRunner('sendFinalConfirmationMails', data);
	  },
	  forgotPassword: function forgotPassword(username) {
	    loaderSwitch(true);
	    return new _promise2.default(function (resolve, reject) {
	      RestClient.$parse().User.requestPasswordReset(username, {
	        success: function success(user) {
	          loaderSwitch(false);
	          resolve('Password reset request was sent successfully');
	        },
	        error: function error(user, _error4) {
	          loaderSwitch(false);
	          reject(errorHelper(user.code, user));
	        }
	      });
	    });
	  }
	};
	
	var RestClient = exports.RestClient = new _vue2.default();

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APPROVE_WITH_CHANGES = exports.APPROVE_WITH_CHANGES = 1;
	var APPROVE_WITH_NO_CHANGES = exports.APPROVE_WITH_NO_CHANGES = 2;
	var APPROVE_WITH_CHANGES_TEXT = exports.APPROVE_WITH_CHANGES_TEXT = 'You have made the following changes:';
	
	var SET_ZONE = exports.SET_ZONE = 3;
	
	var REJECT_OFFER = exports.REJECT_OFFER = 4;
	
	var NO_CHANGES_TEXT = exports.NO_CHANGES_TEXT = 'There are no changes';
	var SUBMIT_TEXT = exports.SUBMIT_TEXT = 'Are you sure to submit?';
	var REJECT_TEXT = exports.REJECT_TEXT = 'Are you sure to submit with the reason?';
	
	var MERCHANT_ROLE = exports.MERCHANT_ROLE = 'merchant';
	var SUPER_USER_ROLE = exports.SUPER_USER_ROLE = 'superuser';
	var EMAIL_SELECTED_BY_SUPERUSER = exports.EMAIL_SELECTED_BY_SUPERUSER = 'email_selected_by_superuser';
	var MERCHANT_SELECTED_BY_SUPERUSER = exports.MERCHANT_SELECTED_BY_SUPERUSER = 'merchant_selected_by_superuser';
	var CLEAR_FILTER = exports.CLEAR_FILTER = 'clear_filter';
	
	var REGULAR_RETAIL = exports.REGULAR_RETAIL = 'regular_retail';
	var SUGGESTED_SB_ALLOWANCE = exports.SUGGESTED_SB_ALLOWANCE = 'manufacturer_suggested_sb_allowance';
	var SUGGESTED_OI_ALLOWANCE = exports.SUGGESTED_OI_ALLOWANCE = 'manufacturer_suggested_oi_allowance';
	var SUGGESTED_RETAIL_SAVINGS = exports.SUGGESTED_RETAIL_SAVINGS = 'manufacturer_suggested_retail_savings';
	var SUGGESTED_RETAIL = exports.SUGGESTED_RETAIL = 'manufacturer_suggested_retail';
	var RETAIL_FUNDING = exports.RETAIL_FUNDING = 'psp_retail_funding';
	var FUNDING_MERCHANT_ADJUSTED = exports.FUNDING_MERCHANT_ADJUSTED = 'psp_funding_merchant_adjusted';
	
	var VENDOR_ALLOWANCE = exports.VENDOR_ALLOWANCE = 'vendorAllowance';
	var PSP_ALLOWANCE = exports.PSP_ALLOWANCE = 'pspAllowance';
	var VENDOR_ALLOWANCE_PERCENT = exports.VENDOR_ALLOWANCE_PERCENT = 'vendorAllowancePercent';
	var RETAIL_SAVING_PERCENT = exports.RETAIL_SAVING_PERCENT = 'retailSavingsPercent';
	var RETAIL_SAVING = exports.RETAIL_SAVING = 'retailSavings';
	var RETAIL_PRICE = exports.RETAIL_PRICE = 'retailPrice';
	var MERCHANT_PORTAL_GUIDE_URL = exports.MERCHANT_PORTAL_GUIDE_URL = 'https://storage.googleapis.com/pspvendorportaltest/Merchant%20Portal%20Guide.pdf';

/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(275)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(191),
	  /* template */
	  __webpack_require__(361),
	  /* scopeId */
	  "data-v-38f12196",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableHeightByFixedWidth = undefined;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _DOM = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableHeightByFixedWidth = exports.TableHeightByFixedWidth = function () {
	  function TableHeightByFixedWidth(data, width, fontSize, padding) {
	    (0, _classCallCheck3.default)(this, TableHeightByFixedWidth);
	
	    this._init(data, width, fontSize, padding);
	  }
	
	  (0, _createClass3.default)(TableHeightByFixedWidth, [{
	    key: '_init',
	    value: function _init(data, width, fontSize, padding) {
	      var tableStyle = {
	        'position': 'fixed',
	        'top': '50px',
	        'fontSize': fontSize,
	        'visibility': 'hidden'
	      };
	
	      var tdStyle = {
	        'width': width + 'rem',
	        'fontSize': fontSize,
	        'padding': padding
	      };
	
	      this.data = data;
	      this.width = width;
	      this.dom = new _DOM.DOM('#app');
	
	      this.table = this.dom.create('table', 'test-table');
	      this.dom.style(this.table, tableStyle);
	      this.dom.add('#app', this.table);
	      this.dom.add('#test-table', this.dom.create('tr'));
	      this.td = this.dom.create('td');
	      this.dom.add('#test-table tr', this.td);
	      this.dom.style(this.td, tdStyle);
	    }
	  }, {
	    key: 'calc',
	    value: function calc(str, width) {
	      this.td.innerHTML = str;
	      return this.dom.rect(this.td).height + 5;
	    }
	  }, {
	    key: 'clear',
	    value: function clear(width) {
	      this.dom.remove('#app', this.table);
	    }
	  }, {
	    key: 'getHeightMap',
	    value: function getHeightMap() {
	      var dataLen = this.data.length;
	      var dataChildLen = this.data[0].length;
	      var str = void 0;
	      var heightMap = [];
	      var maxHeight = 0;
	      var currentHeight = 0;
	      for (var i = 0; i < dataChildLen; i++) {
	        for (var j = 0; j < dataLen; j++) {
	          str = typeof this.data[j][i].value !== 'undefined' && this.data[j][i].value !== null ? this.data[j][i].value : this.data[j][i];
	          currentHeight = this.calc(str, this.width);
	          maxHeight = currentHeight > maxHeight ? currentHeight : maxHeight;
	        }
	        heightMap.push(maxHeight);
	        maxHeight = 0;
	      }
	
	      return heightMap;
	    }
	  }, {
	    key: 'modifyTableRowHeight',
	    value: function modifyTableRowHeight(el) {
	      var _this = this;
	
	      var heightMap = this.getHeightMap();
	      var containers = this.dom.findAll(el);
	      this.dom.each(containers, function (container) {
	        _this.dom.each(container.children, function (tables) {
	          _this.dom.each(tables.children, function (tr, i) {
	            tr.style.height = heightMap[i] + 'px';
	          });
	        });
	      });
	      this.clearDummys();
	    }
	  }, {
	    key: 'clearDummys',
	    value: function clearDummys() {
	      while (document.getElementById('test-table')) {
	        this.dom.$root.removeChild(document.getElementById('test-table'));
	      }
	    }
	  }]);
	  return TableHeightByFixedWidth;
	}();

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSuperUser = isSuperUser;
	exports.getVendorId = getVendorId;
	
	var _Constants = __webpack_require__(18);
	
	var _authorization = __webpack_require__(78);
	
	var _authorization2 = _interopRequireDefault(_authorization);
	
	var _profile = __webpack_require__(101);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isSuperUser() {
	  var auth = _authorization2.default.getters[NameSpace.AUTH_GETTER](_authorization2.default.state);
	  auth = auth.auth;
	  if (auth && auth.user_group) {
	    if (auth.user_group.indexOf(_Constants.SUPER_USER_ROLE) !== -1) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function getVendorId() {
	  var profile = _profile2.default.getters[NameSpace.GETTER_EMAIL_SELECTED_BY_SUPERUSER](_profile2.default.state);
	  if (profile) {
	    return profile;
	  }
	}

/***/ },
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mainContainerStyle = exports.mainContainerStyle = {
	  mainStyle: {
	    approveWithChanges: {
	      'background-color': '#eee',
	      'width': '94%',
	      'height': '90%',
	      'position': 'absolute',
	      'top': '5%',
	      'left': '3%',
	      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.2)'
	    },
	    scrollable: {
	      'height': '95%',
	      'margin-top': '2rem',
	      'margin-right': '1.1rem',
	      'overflow-y': 'auto'
	    },
	    tableButton: {
	      'margin-top': '1rem',
	      'text-align': 'center'
	    },
	    goalsAndDisplayStyle: {
	      'background-color': '#eee',
	      'width': '70%',
	      'height': '65%',
	      'max-height': '400px',
	      'position': 'absolute',
	      'top': '15%',
	      'left': '15%',
	      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.5)'
	    },
	    rejectOffer: {
	      'background-color': '#eee',
	      'width': '60%',
	      'height': '55%',
	      'position': 'absolute',
	      'top': '15%',
	      'left': '20%',
	      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.5)'
	    },
	    zoneScrollable: {
	      'margin': '1rem 1rem 0 1rem',
	      'overflow-y': 'auto'
	    },
	    tableZonePriceChangeTitleStyle: {
	      'text-align': 'center',
	      'padding': '1rem',
	      'color': '#05983b',
	      'font-size': '1.8rem',
	      'font-weight': '2'
	    },
	    tableZonePriceChangeMinHeight: {
	      'min-height': '65%',
	      'font-size': '1.3rem'
	    },
	    confirmationApproveWithChanges: {
	      'background-color': '#eee',
	      'position': 'absolute',
	      'left': '50%',
	      'top': '50%',
	      'width': '70%',
	      'transform': 'translate(-50%, -50%)',
	      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.2)'
	    }
	  }
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FlexTable = undefined;
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _slicedToArray2 = __webpack_require__(209);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlexTable = exports.FlexTable = function () {
	  function FlexTable(schema, data, orientation) {
	    (0, _classCallCheck3.default)(this, FlexTable);
	
	    this.SETTINGS = {
	      HORIZONTAL: 0,
	      VERTICAL: 1
	    };
	    this.fixedData = [];
	    this.schema = (0, _lodash.cloneDeep)(schema);
	    this.data = (0, _lodash.cloneDeep)(data);
	    this.orientation = this.setTableOrientation(orientation);
	    this.deleted = [];
	  }
	
	  (0, _createClass3.default)(FlexTable, [{
	    key: 'setTableOrientation',
	    value: function setTableOrientation(setting) {
	      if (this.SETTINGS.HORIZONTAL === setting) {
	        return this.SETTINGS.HORIZONTAL;
	      } else if (this.SETTINGS.VERTICAL === setting) {
	        return this.SETTINGS.VERTICAL;
	      } else {
	        throw Error('Orientation can only receive 0 or 1.');
	      }
	    }
	  }, {
	    key: 'getRowName',
	    value: function getRowName(obj) {
	      return (0, _keys2.default)(obj).map(function (e) {
	        return obj[e].name;
	      });
	    }
	  }, {
	    key: 'formatAsMoney',
	    value: function formatAsMoney(input) {
	      if (typeof input === 'string') {
	        if (input.indexOf('-') > -1) {
	          var _input$split = input.split('-'),
	              _input$split2 = (0, _slicedToArray3.default)(_input$split, 2),
	              upperRange = _input$split2[0],
	              lowerRange = _input$split2[1];
	
	          return this.formatAsMoney(upperRange) + ' - ' + this.formatAsMoney(lowerRange);
	        }
	        return '$ ' + this.commaTose(input, 3);
	      } else if (parseInt(input) === input) {
	        return '$ ' + this.commaTose(input, 3) + '.00';
	      } else if (typeof input === 'number') {
	        return '$ ' + this.commaTose(input, 3);
	      }
	    }
	  }, {
	    key: 'commaTose',
	    value: function commaTose(value, interval) {
	      var _value$toString$split = value.toString().split('.'),
	          _value$toString$split2 = (0, _slicedToArray3.default)(_value$toString$split, 2),
	          input = _value$toString$split2[0],
	          decimal = _value$toString$split2[1];
	
	      input = input.split('').reverse();
	
	      var chunks = (0, _lodash.chunk)(input, interval);
	
	      chunks = (0, _lodash.map)(chunks, function (e) {
	        return e.reverse().join('');
	      });
	
	      chunks = chunks.reverse().join(',');
	
	      if (decimal) {
	        chunks = chunks + '.' + decimal;
	      }
	
	      return chunks;
	    }
	  }, {
	    key: 'makeEditable',
	    value: function makeEditable(input) {
	      return {
	        value: input,
	        isEditable: true
	      };
	    }
	  }, {
	    key: 'formatAsPercentage',
	    value: function formatAsPercentage(input) {
	      return input + ' %';
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(val, obj, key) {
	      this.deleted.push({ val: obj[key], key: key });
	      delete obj[key];
	    }
	  }, {
	    key: 'getFixedFromSchema',
	    value: function getFixedFromSchema() {
	      var _this = this;
	
	      var rows = [];
	      var propertiesInSchema = (0, _keys2.default)(this.schema);
	      if (this.orientation === this.SETTINGS.VERTICAL) {
	        rows = propertiesInSchema.map(function (e) {
	          var childProperties = (0, _keys2.default)(_this.schema[e].contains);
	          if (e === 'basic_facts' && childProperties[0] === 'itemId') {
	            childProperties.shift();
	          }
	          var partial = [];
	          for (var i = 0; i < childProperties.length; i++) {
	            if (i === 0) {
	              partial.push({ name: _this.schema[e].contains[childProperties[i]].name, parent: _this.schema[e].name, parent_span: childProperties.length });
	            } else {
	              partial.push({ name: _this.schema[e].contains[childProperties[i]].name });
	            }
	          }
	          return partial;
	        });
	      }
	      return (0, _lodash.flatten)(rows);
	    }
	  }, {
	    key: 'getDataFromSchema',
	    value: function getDataFromSchema(screenName, status) {
	      var _this2 = this;
	
	      var data = (0, _lodash.cloneDeep)(this.data);
	      var functionable = this.data.my_offer && !this.data.lock;
	      var propStore = {
	        lock: data.lock,
	        my_offer: data.my_offer
	      };
	      delete data.lock;
	      delete data.my_offer;
	      var dataFields = (0, _keys2.default)(data);
	      var formattedData = [];
	      dataFields.forEach(function (field) {
	        var datacols = data[field].map(function (el, i, ctx) {
	          var propInField = (0, _keys2.default)(el);
	          propInField.forEach(function (prop) {
	            if (prop === 'pet_depot_funding' && screenName === 'offer_select' && functionable) {
	              el[prop] = _this2['makeEditable'](el[prop]);
	            } else {
	              try {
	                _this2.schema[field].contains[prop].fn.forEach(function (fn) {
	                  if (fn !== 'delete') {
	                    el[prop] = _this2[fn](el[prop], el, prop);
	                  } else {
	                    _this2[fn](el[prop], el, prop);
	                  }
	                });
	              } catch (e) {
	                console.log(e);
	              }
	            }
	          });
	          return el;
	        });
	
	        formattedData.push(datacols);
	      });
	      for (var prop in propStore) {
	        if (!isNaN(Number(prop))) throw Error('Got property as a number');
	        formattedData[prop] = propStore[prop];
	      }
	      console.log(formattedData);
	      return formattedData;
	    }
	  }, {
	    key: 'dataTableStyle',
	    value: function dataTableStyle(screenName, status) {
	      var _this3 = this;
	
	      var data = (0, _lodash.cloneDeep)(this.data);
	      var dataKeys = (0, _keys2.default)(data);
	      var tableData = [];
	      var partials = void 0;
	      var formattedData = void 0;
	      var propStore = void 0;
	      if (status) {
	        formattedData = this.getDataFromSchema(screenName, status);
	      } else {
	        formattedData = this.getDataFromSchema(screenName);
	      }
	      propStore = {
	        lock: formattedData.lock,
	        my_offer: formattedData.my_offer
	      };
	      console.log(formattedData);
	      var dataSize = dataKeys.reduce(function (acc, key) {
	        return (0, _lodash.size)(data[key]) > acc ? (0, _lodash.size)(data[key]) : acc;
	      }, 0);
	
	      var _loop = function _loop(i) {
	        partials = [];
	        formattedData.forEach(function (data) {
	          partials.push((0, _lodash.values)(data[i]));
	        });
	        tableData.push((0, _lodash.flatten)(partials));
	        tableData.forEach(function (e, i) {
	          if (_this3.deleted[i]) {
	            e[_this3.deleted[i].key] = _this3.deleted[i].val;
	          }
	        });
	      };
	
	      for (var i = 0; i < dataSize; i++) {
	        _loop(i);
	      }
	      for (var prop in propStore) {
	        if (!isNaN(Number(prop))) throw Error('Got property as a number');
	        tableData[prop] = propStore[prop];
	      }
	      return tableData;
	    }
	  }, {
	    key: 'getTableData',
	    value: function getTableData() {
	      var data = (0, _lodash.cloneDeep)(this.data);
	      var dataKeys = (0, _keys2.default)(data);
	      var tableData = [];
	
	      var dataSize = dataKeys.reduce(function (acc, key) {
	        return (0, _lodash.size)(data[key]) > acc ? (0, _lodash.size)(data[key]) : acc;
	      }, 0);
	
	      var _loop2 = function _loop2(i) {
	        var dataCollector = [];
	        dataKeys.forEach(function (key) {
	          (0, _keys2.default)(data[dataKeys][i]);
	          dataCollector.push(data[dataKeys][i]);
	        });
	        tableData.push(dataCollector);
	      };
	
	      for (var i = 0; i < dataSize; i++) {
	        _loop2(i);
	      }
	      return tableData;
	    }
	  }, {
	    key: 'getHorizontalTableHeader',
	    value: function getHorizontalTableHeader(inputHeaderJsonSchema, key) {
	      return (0, _lodash.map)(inputHeaderJsonSchema.header, key);
	    }
	  }, {
	    key: 'getHorizontalTableData',
	    value: function getHorizontalTableData(inputHeaderJsonSchema, inputDataJsonSchema, fnKey) {
	      var finalJsonArray = [];
	      var input = inputDataJsonSchema.data;
	      for (var i = 0; i < input.length; i++) {
	        var eachJsonArray = [];
	        var data = input[i];
	        for (var key in data) {
	          var resultantData = {};
	          resultantData.value = data[key];
	          resultantData.edit = false;
	          resultantData.editable = inputHeaderJsonSchema.header[key].fn.includes(fnKey);
	          eachJsonArray.push(resultantData);
	        }
	        finalJsonArray.push(eachJsonArray);
	      }
	      return finalJsonArray;
	    }
	  }, {
	    key: 'getObjectTableHeaders',
	    value: function getObjectTableHeaders(headerSchema) {
	      var listHeaders = [];
	
	      for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        keys[_key - 1] = arguments[_key];
	      }
	
	      for (var offer in headerSchema) {
	        if (keys !== undefined && keys.indexOf(headerSchema[offer].name) === -1) {
	          listHeaders.push({ value: headerSchema[offer].name, key: offer });
	        }
	      }
	      return listHeaders;
	    }
	  }, {
	    key: 'getStringTableHeaders',
	    value: function getStringTableHeaders(headerSchema) {
	      return (0, _keys2.default)(headerSchema);
	    }
	  }, {
	    key: 'getHeadersForFixedTable',
	    value: function getHeadersForFixedTable(headerSchema, screenName) {
	      var headersSchemaKeys = (0, _lodash.keysIn)(headerSchema);
	      var fixedRowKeys = headersSchemaKeys.filter(function (e) {
	        return headerSchema[e].fixed;
	      });
	      return fixedRowKeys.map(function (e) {
	        var obj = {};
	        obj.value = headerSchema[e].name;
	        return obj;
	      });
	    }
	  }, {
	    key: 'getHeadersForScrollableTable',
	    value: function getHeadersForScrollableTable(headerSchema, fixedRowKeys) {
	      var scrollableRowKeys = (0, _lodash.keysIn)(headerSchema).filter(function (e) {
	        return fixedRowKeys.indexOf(e) === -1;
	      });
	      return scrollableRowKeys.map(function (e) {
	        var obj = {};
	        obj.value = headerSchema[e].name;
	        return obj;
	      });
	    }
	  }, {
	    key: 'getMapHeaders',
	    value: function getMapHeaders(headerSchema, fixedRowKeys) {
	      return (0, _lodash.keysIn)(headerSchema).filter(function (e) {
	        return fixedRowKeys.indexOf(e) === -1;
	      });
	    }
	  }, {
	    key: 'getLinkableHeaders',
	    value: function getLinkableHeaders(headerSchema, key) {
	      var headersSchemaKeys = (0, _lodash.keysIn)(headerSchema);
	      var fixedRowKeys = headersSchemaKeys.filter(function (e) {
	        return headerSchema[e] && headerSchema[e].fn && headerSchema[e].fn.includes(key);
	      });
	      return fixedRowKeys;
	    }
	  }, {
	    key: 'getIndexforFillteredTableHeaders',
	    value: function getIndexforFillteredTableHeaders(headerSchema, key) {
	      var headersSchemaKeys = (0, _lodash.keysIn)(headerSchema);
	      var fixedRowKeys = headersSchemaKeys.filter(function (e) {
	        return headerSchema[e].fn.includes(key);
	      });
	      var keyIndexes = fixedRowKeys.map(function (e) {
	        return (0, _lodash.indexOf)(headersSchemaKeys, e);
	      });
	      return keyIndexes;
	    }
	  }, {
	    key: 'getTableDataAsObjectArray',
	    value: function getTableDataAsObjectArray(keys, data, cellStyle, hasLinkIndex) {
	      var cols = (0, _lodash.keysIn)(data);
	      var myData = cols.map(function (e) {
	        var val = (0, _lodash.values)((0, _lodash.pick)(data[e], keys));
	        var myArray = [];
	        for (var i = 0; i < val.length; i++) {
	          var obj = {};
	          if (typeof val[i] === 'string') {
	            if (val[i].length) {
	              obj.value = val[i];
	              if (cellStyle === 'makeLink') {
	                if (hasLinkIndex !== undefined && i === hasLinkIndex) {
	                  obj.makeLink = true;
	                  obj.clickable = true;
	                } else if (hasLinkIndex !== undefined) {} else {
	                  obj.makeLink = true;
	                }
	              }
	              myArray.push(obj);
	            }
	          } else {
	            obj.value = val[i];
	            if (cellStyle === 'makeLink') {
	              if (hasLinkIndex !== undefined && i === hasLinkIndex) {
	                obj.makeLink = true;
	                obj.clickable = true;
	              } else if (hasLinkIndex !== undefined) {} else {
	                obj.makeLink = true;
	              }
	            }
	            myArray.push(obj);
	          }
	        }
	        if (myArray.length) {
	          return myArray;
	        }
	      });
	      if (myData && myData[0]) {
	        return myData;
	      } else {
	        return {};
	      }
	    }
	  }, {
	    key: 'getCellDataAsObject',
	    value: function getCellDataAsObject(keys, data, cellStyle, screenName, hasLinkIndex, filteredHeadersKeys) {
	      var _this4 = this;
	
	      var cols = (0, _lodash.keysIn)(data);
	      var val = void 0;
	      var propStore = {};
	      var indexOfferId = void 0;
	      if (screenName === 'selected_offer_list') {
	        keys = keys.filter(function (e) {
	          return ['my_offer', 'lock'].indexOf(e) === -1;
	        });
	      }
	
	      var myData = cols.map(function (e, itemPosition) {
	        if (screenName === 'offer_details') {
	          indexOfferId = (0, _lodash.indexOf)(keys, 'offer_id');
	        } else if (screenName === 'set_zone') {
	          indexOfferId = (0, _lodash.indexOf)(keys, 'zoneItemId');
	        } else if (screenName === 'selected_offer_list') {
	          indexOfferId = (0, _lodash.indexOf)(keys, 'offer_id');
	        }
	
	        propStore = {
	          lock: data[e].lock,
	          my_offer: data[e].my_offer
	        };
	
	        val = (0, _lodash.values)((0, _lodash.pick)(data[e], keys));
	        var myArray = [];
	        for (var i = 0; i < val.length; i++) {
	          var obj = {};
	          var tempObject = val[i];
	          if (screenName === 'landing') {
	            if ((0, _typeof3.default)(val[i]) === 'object') {
	              var myVal = tempObject.offerCount + '(' + tempObject.itemCount + ')';
	              obj.value = myVal;
	              obj.object = tempObject.itemToOfferMapping;
	              if (tempObject.status) {
	                obj.status = tempObject.status;
	              }
	            } else {
	              obj.value = val[i];
	            }
	            if (cellStyle === 'makeLink') {
	              if (hasLinkIndex !== -1 && i === hasLinkIndex) {
	                obj.makeLink = true;
	                obj.clickable = true;
	              } else if (hasLinkIndex !== -1) {} else {
	                if (tempObject.offerCount !== 0) {
	                  obj.makeLink = true;
	                }
	              }
	            }
	          } else if (screenName === 'offer_details' || screenName === 'selected_offer_list') {
	            if (screenName === 'selected_offer_list') {}
	            if ((0, _typeof3.default)(val[i]) === 'object') {} else {
	              var offerId = val[indexOfferId];
	              obj.id = offerId;
	              obj.value = val[i];
	            }
	            if (cellStyle === 'makeLink') {
	              if (hasLinkIndex !== -1 && i === hasLinkIndex) {
	                obj.makeLink = true;
	                obj.clickable = true;
	              } else if (hasLinkIndex !== -1) {} else {
	                obj.makeLink = true;
	              }
	            }
	          } else if (screenName === 'approve_with_changes') {
	            obj.value = val[i];
	            if (cellStyle === 'makeEditable') {
	              if (filteredHeadersKeys.indexOf(i) > -1) {
	                obj.editable = true;
	                obj.index = i;
	                obj['itemIndex'] = itemPosition;
	              }
	            }
	          } else if (screenName === 'set_zone') {
	            if ((0, _typeof3.default)(val[i]) === 'object') {} else {
	              obj.id = val[indexOfferId];
	              obj.index = i;
	              obj.value = val[i];
	            }
	            if (cellStyle === 'makeEditable') {
	              if (filteredHeadersKeys.indexOf(i) > -1) {
	                obj.editable = true;
	              }
	            }
	          }
	          myArray.push(obj);
	        }
	        if (screenName === 'selected_offer_list') {
	          myArray.splice(indexOfferId, 1);
	        } else if (screenName === 'offer_details') {
	          myArray.splice(indexOfferId, 1);
	          myArray[_this4.deleted.key] = _this4.deleted.value;
	        } else if (screenName === 'landing') {
	          myArray.unshift({ value: e.toUpperCase() });
	        }
	        for (var prop in propStore) {
	          if (!isNaN(Number(prop))) throw Error('Got property as a number');
	          myArray[prop] = propStore[prop];
	        }
	        return myArray;
	      });
	      if (screenName === 'approve_with_changes') {
	        addAdditonalColumn(myData, val, cellStyle, filteredHeadersKeys);
	      }
	      return myData;
	    }
	  }]);
	  return FlexTable;
	}();
	
	function addAdditonalColumn(myData, val, cellStyle, filteredHeadersKeys) {
	  var myArray = [];
	  for (var i = 0; i < val.length; i++) {
	    var obj = {};
	    obj.index = i;
	    if (i === 0) {
	      obj.value = 'Common Override';
	    }
	    if (cellStyle === 'makeEditable') {
	      if (filteredHeadersKeys.indexOf(i) > -1) {
	        obj.editable = true;
	        obj.commonOverride = true;
	        obj.itemIndex = myData.length;
	        obj.value = '';
	      } else {
	        obj.value = obj.value === '' || typeof obj.value === 'undefined' ? '\xa0' : obj.value;
	      }
	    }
	    myArray.push(obj);
	  }
	  myData.push(myArray);
	  return myData;
	}

/***/ },
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(295)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(187),
	  /* template */
	  __webpack_require__(381),
	  /* scopeId */
	  "data-v-b6e2b3d6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submittedOffersEditValidator = undefined;
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.present = present;
	exports.validEmail = validEmail;
	exports.isValidPassword = isValidPassword;
	exports.undefinedField = undefinedField;
	exports.validateMobile = validateMobile;
	exports.validateFields = validateFields;
	exports.validateInputField = validateInputField;
	
	var _submittedOffersEditValidator = __webpack_require__(136);
	
	var offersEditValidator = _interopRequireWildcard(_submittedOffersEditValidator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var submittedOffersEditValidator = exports.submittedOffersEditValidator = offersEditValidator;
	
	function present() {
	  for (var _len = arguments.length, inputs = Array(_len), _key = 0; _key < _len; _key++) {
	    inputs[_key] = arguments[_key];
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(inputs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var input = _step.value;
	
	      if (!input) return false;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return true;
	}
	
	function validEmail(testStr) {
	  var reg = new RegExp(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/);
	  if (!reg.test(testStr)) {
	    return false;
	  }
	  return true;
	}
	
	function isValidPassword(testStr) {
	  var reg = new RegExp(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/);
	  if (!reg.test(testStr)) {
	    return false;
	  }
	  return true;
	}
	
	function undefinedField(inputs) {
	  var localObj = {};
	  for (var key in inputs) {
	    if (!inputs[key]) {
	      localObj[' ' + key[0].toUpperCase() + key.substr(1)] = inputs[key];
	    }
	  }
	  return (0, _keys2.default)(localObj).toString();
	}
	
	function validateMobile(mobile) {
	  var reg = new RegExp(/^[0-9]+$/);
	  if (!reg.test(mobile)) {
	    return false;
	  }
	  return true;
	}
	
	function validateFields(input, type) {
	  return {
	    'length': function (input) {
	      return !input ? type + ' cannot be blank.' : checkInputLength(profileValidationRules[type].length.min, profileValidationRules[type].length.max, input) ? profileValidationRules[type].length.max ? 'Length should be between ' + profileValidationRules[type].length.min + ' -\n              ' + profileValidationRules[type].length.max + ' characters.' : 'Length should be more than ' + profileValidationRules[type].length.min : false;
	    }(input),
	    'format': checkInputFormat(profileValidationRules[type].expression, input) ? type + ' is not in valid format.' : false
	  };
	}
	
	var profileValidationRules = {
	  name: {
	    length: {
	      min: 1,
	      max: 30
	    },
	    expression: new RegExp(/^[a-zA-Z\s]+$/)
	  },
	  phone: {
	    length: {
	      min: 10,
	      max: 13
	    },
	    expression: new RegExp(/^[0-9]+$/)
	  },
	  email: {
	    length: {
	      min: 6,
	      max: null
	    },
	    expression: new RegExp(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/)
	  }
	};
	
	function checkInputFormat(reg, input) {
	  return !reg.test(input);
	}
	
	function checkInputLength(min, max, input) {
	  if (max) {
	    return input.length >= max || input.length < min;
	  } else {
	    return input.length < min;
	  }
	}
	
	function validateInputField(key, value, isCommonOverride) {
	  var regex = void 0;
	  var msg = ['Values must meet the following:-', '1. Should only be numeric.', '2. Can optionally start by + or -', '3. Can have max four digits before or two digits after decimal point.'];
	
	  regex = new RegExp(/^(\d{1,4})(\.\d{1,2})?$/);
	  if (!regex.test(value)) {
	    return { result: true, msg: msg };
	  } else {
	    return { result: false, msg: '' };
	  }
	}

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(25);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.clone = clone;
	exports.breadthFirstSearch = breadthFirstSearch;
	exports.notNullCopy = notNullCopy;
	exports.merge = merge;
	exports.hollow = hollow;
	exports.objectEqualForSameKeys = objectEqualForSameKeys;
	exports.jsonIsObjectEqual = jsonIsObjectEqual;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clone(actualObject) {
	  if (Array.isArray(actualObject)) {
	    return cloneArray(actualObject);
	  } else if ((typeof actualObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(actualObject)) === 'object') {
	    return cloneObject(actualObject);
	  }
	  return null;
	}
	
	function cloneObject(actualObject) {
	  var cloneObject = {};
	  for (var property in actualObject) {
	    cloneObject[property] = actualObject[property];
	  }
	  return cloneObject;
	}
	
	function cloneArray(actualObject) {
	  return actualObject.slice();
	}
	
	function breadthFirstSearch(testInput, attr, value) {
	  for (var prop in testInput) {
	    if (attr === prop) {
	      if (!hollow(value)) {
	        testInput[attr] = value;
	        console.log(testInput, attr, value);
	      }
	      return true;
	    } else if ((0, _typeof3.default)(testInput[prop]) === 'object' && !Array.isArray(testInput[prop])) {
	      if (breadthFirstSearch(testInput[prop], attr, value)) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function notNullCopy(testInput) {
	  (0, _keys2.default)(testInput).forEach(function (key) {
	    if (testInput[key] && (0, _typeof3.default)(testInput[key]) === 'object') notNullCopy(testInput[key]);else if (testInput[key] == null) delete testInput[key];
	  });
	  return testInput;
	}
	
	function merge(reference, testInput) {
	  var referenceClone = clone(reference);
	  for (var attr in testInput) {
	    if ((0, _typeof3.default)(testInput[attr]) === 'object' && !Array.isArray(testInput[attr])) {
	      referenceClone[attr] = merge(referenceClone[attr], testInput[attr]);
	    } else {
	      referenceClone[attr] = testInput[attr];
	    }
	  }
	  return referenceClone;
	}
	
	function hollow(testInput) {
	  if (typeof testInput === 'undefined' || testInput === null || typeof testInput === 'number' && isNaN(testInput)) {
	    return true;
	  }
	  return false;
	}
	
	function objectEqualForSameKeys(obj1, obj2) {
	  for (var key in obj1) {
	    if ((0, _typeof3.default)(obj1[key]) === 'object' && (0, _typeof3.default)(obj2[key]) === 'object') {
	      return objectEqualForSameKeys(obj1[key], obj2[key]);
	    } else if (obj1[key] !== obj2[key]) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function jsonIsObjectEqual(obj1, obj2) {
	  return (0, _stringify2.default)(obj1) === (0, _stringify2.default)(obj2);
	}

/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tableStyles = exports.tableStyles = {
	  offersListHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%',
	      'margin-left': '1.5rem'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'font-size': '1.3rem'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offersListDataStyle: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'font-size': '1.3rem'
	    },
	    editBoxWidthFull: {
	      'display': 'inline-block',
	      'width': '100%',
	      'height': '32px',
	      'padding-left': '1rem',
	      'padding-right': '1rem'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offerZoneListHeaderStyle: {
	    headerTableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%',
	      'position': 'relative'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '0.8rem',
	      'background-color': 'rgb(246,246,230)',
	      'width': '25%',
	      'word-wrap': 'break-word',
	      'border': '1px solid #cecece'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'width': '100%'
	    },
	    thStyle: {
	      'border': '1px solid #cecece',
	      'width': '25%',
	      'word-wrap': 'break-word',
	      'padding': '1rem 1rem'
	    },
	    tableContainerStyle: {
	      'width': '100%'
	    },
	    editableLabel: {
	      'display': 'inline-block',
	      'width': '90%'
	    },
	    editableEditBox: {
	      'display': 'inline-block',
	      'cursor': 'pointer'
	    }
	  }
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.AUTH_STATE, {
	  auth: {},
	  error: null,
	  expired: null
	}), (0, _defineProperty3.default)(_state, NameSpace.FORGOT_PASSWORD_STATE, {
	  success: null,
	  error: null
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.AUTH_GETTER, function (state) {
	  return state[NameSpace.AUTH_STATE];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_FORGOT_PASSWORD_STATUS, function (state) {
	  return state[NameSpace.FORGOT_PASSWORD_STATE];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.AUTH_MUTATION, function (state, payload) {
	  state[NameSpace.AUTH_STATE] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.CLEAR_AUTH_ERRORS_MUTATION, function (state, payload) {
	  state[NameSpace.AUTH_STATE].error = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_FORGOT_PASSWORD, function (state, payload) {
	  state[NameSpace.FORGOT_PASSWORD_STATE] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_AUTH_EXPIRY, function (state, payload) {
	  state[NameSpace.AUTH_STATE].expired = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ASYNC_AUTH_ACTION, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.login(payload.username, payload.password).then(function (user) {
	    commit(NameSpace.AUTH_MUTATION, { auth: user, error: null, expired: false });
	  }).catch(function (error) {
	    commit(NameSpace.AUTH_MUTATION, { auth: [], error: error, expired: null });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.GET_USER_FROM_LOCAL_STORAGE, function (_ref2) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.AUTH_MUTATION, {
	    auth: JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser') || '{}'),
	    error: null,
	    expired: false
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.UPDATE_AUTH_USER_FROM_PROFILE, function (_ref3) {
	  var commit = _ref3.commit;
	
	  commit(NameSpace.AUTH_MUTATION, {
	    auth: JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser') || '{}'),
	    error: null,
	    expired: false
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.CLEAR_AUTH_ERRORS_ACTION, function (_ref4) {
	  var commit = _ref4.commit;
	
	  commit(NameSpace.CLEAR_AUTH_ERRORS_MUTATION, null);
	}), (0, _defineProperty3.default)(_actions, NameSpace.RESET_PASSWORD, function (_ref5, payload) {
	  var commit = _ref5.commit;
	
	  _parse.ParseService.forgotPassword(payload).then(function (message) {
	    commit(NameSpace.MUTATE_FORGOT_PASSWORD, { success: message, error: null });
	    setTimeout(function () {
	      commit(NameSpace.MUTATE_FORGOT_PASSWORD, { success: null, error: null });
	    });
	  }).catch(function (error) {
	    commit(NameSpace.MUTATE_FORGOT_PASSWORD, { success: {}, error: error });
	    setTimeout(function () {
	      commit(NameSpace.MUTATE_FORGOT_PASSWORD, { success: null, error: null });
	    });
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _defineProperty3.default)({}, NameSpace.LOADER_STATE, false);
	
	var getters = (0, _defineProperty3.default)({}, NameSpace.GET_LOADER_STATE, function (state) {
	  return state[NameSpace.LOADER_STATE];
	});
	
	var mutations = (0, _defineProperty3.default)({}, NameSpace.MUTATE_LOADER_STATE, function (state, payload) {
	  state[NameSpace.LOADER_STATE] = payload;
	});
	
	var actions = (0, _defineProperty3.default)({}, NameSpace.LOADER_SHOW_ACTION, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  commit(NameSpace.MUTATE_LOADER_STATE, payload);
	});
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(282)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(186),
	  /* template */
	  __webpack_require__(368),
	  /* scopeId */
	  "data-v-4edb2653",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(278)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(188),
	  /* template */
	  __webpack_require__(364),
	  /* scopeId */
	  "data-v-49aafa6a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 100 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getGoalAndDisplayDetails = exports.getGoalAndDisplayDetails = {
	  'goal': 'goal',
	  '4-Pager/Mega': '4-Pager/Mega',
	  'Display': 'display'
	};
	
	var getLocalOfferNames = exports.getLocalOfferNames = {
	  'offerName': 'offerName',
	  'offerId': 'offerId'
	};
	
	var getLocalRejectOfferResult = exports.getLocalRejectOfferResult = {
	  'offerName': 'offerName',
	  'offerId': 'offerId'
	};
	
	var SubmittedOfferTableKeys = exports.SubmittedOfferTableKeys = {
	  'period': '0',
	  'category': '1',
	  'description': '2',
	  'UPC': '3',
	  'brand-name': '4',
	  'size': '3',
	  'UOM': '4',
	  'CPTS': '5',
	  'off_invoice_allowance_amount': '6',
	  'scan_back_allowance_amount': '7',
	  'total': '8',
	  'URR': '9',
	  'suggested_retail_savings': '10',
	  'offer_name': '11',
	  'offer_period': '12'
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(25);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _objectModifier = __webpack_require__(76);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.PROFILE, {
	  profile: {
	    manufacturer: '',
	    name: '',
	    phone: '',
	    email: ''
	  },
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.ALL_EMAILS, {
	  manufacturers: [],
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.EMAIL_SELECTED_BY_SUPERUSER, null), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_PROFILE, function (state) {
	  return state[NameSpace.PROFILE];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GETTER_ALL_EMAILS, function (state) {
	  return state[NameSpace.ALL_EMAILS];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GETTER_EMAIL_SELECTED_BY_SUPERUSER, function (state) {
	  return state[NameSpace.EMAIL_SELECTED_BY_SUPERUSER];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_PROFILE, function (state, payload) {
	  var localUser = JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser'));
	  if (localUser && (typeof payload === 'undefined' ? 'undefined' : (0, _typeof3.default)(payload)) === 'object') {
	    var refUser = (0, _objectModifier.merge)(localUser, JSON.parse((0, _stringify2.default)(payload)));
	    localStorage.setItem('Parse/74835-54897-3473865-437684/currentUser', (0, _stringify2.default)(refUser));
	    state[NameSpace.PROFILE].profile = (0, _stringify2.default)(payload);
	  }
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_PROFILE_ERROR, function (state, payload) {
	  state[NameSpace.PROFILE].error = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_ALL_EMAILS, function (state, payload) {
	  state[NameSpace.ALL_EMAILS] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_EMAIL_SELECTED_BY_SUPERUSER, function (state, payload) {
	  state[NameSpace.EMAIL_SELECTED_BY_SUPERUSER] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ACTION_PROFILE, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  payload = (0, _lodash.pick)(payload, ['email', 'phone', 'name']);
	  _parse.ParseService.updateProfile(payload).then(function (profile) {
	    commit(NameSpace.MUTATE_PROFILE, payload);
	  }).catch(function (error) {
	    commit(NameSpace.MUTATE_PROFILE_ERROR, error);
	    setTimeout(function () {
	      commit(NameSpace.MUTATE_PROFILE_ERROR, null);
	    }, null);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_ALL_EMAILS, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  _parse.ParseService.getManufacturersForSuperUser(payload).then(function (manufacturers) {
	    commit(NameSpace.MUTATE_ALL_EMAILS, { manufacturers: manufacturers, error: null });
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_ALL_EMAILS, { manufacturers: [], error: error });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.SET_EMAIL_SELECTED_BY_SUPERUSER, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  commit(NameSpace.MUTATE_EMAIL_SELECTED_BY_SUPERUSER, payload);
	}), _actions);
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  getters: getters,
	  actions: actions
	};

/***/ },
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(291)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(183),
	  /* template */
	  __webpack_require__(377),
	  /* scopeId */
	  "data-v-7ab1f3ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(281)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(192),
	  /* template */
	  __webpack_require__(367),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(271)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(193),
	  /* template */
	  __webpack_require__(357),
	  /* scopeId */
	  "data-v-196e33c8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(285)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(198),
	  /* template */
	  __webpack_require__(371),
	  /* scopeId */
	  "data-v-65201310",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 135 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.validate = validate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var periodOptions = ['LAST TWO WEEKS', 'FIRST TWO WEEKS', 'MONTHLY OFFER'];
	
	function isAllNumeric(expectedNumber) {
	  return !isNaN(Number(expectedNumber)) && expectedNumber !== '';
	}
	
	function hasNoAlphabets(expectedAlphabetString) {
	  return expectedAlphabetString && expectedAlphabetString.length > 0;
	}
	
	function isPeriodInPeriodOptions(periodOptions, selectedOption) {
	  return periodOptions.indexOf(selectedOption) > -1;
	}
	
	function validateOffer(offer) {
	  var error = {};
	
	  if (!isAllNumeric(offer.offInvoiceDiscount)) error.offInvoiceDiscount = 'The Off Invoice Discount Amount can only be numeric and non empty.';
	  if (!isAllNumeric(offer.scanBackDiscount)) error.scanBackDiscount = 'The Scan Back Discount Amount can only be numeric and non empty.';
	  if (!isAllNumeric(offer.suggestedRetailSavings)) error.suggestedRetailSavings = 'The Suggested Retail Savings can only be numeric and non empty.';
	  if (!isPeriodInPeriodOptions(periodOptions, offer.period)) error.periodOptions = 'You can only choose between "LAST TWO WEEKS" or "FIRST TWO WEEKS" for editing a period.';
	  if (!hasNoAlphabets(offer.offerName)) error.offerName = 'Offer name must not be empty.';
	  return (0, _keys2.default)(error).length > 0 ? error : false;
	}
	
	function validate(offers) {
	  var errorsInOffers = offers.map(validateOffer);
	  var errorCount = 0;
	  for (var offerIndex = 0; offerIndex < errorsInOffers.length; offerIndex++) {
	    if (errorsInOffers[offerIndex]) errorCount = errorCount + 1;
	  }
	  return errorCount === 0 ? false : errorsInOffers;
	}

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.randomColour = randomColour;
	function randomColour() {
	  var colour = {
	    r: 0,
	    g: 0,
	    b: 0
	  };
	
	  for (var component in colour) {
	    colour[component] = randomNumber(240);
	  }
	
	  return colour;
	}
	
	function randomNumber(upperLimit) {
	  return Math.floor(Math.random() * upperLimit) + 1;
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parse = __webpack_require__(304);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ParseHelper = {};
	_parse2.default.CoreManager.set('REQUEST_ATTEMPT_LIMIT', 1);
	ParseHelper.install = function (Vue, options) {
	  _parse2.default.initialize(options.appId);
	  _parse2.default.serverURL = options.url;
	
	  Vue.prototype.$parse = function () {
	    return _parse2.default;
	  };
	};
	
	exports.default = ParseHelper;

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dotty = dotty;
	function dotty(str, len) {
	  if (typeof str !== 'string') return str;
	  if (str.length < len) return str;
	  return str.substring(0, len) + '...';
	}

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getContainerWidthFromText = getContainerWidthFromText;
	function getContainerWidthFromText(text, fontSize, padding) {
	  var span = document.createElement('span');
	  span.style.visiblity = 'hidden';
	  span.style.fontFamily = 'Roboto';
	  span.style.padding = padding || '0';
	  span.innerHTML = text;
	  span.style.fontSize = fontSize;
	  document.body.appendChild(span);
	  var width = span.offsetWidth * 2;
	  console.log(width);
	  document.body.removeChild(span);
	  return width;
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOM = undefined;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOM = exports.DOM = function () {
	  function DOM(el) {
	    (0, _classCallCheck3.default)(this, DOM);
	
	    this.$root = document.querySelector(el);
	  }
	
	  (0, _createClass3.default)(DOM, [{
	    key: 'create',
	    value: function create(el, id) {
	      el = document.createElement(el);
	      el.id = id;
	      return el;
	    }
	  }, {
	    key: 'style',
	    value: function style(el, styles) {
	      if (typeof el === 'string') {
	        el = this.find(el);
	      }
	      for (var style in styles) {
	        el.style[style] = styles[style];
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add(src, el) {
	      if (typeof src === 'string') {
	        this.find(src).appendChild(el);
	      } else {
	        src.appendChild(el);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(src, el) {
	      if (typeof src === 'string') {
	        this.find(src).removeChild(el);
	      } else {
	        src.removeChild(el);
	      }
	    }
	  }, {
	    key: 'find',
	    value: function find(queryStr) {
	      return document.querySelector(queryStr);
	    }
	  }, {
	    key: 'findAll',
	    value: function findAll(queryStr) {
	      return document.querySelectorAll(queryStr);
	    }
	  }, {
	    key: 'each',
	    value: function each(arrayLike, fn) {
	      for (var i = 0; i < arrayLike.length; i++) {
	        fn(arrayLike[i], i);
	      }
	    }
	  }, {
	    key: 'children',
	    value: function children(el) {
	      return typeof el === 'string' ? this.find(el).children : el.children;
	    }
	  }, {
	    key: 'attr',
	    value: function attr(el, name, value) {
	      el.setAttribute(name, value);
	    }
	  }, {
	    key: 'rect',
	    value: function rect(el) {
	      return el.getBoundingClientRect();
	    }
	  }]);
	  return DOM;
	}();

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tableStyles = exports.tableStyles = {
	  offersListHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.5rem',
	      'border-collapse': 'collapse',
	      'width': '100%',
	      'margin-left': '1.5rem'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'font-size': '1.3rem'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offersListDataStyle: {
	    tableStyle: {
	      'font-size': '1.5rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'font-size': '1.3rem'
	    },
	    editBoxWidthFull: {
	      'display': 'inline-block',
	      'width': '100%',
	      'border': 'none',
	      'height': '33px',
	      'padding-left': '1rem',
	      'padding-right': '1rem'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offerZoneListHeaderStyle: {
	    headerTableStyle: {
	      'font-size': '1.5rem',
	      'border-collapse': 'collapse',
	      'width': '100%',
	      'position': 'relative'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '0.8rem',
	      'background-color': 'rgb(246,246,230)',
	      'width': '25%',
	      'word-wrap': 'break-word',
	      'border': '1px solid #cecece'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'width': '100%'
	    },
	    thStyle: {
	      'border': '1px solid #cecece',
	      'width': '25%',
	      'word-wrap': 'break-word',
	      'padding': '1rem 1rem'
	    },
	    tableContainerStyle: {
	      'width': '100%'
	    },
	    editableLabel: {
	      'display': 'inline-block',
	      'width': '90%'
	    },
	    editableEditBox: {
	      'display': 'inline-block',
	      'cursor': 'pointer'
	    }
	  }
	};

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tableStyles = exports.tableStyles = {
	  'headerTableStyles': {
	    headerTableTdClasses: {
	      'primaryGreenBg': {
	        'primary-green-bg': true
	      },
	      'darkGreenBg': {
	        'dark-green-bg': true
	      }
	    },
	    headerTable: {
	      'border-collapse': 'collapse',
	      'font-size': '1.2rem',
	      'font-weight': 'normal',
	      'text-align': 'left'
	    },
	    tableStyle: {
	      'font-size': '1.5rem',
	      'border-collapse': 'collapse',
	      'width': '100%',
	      'margin-left': '1.5rem'
	    },
	    thStyle: {
	      'font-weight': 'normal',
	      'padding': '0.5rem 1rem',
	      'color': 'white',
	      'border-color': 'white'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '0.5rem 1rem',
	      'background-color': 'white',
	      'word-wrap': 'break-word'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    }
	  },
	  summaryTableStyles: {
	    tableStyle: {
	      'font-size': '1.2rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '0.5rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    }
	  },
	  detailsTableStyles: {
	    tableStyle: {
	      'font-size': '1.2rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '0.5rem 1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    editBoxWidthFull: {
	      'display': 'inline-block',
	      'width': '95%',
	      'height': '32px',
	      'padding-left': '1rem',
	      'padding-right': '1rem'
	    },
	    actualStyle: {
	      'color': 'black',
	      'padding': '0.5rem 1rem',
	      'background-color': 'white'
	    },
	    estimatedStyle: {
	      'color': '#00AF41',
	      'padding': '0.5rem 1rem',
	      'background-color': 'white'
	    }
	  }
	};

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tableStyles = exports.tableStyles = {
	  offersListFixedHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offersListFixedDataStyle: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    aStyle: {
	      'cursor': 'pointer'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offersListScrollableHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    }
	  },
	  offersListScrollableDataStyle: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    aStyle: {
	      'cursor': 'pointer'
	    }
	  }
	};

/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tableStyles = exports.tableStyles = {
	  offersListFixedHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offersListFixedDataStyle: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    aStyle: {
	      'cursor': 'pointer'
	    },
	    topHeaderStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(230, 232, 246)'
	    }
	  },
	  offersListScrollableHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    }
	  },
	  offersListScrollableDataStyle: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'white'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    },
	    aStyle: {
	      'cursor': 'pointer'
	    }
	  }
	};

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mockSelectedOffers = exports.mockSelectedOffers = {
	  data: [{
	    'offer_name': '$3 OFF XYZ DOG FOOD',
	    'items': '3',
	    'avg_sales_per_store_week': 34,
	    'print': 'N/A',
	    'display': 'N/A',
	    'est_sales_qty_during_promo_lift': '685 (34%)',
	    'est_sales_dollars_during_promo': '$3700',
	    'est_retail_savings_during_promo': '$1234',
	    'est_psp_funding': '25',
	    'est_vendor_funding': '$1445 (51%)',
	    'total_est_unit_sales_lift': '12-22.3%',
	    'total_est_margin_gain': '1456',
	    'total_est_margin_lift': '23%',
	    'est_direct_lift': '21%',
	    'est_halo_lift': '1%',
	    'est_affinity_pull_lift': '1%',
	    'est_cannibalization_loss': '0%',
	    'est_pull_forward_loss': '0%'
	  }, {
	    'offer_name': '$3 OFF XYZ DOG FOOD',
	    'items': '3',
	    'avg_sales_per_store_week': 34,
	    'print': 'N/A',
	    'display': 'N/A',
	    'est_sales_qty_during_promo_lift': '685 (34%)',
	    'est_sales_dollars_during_promo': '$3700',
	    'est_retail_savings_during_promo': '$1234',
	    'est_psp_funding': '25',
	    'est_vendor_funding': '$1445 (51%)',
	    'total_est_unit_sales_lift': '12-22.3%',
	    'total_est_margin_gain': '1456',
	    'total_est_margin_lift': '23%',
	    'est_direct_lift': '21%',
	    'est_halo_lift': '1%',
	    'est_affinity_pull_lift': '1%',
	    'est_cannibalization_loss': '0%',
	    'est_pull_forward_loss': '0%'
	  }, {
	    'offer_name': '$3 OFF XYZ DOG FOOD',
	    'items': '3',
	    'avg_sales_per_store_week': 34,
	    'print': 'N/A',
	    'display': 'N/A',
	    'est_sales_qty_during_promo_lift': '685 (34%)',
	    'est_sales_dollars_during_promo': '$3700',
	    'est_retail_savings_during_promo': '$1234',
	    'est_psp_funding': '25',
	    'est_vendor_funding': '$1445 (51%)',
	    'total_est_unit_sales_lift': '12-22.3%',
	    'total_est_margin_gain': '1456',
	    'total_est_margin_lift': '23%',
	    'est_direct_lift': '21%',
	    'est_halo_lift': '1%',
	    'est_affinity_pull_lift': '1%',
	    'est_cannibalization_loss': '0%',
	    'est_pull_forward_loss': '0%'
	  }, {
	    'offer_name': '$4 OFF XYZ CAT FOOD',
	    'items': '5',
	    'avg_sales_per_store_week': 23,
	    'print': 'N/A',
	    'display': 'N/A',
	    'est_sales_qty_during_promo_lift': '456 (34%)',
	    'est_sales_dollars_during_promo': '$3700',
	    'est_retail_savings_during_promo': '$876',
	    'est_psp_funding': '25',
	    'est_vendor_funding': '$1165 (52%)',
	    'total_est_unit_sales_lift': '23-45%',
	    'total_est_margin_gain': '876',
	    'total_est_margin_lift': '22%',
	    'est_direct_lift': '19%',
	    'est_halo_lift': '3%',
	    'est_affinity_pull_lift': '1%',
	    'est_cannibalization_loss': '-1%',
	    'est_pull_forward_loss': '0%'
	  }, {
	    'offer_name': '$5 OFF XYZ DOG FOOD',
	    'items': '7',
	    'avg_sales_per_store_week': 13,
	    'print': 'N/A',
	    'display': 'N/A',
	    'est_sales_qty_during_promo_lift': '786 (43%)',
	    'est_sales_dollars_during_promo': '$4000',
	    'est_retail_savings_during_promo': '$1097',
	    'est_psp_funding': '25',
	    'est_vendor_funding': '$1534 (53%)',
	    'total_est_unit_sales_lift': '45-56.7%',
	    'total_est_margin_gain': '-98',
	    'total_est_margin_lift': '19%',
	    'est_direct_lift': '16%',
	    'est_halo_lift': '4%',
	    'est_affinity_pull_lift': '1%',
	    'est_cannibalization_loss': '-2%',
	    'est_pull_forward_loss': '0%'
	  }]
	};

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var selectedOffersSchema = exports.selectedOffersSchema = {
	  'offer_name': {
	    name: 'Offer Name',
	    type: 'string',
	    fn: []
	  },
	  'items': {
	    name: 'Items',
	    type: 'string',
	    fn: []
	  },
	  'avg_sales_per_store_week': {
	    name: 'AVERAGE SALES PER STORE PER WEEK ($)',
	    type: 'number',
	    fn: ['formatAsMoney']
	  },
	  'print': {
	    name: 'PRINT',
	    type: 'string',
	    fn: []
	  },
	  'display': {
	    name: 'DISPLAY',
	    type: 'string',
	    fn: []
	  },
	  'est_sales_qty_during_promo_lift': {
	    name: 'Estimated SALES QTY DURING PROMO AND (LIFT %)',
	    type: 'string',
	    fn: []
	  },
	  'est_sales_dollars_during_promo': {
	    name: 'Estimated SALES $ DURING PROMO',
	    type: 'number',
	    fn: ['formatAsMoney']
	  },
	  'est_retail_savings_during_promo': {
	    name: 'Estimated RETAIL SAVINGS $ DURING PROMO',
	    type: 'number',
	    fn: ['formatAsMoney']
	  },
	  'est_psp_funding': {
	    name: 'Estimated PSP FUNDING $ (%)',
	    type: 'number',
	    fn: ['formatAsMoney']
	  },
	  'est_vendor_funding': {
	    name: 'Estimated VENDOR FUNDING $ (%)',
	    type: 'number',
	    fn: ['formatAsMoney']
	  },
	  'total_est_unit_sales_lift': {
	    name: 'TOTAL Estimated Unit Sales lift required for margin neutrality (POS)',
	    type: 'string',
	    fn: ['formatAsPercentage']
	  },
	  'total_est_margin_gain': {
	    name: 'TOTAL Estimated MARGIN $ GAIN (POS)',
	    type: 'number',
	    fn: ['formatAsMoney']
	  },
	  'total_est_margin_lift': {
	    name: 'TOTAL Estimated MARGIN LIFT (POS)',
	    type: 'number',
	    fn: ['formatAsPercentage']
	  },
	  'est_direct_lift': {
	    name: 'Estimated DIRECT LIFT (POS)',
	    type: 'number',
	    fn: ['formatAsPercentage']
	  },
	  'est_halo_lift': {
	    name: 'Estimated HALO LIFT (POS)',
	    type: 'number',
	    fn: ['formatAsPercentage']
	  },
	  'est_affinity_pull_lift': {
	    name: 'Estimated AFFINITY PULL LIFT (POS)',
	    type: 'number',
	    fn: ['formatAsPercentage']
	  },
	  'est_cannibalization_loss': {
	    name: 'Estimated CANNIBALIZATION LOSS (POS)',
	    type: 'number',
	    fn: ['formatAsPercentage']
	  },
	  'est_pull_forward_loss': {
	    name: 'Estimated PULL-FORWARD LOSS (POS)',
	    type: 'number',
	    fn: ['formatAsPercentage']
	  }
	};

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tableStyles = exports.tableStyles = {
	  offersListHeaderStyles: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%',
	      'position': 'relative'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'rgb(246,246,230)'
	    },
	    trStyle: {
	      'border': '1px solid #cecece'
	    }
	  },
	  offersListDataStyle: {
	    tableStyle: {
	      'font-size': '1.3rem',
	      'border-collapse': 'collapse',
	      'width': '100%'
	    },
	    tdStyle: {
	      'font-weight': 'normal',
	      'padding': '1rem 1rem',
	      'background-color': 'transparent'
	    },
	    trStyle: {
	      'border': '1px solid #cecece',
	      'background-color': 'transparent'
	    },
	    aStyle: {
	      'cursor': 'pointer'
	    },
	    aActualStyle: {
	      'cursor': 'pointer',
	      'color': 'black'
	    }
	  }
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.uploadedOffersResponseHelper = uploadedOffersResponseHelper;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseObjectToArray(viewMap, filterArray, object) {
	  var finalArray = new Array((0, _keys2.default)(viewMap).length);
	  (0, _keys2.default)(object).forEach(function (key) {
	    finalArray[viewMap[key]] = object[key];
	    if (object[key] !== undefined && object[key].length > 0 && filterArray !== undefined && filterArray.indexOf(key) > -1) {
	      finalArray[key] = object[key];
	    }
	  });
	  return finalArray;
	}
	
	function uploadedOffersResponseHelper(responseArray, viewMap, filterArray) {
	  return responseArray.map(parseObjectToArray.bind(null, viewMap, filterArray));
	}

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(102);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(105);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.uploadedOffersResponseHelper = uploadedOffersResponseHelper;
	exports.objectMapper = objectMapper;
	exports.serverJsonToViewJson = serverJsonToViewJson;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseObjectToArray(viewMap, filterArray, object) {
	  var finalArray = new Array((0, _keys2.default)(viewMap).length);
	  (0, _keys2.default)(object).forEach(function (key) {
	    finalArray[viewMap[key]] = object[key];
	    if (object[key] !== undefined && object[key].length > 0 && filterArray !== undefined && filterArray.indexOf(key) > -1) {
	      finalArray[key] = object[key];
	    }
	  });
	  return finalArray;
	}
	
	function uploadedOffersResponseHelper(responseArray, viewMap, filterArray) {
	  return responseArray.map(parseObjectToArray.bind(null, viewMap, filterArray));
	}
	
	function removeParseDefaults(object) {
	  if (object) {
	    delete object.createdAt;
	    delete object.updatedAt;
	    delete object.objectId;
	    delete object.user;
	  }
	  return object;
	}
	
	function objectMapper(jsonArray, viewMap) {
	  var arrayOfObjects = [];
	  jsonArray.forEach(function (data) {
	    removeParseDefaults(data);
	    var replacedKeyObject = _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)((0, _keys2.default)(data).map(function (key) {
	      var mappedKey = getViewMapKey(key, viewMap);
	      if (mappedKey) {
	        return (0, _defineProperty3.default)({}, mappedKey, data[key] === undefined || data[key].length === 0 ? '' : data[key]);
	      }
	    }))));
	    arrayOfObjects.push(replacedKeyObject);
	  });
	  return arrayOfObjects;
	}
	
	function serverJsonToViewJson(serverJson, viewJson) {
	  var replacedKeyObject = _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)((0, _keys2.default)(serverJson).map(function (key) {
	    var mappedKey = getViewMapKey(key, viewJson);
	    if (mappedKey) {
	      return (0, _defineProperty3.default)({}, mappedKey, serverJson[key] === undefined || serverJson[key].length === 0 ? '' : serverJson[key]);
	    }
	  }))));
	  return replacedKeyObject;
	}
	
	function getViewMapKey(inputKey, viewMap) {
	  return viewMap[inputKey];
	}

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mouseEventTrigger = mouseEventTrigger;
	function mouseEventTrigger(element, type) {
	  try {
	    var click = new MouseEvent(type, {
	      'view': window,
	      'bubbles': false,
	      'cancelable': true
	    });
	
	    element.dispatchEvent(click);
	  } catch (e) {
	    var _click = document.createEvent('MouseEvent');
	    _click.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	    element.dispatchEvent(_click);
	  }
	}

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.simulateClick = simulateClick;
	function simulateClick(arg) {
	  var btn = document.createElement('a');
	  btn.style.display = 'none';
	  btn.href = arg;
	  document.body.appendChild(btn);
	  btn.click();
	  document.body.removeChild(btn);
	}

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _Login = __webpack_require__(338);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Navbar = __webpack_require__(339);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Profile = __webpack_require__(346);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _SelectedOffersList = __webpack_require__(347);
	
	var _SelectedOffersList2 = _interopRequireDefault(_SelectedOffersList);
	
	var _OffersComponent = __webpack_require__(341);
	
	var _OffersComponent2 = _interopRequireDefault(_OffersComponent);
	
	var _PendingApproval = __webpack_require__(343);
	
	var _PendingApproval2 = _interopRequireDefault(_PendingApproval);
	
	var _PastApproval = __webpack_require__(342);
	
	var _PastApproval2 = _interopRequireDefault(_PastApproval);
	
	var _GraphSimulationNavBar = __webpack_require__(331);
	
	var _GraphSimulationNavBar2 = _interopRequireDefault(_GraphSimulationNavBar);
	
	var _Waterfall = __webpack_require__(334);
	
	var _Waterfall2 = _interopRequireDefault(_Waterfall);
	
	var _Simulation = __webpack_require__(333);
	
	var _Simulation2 = _interopRequireDefault(_Simulation);
	
	var _PastTrends = __webpack_require__(332);
	
	var _PastTrends2 = _interopRequireDefault(_PastTrends);
	
	var _FileUpload = __webpack_require__(336);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = exports.routes = [{
	  path: '',
	  name: 'login',
	  component: _Login2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    if (JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser'))) {
	      next({ name: 'PendingApproval' });
	    } else {
	      next();
	    }
	  }
	}, {
	  path: '/',
	  component: _Navbar2.default,
	  children: [{ name: 'profile', path: '/profile', component: _Profile2.default }, { name: 'selectPendingOffers', path: '/pending-offers/offer-select', component: _OffersComponent2.default }, { name: 'selectPastOffers', path: '/past-offers/offer-select', component: _OffersComponent2.default }, { name: 'selectedPendingOffers', path: '/pending-offers/selected-offers', component: _SelectedOffersList2.default }, { name: 'selectedPastOffers', path: '/past-offers/selected-offers', component: _SelectedOffersList2.default }, { name: 'PendingApproval', path: '/pending-offers', component: _PendingApproval2.default }, { name: 'PastOffers', path: '/past-offers', component: _PastApproval2.default }, { name: 'FileUpload', path: '/file-upload', component: _FileUpload2.default }, { name: 'PastOffersSpecific', path: '/past-offers/:collection_id/:offer_id', component: _OffersComponent2.default }, { name: 'graph-simulation-navbar',
	    path: '/chart-graph-simulation',
	    component: _GraphSimulationNavBar2.default,
	    children: [{ path: 'past-trends', component: _PastTrends2.default, name: 'past-trends' }, { path: 'waterfall', component: _Waterfall2.default, name: 'waterfall' }, { path: 'simulation', component: _Simulation2.default, name: 'simulation' }]
	  }]
	}];

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _flexTables = __webpack_require__(50);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.APPROVE_WITH_CHANGES_OLD, {
	  data: []
	}), (0, _defineProperty3.default)(_state, NameSpace.APPROVE_WITH_CHANGES, {
	  headers: [],
	  data: [],
	  success: false,
	  error: null,
	  showAgain: null,
	  itemRemoved: false
	}), (0, _defineProperty3.default)(_state, NameSpace.APPROVE_WITH_CHANGES_RESULT, {
	  result: null,
	  success: false
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_APPROVE_WITH_CHANGES_OLD, function (state) {
	  return state[NameSpace.APPROVE_WITH_CHANGES_OLD];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_APPROVE_WITH_CHANGES, function (state) {
	  return state[NameSpace.APPROVE_WITH_CHANGES];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_APPROVE_WITH_CHANGES_RESULT, function (state) {
	  return state[NameSpace.APPROVE_WITH_CHANGES_RESULT];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_APPROVE_WITH_CHANGES_OLD, function (state, payload) {
	  state[NameSpace.APPROVE_WITH_CHANGES_OLD] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_APPROVE_WITH_CHANGES, function (state, payload) {
	  state[NameSpace.APPROVE_WITH_CHANGES] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, function (state, payload) {
	  state[NameSpace.APPROVE_WITH_CHANGES_RESULT] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.FETCH_APPROVE_WITH_CHANGES, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.getEditOfferItems(payload).then(function (offers) {
	    var result = getUpApproveWithChanges(offers);
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, result);
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_OLD, (0, _lodash.cloneDeep)(result.data));
	  }).catch(function (error) {
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, {
	      headers: [],
	      data: [],
	      success: false,
	      error: error,
	      showAgain: true,
	      itemRemoved: false
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.SUBMIT_OFFER_LOCK, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  _parse.ParseService.approveWithChanges(payload).then(function (result) {
	    var hasWarning = false;
	    if (result && result.warnings && result.warnings.length) {
	      hasWarning = true;
	    }
	    if (hasWarning) {
	      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, { result: setUpZonePriceData(result), success: true, error: result.warnings });
	    } else {
	      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, { result: setUpZonePriceData(result), success: true });
	    }
	  }).catch(function (error) {
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, {
	      result: {
	        headers: [],
	        data: [],
	        success: false,
	        error: error,
	        showAgain: true
	      },
	      success: false
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_REMOVE_ITEM_BY_ID, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  _parse.ParseService.removeItemById(payload).then(function (offers) {
	    var result = getUpApproveWithChanges(offers);
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, result);
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_OLD, (0, _lodash.cloneDeep)(result.data));
	  }).catch(function (error) {
	    console.log('ERROR:::', error);
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, {
	      headers: [],
	      data: [],
	      success: false,
	      error: error,
	      showAgain: true,
	      itemRemoved: false
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.HARD_RESET_APPROVE_WITH_CHANGES, function (_ref4, payload) {
	  var commit = _ref4.commit;
	
	  if (payload) {
	    var stateObject = state[NameSpace.APPROVE_WITH_CHANGES];
	    stateObject.data = payload;
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, stateObject);
	  } else {
	    commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, {
	      headers: [],
	      data: [],
	      success: false,
	      error: null,
	      showAgain: null,
	      itemRemoved: false
	    });
	  }
	}), _actions);
	
	function getUpApproveWithChanges(offers) {
	  var copyData = (0, _lodash.cloneDeep)(offers);
	  var header = copyData.header,
	      data = copyData.data;
	
	  var items = data.items;
	  if (items.length === 0) {
	    var result = {
	      headers: [],
	      data: null,
	      success: false,
	      error: null,
	      showAgain: null,
	      itemRemoved: false
	    };
	    return result;
	  } else {
	    var tableInstance = new _flexTables.FlexTable(header, items, 1);
	    var toDeleteHeaders = tableInstance.getLinkableHeaders(header, 'delete');
	    toDeleteHeaders.forEach(function (field) {
	      delete header[field];
	    });
	    var tableHeaders = tableInstance.getObjectTableHeaders(header);
	    var tableHeaderString = tableInstance.getStringTableHeaders(header);
	    var editableHeaders = tableInstance.getIndexforFillteredTableHeaders(header, 'makeEditable');
	    var tableData = tableInstance.getCellDataAsObject(tableHeaderString, items, 'makeEditable', 'approve_with_changes', 100, editableHeaders);
	    for (var i = 0; i < items.length; i++) {
	      tableData[i]['itemId'] = items[i].itemId;
	      var itemObject = tableData[i][0];
	      for (var c = 0; c < tableData[i].length; c++) {
	        var record = tableData[i][c];
	        if (record.editable) {
	          record.clickAway = true;
	        }
	      }
	      itemObject.arrow_for_close = true;
	      itemObject.itemIndex = i;
	    }
	    tableData[tableData.length - 1].forEach(function (record) {
	      if (record.editable) {
	        record.clickAway = true;
	      }
	    });
	    var _result = {
	      headers: tableHeaders,
	      data: tableData,
	      success: true,
	      error: null,
	      itemRemoved: data.itemRemoved
	    };
	    return _result;
	  }
	}
	
	function setUpZonePriceData(approveResult) {
	  var tableInstance = new _flexTables.FlexTable(approveResult.header, approveResult.data, 0);
	  var resultHeader = tableInstance.getObjectTableHeaders(approveResult.header, 'Zone Id');
	  var tableHeadersString = tableInstance.getStringTableHeaders(approveResult.header);
	  var editableHeader = tableInstance.getIndexforFillteredTableHeaders(approveResult.header, 'makeEditable');
	  var tableData = tableInstance.getCellDataAsObject(tableHeadersString, approveResult.data, 'makeEditable', 'set_zone', 100, editableHeader);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var array = _step.value;
	
	      array.splice(0, 1);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var result = {
	    headers: resultHeader,
	    data: tableData,
	    success: true,
	    error: null,
	    showAgain: true,
	    itemRemoved: false
	  };
	  return result;
	}
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _flexTables = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.BAR_CHART, {
	  chart: null,
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.LIFT_SIMULATION, {
	  graphFilterMap: null,
	  headers: [],
	  originalTableHeader: null,
	  data: [],
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.WATERFALL_DATA, {
	  data: {
	    graphData: null,
	    labels: null,
	    colors: null
	  },
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.CALCULATION_FIELDS, {
	  data: null,
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.SIMULATION_CHANGES, {
	  isSuccess: false
	}), _state);
	
	var toolTipStyle = 'style="width: 150px; padding: 5px; font-size: 1.2rem;"';
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_CALCULATION_FIELDS, function (state) {
	  return state[NameSpace.CALCULATION_FIELDS];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SIMULATION_CHANGES, function (state) {
	  return state[NameSpace.SIMULATION_CHANGES];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_BAR_CHART, function (state) {
	  return transform(state[NameSpace.BAR_CHART]);
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_BAR_CHART_LEGENDS, function (state) {
	  var stateObj = state[NameSpace.BAR_CHART];
	  if (stateObj.chart) {
	    var header = stateObj.chart.header;
	
	    return header;
	  } else {
	    return [];
	  }
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_LIFT_SIMULATION, function (state) {
	  return state[NameSpace.LIFT_SIMULATION];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_LINE_CHART_RADIO, function (state) {
	  var graphRadio = state[NameSpace.LIFT_SIMULATION].graphFilterMap;
	  if (graphRadio) {
	    return graphRadio;
	  }
	  return null;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_WATERFALL_DATA, function (state) {
	  return state[NameSpace.WATERFALL_DATA];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_BAR_CHART, function (state, payload) {
	  state[NameSpace.BAR_CHART] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_LIFT_SIMULATION, function (state, payload) {
	  state[NameSpace.LIFT_SIMULATION] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_WATERFALL_DATA, function (state, payload) {
	  state[NameSpace.WATERFALL_DATA] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_CALCULATION_FIELDS, function (state, payload) {
	  state[NameSpace.CALCULATION_FIELDS] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SIMULATION_CHANGES, function (state, payload) {
	  state[NameSpace.SIMULATION_CHANGES] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.FETCH_CALCULATION_FIELDS, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.refreshLiftChanges(payload).then(function (data) {
	    console.log(data);
	    if (data) {
	      commit(NameSpace.MUTATE_CALCULATION_FIELDS, {
	        data: data,
	        error: null
	      });
	    }
	  }).catch(function (error) {
	    console.log('In chart js:', error);
	    commit(NameSpace.MUTATE_CALCULATION_FIELDS, {
	      data: null,
	      error: error
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_BAR_CHART, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  _parse.ParseService.getGraphData(payload).then(function (data) {
	    if (data) {
	      commit(NameSpace.MUTATE_BAR_CHART, {
	        chart: data,
	        error: null
	      });
	    } else {
	      commit(NameSpace.MUTATE_BAR_CHART, {
	        chart: null,
	        error: null
	      });
	    }
	  }).catch(function (error) {
	    console.log('In chart js:', error);
	    commit(NameSpace.MUTATE_BAR_CHART, {
	      chart: null,
	      error: error
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_LIFT_SIMULATION, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  resetGetLiftSimulationData(commit);
	  _parse.ParseService.getLiftSimulation(payload).then(function (simulate) {
	    if (simulate) {
	      var header = simulate.header,
	          data = simulate.data;
	
	      var tableInstance = new _flexTables.FlexTable(header, data, 1);
	      var tableHeaders = tableInstance.getObjectTableHeaders(header);
	
	      commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	        graphFilterMap: data.graphFilterMap,
	        headers: tableHeaders,
	        originalTableHeader: header,
	        data: data,
	        error: null
	      });
	    } else {
	      commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	        graphFilterMap: null,
	        headers: [],
	        originalTableHeader: null,
	        data: [],
	        error: null
	      });
	    }
	  }).catch(function (error) {
	    console.log('In FETCH_LIFT_SIMULATION:', error);
	    commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	      graphFilterMap: null,
	      headers: [],
	      originalTableHeader: null,
	      data: [],
	      error: error
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_WATERFALL_DATA, function (_ref4, payload) {
	  var commit = _ref4.commit;
	
	  resetWaterfallData(commit);
	  _parse.ParseService.getWaterFallData(payload).then(function (waterfall) {
	    if (waterfall) {
	      var graphData = waterfall.graphData,
	          labels = waterfall.labels,
	          colors = waterfall.colors;
	
	
	      commit(NameSpace.MUTATE_WATERFALL_DATA, {
	        data: {
	          graphData: graphData,
	          labels: labels,
	          colors: colors
	        },
	        error: null
	      });
	    } else {
	      commit(NameSpace.MUTATE_WATERFALL_DATA, {
	        data: {
	          graphData: null,
	          labels: null,
	          colors: null
	        },
	        error: 'No Data Found'
	      });
	    }
	  }).catch(function (error) {
	    console.log('In FETCH WATERFALL DATA:', error);
	    commit(NameSpace.MUTATE_WATERFALL_DATA, {
	      data: {
	        graphData: null,
	        labels: null,
	        colors: null
	      },
	      error: error
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.POST_SIMULATION_CHANGES, function (_ref5, payload) {
	  var commit = _ref5.commit;
	
	  commit(NameSpace.MUTATE_SIMULATION_CHANGES, false);
	  _parse.ParseService.applySimulationDecision(payload).then(function (simulate) {
	    if (simulate) {
	      console.log(simulate);
	      var hasWarning = false;
	      var header = simulate.header,
	          data = simulate.data;
	
	      var tableInstance = new _flexTables.FlexTable(header, data, 1);
	      var tableHeaders = tableInstance.getObjectTableHeaders(header);
	      if (simulate.warnings && simulate.warnings.length) {
	        hasWarning = true;
	      }
	      if (hasWarning) {
	        commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	          graphFilterMap: data.graphFilterMap,
	          headers: tableHeaders,
	          originalTableHeader: header,
	          data: data,
	          warnings: simulate.warnings,
	          error: null
	        });
	      } else {
	        commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	          graphFilterMap: data.graphFilterMap,
	          headers: tableHeaders,
	          originalTableHeader: header,
	          data: data,
	          error: null
	        });
	      }
	      commit(NameSpace.MUTATE_SIMULATION_CHANGES, { isSuccess: true });
	    } else {
	      commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	        graphFilterMap: null,
	        headers: [],
	        originalTableHeader: null,
	        data: [],
	        error: null
	      });
	    }
	  }).catch(function (error) {
	    console.log('In FETCH_LIFT_SIMULATION:', error);
	    commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	      graphFilterMap: null,
	      headers: [],
	      originalTableHeader: null,
	      data: [],
	      error: error
	    });
	  });
	}), _actions);
	
	function resetGetLiftSimulationData(commit) {
	  commit(NameSpace.MUTATE_LIFT_SIMULATION, {
	    graphFilterMap: null,
	    headers: [],
	    originalTableHeader: null,
	    data: [],
	    error: null
	  });
	}
	
	function resetWaterfallData(commit) {
	  commit(NameSpace.MUTATE_WATERFALL_DATA, {
	    data: {
	      graphData: null,
	      labels: null,
	      colors: null
	    },
	    error: null
	  });
	}
	
	function transform(data) {
	  if (data) {
	    var chart = data.chart;
	
	    if (chart && chart.header && chart.graphData) {
	      var header = chart.header;
	      var graphData = chart.graphData;
	      return graphData.map(function (obj) {
	        var inColor = obj.colorCode;
	        var outColor = header[inColor.toString()].color;
	        var annotate = '';
	        if (obj.quantity_per_week >= 0) {
	          annotate = obj.quantity_per_week;
	        }
	        return [obj.date, obj.quantity_per_week, outColor, annotate.toString(), getToolTipData(obj, chart.labels, chart.onHover)];
	      });
	    }
	  }
	}
	
	function getToolTipData(obj, labels, onHover) {
	  var finalToolTip = '';
	  onHover.map(function (item) {
	    finalToolTip = finalToolTip.concat('<div ' + toolTipStyle + '>' + labels[item] + ' : ' + (!obj[item] ? 'N/A' : obj[item]) + '</div>');
	    return finalToolTip;
	  });
	  return finalToolTip;
	}
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.SELECTED_DEPARTMENT, {
	  department: null
	}), (0, _defineProperty3.default)(_state, NameSpace.SELECTED_SUB_DEPARTMENT, {
	  sub_department: null
	}), (0, _defineProperty3.default)(_state, NameSpace.SELECTED_CLASS, {
	  class: null
	}), (0, _defineProperty3.default)(_state, NameSpace.SELECTED_SUB_CLASS, {
	  sub_class: null
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_DEPARTMENT, function (state) {
	  return state[NameSpace.SELECTED_DEPARTMENT];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_SUB_DEPARTMENT, function (state) {
	  return state[NameSpace.SELECTED_SUB_DEPARTMENT];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_CLASS, function (state) {
	  return state[NameSpace.SELECTED_CLASS];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_SUB_CLASS, function (state) {
	  return state[NameSpace.SELECTED_SUB_CLASS];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_DEPARTMENT, function (state, payload) {
	  state[NameSpace.SELECTED_DEPARTMENT] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_SUB_DEPARTMENT, function (state, payload) {
	  state[NameSpace.SELECTED_SUB_DEPARTMENT] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_CLASS, function (state, payload) {
	  state[NameSpace.SELECTED_CLASS] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_SUB_CLASS, function (state, payload) {
	  state[NameSpace.SELECTED_SUB_CLASS] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.SET_SELECTED_DEPARTMENT, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_DEPARTMENT, { department: payload });
	}), (0, _defineProperty3.default)(_actions, NameSpace.SET_SELECTED_SUB_DEPARTMENT, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_SUB_DEPARTMENT, { sub_department: payload });
	}), (0, _defineProperty3.default)(_actions, NameSpace.SET_SELECTED_CLASS, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_CLASS, { class: payload });
	}), (0, _defineProperty3.default)(_actions, NameSpace.SET_SELECTED_SUB_CLASS, function (_ref4, payload) {
	  var commit = _ref4.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_SUB_CLASS, { sub_class: payload });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _defineProperty3.default)({}, NameSpace.UPLOAD_FILE, {
	  mistake: [],
	  error: true,
	  success: null
	});
	
	var getters = (0, _defineProperty3.default)({}, NameSpace.GETTER_UPLOAD_FILE_RESPONSE, function (state) {
	  return state[NameSpace.UPLOAD_FILE];
	});
	
	var mutations = (0, _defineProperty3.default)({}, NameSpace.UPLOAD_FILE_RESPONSE, function (state, payload) {
	  state[NameSpace.UPLOAD_FILE] = payload;
	});
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ACTION_UPLOAD_FILE, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.fileUpload(payload).then(function (offer) {
	    if (Array.isArray(offer)) {
	      commit(NameSpace.UPLOAD_FILE_RESPONSE, { mistake: getMistakes(offer), error: getMistakes(offer).length > 0 });
	    } else {
	      commit(NameSpace.UPLOAD_FILE_RESPONSE, {
	        mistake: [],
	        error: null,
	        success: offer
	      });
	    }
	  }).catch(function (error) {
	    if (Array.isArray(error)) {
	      var errorResponse = getMistakes(error);
	      commit(NameSpace.UPLOAD_FILE_RESPONSE, { mistake: errorResponse, error: errorResponse.length > 0 });
	    } else {
	      commit(NameSpace.UPLOAD_FILE_RESPONSE, { mistake: [], error: error });
	    }
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_RESET_UPLOAD_FILE, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.UPLOAD_FILE_RESPONSE, {
	    mistake: [],
	    error: null,
	    success: null
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_MISTAKES_IN_UPLOAD_FILE, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  commit(NameSpace.UPLOAD_FILE_RESPONSE, payload);
	}), _actions);
	
	function getMistakes(data) {
	  var mistakes = [];
	  data.forEach(function (value) {
	    if (value.error !== undefined || value.warnings !== undefined) {
	      var mistakeObject = {};
	      if (value.error !== undefined) {
	        mistakeObject.error = value.error;
	      }
	
	      if (value.warnings !== undefined) {
	        mistakeObject.warn = value.warnings;
	      }
	      mistakes.push({ 'UPC': value.upc || value.UPC, 'mistakes': mistakeObject });
	    }
	  });
	  return mistakes;
	}
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  getters: getters,
	  actions: actions
	};

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _flexTables = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.STATE_GOALS_AND_DISPLAY, {
	  value: [],
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.STATE_APPROVE_OFFER_SUCCESS, {
	  result: null,
	  success: false
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_GOALS_AND_DISPLAY, function (state) {
	  return state[NameSpace.STATE_GOALS_AND_DISPLAY];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_APPROVE_OFFER_SUCCESS, function (state) {
	  return state[NameSpace.STATE_APPROVE_OFFER_SUCCESS];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_GOALS_AND_DISPLAY, function (state, payload) {
	  state[NameSpace.STATE_GOALS_AND_DISPLAY] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, function (state, payload) {
	  state[NameSpace.STATE_APPROVE_OFFER_SUCCESS] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ACTION_GOALS_AND_DISPLAY, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.getApproveOffers(payload).then(function (goalsAndDisplay) {
	    console.log(goalsAndDisplay);
	
	    if (goalsAndDisplay) {
	      commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, { value: goalsAndDisplay, error: null });
	    } else {
	      commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, { value: [], error: null });
	    }
	  }).catch(function (error) {
	    console.log('In goalsAndDisplay js getApproveOffers:', error);
	    commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, { value: [], error: error });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_APPROVE_OFFER, function (_ref2, payload) {
	  var commit = _ref2.commit,
	      state = _ref2.state;
	
	  _parse.ParseService.approveOffer(payload).then(function (approveOffersResult) {
	    if (approveOffersResult) {
	      commit(NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, { result: setUpZonePriceData(approveOffersResult), success: true });
	    } else {
	      commit(NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, { result: approveOffersResult, success: false });
	    }
	  }).catch(function (error) {
	    console.log('In goalsAndDisplay js approveOffer:', error);
	    commit(NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, {
	      result: (typeof err === 'undefined' ? 'undefined' : (0, _typeof3.default)(err)) === 'object' ? error.message : error,
	      success: false
	    });
	    setTimeout(function () {
	      commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, {
	        result: null,
	        success: false
	      });
	    }, 0);
	  });
	}), _actions);
	
	function setUpZonePriceData(approveResult) {
	  var tableInstance = new _flexTables.FlexTable(approveResult.header, approveResult.data, 0);
	  var resultHeader = tableInstance.getObjectTableHeaders(approveResult.header, 'Zone Id');
	  var tableHeadersString = tableInstance.getStringTableHeaders(approveResult.header);
	  var editableHeader = tableInstance.getIndexforFillteredTableHeaders(approveResult.header, 'makeEditable');
	  var tableData = tableInstance.getCellDataAsObject(tableHeadersString, approveResult.data, 'makeEditable', 'set_zone', 100, editableHeader);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var array = _step.value;
	
	      array.splice(0, 1);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  var result = {
	    headers: resultHeader,
	    data: tableData,
	    success: true,
	    error: null,
	    showAgain: true
	  };
	  return result;
	}
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.LANDING_DATA, {
	  data: {
	    departments: [],
	    brands: [],
	    periods: [],
	    storeLevel: [],
	    offers: [],
	    subDepartments: [],
	    classes: [],
	    subClasses: [],
	    merchants: []
	  },
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.SELECTED_MERCHANT, null), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_LANDING_DATA, function (state) {
	  return state[NameSpace.LANDING_DATA];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_MERCHANT, function (state) {
	  return state[NameSpace.SELECTED_MERCHANT];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_LANDING_DATA, function (state, payload) {
	  state[NameSpace.LANDING_DATA] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_MERCHANT, function (state, payload) {
	  state[NameSpace.SELECTED_MERCHANT] = payload;
	}), _mutations);
	
	function getBrands(brands) {
	  (0, _keys2.default)(brands).forEach(function (key) {
	    brands[key].name = brands[key].brandName;
	    delete brands[key].brandName;
	  });
	  return brands;
	}
	
	function getDepartments(departments) {
	  return departments.map(function (e) {
	    return {
	      name: e.categoryName,
	      id: e.categoryId
	    };
	  });
	}
	
	function getSubDepartments(subDepartments) {
	  return subDepartments.map(function (e) {
	    return {
	      name: e.categoryName,
	      id: e.categoryId
	    };
	  });
	}
	
	function getClasses(classes) {
	  return classes.map(function (e) {
	    return {
	      name: e.categoryName,
	      id: e.categoryId
	    };
	  });
	}
	
	function getSubClasses(subClasses) {
	  return subClasses.map(function (e) {
	    return {
	      name: e.categoryName,
	      id: e.categoryId
	    };
	  });
	}
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.SET_SELECTED_MERCHANT, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_MERCHANT, payload);
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_LANDING_DATA, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  _parse.ParseService.getLandingData({}).then(function (info) {
	    if (info) {
	      var merchants = info['merchantEmails'];
	      if (typeof merchants === 'undefined') {
	        merchants = [];
	      }
	      var brands = info['brands'];
	      var periods = (0, _lodash.map)(info['dueDates'], 'period');
	      var departments = info['departments'];
	      (0, _lodash.remove)(departments, function (obj) {
	        return obj.categoryName === undefined;
	      });
	      departments = getDepartments(info['departments']);
	      if (brands) {
	        getBrands(brands);
	      }
	      commit(NameSpace.MUTATE_LANDING_DATA, {
	        data: {
	          departments: departments,
	          brands: brands,
	          periods: periods,
	          storeLevel: info['storeLevel'],
	          offers: info['offers'],
	          subDepartments: [],
	          classes: [],
	          subClasses: [],
	          merchants: merchants
	        },
	        error: null
	      });
	    } else {
	      commit(NameSpace.MUTATE_LANDING_DATA, { data: null, error: null });
	    }
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_OFFER_NAMES, { data: null, error: error });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_SUB_DEPARTMENTS, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  _parse.ParseService.getSubDepartments(payload).then(function (subDepartments) {
	    if (subDepartments) {
	      (0, _lodash.remove)(subDepartments, function (obj) {
	        return obj.categoryName === undefined;
	      });
	      subDepartments = getSubDepartments(subDepartments);
	      var myState = state[NameSpace.LANDING_DATA].data;
	      myState['subDepartments'] = subDepartments;
	    }
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_OFFER_NAMES, { data: null, error: error });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_CLASSES, function (_ref4, payload) {
	  var commit = _ref4.commit;
	
	  _parse.ParseService.getClasses(payload).then(function (classes) {
	    if (classes) {
	      (0, _lodash.remove)(classes, function (obj) {
	        return obj.categoryName === undefined;
	      });
	      classes = getClasses(classes);
	      var myState = state[NameSpace.LANDING_DATA].data;
	      myState['classes'] = classes;
	    }
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_OFFER_NAMES, { data: null, error: error });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.FETCH_SUB_CLASSES, function (_ref5, payload) {
	  var commit = _ref5.commit;
	
	  _parse.ParseService.getSubClasses(payload).then(function (subClasses) {
	    if (subClasses) {
	      console.log('#########', subClasses);
	      (0, _lodash.remove)(subClasses, function (obj) {
	        return obj.categoryName === undefined;
	      });
	      subClasses = getSubClasses(subClasses);
	      console.log('#########', subClasses);
	      var myState = state[NameSpace.LANDING_DATA].data;
	      myState['subClasses'] = subClasses;
	      console.log('#########', myState);
	    }
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_OFFER_NAMES, { data: null, error: error });
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _objectModifier = __webpack_require__(76);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.MODAL_CONFIG, {
	  header: 'Alert',
	  message: 'An action is required!',
	  buttons: {
	    accept: {
	      text: 'OKAY',
	      action: null
	    },
	    decline: {
	      text: 'DECLINE',
	      present: false,
	      action: null
	    }
	  },
	  type: null
	}), (0, _defineProperty3.default)(_state, NameSpace.MODAL_RESPONSE, {
	  response: null
	}), (0, _defineProperty3.default)(_state, NameSpace.MODAL_CONFIG_DEFAULT, {
	  header: 'Alert',
	  message: 'An action is required!',
	  buttons: {
	    accept: {
	      text: 'OKAY'
	    },
	    decline: {
	      text: 'DECLINE',
	      present: false
	    }
	  },
	  type: null
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.MODAL_CONFIG_GETTER, function (state) {
	  return state[NameSpace.MODAL_CONFIG];
	}), (0, _defineProperty3.default)(_getters, NameSpace.MODAL_RESPONSE_GETTER, function (state) {
	  return state[NameSpace.MODAL_RESPONSE];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MODAL_CONFIG_MUTATE, function (state, payload) {
	  state[NameSpace.MODAL_CONFIG] = (0, _objectModifier.merge)(state[NameSpace.MODAL_CONFIG_DEFAULT], payload);
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MODAL_RESPONSE_MUTATE, function (state, payload) {
	  state[NameSpace.MODAL_RESPONSE] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.SET_MODAL_CONFIG_ACTION, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  commit(NameSpace.MODAL_CONFIG_MUTATE, payload);
	}), (0, _defineProperty3.default)(_actions, NameSpace.SET_MODAL_RESPONSE_ACTION, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.MODAL_RESPONSE_MUTATE, payload);
	  setTimeout(function () {
	    commit(NameSpace.MODAL_RESPONSE_MUTATE, null);
	  }, 100);
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _flexTables = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.OFFER_DETAILS, {
	  data: {
	    headers: [],
	    aggregatedData: [],
	    detailedData: [],
	    functionable: null
	  },
	  errors: null
	}), (0, _defineProperty3.default)(_state, NameSpace.OFFER_ITEMS, {
	  detailedData: []
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_OFFER_DETAILS_DATA, function (state) {
	  return state[NameSpace.OFFER_DETAILS].data;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_OFFER_DETAILS_ERRORS, function (state) {
	  return state[NameSpace.OFFER_DETAILS].errors;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_OFFER_ITEMS, function (state) {
	  return state[NameSpace.OFFER_ITEMS];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.ADD_OFFER_DETAILS_DATA, function (state, payload) {
	  state[NameSpace.OFFER_DETAILS].data = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, function (state, payload) {
	  state[NameSpace.OFFER_DETAILS].errors = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_OFFER_ITEMS, function (state, payload) {
	  state[NameSpace.OFFER_ITEMS] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.REQUEST_OFFER_DETAILS_DATA, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  var data = { offerId: payload.offerId, storeLevel: payload.storeLevel };
	  if (payload.actual_calc) {
	    data.actual_calc = payload.actual_calc;
	  }
	  _parse.ParseService.getOfferDetails(data).then(function (offerDetailsObject) {
	    if (offerDetailsObject && offerDetailsObject.header && offerDetailsObject.data) {
	      var tableInstance = new _flexTables.FlexTable(offerDetailsObject.header, offerDetailsObject.data, 1);
	      var headers = tableInstance.getFixedFromSchema();
	      var tableData = tableInstance.dataTableStyle('offer_select', payload.status);
	      var aggregatedData = tableData.shift();
	      var detailedData = tableData;
	      var functionable = tableData.my_offer && !tableData.lock;
	      if (functionable) {
	        detailedData = detailedData.map(function (e) {
	          e.selfOffer = true;
	          return e;
	        });
	      }
	      commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
	        headers: headers,
	        aggregatedData: aggregatedData,
	        detailedData: detailedData,
	        functionable: functionable
	      });
	      commit(NameSpace.MUTATE_OFFER_ITEMS, {
	        detailedData: detailedData
	      });
	    }
	  }).catch(function (error) {
	    console.log(error);
	    if ((typeof error === 'undefined' ? 'undefined' : (0, _typeof3.default)(error)) === 'object') {
	      if (!error.message.error.length) {
	        error = 'Unknown Error!';
	      }
	    }
	    commit(NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, error);
	    commit(NameSpace.MUTATE_OFFER_ITEMS, {
	      detailedData: []
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_UPDATE_PET_DEPOT_FUNDING, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, null);
	  _parse.ParseService.updatePetDepotFunding({
	    offerId: payload.offerId,
	    storeLevel: payload.storeLevel,
	    petDepotFunding: payload.petDepotFunding,
	    itemId: payload.itemId
	  }).then(function (offerDetailsObject) {
	    if (offerDetailsObject && offerDetailsObject.header && offerDetailsObject.data) {
	      var tableInstance = new _flexTables.FlexTable(offerDetailsObject.header, offerDetailsObject.data, 1);
	      var headers = tableInstance.getFixedFromSchema();
	      var tableData = tableInstance.dataTableStyle('offer_select', payload.status);
	      var aggregatedData = tableData.shift();
	      var detailedData = tableData;
	      var functionable = tableData.my_offer && !tableData.lock;
	      if (functionable) {
	        detailedData = detailedData.map(function (e) {
	          e.selfOffer = true;
	          return e;
	        });
	      }
	      commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
	        headers: headers,
	        aggregatedData: aggregatedData,
	        detailedData: detailedData,
	        functionable: functionable
	      });
	      commit(NameSpace.MUTATE_OFFER_ITEMS, {
	        detailedData: detailedData
	      });
	    }
	  }).catch(function (error) {
	    console.log(error);
	    if ((typeof error === 'undefined' ? 'undefined' : (0, _typeof3.default)(error)) === 'object') {
	      if (!error.message.error.length) {
	        error = 'Unknown Error!';
	      }
	    }
	    commit(NameSpace.REPORT_ERRORS_IN_OFFER_DETAIL, error);
	    commit(NameSpace.MUTATE_OFFER_ITEMS, {
	      detailedData: []
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.RESET_FUNCTIONABLE_TO_DEFAULT, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  var headers = state[NameSpace.OFFER_DETAILS].data.headers;
	  var aggregatedData = state[NameSpace.OFFER_DETAILS].data.aggregatedData;
	  var detailedData = state[NameSpace.OFFER_DETAILS].data.detailedData;
	  var functionable = null;
	  commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
	    headers: headers,
	    aggregatedData: aggregatedData,
	    detailedData: detailedData,
	    functionable: functionable
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.RESET_OFFER_DETAILS, function (_ref4, payload) {
	  var commit = _ref4.commit;
	
	  commit(NameSpace.ADD_OFFER_DETAILS_DATA, {
	    data: {
	      headers: [],
	      aggregatedData: [],
	      detailedData: [],
	      functionable: null
	    },
	    errors: null
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _ViewKeyToServerKeyMapper = __webpack_require__(100);
	
	var _ServerOjectToViewObject = __webpack_require__(150);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.STATE_OFFER_NAMES, {
	  value: [],
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.STATE_SELECTED_OFFER_NAME, {
	  offerData: null
	}), (0, _defineProperty3.default)(_state, NameSpace.STATE_REJECT_OFFER_RESULT, {
	  rejectOfferResult: null,
	  error: null
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_OFFER_NAMES, function (state) {
	  return state[NameSpace.STATE_OFFER_NAMES];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_OFFER_NAME, function (state) {
	  return state[NameSpace.STATE_SELECTED_OFFER_NAME];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_REJECT_OFFER_RESULT, function (state) {
	  return state[NameSpace.STATE_REJECT_OFFER_RESULT];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_OFFER_NAMES, function (state, payload) {
	  state[NameSpace.STATE_OFFER_NAMES] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_OFFER_NAME, function (state, payload) {
	  state[NameSpace.STATE_SELECTED_OFFER_NAME] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_REJECT_OFFER_RESULT, function (state, payload) {
	  state[NameSpace.STATE_REJECT_OFFER_RESULT] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ACTION_FETCH_OFFER_NAMES, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.getOfferNames(payload).then(function (offerNames) {
	    var data = (0, _ServerOjectToViewObject.objectMapper)(offerNames, _ViewKeyToServerKeyMapper.getLocalOfferNames);
	    if (data) {
	      commit(NameSpace.MUTATE_OFFER_NAMES, { value: data, error: null });
	    } else {
	      commit(NameSpace.MUTATE_OFFER_NAMES, { value: [], error: null });
	    }
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_OFFER_NAMES, { value: [], error: error });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_SELECT_OFFER_NAME, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_OFFER_NAME, payload);
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_REJECT_OFFER, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  _parse.ParseService.rejectOffer(payload).then(function (rejectOffer) {
	    var data = (0, _ServerOjectToViewObject.serverJsonToViewJson)(rejectOffer, _ViewKeyToServerKeyMapper.getLocalRejectOfferResult);
	    if (data) {
	      commit(NameSpace.MUTATE_REJECT_OFFER_RESULT, { rejectOfferResult: data, error: null });
	    } else {
	      commit(NameSpace.MUTATE_REJECT_OFFER_RESULT, { rejectOfferResult: null, error: null });
	    }
	  }).catch(function (error) {
	    console.log(error);
	    commit(NameSpace.MUTATE_REJECT_OFFER_RESULT, { rejectOfferResult: null, error: error });
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _lodash = __webpack_require__(13);
	
	var _simulateClick = __webpack_require__(152);
	
	var _Constants = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.STATE_PENDING_APPROVALS, {
	  fix: {
	    headers: [],
	    data: []
	  },
	  scrollablePending: {
	    headers: [],
	    data: []
	  },
	  scrollablePast: {
	    headers: [],
	    data: []
	  },
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.SELECTED_AGG_CELL, {}), (0, _defineProperty3.default)(_state, NameSpace.AGG_INPUT_FILTER_DATA, {}), (0, _defineProperty3.default)(_state, NameSpace.DOWNLOAD_ERROR, null), (0, _defineProperty3.default)(_state, NameSpace.CONFIRMATION_MAIL_RESPONSE, null), (0, _defineProperty3.default)(_state, NameSpace.NAV_BAR_COLLAPSE, false), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_NAV_BAR_COLLAPSE, function (state) {
	  return state[NameSpace.NAV_BAR_COLLAPSE];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_AGGREGATED_FIX_TABLE, function (state) {
	  return state[NameSpace.STATE_PENDING_APPROVALS].fix;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_PENDING_AGGREGATED_SCROLLABLE_TABLE, function (state) {
	  return state[NameSpace.STATE_PENDING_APPROVALS].scrollablePending;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_PAST_AGGREGATED_SCROLLABLE_TABLE, function (state) {
	  return state[NameSpace.STATE_PENDING_APPROVALS].scrollablePast;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_AGG_DATA, function (state) {
	  return state[NameSpace.SELECTED_AGG_CELL];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_AGG_INPUT_FILTER_DATA, function (state) {
	  return state[NameSpace.AGG_INPUT_FILTER_DATA];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_AGG_INPUT_FILTER_NAME, function (state) {
	  var stateObject = state[NameSpace.AGG_INPUT_FILTER_DATA];
	  var result = {};
	  for (var object in stateObject) {
	    var pickData = (0, _lodash.pick)(stateObject[object], ['name']);
	    result[object] = pickData;
	  }
	  return stateObject;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_AGG_INPUT_FILTER_ID, function (state) {
	  var clonedObject = state[NameSpace.AGG_INPUT_FILTER_DATA];
	  var result = {};
	  for (var object in clonedObject) {
	    var pickData = (0, _lodash.pick)(clonedObject[object], ['id']);
	    result[object] = pickData;
	  }
	  return result;
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_DOWNLOAD_ERROR, function (state) {
	  return state[NameSpace.DOWNLOAD_ERROR];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GETTER_CONFIRMATION_MAIL_RESPONSE, function (state) {
	  return state[NameSpace.CONFIRMATION_MAIL_RESPONSE];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_NAV_BAR_COLLAPSE, function (state, payload) {
	  state[NameSpace.NAV_BAR_COLLAPSE] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_PENDING_APPROVALS, function (state, payload) {
	  state[NameSpace.STATE_PENDING_APPROVALS] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_AGG_DATA, function (state, payload) {
	  state[NameSpace.SELECTED_AGG_CELL] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_AGG_INPUT_FILTER_DATA, function (state, payload) {
	  state[NameSpace.AGG_INPUT_FILTER_DATA] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_DOWNLOAD_ERROR, function (state, payload) {
	  state[NameSpace.DOWNLOAD_ERROR] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, function (state, payload) {
	  state[NameSpace.CONFIRMATION_MAIL_RESPONSE] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ACTION_NAV_BAR_COLLAPSE, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  commit(NameSpace.MUTATE_NAV_BAR_COLLAPSE, payload);
	}), (0, _defineProperty3.default)(_actions, NameSpace.RESET_PENDING_APPROVALS, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.MUTATE_PENDING_APPROVALS, {
	    fix: {
	      headers: [],
	      data: []
	    },
	    scrollablePending: {
	      headers: [],
	      data: []
	    },
	    scrollablePast: {
	      headers: [],
	      data: []
	    },
	    error: null
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_PENDING_APPROVALS, function (_ref3, payload) {
	  var commit = _ref3.commit;
	
	  _parse.ParseService.getAggregatedOffers(payload).then(function (aggregatedOffers) {
	    var headerPart = aggregatedOffers.header.colours;
	    var dataPart = aggregatedOffers.data;
	    var rowData = [];
	
	    for (var key in headerPart) {
	      var headerField = {};
	      var columnArray = [];
	      if (key !== 'pending_offers' && key !== 'past_offers') {
	        headerField.data = { value: headerPart[key].name };
	        columnArray.push(headerField);
	      }
	      for (var dataKey in dataPart) {
	        if (key !== 'pending_offers' && key !== 'past_offers') {
	          var dataField = {};
	          var v = dataPart[dataKey][key].offerCount + '(' + dataPart[dataKey][key].itemCount + ')';
	          var existProperty = dataPart[dataKey][key];
	          existProperty.clickable = dataPart[dataKey][key].offerCount > 0;
	          dataField.data = { value: v, others: existProperty };
	          columnArray.push(dataField);
	        }
	      }
	      rowData.push(columnArray);
	    }
	
	    var scrollableHeaderPart = aggregatedOffers.header.colours.pending_offers.contains;
	    var pendingScrollbaleRowArray = [];
	    var pastScrollbaleRowArray = [];
	    for (var _key in scrollableHeaderPart) {
	      var _headerField = {};
	      var pendingColumnArray = [];
	      _headerField.data = { value: scrollableHeaderPart[_key].name };
	      pendingColumnArray.push(_headerField);
	
	      var pastHeaderField = {};
	      var pastColumnArray = [];
	      pastHeaderField.data = { value: scrollableHeaderPart[_key].name };
	      pastColumnArray.push(pastHeaderField);
	      for (var _dataKey in dataPart) {
	        var pendingDataField = {};
	        var pastDataField = {};
	        var pendingObject = dataPart[_dataKey]['pending_offers'];
	        pendingDataField.data = { value: pendingObject[_key] };
	        pendingColumnArray.push(pendingDataField);
	
	        var pastObject = dataPart[_dataKey]['past_offers'];
	        pastDataField.data = { value: pastObject[_key] };
	        pastColumnArray.push(pastDataField);
	      }
	      pendingScrollbaleRowArray.push(pendingColumnArray);
	      pastScrollbaleRowArray.push(pastColumnArray);
	    }
	
	    commit(NameSpace.MUTATE_PENDING_APPROVALS, {
	      fix: rowData,
	      scrollablePending: pendingScrollbaleRowArray,
	      scrollablePast: pastScrollbaleRowArray,
	      error: null
	    });
	  }).catch(function (error) {
	    console.log(error);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_SELECTED_AGG_DATA, function (_ref4, payload) {
	  var commit = _ref4.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_AGG_DATA, payload);
	}), (0, _defineProperty3.default)(_actions, NameSpace.SET_AGG_INPUT_FILTER_DATA, function (_ref5, payload) {
	  var commit = _ref5.commit;
	
	  commit(NameSpace.MUTATE_AGG_INPUT_FILTER_DATA, payload);
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_DOWNLOAD_ALL_DETAILS, function (_ref6, payload) {
	  var commit = _ref6.commit;
	
	  commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null);
	  _parse.ParseService.downloadMerchantAllDetails(payload).then(function (result) {
	    console.log(result);
	    (0, _simulateClick.simulateClick)(result.url);
	  }).catch(function (error) {
	    console.log('oops! Error in downloading template', error);
	    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_DOWNLOAD_PORTAL_GUIDE, function (_ref7, payload) {
	  var commit = _ref7.commit;
	
	  commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null);
	  (0, _simulateClick.simulateClick)(_Constants.MERCHANT_PORTAL_GUIDE_URL);
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_DOWNLOAD_MANUFACTURER_INFO, function (_ref8, payload) {
	  var commit = _ref8.commit;
	
	  commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null);
	  _parse.ParseService.downloadManufacturerInfo(payload).then(function (result) {
	    console.log(result);
	    (0, _simulateClick.simulateClick)(result.url);
	  }).catch(function (error) {
	    console.log('oops! Error in downloading template', error);
	    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS, function (_ref9, payload) {
	  var commit = _ref9.commit;
	
	  commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null);
	  _parse.ParseService.downloadNegativeMarginItems(payload).then(function (result) {
	    console.log(result);
	    (0, _simulateClick.simulateClick)(result.url);
	  }).catch(function (error) {
	    console.log('oops! Error in downloading template', error);
	    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_DOWNLOAD_MERCHANT_TEMPLATE, function (_ref10, payload) {
	  var commit = _ref10.commit;
	
	  commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null);
	  _parse.ParseService.downloadTemplateMerchant({}).then(function (result) {
	    (0, _simulateClick.simulateClick)(result.url);
	  }).catch(function (error) {
	    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_DOWNLOAD_DAX, function (_ref11, payload) {
	  var commit = _ref11.commit;
	
	  commit(NameSpace.MUTATE_DOWNLOAD_ERROR, null);
	  _parse.ParseService.downloadDax(payload).then(function (result) {
	    (0, _simulateClick.simulateClick)(result.url);
	  }).catch(function (error) {
	    commit(NameSpace.MUTATE_DOWNLOAD_ERROR, error);
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.ACTION_SEND_CONFIRMATION_MAIL, function (_ref12, payload) {
	  var commit = _ref12.commit;
	
	  commit(NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, null);
	  _parse.ParseService.sendFinalConfirmationMails(payload).then(function (result) {
	    commit(NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, result);
	  }).catch(function (error) {
	    console.log('oops! Error in send mail', error);
	    commit(NameSpace.MUTATE_CONFIRMATION_MAIL_RESPONSE, error);
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _state, _getters, _mutations, _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	var _flexTables = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (_state = {}, (0, _defineProperty3.default)(_state, NameSpace.STATE_SELECTED_PENDING_APPROVALS, {
	  headers: [],
	  data: [],
	  error: null
	}), (0, _defineProperty3.default)(_state, NameSpace.OFFERS, {
	  data: null
	}), _state);
	
	var getters = (_getters = {}, (0, _defineProperty3.default)(_getters, NameSpace.GET_SELECTED_PENDING_APPROVALS, function (state) {
	  return state[NameSpace.STATE_SELECTED_PENDING_APPROVALS];
	}), (0, _defineProperty3.default)(_getters, NameSpace.GET_OFFERS, function (state) {
	  return state[NameSpace.OFFERS];
	}), _getters);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, function (state, payload) {
	  state[NameSpace.STATE_SELECTED_PENDING_APPROVALS] = payload;
	}), (0, _defineProperty3.default)(_mutations, NameSpace.MUTATE_OFFERS, function (state, payload) {
	  state[NameSpace.OFFERS] = payload;
	}), _mutations);
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.ACTION_SELECTED_PENDING_APPROVALS, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  _parse.ParseService.getHighLevelOffers(payload).then(function (offersData) {
	    var tableInstance = new _flexTables.FlexTable(offersData.header, offersData.data, 1);
	    var tableHeaders = tableInstance.getObjectTableHeaders(offersData.header, 'Offer Id', 'lock', 'my_offer');
	    var tableHeadersString = tableInstance.getStringTableHeaders(offersData.header);
	    var tableData = tableInstance.getCellDataAsObject(tableHeadersString, offersData.data, 'makeLink', 'selected_offer_list', 1);
	    commit(NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, {
	      headers: tableHeaders,
	      data: tableData,
	      error: null
	    });
	    commit(NameSpace.MUTATE_OFFERS, {
	      data: tableData
	    });
	  }).catch(function (err) {
	    commit(NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, {
	      headers: [],
	      data: [],
	      error: err
	    });
	    commit(NameSpace.MUTATE_OFFERS, {
	      data: null
	    });
	  });
	}), (0, _defineProperty3.default)(_actions, NameSpace.RESET_SELECTED_PENDING_APPROVALS, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  commit(NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, {
	    headers: [],
	    data: [],
	    error: null
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _actions;
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _parse = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _defineProperty3.default)({}, NameSpace.STATE_ZONE_SALE_PRICES, {
	  data: null,
	  headers: null,
	  error: null,
	  showAgain: false,
	  showModal: false
	});
	
	var getters = (0, _defineProperty3.default)({}, NameSpace.GET_ZONE_SALE_PRICES, function (state) {
	  return state[NameSpace.STATE_ZONE_SALE_PRICES];
	});
	
	var mutations = (0, _defineProperty3.default)({}, NameSpace.MUTATE_ZONE_SALE_PRICES, function (state, payload) {
	  state[NameSpace.STATE_ZONE_SALE_PRICES] = payload;
	});
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, NameSpace.SET_ZONE_STATE, function (_ref, payload) {
	  var commit = _ref.commit;
	
	  if (payload === null) {
	    commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
	      data: null,
	      headers: null,
	      error: null,
	      showAgain: false,
	      showModal: false
	    });
	  } else {
	    console.log('SET_ZONE_STATE', payload);
	    commit(NameSpace.MUTATE_ZONE_SALE_PRICES, payload);
	  }
	}), (0, _defineProperty3.default)(_actions, NameSpace.UPDATE_ZONE_STATE, function (_ref2, payload) {
	  var commit = _ref2.commit;
	
	  _parse.ParseService.updateZonePrices({ data: payload.data }).then(function (result) {
	    var myData = state[NameSpace.STATE_ZONE_SALE_PRICES].data;
	    var myHeaders = state[NameSpace.STATE_ZONE_SALE_PRICES].headers;
	    if (result && result.success) {
	      commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
	        data: myData,
	        headers: myHeaders,
	        error: null,
	        showAgain: false,
	        showModal: true
	      });
	    } else {
	      commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
	        data: payload.original,
	        headers: myHeaders,
	        showAgain: false,
	        showModal: true,
	        error: result
	      });
	    }
	  }).catch(function (error) {
	    var myHeaders = state[NameSpace.STATE_ZONE_SALE_PRICES].headers;
	    commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
	      data: null,
	      headers: myHeaders,
	      error: error,
	      showAgain: false,
	      showModal: true
	    });
	  });
	}), _actions);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(5);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _authorization = __webpack_require__(78);
	
	var _authorization2 = _interopRequireDefault(_authorization);
	
	var _profile = __webpack_require__(101);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _modalConfig = __webpack_require__(160);
	
	var _modalConfig2 = _interopRequireDefault(_modalConfig);
	
	var _loader = __webpack_require__(79);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _goalsAndDisplay = __webpack_require__(158);
	
	var _goalsAndDisplay2 = _interopRequireDefault(_goalsAndDisplay);
	
	var _offerList = __webpack_require__(162);
	
	var _offerList2 = _interopRequireDefault(_offerList);
	
	var _offerDetails = __webpack_require__(161);
	
	var _offerDetails2 = _interopRequireDefault(_offerDetails);
	
	var _zonePriceEdit = __webpack_require__(165);
	
	var _zonePriceEdit2 = _interopRequireDefault(_zonePriceEdit);
	
	var _pendingApprovals = __webpack_require__(163);
	
	var _pendingApprovals2 = _interopRequireDefault(_pendingApprovals);
	
	var _selectedOfferList = __webpack_require__(164);
	
	var _selectedOfferList2 = _interopRequireDefault(_selectedOfferList);
	
	var _dropdown = __webpack_require__(156);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _landing = __webpack_require__(159);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	var _approveWithChanges = __webpack_require__(154);
	
	var _approveWithChanges2 = _interopRequireDefault(_approveWithChanges);
	
	var _chart = __webpack_require__(155);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _fileUpload = __webpack_require__(157);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = exports.store = new _vuex2.default.Store({
	  modules: {
	    authorization: _authorization2.default,
	    profile: _profile2.default,
	    modalConfig: _modalConfig2.default,
	    loader: _loader2.default,
	    goalsAndDisplay: _goalsAndDisplay2.default,
	    offerList: _offerList2.default,
	    offerDetails: _offerDetails2.default,
	    zonePriceEdit: _zonePriceEdit2.default,
	    pendingApproval: _pendingApprovals2.default,
	    selectedPendingApproval: _selectedOfferList2.default,
	    dropdown: _dropdown2.default,
	    landing: _landing2.default,
	    approveWithChanges: _approveWithChanges2.default,
	    chart: _chart2.default,
	    fileUpload: _fileUpload2.default
	  }
	});

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _Modal = __webpack_require__(353);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Loader = __webpack_require__(350);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Constants = __webpack_require__(18);
	
	var _superUser = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    authState: NameSpace.AUTH_GETTER,
	    gettersLandingInfo: NameSpace.GET_LANDING_DATA,
	    gettersAllEmails: NameSpace.GETTER_ALL_EMAILS
	  }), {
	    sessionExpiry: function sessionExpiry() {
	      return this.authState.expired;
	    },
	    auth: function auth() {
	      return this.authState.auth;
	    },
	    isMerchant: function isMerchant() {
	      if (this.auth && this.auth.user_group) {
	        return this.checkAuthorize(this.auth.user_group);
	      }
	    },
	    errorInitializingLandingData: function errorInitializingLandingData() {
	      return this.gettersLandingInfo.error;
	    }
	  }),
	  watch: {
	    'gettersAllEmails.error': function gettersAllEmailsError() {
	      var error = this.gettersAllEmails.error;
	      if (error) {
	        this.showError(error);
	      }
	    },
	    errorInitializingLandingData: function errorInitializingLandingData() {
	      this.showError(this.gettersLandingInfo.error);
	    },
	    auth: function auth() {
	      if (this.isLogged()) {
	        if (this.isMerchant) {
	          if ((0, _superUser.isSuperUser)()) {
	            this.setEmail();
	            this.getEmailsForSuperUser();
	          }
	          this.fetchLandingInfo();
	        }
	      }
	    },
	    sessionExpiry: function sessionExpiry(n, o) {
	      if (this.sessionExpiry === true) {
	        this.$router.push({ name: 'login' });
	      }
	    }
	  },
	  created: function created() {
	    if (this.isLogged()) {
	      this.getUser();
	      if ((0, _superUser.isSuperUser)()) {
	        this.setEmail();
	      }
	    }
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    loader: NameSpace.LOADER_SHOW_ACTION,
	    fetchLandingInfo: NameSpace.FETCH_LANDING_DATA,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    getUser: NameSpace.GET_USER_FROM_LOCAL_STORAGE,
	    getEmailsForSuperUser: NameSpace.ACTION_ALL_EMAILS,
	    storeSelectedVendor: NameSpace.SET_EMAIL_SELECTED_BY_SUPERUSER,
	    setSelectedMerchant: NameSpace.SET_SELECTED_MERCHANT
	  }), {
	    generateStrayClick: function generateStrayClick(e) {
	      window.eventBus.$emit('strayClick', e);
	    },
	    checkAuthorize: function checkAuthorize(userGroup) {
	      if (userGroup.indexOf(_Constants.MERCHANT_ROLE) !== -1) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isLogged: function isLogged() {
	      if (JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser'))) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    showError: function showError(error) {
	      this.pop({
	        header: 'Request Failed',
	        message: error,
	        type: 'ERROR'
	      });
	    },
	    setEmail: function setEmail() {
	      var vendor = localStorage.getItem(_Constants.EMAIL_SELECTED_BY_SUPERUSER);
	      if (vendor) {
	        vendor = JSON.parse(vendor);
	        this.storeSelectedVendor(vendor);
	      }
	
	      var merchant = localStorage.getItem(_Constants.MERCHANT_SELECTED_BY_SUPERUSER);
	      if (typeof merchant !== 'undefined') {
	        merchant = JSON.parse(merchant);
	        this.setSelectedMerchant(merchant);
	      }
	      return null;
	    }
	  }),
	  components: {
	    Modal: _Modal2.default,
	    Loader: _Loader2.default
	  }
	};

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      previousRouterPath: '/pending-offers/offer-select',
	      buttonEnabled: true
	    };
	  },
	
	  methods: {
	    goBack: function goBack() {
	      this.$router.push(this.previousRouterPath);
	    }
	  },
	  created: function created() {
	    this.buttonEnabled = this.$route.params.buttonEnabled;
	  }
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _SearchableDropDown = __webpack_require__(73);
	
	var _SearchableDropDown2 = _interopRequireDefault(_SearchableDropDown);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      picked: '',
	      selectedItemIndex: 0,
	      itemArrays: [],
	      selectedItem: null,
	      windowWidth: 0,
	      duplicatedItemName: null,
	      homeRouterPath: '/pending-offers'
	    };
	  },
	
	  watch: {
	    chartData: function chartData() {
	      if (typeof this.chartData !== 'undefined' && this.chartData.length === 0) {
	        this.pop({
	          header: 'Message',
	          message: 'No Data Found.',
	          type: ''
	        });
	      }
	    },
	    selectedItem: function selectedItem() {
	      if (this.selectedItem.id) {
	        this.duplicatedItemName = (0, _lodash.cloneDeep)(this.selectedItem);
	        var _gettersAggInputData = this.gettersAggInputData,
	            storeLevel = _gettersAggInputData.storeLevel,
	            period = _gettersAggInputData.period;
	
	        this.fetchBarChartData({ itemId: this.selectedItem.id, storeLevel: storeLevel.id, period: period.id });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersBarChartData: NameSpace.GET_BAR_CHART,
	    gettersBarChartLegends: NameSpace.GET_BAR_CHART_LEGENDS,
	    gettersOfferDetails: NameSpace.GET_OFFER_ITEMS,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
	    gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME
	  }), {
	    offerItems: function offerItems() {
	      var parentArray = this.gettersOfferDetails.detailedData;
	      return parentArray.map(function (arr) {
	        return { name: arr[0], id: arr.itemId };
	      });
	    },
	    columns: function columns() {
	      return [{
	        'type': 'string',
	        'label': ''
	      }, {
	        'type': 'number',
	        'label': ''
	      }, {
	        type: 'string',
	        role: 'style'
	      }, {
	        type: 'string',
	        role: 'annotation'
	      }, {
	        type: 'string',
	        role: 'tooltip',
	        'p': {
	          'html': true
	        }
	      }];
	    },
	    rows: function rows() {
	      return this.getChartsData();
	    },
	    options: function options() {
	      return {
	        explorer: {
	          actions: ['dragToZoom', 'rightClickToReset'],
	          axis: 'horizontal',
	          keepInBounds: true,
	          maxZoomIn: 4.0
	        },
	
	        lineWidth: 20,
	        chartArea: {
	          left: 100,
	          width: '100%'
	        },
	        tooltip: { isHtml: true },
	
	        legend: 'none',
	        bar: {
	          groupWidth: '70%'
	        },
	        annotations: {
	          textStyle: {
	            fontSize: 10
	          },
	          alwaysOutside: true,
	          stem: { length: '1' }
	        },
	        animation: {
	          duration: 500,
	          easing: 'out',
	          startup: true
	        },
	        title: this.gettersSelectedOffer.name,
	        hAxis: {
	          title: '',
	          textPosition: 'out',
	
	          textStyle: {
	            fontSize: 12
	          },
	          slantedText: true,
	          slantedTextAngle: 90,
	
	          gridlines: {
	            count: this.getChartsData() ? this.getChartsData().length : 0
	          }
	        },
	        vAxis: {
	          title: 'Quantity Per Week',
	
	          gridlines: {
	            color: '#DDD',
	            count: 10
	          }
	        },
	        width: this.windowWidth,
	        height: 400
	      };
	    },
	    chartData: function chartData() {
	      return this.gettersBarChartData;
	    },
	    barChartLegends: function barChartLegends() {
	      return this.gettersBarChartLegends;
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchBarChartData: NameSpace.FETCH_BAR_CHART,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION
	  }), {
	    getChartsData: function getChartsData() {
	      return this.chartData;
	    }
	  }),
	  components: {
	    SearchableDropdown: _SearchableDropDown2.default
	  },
	  created: function created() {
	    console.log(window.innerWidth);
	    this.windowWidth = window.innerWidth;
	    var delta = 0;
	    switch (this.windowWidth) {
	      case 1336:
	        this.windowWidth = 1000;
	        break;
	      case 1536:
	        delta = 536 - 336;
	        this.windowWidth = 1000 + delta;
	        break;
	      case 2400:
	        delta = 1400 - 336;
	        this.windowWidth = 1000 + delta;
	        break;
	      case 1280:
	        delta = 336 - 1280;
	        this.windowWidth = 1000 - delta;
	        break;
	      default:
	        this.windowWidth = 1000;
	    }
	    this.itemArrays = this.offerItems;
	    this.selectedItem = this.itemArrays[0];
	    this.selectedItem = this.itemArrays[0];
	    if (!this.selectedItem) {
	      this.$router.push(this.homeRouterPath);
	    }
	    this.duplicatedItemName = (0, _lodash.cloneDeep)(this.selectedItem);
	  }
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _vueSliderComponent = __webpack_require__(387);
	
	var _vueSliderComponent2 = _interopRequireDefault(_vueSliderComponent);
	
	var _vuex = __webpack_require__(5);
	
	var _height = __webpack_require__(39);
	
	var _tableStyles = __webpack_require__(142);
	
	var _mainContainerStyle = __webpack_require__(49);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _HorizontalTable = __webpack_require__(132);
	
	var _HorizontalTable2 = _interopRequireDefault(_HorizontalTable);
	
	var _SearchableDropDown = __webpack_require__(73);
	
	var _SearchableDropDown2 = _interopRequireDefault(_SearchableDropDown);
	
	var _lodash = __webpack_require__(13);
	
	var _Constants = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      tableStyles: _tableStyles.tableStyles,
	      mainContainerStyle: _mainContainerStyle.mainContainerStyle,
	      slider1Value: undefined,
	      slider2Value: undefined,
	      slider1Disabled: false,
	      slider1CurrentValue: null,
	      slider2CurrentValue: null,
	      width: 'auto',
	      tooltip: 'always',
	      disabled: false,
	      piecewise: true,
	      piecewiseLabel: true,
	      piecewiseStyle: {
	        'backgroundColor': '#ccc',
	        'visibility': 'visible',
	        'width': '12px',
	        'height': '12px'
	      },
	      style: {
	        'marginLeft': '1.5rem'
	      },
	      piecewiseActiveStyle: {
	        'backgroundColor': '#05983b'
	      },
	      labelActiveStyle: {
	        'color': '#05983b'
	      },
	      processStyle: {
	        'backgroundColor': '#05983b'
	      },
	      scrollable2Width: '0px',
	      scrollable1Width: '0px',
	      scrollableChildrenWidth: 15,
	      table1BodyWidth: 25,
	      table1Header: [],
	      type: 'record',
	      table1Data: [],
	      slider1Data: [],
	      slider2Data: [],
	      currentDecision: null,
	      simulation: [],
	      originalData: {},
	      table1Column: [],
	      switchToggle: false,
	      mappedKey: null,
	      picked: '',
	      rows: [],
	      itemArrays: [],
	      selectedItem: null,
	      refresh: false,
	      hasChanges: false,
	      updatedData: {},
	      duplicatedItemName: null,
	      updateChanges: this.updateChanges,
	      vaAllowancePercentPos: 0,
	      retailSavingPercentPos: 0,
	      pspAllowancePos: 0,
	      vendorAllowancePos: 0,
	      retailSavingPos: 0,
	      validationMsg: 'Psp Allowance($) must be less than or equal to Retail Savings($).',
	      homeRouterPath: '/pending-offers'
	    };
	  },
	  beforeUpdate: function beforeUpdate() {},
	
	  components: {
	    VueSlider: _vueSliderComponent2.default,
	    DataTable: _DataTable2.default,
	    HorizontalTable: _HorizontalTable2.default,
	    SearchableDropdown: _SearchableDropDown2.default
	  },
	  created: function created() {
	    this.itemArrays = this.offerItems;
	    this.selectedItem = this.itemArrays[0];
	    if (!this.selectedItem) {
	      this.$router.push(this.homeRouterPath);
	    }
	    this.duplicatedItemName = (0, _lodash.cloneDeep)(this.selectedItem);
	  },
	
	  watch: {
	    gettersSelectedOffer: function gettersSelectedOffer() {
	      console.log(this.gettersSelectedOffer);
	      if (!this.gettersSelectedOffer.name) {
	        console.log('-----------------');
	      }
	    },
	    'gettersSubmittedDecision.isSuccess': function gettersSubmittedDecisionIsSuccess() {
	      if (this.gettersSubmittedDecision.isSuccess) {
	        var warnings = this.gettersLiftSimulation.warnings;
	        if (warnings) {
	          this.pop({
	            header: 'WARNINGS',
	            message: warnings.map(function (e) {
	              var key = (0, _keys2.default)(e).pop();
	              return key + ': ' + e[key];
	            })
	          });
	        } else {
	          this.pop({
	            header: 'Success!!',
	            message: 'Submitted successfully.',
	            type: 'SUCCESS'
	          });
	        }
	      }
	    },
	    'gettersCalculationField.data': function gettersCalculationFieldData() {
	      var data = this.gettersCalculationField.data;
	      if (data) {
	        for (var i = 1; i < this.table1Header.length; i++) {
	          var key = this.table1Header[i].key;
	          var val = data[key];
	
	          this.table1Data[1][i].value = val;
	        }
	      }
	    },
	    'gettersCalculationField.error': function gettersCalculationFieldError() {
	      this.pop({
	        header: 'UNKNOWN ERROR!!',
	        message: this.gettersCalculationField.error,
	        type: 'ERROR'
	      });
	    },
	    switchToggle: function switchToggle() {
	      if (this.switchToggle) {
	        this.$nextTick(function () {
	          this.scrollable2Width = this.getTable2ContainerWidth();
	        });
	      }
	    },
	    selectedItem: function selectedItem() {
	      if (this.selectedItem && this.selectedItem.id) {
	        this.duplicatedItemName = (0, _lodash.cloneDeep)(this.selectedItem);
	        this.resetLocalData();
	        this.refresh = true;
	        this.fetchLiftSimulation({ storeLevel: this.storeLevel, itemId: this.selectedItem.id, period: this.period });
	      }
	    },
	    picked: function picked() {
	      this.$set(this.options, 'title', this.picked);
	      if (this.mappedKey) {
	        var keyToFilterBy = this.mappedKey[this.picked];
	        this.setGraphRows(keyToFilterBy);
	      }
	    },
	    'gettersLiftSimulation.data': function gettersLiftSimulationData() {
	      var headers = this.gettersLiftSimulation.headers;
	      headers.splice(0, 0, { key: '\xa0', value: '\xa0' });
	      this.table1Header = headers;
	      if (headers) {
	        this.vaAllowancePercentPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.VENDOR_ALLOWANCE_PERCENT);
	        this.retailSavingPercentPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.RETAIL_SAVING_PERCENT);
	        this.pspAllowancePos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.PSP_ALLOWANCE);
	        this.vendorAllowancePos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.VENDOR_ALLOWANCE);
	        this.retailSavingPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.RETAIL_SAVING);
	        this.retailPricePos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.RETAIL_PRICE);
	      }
	      this.processData();
	      if (this.mappedKey) {
	        var keyToFilterBy = this.mappedKey[this.picked];
	        this.setGraphRows(keyToFilterBy);
	      }
	    },
	    'gettersLiftSimulation.error': function gettersLiftSimulationError() {
	      if (Array.isArray(this.gettersLiftSimulation)) {
	        this.pop({
	          header: 'ERROR',
	          message: this.gettersLiftSimulation.error.map(function (e) {
	            var key = (0, _keys2.default)(e).pop();
	            return key + ': ' + e[key];
	          }),
	          type: 'ERROR'
	        });
	      } else {
	        if (this.gettersLiftSimulation.error) {
	          var msg = this.gettersLiftSimulation.error ? this.gettersLiftSimulation.error : 'Opps got unknown error';
	          this.pop({
	            header: 'ERROR!!',
	            message: msg + ', please click back button.',
	            type: 'ERROR'
	          });
	        }
	      }
	    },
	    slider1Value: function slider1Value() {
	      this.updateTable1BySlider1Changes();
	    },
	    slider2Value: function slider2Value() {
	      this.updateTable1BySlider2Changes();
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersLiftSimulation: NameSpace.GET_LIFT_SIMULATION,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
	    gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
	    gettersOfferDetails: NameSpace.GET_OFFER_ITEMS,
	    gettersRadioOption: NameSpace.GET_LINE_CHART_RADIO,
	    gettersCalculationField: NameSpace.GET_CALCULATION_FIELDS,
	    gettersSubmittedDecision: NameSpace.GET_SIMULATION_CHANGES
	  }), {
	    simulationData: function simulationData() {
	      this.resetLocalData();
	      return this.gettersLiftSimulation.data;
	    },
	    period: function period() {
	      return this.gettersAggInputData.period.id;
	    },
	    storeLevel: function storeLevel() {
	      return this.gettersAggInputData.storeLevel.id;
	    },
	    lineChartInputOptionArray: function lineChartInputOptionArray() {
	      if (this.gettersRadioOption) {
	        var radioArrays = (0, _keys2.default)(this.gettersRadioOption);
	        if (radioArrays.length) {
	          this.picked = radioArrays[0];
	          return radioArrays;
	        }
	      }
	      return [];
	    },
	    originalHeader: function originalHeader() {
	      var orignalHeader = this.gettersLiftSimulation.originalTableHeader;
	      if (orignalHeader) {
	        return orignalHeader;
	      }
	    },
	    options: function options() {
	      return {
	        legend: 'none',
	        title: '',
	        pointSize: 6,
	        colors: ['#05983b'],
	        hAxis: {
	          title: 'Retail Savings($)',
	          minValue: '0',
	          maxValue: '4',
	          slantedText: true,
	          slantedTextAngle: 90
	        },
	        vAxis: {
	          title: '',
	          minValue: 0,
	          maxValue: 1000,
	          gridlines: {
	            count: 15,
	            color: 'none'
	          }
	        },
	        height: 450,
	        curveType: 'function'
	      };
	    },
	    columns: function columns() {
	      return [{
	        'type': 'string',
	        'label': 'Year'
	      }, {
	        'type': 'number'
	      }];
	    },
	    table2Headers: function table2Headers() {
	      var key = 'retailSavingsPercent';
	      var tempHeader = (0, _lodash.cloneDeep)(this.table1Header);
	      var retObject = void 0,
	          index = void 0;
	      for (var i = 0; i < tempHeader.length; i++) {
	        var obj = tempHeader[i];
	        if (obj.key === key) {
	          retObject = obj;
	          index = i;
	          break;
	        }
	      }
	      tempHeader.splice(index, 1);
	      tempHeader[0] = retObject;
	      return tempHeader;
	    },
	    table2Data: function table2Data() {
	      this.table2Data = [];
	      var a = [];
	      var key = 'retailSavingsPercent';
	      var localArray = (0, _lodash.cloneDeep)(this.originalData.simulation);
	      localArray = (0, _lodash.filter)(localArray, { 'vendorAllowancePercent': this.slider1CurrentValue });
	      localArray = (0, _lodash.sortBy)(localArray, key);
	      localArray.unshift((0, _lodash.cloneDeep)(this.originalData.currentDecision));
	      localArray[0]['retailSavingsPercent'] = 'Current' + ' (' + this.originalData.currentDecision['retailSavingsPercent'] + '%)';
	      localArray.forEach(function (data, j) {
	        var column = [];
	        var index = void 0;
	        var rsPercent = void 0;
	        var keyArray = (0, _keys2.default)(data);
	        for (var i = 0; i < keyArray.length; i++) {
	          var eachKey = keyArray[i];
	          if (eachKey === 'tagNo') {
	            column.tagNo = data[eachKey];
	
	            continue;
	          }
	          if (key === eachKey) {
	            index = i;
	            rsPercent = data[key];
	          }
	          if (!data[eachKey]) {
	            data[eachKey] = 0;
	          }
	          column.push(data[eachKey]);
	        }
	        if (j === 0) {
	          column.splice(0, 0, rsPercent);
	        } else {
	          column.splice(0, 0, rsPercent + '%');
	        }
	        column.splice(index + 1, 1);
	        a.push(column);
	        return a;
	      });
	      return a;
	    },
	    offerItems: function offerItems() {
	      var parentArray = this.gettersOfferDetails.detailedData;
	      return parentArray.map(function (arr) {
	        return { name: arr[0], id: arr.itemId };
	      });
	    }
	  }),
	  mounted: function mounted() {
	    this.tempMethod();
	  },
	  updated: function updated() {
	    this.tempMethod();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchLiftSimulation: NameSpace.FETCH_LIFT_SIMULATION,
	    postSimulationChanges: NameSpace.POST_SIMULATION_CHANGES,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    fetchCalculationFields: NameSpace.FETCH_CALCULATION_FIELDS
	  }), {
	    resetLocalData: function resetLocalData() {
	      this.switchToggle = false;
	      this.table1Data = [];
	      this.table2Data = [];
	      this.slider1Value = undefined;
	      this.slider2Value = undefined;
	      this.slider1Disabled = false;
	      this.slider1CurrentValue = null;
	      this.slider2CurrentValue = null;
	      this.slider1Data = [];
	      this.slider2Data = [];
	    },
	    updateSimulationDataLocally: function updateSimulationDataLocally(modifiedData) {
	      var index1 = (0, _lodash.findIndex)(this.originalData.simulation, ['tagNo', modifiedData.tagNo]);
	      this.originalData.simulation[index1] = modifiedData;
	      var index2 = (0, _lodash.findIndex)(this.simulation, ['tagNo', modifiedData.tagNo]);
	      this.simulation[index2] = modifiedData;
	    },
	    submitChanges: function submitChanges() {
	      if ((0, _keys2.default)(this.updatedData).length === 0) {
	        this.updatedData[_Constants.VENDOR_ALLOWANCE] = this.table1Data[1][this.vendorAllowancePos].value;
	      }
	      this.updatedData.salesSave = this.table1Data[1][this.retailSavingPos].value;
	      var inputObj = {
	        itemId: this.duplicatedItemName.id,
	        storeLevel: this.storeLevel,
	        period: this.period,
	        updatedData: this.updatedData
	      };
	
	      this.postSimulationChanges(inputObj);
	    },
	    updateTable1BySlider2Changes: function updateTable1BySlider2Changes() {
	      if (this.slider2Value !== undefined) {
	        var rs = this.slider2Value;
	        var va = this.slider1Value === undefined ? this.slider1Data[0] : this.slider1Value;
	        var vaSliderValue = void 0;
	        if (va.startsWith('Current')) {
	          vaSliderValue = this.slider1CurrentValue;
	        } else {
	          vaSliderValue = va.slice(0, -1);
	        }
	        var suggestedColumn = this.filterArray(vaSliderValue, rs);
	        this.modifySecondColumn(suggestedColumn);
	      }
	    },
	    modifySecondColumn: function modifySecondColumn(suggestedColumn) {
	      var _this = this;
	
	      if (this.table1Data.length > 1 && this.table1Data[1]) {
	        this.table1Data.splice(1, this.table1Data.length - 1);
	      }
	      if (suggestedColumn && suggestedColumn.length && Array.isArray(suggestedColumn[0])) {
	        suggestedColumn.map(function (data) {
	          data.splice(0, 0, 'As per simulation suggestions');
	          _this.table1Data.push(data);
	        });
	      } else {
	        suggestedColumn.splice(0, 0, 'As per simulation suggestions');
	        this.table1Data.push(suggestedColumn);
	      }
	      this.tempMethod();
	    },
	    updateTable1BySlider1Changes: function updateTable1BySlider1Changes() {
	      if (this.slider1Value !== undefined) {
	        var va = this.slider1Value;
	        var rs = this.slider2Value === undefined ? this.slider2Data[0] : this.slider2Value;
	        var rsSliderValue = void 0;
	        if (rs.startsWith('Current')) {
	          rsSliderValue = this.slider2CurrentValue;
	        } else {
	          rsSliderValue = rs.slice(0, -1);
	        }
	        var suggestedColumn = this.filterArray(va, rsSliderValue);
	        this.modifySecondColumn(suggestedColumn);
	      }
	    },
	    tempMethod: function tempMethod() {
	      if (this.table1Data.length <= 4) {
	        this.scrollable1Width = this.table1Data.length * 10 * this.table1BodyWidth + 10 + 'px';
	      } else {
	        this.scrollable1Width = this.getTable1ContainerWidth();
	      }
	    },
	    processData: function processData() {
	      var fetchData = this.simulationData;
	      var currentDecision = fetchData.currentDecision,
	          simulation = fetchData.simulation;
	
	      if (fetchData) {
	        if (this.gettersRadioOption) {
	          this.mappedKey = this.gettersRadioOption;
	        }
	        if (currentDecision) {
	          this.originalData.currentDecision = currentDecision;
	          var tagNo = currentDecision.tagNo;
	          delete currentDecision['tagNo'];
	          var tempArray = (0, _keys2.default)(currentDecision).map(function (k) {
	            if (!currentDecision[k]) {
	              currentDecision[k] = 0;
	            }
	            return currentDecision[k];
	          });
	          this.slider1CurrentValue = currentDecision['vendorAllowancePercent'];
	          this.slider2CurrentValue = currentDecision['retailSavingsPercent'];
	
	          tempArray.splice(0, 0, 'As per currrent suggestions');
	          tempArray.tagNo = tagNo;
	          this.table1Data.push(tempArray);
	        }
	        if (simulation) {
	          this.simulation = simulation;
	
	          this.originalData.simulation = simulation;
	          var pickData1 = [];
	          var pickData2 = [];
	          for (var i = 0; i < simulation.length; i++) {
	            var obj = simulation[i];
	            var va = obj['vendorAllowancePercent'];
	            if (va) {
	              this.binaryInsert(va, pickData1);
	            }
	            if (obj['retailSavingsPercent']) {
	              this.binaryInsert(obj['retailSavingsPercent'], pickData2);
	            }
	          }
	          this.binaryInsert(this.slider1CurrentValue, pickData1);
	          this.slider1Data = pickData1;
	          if (this.slider1Data.length === 1) {
	            this.slider1Disabled = true;
	            this.slider1Data = [0, this.slider1Data[0]];
	          }
	          var currentIndex1 = this.slider1Data.indexOf(this.slider1CurrentValue + '%');
	          this.slider1Data[currentIndex1] = 'Current(' + this.slider1CurrentValue + '%)';
	          if (this.slider1Value === undefined) {
	            this.slider1Value = this.slider1Data[currentIndex1];
	          }
	
	          this.binaryInsert(this.slider2CurrentValue, pickData2);
	          this.slider2Data = pickData2;
	          var currentIndex2 = this.slider2Data.indexOf(this.slider2CurrentValue + '%');
	          this.slider2Data[currentIndex2] = 'Current(' + this.slider2CurrentValue + '%)';
	          if (this.slider2Value === undefined) {
	            this.slider2Value = this.slider2Data[currentIndex2];
	          }
	        }
	      }
	    },
	    performCalculation: function performCalculation(newArray, record) {
	      var newValueOfModifiedKey = Number(record.value);
	      var modifiedKey = this.table1Header[record.index].key;
	
	      var retailSaving = Number(newArray[this.retailSavingPos].value);
	      if (modifiedKey === _Constants.VENDOR_ALLOWANCE) {
	        var retailPrice = Number(newArray[this.retailPricePos].value);
	        if (newValueOfModifiedKey < 0) {
	          return { opt: true, msg: this.validationMsg };
	        } else if (newValueOfModifiedKey > retailPrice) {
	          return { opt: true, msg: 'Vendor Allowance($' + newValueOfModifiedKey + ') must be less than Retail Price($' + retailPrice + ').' };
	        }
	      } else if (modifiedKey === _Constants.PSP_ALLOWANCE) {
	        var delta = retailSaving - newValueOfModifiedKey;
	        if (newValueOfModifiedKey > retailSaving) {
	          return { opt: true, msg: 'Psp Allowance($' + newValueOfModifiedKey + ') must be less than Retail Savings($' + retailSaving + ').' };
	        } else {
	          var key = this.table1Header[this.vendorAllowancePos].key;
	          this.updatedData[key] = delta;
	        }
	      }
	      return { opt: false };
	    },
	    formTableData: function formTableData(obj, foundArray) {
	      var tagNo = void 0;
	      var cloneObj = (0, _lodash.cloneDeep)(obj);
	      if (obj.hasOwnProperty('tagNo')) {
	        tagNo = cloneObj['tagNo'];
	        delete cloneObj['tagNo'];
	      }
	      var keysArray = (0, _keys2.default)(cloneObj);
	      for (var j = 1; j <= keysArray.length; j++) {
	        if (keysArray[j] === 'tagNo') {
	          continue;
	        }
	        var key = this.table1Header[j].key;
	
	        var value = cloneObj[key];
	        if (!value) {
	          value = 0;
	        }
	        var editable = false;
	        editable = this.isEditableOrNot(key);
	        if (editable) {
	          foundArray.push({ value: value, editable: editable, index: j, clickAway: true });
	        } else {
	          foundArray.push({ value: value, editable: editable, index: j });
	        }
	      }
	      foundArray.tagNo = tagNo;
	      return foundArray;
	    },
	    binaryInsert: function binaryInsert(value, array, startVal, endVal) {
	      if (!value) {
	        value = 0;
	      }
	
	      var length = array.length;
	      var start = typeof startVal !== 'undefined' ? startVal : 0;
	      var end = typeof endVal !== 'undefined' ? endVal : length - 1;
	      var m = start + Math.floor((end - start) / 2);
	
	      if (length === 0) {
	        array.push(value + '%');
	        return;
	      }
	      var endItem = array[end].slice(0, -1);
	      var startItem = array[start].slice(0, -1);
	      var mItem = array[m].slice(0, -1);
	
	      if (value > endItem) {
	        array.splice(end + 1, 0, value + '%');
	        return;
	      }
	      if (value < startItem) {
	        array.splice(start, 0, value + '%');
	        return;
	      }
	      if (start >= end) {
	        return;
	      }
	      if (value < mItem) {
	        this.binaryInsert(value, array, start, m - 1);
	        return;
	      }
	      if (value > mItem) {
	        this.binaryInsert(value, array, m + 1, end);
	        return;
	      }
	    },
	    getOriginalData: function getOriginalData(modifyData) {
	      return (0, _lodash.find)(this.originalData.simulation, modifyData);
	    },
	    filterArray: function filterArray(va, rs) {
	      var currentVaPercent = this.originalData.currentDecision[_Constants.VENDOR_ALLOWANCE_PERCENT];
	      var currentRsPercent = this.originalData.currentDecision[_Constants.RETAIL_SAVING_PERCENT];
	
	      this.hasChanges = false;
	      this.updatedData = {};
	      var simulation = this.originalData.simulation;
	      var arrayOfSimSugg = [];
	      va = Number(va.toString().replace(/[^0-9\\.]+/g, ''));
	      this.slider1CurrentValue = va;
	
	      rs = Number(rs.toString().replace(/[^0-9\\.]+/g, ''));
	      this.slider2CurrentValue = rs;
	
	      if (currentVaPercent !== this.slider1CurrentValue || currentRsPercent !== this.slider2CurrentValue) {
	        this.hasChanges = true;
	      } else {
	        this.hasChanges = false;
	      }
	
	      for (var i = 0; i < simulation.length; i++) {
	        var obj = simulation[i];
	        if (obj['vendorAllowancePercent'] === va && obj['retailSavingsPercent'] === rs) {
	          var foundArray = [];
	          foundArray = this.formTableData(obj, foundArray);
	          arrayOfSimSugg.push(foundArray);
	        }
	      }
	      if (arrayOfSimSugg.length) {
	        return arrayOfSimSugg;
	      } else {
	        var emptyArray = [];
	        for (var k = 0; k < this.table1Header.length; k++) {
	          var key = this.table1Header[k].key;
	          if (key && key.trim()) {
	            emptyArray.push({ value: 0, editable: false, index: k, clickAway: true });
	          }
	        }
	        return emptyArray;
	      }
	    },
	    isEditableOrNot: function isEditableOrNot(key) {
	      var obj = this.originalHeader[key];
	      if (obj) {
	        if (obj.fn.includes('makeEditable')) {
	          return true;
	        }
	      }
	      return false;
	    },
	    setGraphRows: function setGraphRows(filterUnit) {
	      var localArray = (0, _lodash.cloneDeep)(this.originalData.simulation);
	      localArray = (0, _lodash.filter)(localArray, { 'vendorAllowancePercent': this.slider1CurrentValue });
	      localArray = (0, _lodash.sortBy)(localArray, 'retailSavingsPercent');
	      var data = localArray.map(function (simulation) {
	        return [simulation.retailSavings.toString(), simulation[filterUnit] ? simulation[filterUnit] : 0];
	      });
	      this.rows = data;
	    },
	    getTable2ContainerWidth: function getTable2ContainerWidth() {
	      try {
	        if (document.getElementById('table2ContainerDiv') && document.getElementById('table2HeaderContainer')) {
	          var tableContainerDiv = document.getElementById('table2ContainerDiv').clientWidth;
	          var tableHeaderContainer = document.getElementById('table2HeaderContainer').clientWidth;
	          var paddingOnInnerDiv = 40;
	          this.modifyTable2HeightByData('#table2HeaderContainer');
	          this.modifyTable2HeightByData('#table2BodyContainer div');
	          return tableContainerDiv - tableHeaderContainer - paddingOnInnerDiv + 'px';
	        }
	      } catch (e) {
	        return 0;
	      }
	    },
	    getTable1ContainerWidth: function getTable1ContainerWidth() {
	      try {
	        if (document.getElementById('table1ContainerDiv') && document.getElementById('table1HeaderContainer')) {
	          var tableContainerDiv = document.getElementById('table1ContainerDiv').clientWidth;
	          var tableHeaderContainer = document.getElementById('table1HeaderContainer').clientWidth;
	          var paddingOnInnerDiv = 40;
	          this.modifyTableHeightByData('#table1HeaderContainer');
	          this.modifyTableHeightByData('#table1BodyContainer div');
	          return tableContainerDiv - tableHeaderContainer - paddingOnInnerDiv + 'px';
	        }
	      } catch (e) {
	        return 0;
	      }
	    },
	    updateChanges: function updateChanges(record) {
	      var regex = new RegExp(/^\d{1,4}(\.\d{1,2})?$/);
	      var response = { result: false };
	      if (!regex.test(record.value)) {
	        response = { result: true, msg: 'Value is not accepted.' };
	      }
	      if (response.result) {
	        this.processData();
	        this.updateTable1BySlider1Changes();
	        this.updateTable1BySlider2Changes();
	        this.pop({
	          header: 'ERROR!',
	          message: response.msg,
	          type: 'ERROR'
	        });
	      } else {
	        var result = this.performCalculation(this.table1Data[1], record);
	        if (result.opt) {
	          this.pop({
	            header: 'ERROR!',
	            message: result.msg,
	            type: 'ERROR'
	          });
	          this.processData();
	          this.updateTable1BySlider1Changes();
	          this.updateTable1BySlider2Changes();
	        } else {
	          this.refreshColumnData(record);
	
	          var inputObj = {
	            itemId: this.duplicatedItemName.id,
	            storeLevel: this.storeLevel,
	            period: this.period,
	            tagNo: this.table1Data[1].tagNo,
	            updatedData: this.updatedData
	          };
	
	          this.fetchCalculationFields(inputObj);
	        }
	      }
	    },
	    refreshColumnData: function refreshColumnData(record) {
	      var index = record.index,
	          value = record.value;
	
	      var updatedKey = this.table1Header[index].key;
	
	      this.updatedData[updatedKey] = value;
	    },
	    modifyTableHeightByData: function modifyTableHeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.table1Data, this.table1BodyWidth, '1.5rem', '1rem');
	      tableHeightAdjustment.modifyTableRowHeight(el);
	    },
	    modifyTable2HeightByData: function modifyTable2HeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.table2Data, this.scrollableChildrenWidth, '1.5rem', '1rem');
	      tableHeightAdjustment.modifyTableRowHeight(el);
	    }
	  })
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _SearchableDropDown = __webpack_require__(73);
	
	var _SearchableDropDown2 = _interopRequireDefault(_SearchableDropDown);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      itemArrays: [],
	      selectedItem: null,
	      rows: null,
	      chartEvents: {
	        ready: this.fillColor
	      },
	      toolTipStyle: 'style="width: 180px; padding: 5px; font-size: 1.5rem; font-weight: bold"',
	      duplicatedItemName: null,
	      homeRouterPath: '/pending-offers'
	    };
	  },
	  created: function created() {
	    this.itemArrays = this.offerItems;
	    this.selectedItem = this.itemArrays[0];
	    this.selectedItem = this.itemArrays[0];
	    if (!this.selectedItem) {
	      this.$router.push(this.homeRouterPath);
	    }
	    this.duplicatedItemName = (0, _lodash.cloneDeep)(this.selectedItem);
	  },
	
	  watch: {
	    'gettersWaterfallChartData.data': function gettersWaterfallChartDataData() {
	      this.processData();
	    },
	    'gettersWaterfallChartData.error': function gettersWaterfallChartDataError() {
	      if (this.gettersWaterfallChartData.error) {
	        var msg = this.gettersWaterfallChartData.error ? this.gettersWaterfallChartData.error : 'Opps got unknown error';
	        this.pop({
	          header: 'ERROR!!',
	          message: msg + ', please click back button.',
	          type: 'ERROR'
	        });
	      }
	    },
	    selectedItem: function selectedItem() {
	      if (this.selectedItem.id) {
	        this.duplicatedItemName = (0, _lodash.cloneDeep)(this.selectedItem);
	        var _gettersAggInputData = this.gettersAggInputData,
	            storeLevel = _gettersAggInputData.storeLevel,
	            period = _gettersAggInputData.period;
	
	        this.fetchWaterfallChartData({ itemId: this.selectedItem.id, storeLevel: storeLevel.id, period: period.id });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersOfferDetails: NameSpace.GET_OFFER_ITEMS,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
	    gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
	    gettersWaterfallChartData: NameSpace.GET_WATERFALL_DATA
	  }), {
	    offerItems: function offerItems() {
	      var parentArray = this.gettersOfferDetails.detailedData;
	      return parentArray.map(function (arr) {
	        return { name: arr[0], id: arr.itemId };
	      });
	    },
	    graphData: function graphData() {
	      return this.gettersWaterfallChartData.data.graphData;
	    },
	    labels: function labels() {
	      return this.gettersWaterfallChartData.data.labels;
	    },
	    colors: function colors() {
	      return this.gettersWaterfallChartData.data.colors;
	    },
	    columns: function columns() {
	      return [{
	        'type': 'string'
	      }, {
	        'type': 'number'
	      }, {
	        'type': 'number'
	      }, {
	        'type': 'number'
	      }, {
	        'type': 'number'
	      }, {
	        type: 'string',
	        role: 'tooltip',
	        'p': {
	          'html': true
	        }
	      }];
	    },
	    options: function options() {
	      return {
	        tooltip: { isHtml: true },
	        chartArea: {
	          width: '80%'
	        },
	        legend: 'none',
	        animation: {
	          duration: 600,
	          easing: 'out',
	          startup: true
	        },
	        height: 450,
	        width: 1000,
	        bar: {
	          groupWidth: '30%'
	        },
	        vAxis: {
	          title: 'Dollar(s) $'
	        },
	        title: this.gettersSelectedOffer.name,
	        candlestick: {
	          fallingColor: { strokeWidth: 0, fill: '#a52714' },
	          risingColor: { strokeWidth: 0, fill: '#0f9d58' } }
	      };
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchWaterfallChartData: NameSpace.FETCH_WATERFALL_DATA,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION
	  }), {
	    processData: function processData() {
	      this.setRows();
	    },
	    setRows: function setRows() {
	      var _this = this;
	
	      var graphData = this.graphData;
	
	      if (graphData) {
	        var result = (0, _keys2.default)(graphData).map(function (data) {
	          var label = _this.labels[data];
	          var zeroth = graphData[data][0];
	          var oneth = graphData[data][1];
	          var tooltip = '';
	          if (data === 'baseLineMargin' || data === 'total') {
	            oneth = Math.round(oneth * 100) / 100;
	            tooltip = tooltip.concat('<div ' + _this.toolTipStyle + '>' + label + ' : ' + oneth + '</div>');
	          } else {
	            var delta = oneth - zeroth;
	            delta = Math.round(delta * 100) / 100;
	            tooltip = tooltip.concat('<div ' + _this.toolTipStyle + '>' + label + ' : ' + delta + '</div>');
	          }
	          return [label, zeroth, zeroth, oneth, oneth, tooltip];
	        });
	        this.rows = result;
	      } else {
	        this.rows = [];
	      }
	    }
	  }),
	  components: {
	    SearchableDropdown: _SearchableDropDown2.default
	  }
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      hasError: false,
	      hasWarnings: false
	    };
	  },
	
	  watch: {},
	  methods: (0, _extends3.default)({
	    close: function close() {
	      this.actionResetMistakesInUpload();
	    }
	  }, (0, _vuex.mapActions)({
	    actionResetMistakesInUpload: NameSpace.ACTION_RESET_UPLOAD_FILE
	  })),
	  props: ['clearErrors', 'mistakes']
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _xlsx = __webpack_require__(391);
	
	var _xlsx2 = _interopRequireDefault(_xlsx);
	
	var _Dropdown = __webpack_require__(98);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Upload = __webpack_require__(337);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	var _Error = __webpack_require__(335);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      fileUploadId1: 'fileUploadId1',
	      selectedPeriod: null,
	      defaultText: 'Select Period',
	      clearUploadButtonText: null,
	
	      filterArray: ['error', 'warnings', 'UPC'],
	      cancelUpload: true
	    };
	  },
	
	  components: {
	    Dropdown: _Dropdown2.default,
	    Upload: _Upload2.default,
	    Error: _Error2.default
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    actionUploadFile: NameSpace.ACTION_UPLOAD_FILE,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    actionMistakesInUpload: NameSpace.ACTION_MISTAKES_IN_UPLOAD_FILE,
	    loader: NameSpace.LOADER_SHOW_ACTION
	  }), {
	    uploadFile: function uploadFile(file) {
	      var extension = file.name.split('.').pop();
	      if (extension === 'xlsx' || extension === 'xls') {
	        this.showPopUpMessage(file);
	      } else {
	        this.pop({
	          header: 'File Not Supported.',
	          message: 'Only allow xlsx or xls file',
	          type: 'ERROR'
	        });
	      }
	    },
	    showPopUpMessage: function showPopUpMessage(file) {
	      this.pop({
	        header: 'INFORMATION',
	        message: 'Existing data of selected period will be modified by your upload. Are you sure?',
	        buttons: {
	          accept: {
	            text: 'YES',
	            action: this.validateExcelFile.bind(this, file)
	          },
	          decline: {
	            text: 'NO',
	            present: true
	          }
	        }
	      });
	    },
	    validateExcelFile: function validateExcelFile(file) {
	      var _this = this;
	
	      this.cancelUpload = true;
	      this.loader(true);
	      var self = this;
	      setTimeout(function () {
	        var reader = new FileReader();
	        var submitOfferErrorArray = [];
	        reader.onload = function (e) {
	          var data = e ? e.target.result : reader.content;
	          var offer = _xlsx2.default.read(data, { type: 'binary' });
	          var result = {};
	          var hasUpc = false;
	          var key = '12 DIGIT UNIT UPC (NO DASHES)';
	          try {
	            offer.SheetNames.forEach(function (sheetName) {
	              var range = _xlsx2.default.utils.decode_range(offer.Sheets[sheetName]['!ref']);
	              var C = range.s.r;
	              var R = range.s.r;
	
	              for (C = range.s.c; C <= range.e.c; ++C) {
	                var cell = offer.Sheets[sheetName][_xlsx2.default.utils.encode_cell({ c: C, r: R })];
	                if (cell && cell['v'] === key) {
	                  hasUpc = true;
	                  break;
	                }
	              }
	              var roa = _xlsx2.default.utils.sheet_to_row_object_array(offer.Sheets[sheetName]);
	
	              result[sheetName] = roa;
	            });
	          } catch (e) {
	            _this.hasUpc = false;
	          }
	
	          if (hasUpc) {
	            self.validateXlsxContents(result, key, submitOfferErrorArray);
	          } else {
	            _this.pop({
	              header: 'Error',
	              message: 'The file uploaded doesn\'t match expected format',
	              type: 'ERROR'
	            });
	          }
	          self.loader(false);
	          if (submitOfferErrorArray.length > 0) {
	            self.actionMistakesInUpload({ mistake: submitOfferErrorArray, error: true });
	          } else if (!self.cancelUpload) {
	            self.actionUploadFile({
	              period: _this.selectedPeriod.id,
	              file: file,
	              type: 'OfferFile',
	              name: 'offerFile.xlsx',
	              filterArray: _this.filterArray
	            });
	
	            self.isFileUploaded = true;
	          }
	          self.clearUploadButtonText = true;
	          file = null;
	        };
	        reader.readAsBinaryString(file);
	      }, 100);
	    },
	    validateXlsxContents: function validateXlsxContents(result, key, submitOfferErrorArray) {
	      var _this2 = this;
	
	      var arraContent = result.Sheet1;
	      var alreadyError = false;
	      if (arraContent.length === 0) {
	        this.pop({
	          header: 'Error',
	          message: 'The file you are trying to upload doesn\'t have any data',
	          type: 'ERROR'
	        });
	        this.cancelUpload = true;
	        alreadyError = true;
	      } else {
	        arraContent.forEach(function (upc, i) {
	          if (upc.hasOwnProperty(key)) {
	            if (!upc[key]) {
	              _this2.cancelUpload = true;
	              alreadyError = true;
	              submitOfferErrorArray.push({
	                mistakes: {
	                  error: ['UPC cannot be blank in row ' + (i + 2)]
	                }
	              });
	            }
	          } else {
	            _this2.cancelUpload = true;
	            alreadyError = true;
	            submitOfferErrorArray.push({
	              mistakes: {
	                error: ['UPC cannot be blank in row ' + (i + 2)]
	              }
	            });
	          }
	        });
	      }
	      if (!alreadyError) {
	        var duplicateUpc = [];
	        var arrayOfUpc = arraContent.map(function (e) {
	          return e[key];
	        });
	        for (var i = 0; i < arrayOfUpc.length; i++) {
	          if (i !== arrayOfUpc.lastIndexOf(arrayOfUpc[i])) {
	            duplicateUpc.push(arrayOfUpc[i]);
	            break;
	          }
	        }
	        if (duplicateUpc.length) {
	          this.pop({
	            header: 'Error',
	            message: 'The file has duplicate UPC: ' + duplicateUpc,
	            type: 'ERROR'
	          });
	          this.cancelUpload = true;
	        } else {
	          this.cancelUpload = false;
	        }
	      }
	    }
	  }),
	  watch: {
	    uploadResult: function uploadResult() {
	      if (this.uploadResult.success) {
	        this.pop({
	          header: 'File Upload',
	          message: this.uploadResult.success,
	          type: 'SUCCESS'
	        });
	      }
	    },
	    clearUploadButtonText: function clearUploadButtonText() {
	      var self = this;
	      setTimeout(function () {
	        self.clearUploadButtonText = null;
	      }, 0);
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersLandingInfo: NameSpace.GET_LANDING_DATA,
	    gettersAggInputDataName: NameSpace.GET_AGG_INPUT_FILTER_NAME,
	    uploadResult: NameSpace.GETTER_UPLOAD_FILE_RESPONSE
	  }), {
	    periods: function periods() {
	      var data = this.gettersLandingInfo.data;
	      if (data && data.periods) {
	        return data.periods.map(function (e) {
	          var obj = {};
	          obj.id = e;
	          obj.name = e;
	          return obj;
	        });
	      } else {
	        return [];
	      }
	    }
	  })
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _mouseEvents = __webpack_require__(151);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      file: null
	    };
	  },
	
	  props: ['period', 'uploadFile', 'disabled', 'clearUploadButtonText'],
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    pop: _NameSpace.SET_MODAL_CONFIG_ACTION,
	    actionDownloadMerchantTemplate: _NameSpace.ACTION_DOWNLOAD_MERCHANT_TEMPLATE
	  }), {
	    uploadInit: function uploadInit() {
	      var uploadInput = document.getElementById('uploadInput');
	      uploadInput.value = '';
	      (0, _mouseEvents.mouseEventTrigger)(uploadInput, 'click');
	    },
	    uploadStart: function uploadStart(event) {
	      this.file = event.target.files[0];
	      var extension = this.file.name.split('.').pop();
	      if (extension !== 'xlsx' && extension !== 'xls') {
	        this.file = null;
	        this.pop({
	          header: 'Invalid File',
	          message: '.xlsx, .xls are the only supported file types',
	          buttons: {
	            accept: {
	              text: 'Try again'
	            }
	          },
	          type: 'ERROR'
	        });
	      } else {
	        this.checkFileSize(this.file);
	      }
	    },
	    uploadFileInitiate: function uploadFileInitiate() {
	      this.uploadFile(this.file);
	    },
	    checkFileSize: function checkFileSize(file) {
	      if ('size' in file && file.size / 1048576 > 1) {
	        this.pop({
	          header: 'Alert',
	          message: 'Are you sure to upload file of size ' + ((file.size / 1048576).toFixed(3) + ' Mb?'),
	          buttons: {
	            accept: {
	              text: 'OK'
	            },
	            decline: {
	              text: 'CANCEL',
	              present: true
	            }
	          },
	          type: null
	        });
	      } else {
	        this.uploadFileInitiate(file);
	      }
	    },
	    downloadTemplateMerchant: function downloadTemplateMerchant() {
	      this.actionDownloadMerchantTemplate();
	    }
	  }),
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    modalResponse: _NameSpace.MODAL_RESPONSE_GETTER,
	    gettersDownloadError: _NameSpace.GET_DOWNLOAD_ERROR
	  }), {
	    uploadButtonClass: function uploadButtonClass() {
	      return {
	        'primary-green-bg': !this.disabled,
	        'primary-text-grey': this.disabled
	      };
	    }
	  }),
	  watch: {
	    modalResponse: function modalResponse() {},
	    clearUploadButtonText: function clearUploadButtonText() {
	      if (this.clearUploadButtonText) {
	        this.file = null;
	      }
	    },
	    'gettersDownloadError': function gettersDownloadError() {
	      this.pop({
	        header: 'Download Failed!',
	        message: this.gettersDownloadError,
	        type: 'ERROR'
	      });
	    }
	  }
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Validation = __webpack_require__(75);
	
	var _lodash = __webpack_require__(13);
	
	var _Constants = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      username: '',
	      password: '',
	      credentialStatus: null,
	      forgotPasswordMode: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    authStateObject: NameSpace.AUTH_GETTER,
	    forgotPasswordStatus: NameSpace.GET_FORGOT_PASSWORD_STATUS
	  }), {
	    authState: function authState() {
	      return this.authStateObject.auth;
	    },
	    authError: function authError() {
	      return this.authStateObject.error;
	    },
	    forgotPasswordSuccess: function forgotPasswordSuccess() {
	      return this.forgotPasswordStatus.success;
	    },
	    forgotPasswordFail: function forgotPasswordFail() {
	      return this.forgotPasswordStatus.error;
	    },
	    isMerchant: function isMerchant() {
	      if (this.authState && this.authState.user_group) {
	        return this.checkAuthorize(this.authState.user_group);
	      }
	    }
	  }),
	  watch: {
	    authError: function authError() {
	      if (this.authError) {
	        this.pop({
	          header: 'Login Failed!',
	          message: this.authError,
	          type: 'ERROR'
	        });
	        this.clearErrors();
	      }
	    },
	    authState: function authState() {
	      if (this.authState.sessionToken) {
	        if (this.isMerchant) {
	          this.$router.push({ name: 'PendingApproval' });
	        }
	      }
	    },
	    credentialStatus: function credentialStatus() {
	      if (this.credentialStatus !== true) {
	        this.pop(this.credentialStatus);
	      }
	    },
	    forgotPasswordSuccess: function forgotPasswordSuccess() {
	      if (this.forgotPasswordSuccess) {
	        this.pop({
	          header: 'Success!',
	          message: 'Check your email for a verification link',
	          type: 'SUCCESS'
	        });
	      }
	    },
	    forgotPasswordFail: function forgotPasswordFail() {
	      if (this.forgotPasswordFail) {
	        this.pop({
	          header: 'Error!',
	          message: this.forgotPasswordFail,
	          type: 'ERROR'
	        });
	      }
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    authorize: NameSpace.ASYNC_AUTH_ACTION,
	    clearErrors: NameSpace.CLEAR_AUTH_ERRORS_ACTION,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    resetPassword: NameSpace.RESET_PASSWORD
	  }), {
	    checkAuthorize: function checkAuthorize(userGroup) {
	      if (userGroup.indexOf(_Constants.MERCHANT_ROLE) !== -1) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    resetLoginForm: function resetLoginForm() {
	      this.username = '';
	      this.password = '';
	    },
	    forgotPasswordModeActivate: function forgotPasswordModeActivate() {
	      this.forgotPasswordMode = true;
	      this.username = '';
	    },
	    forgotPasswordModeDeactivate: function forgotPasswordModeDeactivate() {
	      this.forgotPasswordMode = false;
	      this.username = '';
	    },
	    forgotPassword: function forgotPassword(username) {
	      if (typeof username === 'string' && username.trim().length > 0) {
	        this.resetPassword(username);
	        this.resetLoginForm();
	      }
	    },
	    verifyCredentials: function verifyCredentials(username, password) {
	      if (!(0, _Validation.present)(username, password)) {
	        if (username.trim().length === 0 && password.trim().length === 0) {
	          return {
	            header: 'Invalid Input!',
	            message: 'Email and password cannot be blank.',
	            type: 'ERROR'
	          };
	        } else if (username.trim().length === 0) {
	          return {
	            header: 'Invalid Input!',
	            message: 'Email cannot be blank.',
	            type: 'ERROR'
	          };
	        } else if (password.trim().length === 0) {
	          var msg = 'Password cannot be blank.';
	          if (!(0, _Validation.validEmail)(username)) {
	            msg = 'Email format is not valid and password cannot be blank.';
	          }
	          return {
	            header: 'Invalid Input!',
	            message: msg,
	            type: 'ERROR'
	          };
	        }
	      } else {
	        if (!(0, _Validation.validEmail)(username)) {
	          return {
	            header: 'Invalid Input!',
	            message: 'Email format is not valid.',
	            type: 'ERROR'
	          };
	        } else if (!(0, _Validation.isValidPassword)(password)) {}
	      }
	      return true;
	    },
	    login: function login(username, password) {
	      (0, _lodash.debounce)(function (username, password) {
	        this.credentialStatus = this.verifyCredentials(username, password);
	        if (this.credentialStatus === true) {
	          this.authorize({ username: username, password: password });
	          this.resetLoginForm();
	        }
	      }, 1000).call(this, username, password);
	    },
	    submitByMode: function submitByMode(username, password) {
	      if (this.forgotPasswordMode) {
	        this.forgotPassword(username);
	      } else {
	        this.login(username, password);
	      }
	    }
	  })
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Userlogo = __webpack_require__(340);
	
	var _Userlogo2 = _interopRequireDefault(_Userlogo);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var _superUser = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      navToggle: false,
	      hideHead: false,
	      scrollHeight: 0,
	      landingScreen: '/pending-offers',
	      isSuperUser: false
	    };
	  },
	  beforeMount: function beforeMount() {
	    if ((0, _superUser.isSuperUser)()) {
	      this.isSuperUser = true;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    getSelectedMerchant: _NameSpace.GET_SELECTED_MERCHANT
	  }), {
	    email: function email() {
	      var vendor = (0, _superUser.getVendorId)();
	      if (vendor) {
	        return vendor.name;
	      }
	    },
	    merchant: function merchant() {
	      var merchant = this.getSelectedMerchant;
	      if (merchant && merchant.name) {
	        return merchant.name;
	      }
	      return null;
	    }
	  }),
	  components: {
	    Userlogo: _Userlogo2.default
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    actionCollapseNavBar: _NameSpace.ACTION_NAV_BAR_COLLAPSE
	  }), {
	    logout: function logout() {
	      localStorage.clear();
	      window.location.assign('/');
	    },
	    checkScrollAmount: function checkScrollAmount(e) {
	      if (e.target.scrollTop > 20 && window.innerWidth >= 1000) {
	        this.hideHead = true;
	        this.actionCollapseNavBar(true);
	      }
	
	      this.adaptiveScreenHeight();
	    },
	    adaptiveScreenHeight: function adaptiveScreenHeight() {
	      var windowHeight = window.innerHeight;
	      var navHeight = document.getElementById('navbar').offsetHeight;
	      this.scrollHeight = windowHeight - navHeight - 10;
	    },
	    toggleNavbar: function toggleNavbar() {
	      this.navToggle = !this.navToggle;
	      this.hideHead = this.navToggle ? false : this.hideHead;
	    },
	    goHome: function goHome() {
	      this.$router.push(this.landingScreen);
	    }
	  }),
	  mounted: function mounted() {
	    this.adaptiveScreenHeight();
	  }
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _colours = __webpack_require__(137);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      username: '',
	      spriteText: '',
	      imageLink: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    authState: NameSpace.AUTH_GETTER
	  }), {
	    user: function user() {
	      return this.authState.auth;
	    }
	  }),
	  created: function created() {
	    var name = this.user.name;
	    this.spriteText = name ? name.charAt(0).toUpperCase() + name.slice(1) : '';
	  },
	
	  methods: {
	    randomColorGenerator: function randomColorGenerator() {
	      var _randomColour = (0, _colours.randomColour)(),
	          r = _randomColour.r,
	          g = _randomColour.g,
	          b = _randomColour.b;
	
	      return 'rgb(' + r + ',' + g + ',' + b + ')';
	    }
	  }
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _VerticalHeaderTable = __webpack_require__(133);
	
	var _VerticalHeaderTable2 = _interopRequireDefault(_VerticalHeaderTable);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _tableStyles = __webpack_require__(143);
	
	var _SideBar = __webpack_require__(99);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _mainContainerStyle = __webpack_require__(49);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Main = __webpack_require__(131);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _vuex = __webpack_require__(5);
	
	var _height = __webpack_require__(39);
	
	var _stickyNotifications = __webpack_require__(134);
	
	var _stickyNotifications2 = _interopRequireDefault(_stickyNotifications);
	
	var _superUser = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      headers: null,
	      tableData: null,
	      aggregatedData: null,
	      aggregatedTablePadding: {
	        length: 30
	      },
	      detailedDataPadding: {
	        length: 40
	      },
	      detailedData: [],
	      tableStyles: _tableStyles.tableStyles,
	      sideBarToggle: false,
	      mainContainerStyle: _mainContainerStyle.mainContainerStyle,
	      popUp: false,
	      showToggleButton: true,
	      scrollableWidth: '0px',
	      scrollableChildrenWidth: 15,
	      sideBarType: 'offerList',
	      popUpType: null,
	      defaultNote: 'Data will be displayed here once you select your offer name from sidebar.',
	      simulationRouteName: 'simulation',
	      waterfallRouteName: 'waterfall',
	      previousRouterPath: '/pending-offers/selected-offers',
	      nextPastRouterPath: '/chart-graph-simulation',
	      previousPastRouterPath: '/pending-offers/selected-offers',
	      landingScreen: '/pending-offers',
	      msg: ['Values must meet the following:-', '1. Should only be numeric.', '2. Can either start by +, - or digits', '3. Can have max two digits before or after decimal point.'],
	      editPetDepotFunding: this.submitEditedData,
	      sideBarTitle: 'OFFER NAMES',
	      marginLeft: 0,
	      pastOrPendingFlag: 'PENDING',
	      tableContainerWidth: 0,
	      screenName: 'ItemLevel',
	      offerTypeFlag: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersGoalsAndDisplay: NameSpace.GET_GOALS_AND_DISPLAY,
	    gettersOfferNames: NameSpace.GET_OFFERS,
	    gettersOfferDetails: NameSpace.GET_OFFER_DETAILS_DATA,
	    gettersOfferDetailsError: NameSpace.GET_OFFER_DETAILS_ERRORS,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
	    gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
	    gettersAggCellData: NameSpace.GET_SELECTED_AGG_DATA
	  }), {
	    offerName: function offerName() {
	      var offerName = this.gettersSelectedOffer.name;
	      if (offerName && offerName.length > 60) {
	        return offerName.substring(0, 60) + '...';
	      }
	      return offerName;
	    },
	    filteredOffers: function filteredOffers() {
	      var offers = this.gettersOfferNames.data;
	      if (offers && offers.length > 0) {
	        return offers.map(function (e) {
	          return { name: e[0].value, id: e[0].id };
	        });
	      }
	    },
	    offerStatus: function offerStatus() {
	      return this.gettersAggCellData.status;
	    },
	    buttonEnabled: function buttonEnabled() {
	      if ((0, _superUser.isSuperUser)()) {
	        return true;
	      }
	      return this.gettersOfferDetails.functionable;
	    }
	  }),
	  beforeDestroy: function beforeDestroy() {
	    this.resetOfferDetails();
	    this.resetFunctionable();
	  },
	
	  watch: {
	    gettersGoalsAndDisplay: function gettersGoalsAndDisplay() {
	      if (this.gettersGoalsAndDisplay.value) {
	        this.popUpType = 'goalsAndDisplayType';
	        this.popUp = true;
	        this.mainContainerStyle = _mainContainerStyle.mainContainerStyle.mainStyle.goalsAndDisplayStyle;
	      }
	    },
	    gettersOfferDetails: function gettersOfferDetails() {
	      this.headers = this.gettersOfferDetails.headers;
	      this.aggregatedData = this.gettersOfferDetails.aggregatedData;
	
	      var orginalData = this.gettersOfferDetails.detailedData;
	
	      this.detailedData = orginalData;
	    },
	    gettersOfferDetailsError: function gettersOfferDetailsError() {
	      if (this.gettersOfferDetailsError) {
	        this.refreshOffersData();
	        this.pop({
	          header: 'Validation Failed!',
	          message: this.gettersOfferDetailsError,
	          type: 'ERROR',
	          buttons: {
	            accept: {
	              text: 'OKAY'
	            }
	          }
	        });
	      }
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    actionRequestOfferDetails: NameSpace.REQUEST_OFFER_DETAILS_DATA,
	    actionGetGoalsAndDisplay: NameSpace.ACTION_GOALS_AND_DISPLAY,
	    actionEditPetDepotFunding: NameSpace.ACTION_UPDATE_PET_DEPOT_FUNDING,
	    resetFunctionable: NameSpace.RESET_FUNCTIONABLE_TO_DEFAULT,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    resetOfferDetails: NameSpace.RESET_OFFER_DETAILS
	  }), {
	    refreshOffersData: function refreshOffersData() {
	      if (this.pastOrPendingFlag === 'PAST') {
	        this.offerTypeFlag = false;
	        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, actual_calc: true });
	      } else {
	        this.offerTypeFlag = true;
	        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id });
	      }
	    },
	    submitEditedData: function submitEditedData(record, id) {
	      var value = record.value;
	      if (this.validateInputField(value)) {
	        this.refreshOffersData();
	        this.pop({
	          header: 'Validation Failed!',
	          message: this.msg,
	          type: 'ERROR'
	        });
	      } else {
	        this.actionEditPetDepotFunding({
	          offerId: this.gettersSelectedOffer.id,
	          storeLevel: this.gettersAggInputData.storeLevel.id,
	          petDepotFunding: value,
	          itemId: id
	        });
	      }
	    },
	    openSideBar: function openSideBar(e) {
	      this.sideBarToggle = true;
	      this.showToggleButton = false;
	    },
	    closeSideBar: function closeSideBar(e) {
	      this.showToggleButton = true;
	      this.sideBarToggle = false;
	    },
	    getScrollableWidth: function getScrollableWidth() {
	      if (this.headers !== null && document.getElementById('offersComponentInnerDiv') && document.getElementById('offersHeaderContainer') && document.getElementById('offersSummaryContainer')) {
	        var offersComponentInnerDiv = document.getElementById('offersComponentInnerDiv').clientWidth;
	        var offersHeaderContainer = document.getElementById('offersHeaderContainer').clientWidth;
	        var offersSummaryContainer = document.getElementById('offersSummaryContainer').clientWidth;
	        var paddingOnInnerDiv = 50;
	        return offersComponentInnerDiv - offersHeaderContainer - offersSummaryContainer - paddingOnInnerDiv;
	      }
	    },
	    getMarginLeft: function getMarginLeft() {
	      if (this.headers !== null && document.getElementById('offersComponentInnerDiv') && document.getElementById('offersHeaderContainer') && document.getElementById('offersSummaryContainer')) {
	        var offersComponentInnerDiv = document.getElementById('offersHeaderContainer').clientWidth;
	        var aggDataContainer = document.getElementById('offersSummaryContainer');
	        var scrollWrapper = document.getElementById('outer-div-min');
	        var diff = offersComponentInnerDiv + aggDataContainer.clientWidth;
	        diff = diff + 15;
	        this.tableContainerWidth = scrollWrapper.clientWidth - (diff + 40);
	        return diff;
	      }
	    },
	    getScrollableChildrenWidth: function getScrollableChildrenWidth(n) {
	      return 100 / n + '%';
	    },
	    showGoalsAndDisplay: function showGoalsAndDisplay() {
	      this.popUp = true;
	      var offerId = this.gettersSelectedOffer;
	      if (offerId && offerId.id) {
	        this.actionGetGoalsAndDisplay({ offerId: offerId.id });
	      } else {
	        this.actionGetGoalsAndDisplay();
	      }
	    },
	    closePopUp: function closePopUp(value) {
	      if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value.hasOwnProperty('goHome')) {
	        this.popUp = false;
	        this.$router.push(value.path);
	      }
	      this.popUp = value;
	    },
	    balanceTableHeight: function balanceTableHeight(reference, checkElWidth) {
	      if (this.hasScrollBars(reference, checkElWidth)) {
	        for (var _len = arguments.length, moveAbleEls = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          moveAbleEls[_key - 2] = arguments[_key];
	        }
	
	        moveAbleEls.forEach(function (el) {
	          el.style.top = '-22px';
	        });
	      }
	    },
	    hasScrollBars: function hasScrollBars(el, width) {
	      if (this.headers !== null) {
	        return el.scrollWidth > width;
	      }
	    },
	    rejectOffer: function rejectOffer() {
	      this.popUpType = 'rejectOffer';
	      this.popUp = true;
	      this.mainContainerStyle = _mainContainerStyle.mainContainerStyle.mainStyle.rejectOffer;
	    },
	    approveWithChanges: function approveWithChanges() {
	      this.popUpType = 'approveWithChanges';
	      this.popUp = true;
	      this.mainContainerStyle = _mainContainerStyle.mainContainerStyle.mainStyle.approveWithChanges;
	    },
	    screenAdjustment: function screenAdjustment() {
	      this.scrollableWidth = this.getScrollableWidth();
	      this.marginLeft = this.getMarginLeft();
	      this.modifyTableHeightByData('#offersHeaderContainer');
	      this.modifyTableHeightByData('#offersSummaryContainer');
	      this.modifyTableHeightByData('#offersDetailsScrollableX .inline-block.margin-fix');
	    },
	    openChartsVue: function openChartsVue() {
	      if (this.buttonEnabled) {
	        this.$router.push({ name: this.simulationRouteName, params: { buttonEnabled: this.buttonEnabled } });
	      } else {
	        this.$router.push({ name: this.waterfallRouteName, params: { buttonEnabled: this.buttonEnabled } });
	      }
	    },
	    childEvent: function childEvent(data) {
	      if (this.gettersSelectedOffer.id && this.gettersAggInputData.storeLevel && this.gettersAggInputData.storeLevel.id) {
	        if (this.pastOrPendingFlag === 'PAST') {
	          this.offerTypeFlag = false;
	          this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, actual_calc: true });
	        } else {
	          this.offerTypeFlag = true;
	          this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id });
	        }
	      }
	    },
	    validateInputField: function validateInputField(value) {
	      var regex = new RegExp(/^([+-])?\d{1,2}(\.\d{1,2})?$/);
	      if (!regex.test(value)) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    topScrollContainer: function topScrollContainer() {
	      var scrollWrapper = document.getElementById('scrollWrapper');
	      var actualWrapper = document.getElementById('offersDetailsScrollableX');
	      actualWrapper.scrollLeft = scrollWrapper.scrollLeft;
	    },
	    bottomScrollContainer: function bottomScrollContainer() {
	      var actualWrapper = document.getElementById('scrollWrapper');
	      var scrollWrapper = document.getElementById('offersDetailsScrollableX');
	      actualWrapper.scrollLeft = scrollWrapper.scrollLeft;
	    },
	    modifyTableHeightByData: function modifyTableHeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.detailedData, this.scrollableChildrenWidth, '1.2rem', '1rem');
	      if (this.detailedData && this.detailedData.length) tableHeightAdjustment.modifyTableRowHeight(el);
	    }
	  }),
	  created: function created() {
	    if (this.$route.name === 'selectPastOffers') this.pastOrPendingFlag = 'PAST';else this.pastOrPendingFlag = 'PENDING';
	
	    if (this.gettersSelectedOffer && this.gettersAggInputData.storeLevel && this.gettersAggInputData.storeLevel.id) {
	      if (this.pastOrPendingFlag === 'PAST') {
	        this.offerTypeFlag = false;
	        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, actual_calc: true });
	      } else {
	        this.offerTypeFlag = true;
	        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id });
	      }
	    } else {
	      this.$router.push(this.landingScreen);
	    }
	  },
	  mounted: function mounted() {
	    this.screenAdjustment();
	  },
	  updated: function updated() {
	    this.$nextTick(function () {
	      this.screenAdjustment();
	    });
	  },
	
	  components: {
	    VerticalHeaderTable: _VerticalHeaderTable2.default,
	    DataTable: _DataTable2.default,
	    SideBar: _SideBar2.default,
	    PopUp: _Main2.default,
	    stickyNotifications: _stickyNotifications2.default
	  }
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _tableStyles = __webpack_require__(144);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _SideBar = __webpack_require__(99);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _height = __webpack_require__(39);
	
	var _VerticalHeaderTable = __webpack_require__(133);
	
	var _VerticalHeaderTable2 = _interopRequireDefault(_VerticalHeaderTable);
	
	var _superUser = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      tableStyles: _tableStyles.tableStyles,
	      scrollableWidth: '0px',
	      scrollableChildrenWidth: 14,
	      headerWidth: 0,
	      sideBarToggle: true,
	      popUptype: 'pendingApprovals',
	      sideBarTitle: 'Filter Section',
	      type: 'record',
	      nextRouterPath: '/past-offers/selected-offers',
	
	      buttonDisabled: true,
	      defaultNote: 'Data will be displayed here once you submit data from sidebar.',
	      showToggleButton: false,
	      actualTimer: null,
	      eastimatedTimer: null,
	      isLoginSuperUser: false,
	      scrollableTableWidth: '100rem',
	      marginLeft: 0,
	      showEstimated: false,
	      showActual: false
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchPendingOffer: NameSpace.ACTION_PENDING_APPROVALS,
	    setSelectedAggData: NameSpace.ACTION_SELECTED_AGG_DATA,
	    actionDownloadAllDetails: NameSpace.ACTION_DOWNLOAD_ALL_DETAILS,
	    actionDownloadDax: NameSpace.ACTION_DOWNLOAD_DAX,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    sendConfiramtionMail: NameSpace.ACTION_SEND_CONFIRMATION_MAIL
	  }), {
	    collapseEstimatedTable: function collapseEstimatedTable(value) {
	      this.showEstimated = !value;
	    },
	    collapseActualTable: function collapseActualTable(value) {
	      this.showActual = !value;
	    },
	    getCellRecord: function getCellRecord(record) {
	      var splittedArray = record.split(' ');
	      var arrayResult = [];
	      for (var i = 0; i < splittedArray.length; i++) {
	        var text = splittedArray[i];
	        if (text.includes('-')) {
	          var indexOfMinus = text.indexOf('-');
	          var part1 = text.substring(0, indexOfMinus);
	          if (part1) {
	            arrayResult.push(part1);
	          }
	          var part2 = text.substring(indexOfMinus, text.length);
	          if (part2) {
	            var part2Index = part2.indexOf(')');
	            var first = part2.substring(0, part2Index);
	            if (first) {
	              arrayResult.push(first);
	            }
	            var second = part2.substring(part2Index, part2.length);
	            if (second) {
	              arrayResult.push(second);
	            }
	          } else {
	            arrayResult.push(part2);
	          }
	        } else {
	          arrayResult.push(text);
	        }
	      }
	      return arrayResult;
	    },
	    getScrollableWidth: function getScrollableWidth() {
	      if (this.fixedTableData.length > 0 && document.getElementById('selectedOffersInnerDiv') && document.getElementById('selectedOffersFixedHeaderContainer') && document.getElementById('selectedOffersScrollableHeaderContainer')) {
	        var selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth;
	        var selectedOffersFixedHeaderContainer = document.getElementById('selectedOffersFixedHeaderContainer').clientWidth;
	        var element = document.getElementById('selectedOffersScrollableHeaderContainer');
	        var selectedOffersScrollableHeaderContainer = element.clientWidth;
	        var selectedOffersHeaderContainer = Math.max(selectedOffersFixedHeaderContainer, selectedOffersScrollableHeaderContainer);
	        this.headerWidth = selectedOffersHeaderContainer;
	        var paddingOnInnerDiv = 50;
	
	        this.modifyTableHeightByData('#offersListScrollableX div div');
	        this.modifyTableHeightByData('#selectedOffersScrollableHeaderContainer');
	        return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv;
	      }
	    },
	    modifyTableHeightByData: function modifyTableHeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.scrollableTablePendingData, this.scrollableChildrenWidth, '1.5rem', '1rem');
	      var outerDivMinWidth = document.getElementById('outerDivMinId').clientWidth;
	      this.scrollableTableWidth = document.getElementById('fixedContanerId').clientWidth;
	      this.marginLeft = (outerDivMinWidth - this.scrollableTableWidth - 40) / 2;
	      if (this.scrollableTablePendingData && this.scrollableTablePendingData.length) tableHeightAdjustment.modifyTableRowHeight(el);
	    },
	    openSideBar: function openSideBar(e) {
	      this.sideBarToggle = true;
	      this.showToggleButton = false;
	    },
	    closeSideBar: function closeSideBar(e) {
	      this.showToggleButton = true;
	      this.sideBarToggle = false;
	    },
	    childEvent: function childEvent(record) {
	      var value = record.value,
	          others = record.others;
	
	      var update = {};
	      update.makeLink = others.clickable;
	      update.object = others.itemToOfferMapping;
	      update.status = others.status;
	      update.value = value;
	      if (others.clickable) {
	        this.setSelectedAggData(update);
	
	        this.$router.push(this.nextRouterPath);
	      }
	    },
	    fetchAggregatedOffer: function fetchAggregatedOffer(input) {
	      input.actual_calc = true;
	      if ((0, _superUser.isSuperUser)()) {
	        this.isLoginSuperUser = true;
	        var vendor = (0, _superUser.getVendorId)();
	        if (vendor) {
	          input.manufacturerId = vendor.value;
	        }
	      }
	      this.fetchPendingOffer(input);
	    },
	    getPendingApprovals: function getPendingApprovals(object) {
	      var obj = {};
	      if (object.offers) {
	        obj.offers = object.offers.id;
	      }
	      if (object.period) {
	        obj.period = object.period.id;
	      }
	      if (object.department) {
	        obj.departmentId = object.department.id;
	      }
	      if (object.subDepartment) {
	        obj.subDepartmentId = object.subDepartment.id;
	      }
	      if (object.class) {
	        obj.classId = object.class.id;
	      }
	      if (object.subClass) {
	        obj.subClassId = object.subClass.id;
	      }
	      if (object.brand) {
	        obj.brandId = object.brand.id;
	      }
	      if (object.storeLevel) {
	        obj.storeLevel = object.storeLevel.id;
	      }
	      console.log('In submit of created:', obj);
	      this.fetchAggregatedOffer(obj);
	    },
	    scrollSimulateByActual: function scrollSimulateByActual(e) {
	      var actualId = document.getElementById('actualId');
	      var estimatedId = document.getElementById('estimatedId');
	      if (this.eastimatedTimer) {
	        clearTimeout(this.eastimatedTimer);
	      }
	      this.actualTimer = setTimeout(function () {
	        estimatedId.scrollTop = actualId.scrollTop;
	      }, 0);
	    },
	    scrollSimulateByEstimated: function scrollSimulateByEstimated(e) {
	      var actualId = document.getElementById('actualId');
	      var estimatedId = document.getElementById('estimatedId');
	      if (this.actualTimer) {
	        clearTimeout(this.actualTimer);
	      }
	      this.eastimatedTimer = setTimeout(function () {
	        actualId.scrollTop = estimatedId.scrollTop;
	      }, 0);
	    },
	    downloadAllDetails: function downloadAllDetails() {
	      var obj = this.gettersAggInputDataId;
	      this.actionDownloadAllDetails({ offerCategory: obj.offers.id, period: obj.period.id });
	    },
	    downloadDax: function downloadDax() {
	      var obj = this.gettersAggInputDataId;
	      this.actionDownloadDax({ period: obj.period.id });
	    },
	    sendMail: function sendMail() {
	      this.pop({
	        header: 'CONFIRMATION',
	        message: 'Are you sure to send mail?',
	        buttons: {
	          accept: {
	            text: 'OKAY',
	            action: this.sendAcceptMail.bind(this)
	          },
	          decline: {
	            text: 'CANCEL',
	            present: true
	          }
	        }
	      });
	    },
	    sendAcceptMail: function sendAcceptMail() {
	      var obj = this.gettersAggInputDataId;
	      this.sendConfiramtionMail({ period: obj.period.id });
	    }
	  }),
	  mounted: function mounted() {
	    this.scrollableWidth = this.getScrollableWidth();
	  },
	  created: function created() {
	    var windowWidth = window.innerWidth;
	    if (windowWidth > 900 && windowWidth < 1200) {
	      this.scrollableChildrenWidth = 12;
	    }
	    if (windowWidth > 1200 && windowWidth < 1400) {
	      this.scrollableChildrenWidth = 16;
	    }
	    if (windowWidth > 1400 && windowWidth < 1600) {
	      this.scrollableChildrenWidth = 22;
	    }
	    if (windowWidth > 1600 && windowWidth < 2400) {
	      this.scrollableChildrenWidth = 30;
	    }
	    var obj = this.gettersAggInputDataId;
	    if ((0, _keys2.default)(obj).length) {
	      this.getPendingApprovals(obj);
	    }
	  },
	  updated: function updated() {
	    this.$nextTick(function () {
	      this.scrollableWidth = this.getScrollableWidth();
	    });
	  },
	
	  watch: {
	    scrollableTablePastData: function scrollableTablePastData() {
	      if (this.scrollableTablePastData && this.scrollableTablePastData.length) {
	        this.buttonDisabled = false;
	      }
	    },
	    'gettersDownloadError': function gettersDownloadError() {
	      this.pop({
	        header: 'Download Failed!',
	        message: this.gettersDownloadError,
	        type: 'ERROR'
	      });
	    },
	    getterConfiramtionMailResponse: function getterConfiramtionMailResponse() {
	      if (this.getterConfiramtionMailResponse) {
	        this.pop({
	          header: 'RESULT',
	          message: this.getterConfiramtionMailResponse
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    fixedTable: NameSpace.GET_AGGREGATED_FIX_TABLE,
	    scrollableTablePending: NameSpace.GET_PENDING_AGGREGATED_SCROLLABLE_TABLE,
	    scrollableTablePast: NameSpace.GET_PAST_AGGREGATED_SCROLLABLE_TABLE,
	    gettersAggInputDataId: NameSpace.GET_AGG_INPUT_FILTER_ID,
	    gettersDownloadError: NameSpace.GET_DOWNLOAD_ERROR,
	    getterConfiramtionMailResponse: NameSpace.GETTER_CONFIRMATION_MAIL_RESPONSE,
	    getterNavBarCollapse: NameSpace.GET_NAV_BAR_COLLAPSE
	  }), {
	    fixedTableData: function fixedTableData() {
	      return this.fixedTable;
	    },
	    scrollableTablePendingData: function scrollableTablePendingData() {
	      return this.scrollableTablePending;
	    },
	    scrollableTablePastData: function scrollableTablePastData() {
	      return this.scrollableTablePast;
	    }
	  }),
	  components: {
	    DataTable: _DataTable2.default,
	    SideBar: _SideBar2.default,
	    VerticalHeaderTable: _VerticalHeaderTable2.default
	  }
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _tableStyles = __webpack_require__(145);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _SideBar = __webpack_require__(99);
	
	var _SideBar2 = _interopRequireDefault(_SideBar);
	
	var _stickyNotifications = __webpack_require__(134);
	
	var _stickyNotifications2 = _interopRequireDefault(_stickyNotifications);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _height = __webpack_require__(39);
	
	var _superUser = __webpack_require__(40);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      tableStyles: _tableStyles.tableStyles,
	      scrollableWidth: '0px',
	      scrollableChildrenWidth: 0,
	      headerWidth: 0,
	      sideBarToggle: true,
	      popUptype: 'pendingApprovals',
	      sideBarTitle: 'Filter Section',
	      type: 'record',
	      nextRouterPath: '/pending-offers/selected-offers',
	
	      buttonDisabled: true,
	      buttonDisabledTemp: true,
	      defaultNote: 'Data will be displayed here once you submit data from sidebar.',
	      showToggleButton: false,
	      isLoginSuperUser: false,
	      scrollableTableWidth: '100rem',
	      marginLeft: 0
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchPendingOffer: NameSpace.ACTION_PENDING_APPROVALS,
	    setSelectedAggData: NameSpace.ACTION_SELECTED_AGG_DATA,
	    actionDownloadAllDetails: NameSpace.ACTION_DOWNLOAD_ALL_DETAILS,
	    actionDownloadManufacturerInfo: NameSpace.ACTION_DOWNLOAD_MANUFACTURER_INFO,
	    actionDownloadNegativeMarginItems: NameSpace.ACTION_DOWNLOAD_NEGATIVEMARGIN_ITEMS,
	    actionDownloadDax: NameSpace.ACTION_DOWNLOAD_DAX,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    sendConfiramtionMail: NameSpace.ACTION_SEND_CONFIRMATION_MAIL,
	    resetPendingData: NameSpace.RESET_PENDING_APPROVALS,
	    downloadPortalGuide: NameSpace.ACTION_DOWNLOAD_PORTAL_GUIDE
	  }), {
	    downloadManufacturerInfo: function downloadManufacturerInfo() {
	      var payload = {};
	      if (this.isLoginSuperUser) {
	        var merchant = this.getSelectedMerchant;
	        if (merchant && merchant.value !== undefined) {
	          payload.merchantId = merchant.value;
	        }
	      }
	      this.actionDownloadManufacturerInfo(payload);
	    },
	    downloadNegativeMarginItems: function downloadNegativeMarginItems() {
	      var payload = {};
	      if (this.isLoginSuperUser) {
	        var merchant = this.getSelectedMerchant;
	        if (merchant && merchant.value !== undefined) {
	          payload.merchantId = merchant.value;
	        }
	      }
	      this.actionDownloadNegativeMarginItems(payload);
	    },
	    getCellRecord: function getCellRecord(record) {
	      var splittedArray = record.split(' ');
	      var arrayResult = [];
	      for (var i = 0; i < splittedArray.length; i++) {
	        var text = splittedArray[i];
	        if (text.includes('-')) {
	          var indexOfMinus = text.indexOf('-');
	          var part1 = text.substring(0, indexOfMinus);
	          if (part1) {
	            arrayResult.push(part1);
	          }
	          var part2 = text.substring(indexOfMinus, text.length);
	          if (part2) {
	            var part2Index = part2.indexOf(')');
	            var first = part2.substring(0, part2Index);
	            if (first) {
	              arrayResult.push(first);
	            }
	            var second = part2.substring(part2Index, part2.length);
	            if (second) {
	              arrayResult.push(second);
	            }
	          } else {
	            arrayResult.push(part2);
	          }
	        } else {
	          arrayResult.push(text);
	        }
	      }
	      return arrayResult;
	    },
	    getScrollableWidth: function getScrollableWidth() {
	      if (this.fixedTableData.length > 0 && document.getElementById('selectedOffersInnerDiv') && document.getElementById('selectedOffersFixedHeaderContainer') && document.getElementById('selectedOffersScrollableHeaderContainer')) {
	        var selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth;
	        var selectedOffersFixedHeaderContainer = document.getElementById('selectedOffersFixedHeaderContainer').clientWidth;
	        var selectedOffersScrollableHeaderContainer = document.getElementById('selectedOffersScrollableHeaderContainer').clientWidth;
	        var selectedOffersHeaderContainer = Math.max(selectedOffersFixedHeaderContainer, selectedOffersScrollableHeaderContainer);
	        this.headerWidth = selectedOffersHeaderContainer;
	        var paddingOnInnerDiv = 50;
	
	        this.modifyTableHeightByData('#offersListScrollableX div div');
	        this.modifyTableHeightByData('#selectedOffersScrollableHeaderContainer');
	        return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv;
	      }
	    },
	    modifyTableHeightByData: function modifyTableHeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.scrollableTableData, this.scrollableChildrenWidth, '1.5rem', '1rem');
	      var outerDivMinWidth = document.getElementById('outerDivMinId').clientWidth;
	      this.scrollableTableWidth = document.getElementById('fixedContanerId').clientWidth;
	      this.marginLeft = (outerDivMinWidth - this.scrollableTableWidth - 40) / 2;
	
	      if (this.scrollableTableData && this.scrollableTableData.length) tableHeightAdjustment.modifyTableRowHeight(el);
	    },
	    openSideBar: function openSideBar(e) {
	      this.sideBarToggle = true;
	      this.showToggleButton = false;
	    },
	    closeSideBar: function closeSideBar(e) {
	      this.showToggleButton = true;
	      this.sideBarToggle = false;
	    },
	    childEvent: function childEvent(record) {
	      var value = record.value,
	          others = record.others;
	
	      var update = {};
	      update.makeLink = others.clickable;
	      update.object = others.itemToOfferMapping;
	      update.status = others.status;
	      update.value = value;
	      if (others.clickable) {
	        this.setSelectedAggData(update);
	
	        this.$router.push(this.nextRouterPath);
	      }
	    },
	    fetchAggregatedOffer: function fetchAggregatedOffer(input) {
	      if ((0, _superUser.isSuperUser)()) {
	        this.isLoginSuperUser = true;
	        var vendor = (0, _superUser.getVendorId)();
	        if (vendor) {
	          input.manufacturerId = vendor.value;
	        }
	      }
	      var merchant = this.getSelectedMerchant;
	      if (merchant) {
	        input.merchantId = merchant.value;
	      }
	      this.fetchPendingOffer(input);
	    },
	    getPendingApprovals: function getPendingApprovals(object) {
	      var obj = {};
	      if (object.offers) {
	        obj.offers = object.offers.id;
	      }
	      if (object.period) {
	        obj.period = object.period.id;
	      }
	      if (object.department) {
	        obj.departmentId = object.department.id;
	      }
	      if (object.subDeparmethodstment) {
	        obj.subDepartmentId = object.subDepartment.id;
	      }
	      if (object.class) {
	        obj.classId = object.class.id;
	      }
	      if (object.subClass) {
	        obj.subClassId = object.subClass.id;
	      }
	      if (object.brand) {
	        obj.brandId = object.brand.id;
	      }
	      if (object.storeLevel) {
	        obj.storeLevel = object.storeLevel.id;
	      }
	
	      this.fetchAggregatedOffer(obj);
	    },
	    downloadAllDetails: function downloadAllDetails() {
	      var obj = this.gettersAggInputDataId;
	      this.actionDownloadAllDetails({ offerCategory: obj.offers.id, period: obj.period.id });
	    },
	    downloadDax: function downloadDax() {
	      var obj = this.gettersAggInputDataId;
	      this.actionDownloadDax({ period: obj.period.id });
	    },
	    sendMail: function sendMail() {
	      this.pop({
	        header: 'CONFIRMATION',
	        message: 'Are you sure to send mail?',
	        buttons: {
	          accept: {
	            text: 'OKAY',
	            action: this.sendAcceptMail.bind(this)
	          },
	          decline: {
	            text: 'CANCEL',
	            present: true
	          }
	        }
	      });
	    },
	    sendAcceptMail: function sendAcceptMail() {
	      var obj = this.gettersAggInputDataId;
	      this.sendConfiramtionMail({ period: obj.period.id });
	    }
	  }),
	  mounted: function mounted() {
	    this.scrollableWidth = this.getScrollableWidth();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.resetPendingData();
	  },
	  created: function created() {
	    if ((0, _superUser.isSuperUser)()) {
	      this.isLoginSuperUser = true;
	    }
	    var windowWidth = window.innerWidth;
	    if (windowWidth > 900 && windowWidth < 1200) {
	      this.scrollableChildrenWidth = 12;
	    }
	    if (windowWidth > 1200 && windowWidth < 1400) {
	      this.scrollableChildrenWidth = 16;
	    }
	    if (windowWidth > 1400 && windowWidth < 1600) {
	      this.scrollableChildrenWidth = 24;
	    }
	    if (windowWidth > 1600 && windowWidth < 2400) {
	      this.scrollableChildrenWidth = 30;
	    }
	    var obj = this.gettersAggInputDataId;
	    if ((0, _keys2.default)(obj).length) {
	      this.getPendingApprovals(obj);
	    }
	  },
	  updated: function updated() {
	    this.$nextTick(function () {
	      this.scrollableWidth = this.getScrollableWidth();
	    });
	  },
	
	  watch: {
	    scrollableTableData: function scrollableTableData() {
	      if (this.scrollableTableData && this.scrollableTableData.length) {
	        this.buttonDisabled = false;
	      }
	    },
	    'gettersDownloadError': function gettersDownloadError() {
	      this.pop({
	        header: 'Download Failed!',
	        message: this.gettersDownloadError,
	        type: 'ERROR'
	      });
	    },
	    getterConfiramtionMailResponse: function getterConfiramtionMailResponse() {
	      if (this.getterConfiramtionMailResponse) {
	        this.pop({
	          header: 'RESULT',
	          message: this.getterConfiramtionMailResponse
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    fixedTable: NameSpace.GET_AGGREGATED_FIX_TABLE,
	    scrollableTable: NameSpace.GET_PENDING_AGGREGATED_SCROLLABLE_TABLE,
	    gettersAggInputDataId: NameSpace.GET_AGG_INPUT_FILTER_ID,
	    gettersDownloadError: NameSpace.GET_DOWNLOAD_ERROR,
	    getterConfiramtionMailResponse: NameSpace.GETTER_CONFIRMATION_MAIL_RESPONSE,
	    getterNavBarCollapse: NameSpace.GET_NAV_BAR_COLLAPSE,
	    getSelectedMerchant: NameSpace.GET_SELECTED_MERCHANT
	  }), {
	    fixedTableData: function fixedTableData() {
	      return this.fixedTable;
	    },
	    scrollableTableData: function scrollableTableData() {
	      return this.scrollableTable;
	    }
	  }),
	  components: {
	    DataTable: _DataTable2.default,
	    SideBar: _SideBar2.default,
	    stickyNotifications: _stickyNotifications2.default
	  }
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _tableStyles = __webpack_require__(77);
	
	var _mainContainerStyle = __webpack_require__(49);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Main = __webpack_require__(131);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _lodash = __webpack_require__(13);
	
	var _height = __webpack_require__(39);
	
	var _Validation = __webpack_require__(75);
	
	var _Constants = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      tableStyles: _tableStyles.tableStyles,
	      scrollableChildrenWidth: 15,
	      detailedDataPadding: {
	        length: 15
	      },
	      scrollableWidth: '0px',
	      mainContainerStyle: _mainContainerStyle.mainContainerStyle,
	      approveWithLockInput: {},
	      landingScreen: '/pending-offers',
	      confirmPopUp: false,
	      popUpType: 'Confirmation Query',
	      modifiedIndexValuePair: {},
	      commonOverrideIndexValuePair: {},
	      editedHeaders: [],
	      editedFields: [],
	      code: null,
	      hasChanges: false,
	      copyData: [],
	      msg: ['Values must meet the following:-', '1. Should only be numeric.', '2. Can have max four digits before and two digits after decimal point.'],
	
	      rrPos: 0,
	      sbPos: 0,
	      oiPos: 0,
	      srsPos: 0,
	      srPos: 0,
	      fundPos: 0,
	      previewDataArray: [],
	      previewHeaderArray: [],
	      childEvent: this.childEvent
	    };
	  },
	
	  props: ['handleEvent', 'confirmEventApproveWithChanges'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersAprroveWithChangesOriginal: NameSpace.GET_APPROVE_WITH_CHANGES_OLD,
	    gettersAprroveWithChanges: NameSpace.GET_APPROVE_WITH_CHANGES,
	    gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
	    gettersOfferFilterInput: NameSpace.GET_AGG_INPUT_FILTER_DATA,
	    gettersAprroveWithChangesNew: NameSpace.GET_APPROVE_WITH_CHANGES_RESULT,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA
	  }), {
	    information: function information() {
	      var data = this.gettersAprroveWithChanges.data;
	      if (data) {
	        return data;
	      } else {
	        this.hardResetApproveWithChanges();
	        this.pop({
	          header: 'STATUS',
	          message: 'There is no item to show.',
	          buttons: {
	            accept: {
	              text: 'Ok'
	            }
	          },
	          type: ''
	        });
	        this.handleEvent({ goHome: true, path: this.landingScreen });
	        return [];
	      }
	    },
	    itemRemoved: function itemRemoved() {
	      return this.gettersAprroveWithChanges.itemRemoved;
	    },
	    headers: function headers() {
	      var headers = this.gettersAprroveWithChanges.headers;
	      if (headers) {
	        this.rrPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.REGULAR_RETAIL);
	        this.sbPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.SUGGESTED_SB_ALLOWANCE);
	        this.oiPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.SUGGESTED_OI_ALLOWANCE);
	        this.srsPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.SUGGESTED_RETAIL_SAVINGS);
	        this.srPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.SUGGESTED_RETAIL);
	        this.fundPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.RETAIL_FUNDING);
	        this.maPos = headers.map(function (e) {
	          return e.key;
	        }).indexOf(_Constants.FUNDING_MERCHANT_ADJUSTED);
	      }
	      return headers;
	    },
	    confirmData: function confirmData() {
	      return {
	        contents: this.editedFields,
	        headers: this.editedHeaders,
	        code: this.code
	      };
	    }
	  }),
	  watch: {
	    itemRemoved: function itemRemoved() {
	      if (this.itemRemoved) {
	        this.pop({
	          header: 'REMOVE ITEM',
	          message: 'Successfully Remove the item.',
	          buttons: {
	            accept: {
	              text: 'Ok'
	            }
	          },
	          type: 'SUCCESS'
	        });
	      }
	    },
	    gettersAprroveWithChangesNew: function gettersAprroveWithChangesNew() {
	      if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.success) {
	        this.handleEvent(this.gettersAprroveWithChangesNew.result);
	      } else if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.result && this.gettersAprroveWithChangesNew.result.error) {
	        this.pop({
	          header: 'ERROR',
	          message: this.gettersAprroveWithChangesNew.result.error.map(function (e) {
	            var key = (0, _keys2.default)(e).pop();
	            return key + ': ' + e[key];
	          }),
	          buttons: {
	            accept: {
	              text: 'Try again?'
	            }
	          },
	          type: 'ERROR'
	        });
	      } else if (this.gettersAprroveWithChangesNew && !this.gettersAprroveWithChangesNew.success) {
	        this.pop({
	          header: 'Approve Offer',
	          message: 'Failed In Approve Offer',
	          buttons: {
	            accept: {
	              text: 'Try again?'
	            }
	          },
	          type: 'ERROR'
	        });
	      }
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchApproveWithChangs: NameSpace.FETCH_APPROVE_WITH_CHANGES,
	    submitOfferLock: NameSpace.SUBMIT_OFFER_LOCK,
	    hardResetApproveWithChanges: NameSpace.HARD_RESET_APPROVE_WITH_CHANGES,
	    actionRemoveItem: NameSpace.ACTION_REMOVE_ITEM_BY_ID,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION
	  }), {
	    getScrollableWidth: function getScrollableWidth() {
	      try {
	        if (document.getElementById('selectedOffersInnerDiv') && document.getElementById('selectedOffersHeaderContainer')) {
	          var selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth;
	          var selectedOffersHeaderContainer = document.getElementById('selectedOffersHeaderContainer').clientWidth;
	          var paddingOnInnerDiv = 40;
	          this.modifyTableHeightByData('#selectedOffersHeaderContainer');
	          this.modifyTableHeightByData('#selectedOffersDataContainer div');
	          return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv + 'px';
	        }
	      } catch (e) {
	        return 0;
	      }
	    },
	    topScroll: function topScroll(e) {
	      var actualWrapper = document.getElementById('selectedOffersDataContainer');
	      actualWrapper.scrollLeft = e.target.scrollLeft;
	    },
	    bottomScroll: function bottomScroll(e) {
	      var actualWrapper = document.getElementById('changesApproveScrollWrapper');
	      actualWrapper.scrollLeft = e.target.scrollLeft;
	    },
	    formKeyValues: function formKeyValues(bool, record) {
	      var key = this.headers[record.index].key;
	      for (var j = 0; j < this.information.length - 1; j++) {
	        if (bool) {
	          var itemKey = this.information[j].itemId;
	          this.addEditedValues(itemKey, key, record.value);
	        } else {
	          if (record.commonOverride) {
	            var _itemKey = this.information[j].itemId;
	            this.addEditedValues(_itemKey, key, this.information[j][record.index].value);
	          } else {
	            var commonOverrideKeys = (0, _keys2.default)(this.commonOverrideIndexValuePair);
	            if (commonOverrideKeys.length) {
	              for (var n = 0; n < commonOverrideKeys.length; n++) {
	                var value = this.commonOverrideIndexValuePair[commonOverrideKeys[n]];
	                if (value && value.trim().length) {
	                  var _itemKey2 = this.information[j].itemId;
	                  key = this.headers[commonOverrideKeys[n]].key;
	                  this.addEditedValues(_itemKey2, key, value);
	                } else {
	                  if (j === record.itemIndex) {
	                    var _itemKey3 = this.information[record.itemIndex].itemId;
	                    this.addEditedValues(_itemKey3, key, record.value);
	                  } else {
	                    var _itemKey4 = this.information[j].itemId;
	                    this.addEditedValues(_itemKey4, key, this.information[j][record.index].value);
	                  }
	                }
	              }
	            } else {
	              if (j === record.itemIndex) {
	                var _itemKey5 = this.information[record.itemIndex].itemId;
	                this.addEditedValues(_itemKey5, key, record.value);
	              } else {
	                var _itemKey6 = this.information[j].itemId;
	                this.addEditedValues(_itemKey6, key, this.information[j][record.index].value);
	              }
	            }
	          }
	        }
	      }
	    },
	    addEditedValues: function addEditedValues(itemKey, key, value) {
	      if (!this.approveWithLockInput[itemKey]) {
	        this.approveWithLockInput[itemKey] = (0, _defineProperty3.default)({}, key, value);
	      } else {
	        var oriObject = this.approveWithLockInput[itemKey];
	        oriObject[key] = value;
	      }
	    },
	    removeItem: function removeItem(record) {
	      this.modifiedIndexValuePair = {};
	      this.commonOverrideIndexValuePair = {};
	      var itemId = this.information[record.itemIndex].itemId;
	      this.hardResetApproveWithChanges();
	      this.actionRemoveItem({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, itemId: itemId });
	    },
	    confrimToRemove: function confrimToRemove(record) {
	      this.pop({
	        header: 'REMOVE ITEM',
	        message: 'Are you sure to remove the item? : ' + record.value,
	        type: '',
	        buttons: {
	          accept: {
	            text: 'OKAY',
	            action: this.removeItem.bind(this, record)
	          }
	        }
	      });
	    },
	    setCommonOverrideValue: function setCommonOverrideValue(isCommonOverride, valueIndex, value) {
	      if (isCommonOverride) {
	        var commonOverrideObject = this.information[this.information.length - 1];
	        value = value + '';
	        this.$set(commonOverrideObject[valueIndex], 'value', value);
	      }
	    },
	    getNewValueToSet: function getNewValueToSet(y, valueIndex, newValue, itemObjectArray) {
	      var originalObject = this.gettersAprroveWithChangesOriginal[y];
	      var co = this.information[this.information.length - 1][valueIndex];
	      if (typeof co.value !== 'undefined' && co.value.length > 0 && (co.value[0] === '+' || co.value[0] === '-')) {
	        newValue = Number(originalObject[valueIndex].value) + Number(co.value);
	        itemObjectArray[valueIndex].change = true;
	      } else if (typeof co.value !== 'undefined' && co.value.trim().length > 0) {
	        newValue = Number(co.value);
	        itemObjectArray[valueIndex].change = true;
	      } else {
	        newValue = Number(originalObject[valueIndex].value);
	        itemObjectArray[valueIndex].change = false;
	      }
	      return newValue;
	    },
	    performOperation: function performOperation(isCommonOverride, isDelta, valueIndex, value, y) {
	      var itemObjectArray = this.information[y];
	      var key = this.headers[valueIndex].key;
	      if (key === _Constants.FUNDING_MERCHANT_ADJUSTED) {
	        this.calculateFundingByMA(isCommonOverride, isDelta, value, valueIndex, itemObjectArray, y);
	      } else if (key === _Constants.SUGGESTED_RETAIL_SAVINGS) {
	        this.calculateSRAndRFbySRS(isCommonOverride, isDelta, valueIndex, value, this.srPos, null, itemObjectArray, y);
	      } else if (key === _Constants.SUGGESTED_RETAIL) {
	        this.calculateSRAndRFbySRS(isCommonOverride, isDelta, valueIndex, value, null, this.srsPos, itemObjectArray, y);
	      } else if (key === _Constants.SUGGESTED_SB_ALLOWANCE) {
	        var newValue = void 0;
	        if (value.length === 0) {
	          newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray);
	        } else {
	          itemObjectArray[valueIndex].change = true;
	          if (isDelta) {
	            var oldValue = itemObjectArray[valueIndex].value;
	            newValue = Number(oldValue) + Number(value);
	          } else {
	            newValue = Number(value);
	          }
	        }
	        itemObjectArray[valueIndex].value = newValue.toFixed(2);
	
	        this.calculateRetailFundingBySBorOI(isCommonOverride, newValue, null, itemObjectArray, valueIndex, y);
	      } else if (key === _Constants.SUGGESTED_OI_ALLOWANCE) {
	        var _newValue = void 0;
	        if (value.length === 0) {
	          _newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray);
	        } else {
	          itemObjectArray[valueIndex].change = true;
	          if (isDelta) {
	            var _oldValue = itemObjectArray[valueIndex].value;
	            _newValue = Number(_oldValue) + Number(value);
	          } else {
	            _newValue = Number(value);
	          }
	        }
	        itemObjectArray[valueIndex].value = _newValue.toFixed(2);
	
	        this.calculateRetailFundingBySBorOI(isCommonOverride, null, _newValue, itemObjectArray, valueIndex, y);
	      }
	    },
	    calculate: function calculate(isDelta, valueIndex, itemIndex, value, isCommonOverride) {
	      if (isCommonOverride) {
	        for (var y = 0; y < this.information.length - 1; y++) {
	          this.performOperation(isCommonOverride, isDelta, valueIndex, value, y);
	        }
	      } else {
	        this.performOperation(isCommonOverride, isDelta, valueIndex, value, itemIndex);
	      }
	      this.buttonCondtion();
	    },
	    buttonCondtion: function buttonCondtion() {
	      var hasChanges = false;
	      for (var i = 0; i < this.information.length; i++) {
	        var item = this.information[i];
	        for (var k = 0; k < item.length; k++) {
	          var record = item[k];
	          if (record.change) {
	            hasChanges = true;
	            this.information[i].change = true;
	            break;
	          } else {
	            this.information[i].change = false;
	          }
	        }
	      }
	      if (hasChanges) {
	        this.hasChanges = true;
	      } else {
	        this.hasChanges = false;
	      }
	    },
	    calculateFundingByMA: function calculateFundingByMA(isCommonOverride, isDelta, value, valueIndex, itemObjectArray, y) {
	      var newValue = void 0;
	
	      if (value.length === 0) {
	        newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray);
	      } else {
	        itemObjectArray[valueIndex].change = true;
	        if (isDelta) {
	          var oldValue = itemObjectArray[valueIndex].value;
	          newValue = Number(oldValue) + Number(value);
	        } else {
	          newValue = Number(value);
	        }
	      }
	      var sbAllowance = itemObjectArray[this.sbPos].value;
	      var oiAllowance = itemObjectArray[this.oiPos].value;
	      var srs = itemObjectArray[this.srsPos].value;
	      var sboi = Number(sbAllowance) + Number(oiAllowance);
	      var newPspRetailFunding = Number(srs) - sboi - newValue;
	      if (newValue > itemObjectArray[this.fundPos].value) {
	        this.hasChanges = false;
	        var cloneNewValue = (0, _lodash.cloneDeep)(newValue);
	
	        itemObjectArray[valueIndex].change = false;
	        var errorMessage = itemObjectArray[0].value + ' - Pet Depot Funding [Merchant Adjusted](' + cloneNewValue + ') should not be more than PSP Retail Funding (' + itemObjectArray[this.fundPos].value + ').';
	        this.showErrorMessage(errorMessage);
	        if (isCommonOverride) {
	          this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	          this.calculate(false, valueIndex, y, '', isCommonOverride);
	          this.calculate(false, this.fundPos, y, '', isCommonOverride);
	        } else {
	          newValue = this.getNewValueToSet(y, valueIndex, '', itemObjectArray);
	          itemObjectArray[valueIndex].value = newValue.toFixed(2);
	          this.calculateFundingByMA(isCommonOverride, false, newValue, valueIndex, itemObjectArray, y);
	        }
	        return;
	      } else {
	        itemObjectArray[valueIndex].value = newValue.toFixed(2);
	        if (newPspRetailFunding < 0) {
	          itemObjectArray[this.fundPos].value = 0;
	        } else {
	          itemObjectArray[this.fundPos].value = newPspRetailFunding.toFixed(2);
	        }
	      }
	    },
	    calculateSRAndRFbySRS: function calculateSRAndRFbySRS(isCommonOverride, isDelta, valueIndex, value, srPos, srsPos, itemObjectArray, y) {
	      var oldValue = void 0;
	      var newValue = void 0;
	
	      this.setCommonOverrideValue(isCommonOverride, valueIndex, value);
	      if (value === '') {
	        newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray);
	      } else {
	        itemObjectArray[valueIndex].change = true;
	        if (isDelta) {
	          oldValue = itemObjectArray[valueIndex].value;
	          newValue = Number(oldValue) + Number(value);
	        } else {
	          newValue = Number(value);
	        }
	      }
	      var rrValue = itemObjectArray[this.rrPos].value.substring(1);
	      if (newValue > rrValue) {
	        var cloneNewValue = (0, _lodash.cloneDeep)(newValue);
	        if (isCommonOverride) {
	          this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	          var originalObject = this.gettersAprroveWithChangesOriginal[y];
	          newValue = originalObject[valueIndex].value;
	        } else {
	          newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray);
	          itemObjectArray[valueIndex].value = newValue.toFixed(2);
	        }
	        this.hasChanges = false;
	        itemObjectArray[valueIndex].change = false;
	        if (srPos) {
	          itemObjectArray[this.srPos].value = this.getNewValueToSet(y, this.srPos, value, itemObjectArray);
	
	          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested Retail Savings(' + cloneNewValue + ')  must be less than Regular Retail.');
	
	          if (isCommonOverride) {
	            this.setCommonOverrideValue(isCommonOverride, this.srPos, '');
	            this.setCommonOverrideValue(isCommonOverride, this.srsPos, '');
	          }
	        } else if (srsPos) {
	          itemObjectArray[this.srsPos].value = this.getNewValueToSet(y, this.srsPos, value, itemObjectArray);
	
	          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested Retail(' + cloneNewValue + ') must be less than Regular Retail.');
	
	          if (isCommonOverride) {
	            this.setCommonOverrideValue(isCommonOverride, this.srsPos, '');
	            this.setCommonOverrideValue(isCommonOverride, this.srPos, '');
	          }
	        }
	      }
	
	      itemObjectArray[valueIndex].value = newValue.toFixed(2);
	      var regularRetail = itemObjectArray[this.rrPos].value;
	      if (regularRetail[0] === '$') {
	        regularRetail = regularRetail.substring(1);
	      }
	      var result = Number(regularRetail) - newValue;
	      if (srPos) {
	        itemObjectArray[srPos].value = result.toFixed(2);
	        this.setCommonOverrideValue(isCommonOverride, srPos, '');
	      } else if (srsPos) {
	        itemObjectArray[srsPos].value = result.toFixed(2);
	        this.setCommonOverrideValue(isCommonOverride, srsPos, '');
	      }
	
	      this.calculateRetailFundingBySRS(itemObjectArray);
	    },
	    setValue: function setValue(itemObjectArray, valueIndex, data) {
	      itemObjectArray[valueIndex].value = data.toFixed(2);
	    },
	    calculateRetailFundingBySBorOI: function calculateRetailFundingBySBorOI(isCommonOverride, newSB, newOI, itemObjectArray, valueIndex, y) {
	      var addition = void 0;
	      var rrValue = itemObjectArray[this.rrPos].value.substring(1);
	      var sb = void 0,
	          oi = void 0,
	          message = void 0;
	      if (newSB !== null && typeof newSB !== 'undefined') {
	        rrValue = Number(rrValue);
	        if (newSB > rrValue) {
	          var cloneNewSBValue = (0, _lodash.cloneDeep)(newSB);
	          if (isCommonOverride) {
	            this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	            var originalObject = this.gettersAprroveWithChangesOriginal[y];
	            newSB = originalObject[valueIndex].value;
	          } else {
	            newSB = this.getNewValueToSet(y, valueIndex, newSB, itemObjectArray);
	          }
	          this.hasChanges = false;
	          itemObjectArray[valueIndex].change = false;
	          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested SB Allowance(' + cloneNewSBValue + ') must be less than Regular Retail.');
	
	          this.setValue(itemObjectArray, valueIndex, newSB);
	
	          this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y);
	          return;
	        }
	        var oiAllowance = itemObjectArray[this.oiPos].value;
	        oi = oiAllowance;
	        addition = newSB + Number(oiAllowance);
	      } else if (newOI !== null && typeof newOI !== 'undefined') {
	        rrValue = Number(rrValue);
	        if (newOI > rrValue) {
	          var cloneNewOIValue = (0, _lodash.cloneDeep)(newOI);
	          if (isCommonOverride) {
	            this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	            var _originalObject = this.gettersAprroveWithChangesOriginal[y];
	            newOI = _originalObject[valueIndex].value;
	          } else {
	            newOI = this.getNewValueToSet(y, valueIndex, newOI, itemObjectArray);
	          }
	          this.hasChanges = false;
	          itemObjectArray[valueIndex].change = false;
	          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested OI Allowance(' + cloneNewOIValue + ') must be less than Regular Retail.');
	
	          this.setValue(itemObjectArray, valueIndex, newOI);
	
	          this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y);
	          return;
	        }
	        var sbAllowance = itemObjectArray[this.sbPos].value;
	        sb = sbAllowance;
	        addition = newOI + Number(sbAllowance);
	      }
	      if (addition > rrValue) {
	        if (newSB !== null && typeof newSB !== 'undefined') {
	          message = ' - (Manufacturer Suggested SB Allowance(' + newSB + ') + Manufacturer Suggested OI Allowance(' + oi + ')) must be less than Regular Retail.';
	          if (isCommonOverride) {
	            this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	            var _originalObject2 = this.gettersAprroveWithChangesOriginal[y];
	            newSB = _originalObject2[valueIndex].value;
	          } else {
	            newSB = this.getNewValueToSet(y, valueIndex, newSB, itemObjectArray);
	            itemObjectArray[valueIndex].value = newSB.toFixed(2);
	          }
	          this.setValue(itemObjectArray, valueIndex, newSB);
	        } else if (newOI !== null && typeof newOI !== 'undefined') {
	          message = ' - (Manufacturer Suggested SB Allowance(' + sb + ') + Manufacturer Suggested OI Allowance(' + newOI + ')) must be less than Regular Retail.';
	          if (isCommonOverride) {
	            this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	            var _originalObject3 = this.gettersAprroveWithChangesOriginal[y];
	            newOI = _originalObject3[valueIndex].value;
	          } else {
	            newOI = this.getNewValueToSet(y, valueIndex, newOI, itemObjectArray);
	            itemObjectArray[valueIndex].value = newOI.toFixed(2);
	          }
	          this.setValue(itemObjectArray, valueIndex, newOI);
	        }
	        this.hasChanges = false;
	        itemObjectArray[valueIndex].change = false;
	        this.showErrorMessage(itemObjectArray[0].value + message);
	
	        this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y);
	        return;
	      } else {
	        var srsValue = Number(itemObjectArray[this.srsPos].value);
	        var result = srsValue - addition;
	        result = result - Number(itemObjectArray[this.maPos].value);
	        if (result < 0) {
	          result = 0.00;
	        }
	        itemObjectArray[this.fundPos].value = result.toFixed(2);
	      }
	    },
	    calculateRetailFundingBySRS: function calculateRetailFundingBySRS(itemObjectArray) {
	      var sbAllowance = itemObjectArray[this.sbPos].value;
	      var oiAllowance = itemObjectArray[this.oiPos].value;
	      var addition = Number(sbAllowance) + Number(oiAllowance);
	      var newPspRetailFunding = Number(itemObjectArray[this.srsPos].value) - addition;
	      newPspRetailFunding = newPspRetailFunding - Number(itemObjectArray[this.maPos].value);
	      if (newPspRetailFunding < 0) {
	        newPspRetailFunding = 0.00;
	      }
	      itemObjectArray[this.fundPos].value = newPspRetailFunding.toFixed(2);
	    },
	    childEvent: function childEvent(record) {
	      var isCommonOverride = this.information.length - 1 === Number(record.itemIndex);
	
	      if (record && typeof record.event !== 'undefined') {
	        this.confrimToRemove(record);
	      } else if (record.value || record.value === '') {
	        var value = typeof record.value === 'string' ? record.value.trim() : record.value;
	        var valueIndex = record.index;
	        var itemIndex = record.itemIndex;
	        if (value.length === 0) {
	          this.calculate(false, valueIndex, itemIndex, value, isCommonOverride);
	          return;
	        }
	
	        var response = (0, _Validation.validateInputField)(null, value, isCommonOverride);
	        if (response.result) {
	          value = '';
	
	          this.hasChanges = false;
	          this.showErrorMessage(this.msg);
	        }
	        if (isCommonOverride) {
	          var firstChar = value[0];
	          if (isNaN(firstChar)) {
	            this.hasChanges = false;
	            this.setCommonOverrideValue(isCommonOverride, valueIndex, '');
	            this.showErrorMessage(this.msg);
	
	            this.calculate(true, valueIndex, itemIndex, value, isCommonOverride);
	          } else {
	            this.calculate(false, valueIndex, itemIndex, value, isCommonOverride);
	          }
	        } else {
	          this.calculate(false, valueIndex, itemIndex, value, isCommonOverride);
	        }
	        if (!response.result) {} else {}
	      }
	    },
	    showErrorMessage: function showErrorMessage(errorMessage) {
	      this.pop({
	        header: 'ERROR!!',
	        message: errorMessage,
	        type: 'ERROR'
	      });
	    },
	    validateCondition: function validateCondition(localCopy) {
	      var message = void 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(localCopy)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          var myContent = localCopy[key];
	          message = [];
	          var errorObject = {};
	          var oi = void 0,
	              sb = void 0,
	              rt = void 0;
	          for (var innerKey in myContent) {
	            if (innerKey === _Constants.SUGGESTED_SB_ALLOWANCE) {
	              sb = myContent[innerKey];
	              sb = sb * 1;
	            }
	            if (innerKey === _Constants.SUGGESTED_OI_ALLOWANCE) {
	              oi = myContent[innerKey];
	              oi = oi * 1;
	            }
	            if (innerKey === _Constants.SUGGESTED_RETAIL_SAVINGS) {
	              rt = myContent[innerKey];
	              rt = rt * 1;
	            }
	            var res = (0, _Validation.validateInputField)(innerKey, myContent[innerKey], false);
	            if (res.msg.length && !errorObject.hasOwnProperty('msg')) {
	              errorObject = res;
	            }
	
	            if (errorObject.msg) {
	              message = errorObject.msg;
	            }
	            if (!isNaN(Number(rt)) && isNaN(Number(sb)) && isNaN(Number(oi))) {} else if (!isNaN(Number(rt)) && !isNaN(Number(sb)) && isNaN(Number(oi))) {} else if (!isNaN(Number(rt)) && !isNaN(Number(oi)) && isNaN(Number(sb))) {} else if (!isNaN(Number(oi)) && !isNaN(Number(sb)) && !isNaN(Number(rt))) {}
	          }
	          if (message.length) {
	            return message;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    submitApproveLock: function submitApproveLock() {
	      var _this = this;
	
	      this.previewDataArray = [];
	      this.previewHeaderArray = [];
	      for (var h = 0; h < this.headers.length; h++) {
	        if (h === 0 || h === this.rrPos || h === this.sbPos || h === this.oiPos || h === this.srsPos || h === this.srPos || h === this.fundPos || h === this.maPos) {
	          this.previewHeaderArray.push(this.headers[h]);
	        }
	      }
	      this.information.forEach(function (item) {
	        if (item.change) {
	          var innerArray = [];
	          innerArray.push(item[0]);
	          innerArray.itemId = item.itemId;
	          for (var i = 0; i < item.length; i++) {
	            switch (i) {
	              case _this.rrPos:
	                innerArray.push(item[i]);
	                break;
	              case _this.sbPos:
	                innerArray.push(item[i]);
	                break;
	              case _this.oiPos:
	                innerArray.push(item[i]);
	                break;
	              case _this.srsPos:
	                innerArray.push(item[i]);
	                break;
	              case _this.srPos:
	                innerArray.push(item[i]);
	                break;
	              case _this.fundPos:
	                innerArray.push(item[i]);
	                break;
	              case _this.maPos:
	                innerArray.push(item[i]);
	                break;
	              default:
	            }
	          }
	          _this.previewDataArray.push(innerArray);
	        }
	      });
	      var clone = (0, _lodash.cloneDeep)(this.previewDataArray);
	      clone.forEach(function (item) {
	        item[0].arrow_for_close = false;
	        item.forEach(function (record) {
	          record.editable = false;
	        });
	      });
	      this.editedHeaders = this.previewHeaderArray;
	      this.editedFields = clone;
	
	      var submitObject = {};
	
	      var itemRecord = {};
	      this.previewDataArray.forEach(function (item) {
	        var obj = {};
	
	        for (var i = 1; i < item.length; i++) {
	          if (_this.previewHeaderArray[i]) {
	            var key = _this.previewHeaderArray[i].key;
	            obj[key] = item[i].value;
	          }
	        }
	        itemRecord[item.itemId] = obj;
	      });
	      submitObject['data'] = itemRecord;
	      submitObject['offerId'] = this.gettersSelectedOffer.id;
	      submitObject['period'] = this.gettersOfferFilterInput.period.id;
	      if (clone.length > 0) {
	        this.code = _Constants.APPROVE_WITH_CHANGES;
	      } else {
	        this.editedHeaders = [];
	        this.editedFields = [];
	        this.code = _Constants.APPROVE_WITH_NO_CHANGES;
	      }
	      this.confirmEventApproveWithChanges({ preview: this.confirmData, submit: submitObject });
	    },
	    collectEditableItemWiseData: function collectEditableItemWiseData() {},
	    modifyTableHeightByData: function modifyTableHeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.information, this.scrollableChildrenWidth, '1.3rem', '1rem');
	      tableHeightAdjustment.modifyTableRowHeight(el);
	    },
	    closePopUp: function closePopUp(value) {},
	    finalApprovedOfferData: function finalApprovedOfferData(obj) {
	      var _this2 = this;
	
	      var localInformation = (0, _lodash.cloneDeep)(this.information);
	      localInformation.pop();
	      return localInformation.map(function (e, j) {
	        return e.filter(function (records, i) {
	          if (i === 0) {
	            return e;
	          }
	          var itemId = _this2.information[j].itemId;
	          if (i in obj) {
	            e[i].editable = false;
	            e[i].value = obj[i];
	            return e;
	          }
	          if (obj && obj.hasOwnProperty(itemId)) {
	            var data = obj[itemId];
	            if (data && typeof data[i] !== 'undefined') {
	              e[i].editable = false;
	              e[i].value = data[i];
	              return e;
	            }
	          }
	        });
	      });
	    },
	    finalApprovedOfferHeaders: function finalApprovedOfferHeaders(obj) {
	      var _this3 = this;
	
	      var localHeaders = (0, _lodash.cloneDeep)(this.headers);
	      var result = [];
	
	      var _loop = function _loop(j) {
	        var itemId = _this3.information[j].itemId;
	        var c = -1;
	        localHeaders.filter(function (header) {
	          c++;
	          if (c in obj) {
	            result.push(header);
	            result = (0, _lodash.unionBy)(result, result);
	            return header;
	          }
	          if (obj && itemId && obj.hasOwnProperty(itemId)) {
	            var data = obj[itemId];
	            if (data && data[c]) {
	              result.push(localHeaders[c]);
	              result = (0, _lodash.unionBy)(result, result);
	              return localHeaders[c];
	            }
	          }
	        });
	      };
	
	      for (var j = 0; j < this.information.length; j++) {
	        _loop(j);
	      }
	      return result;
	    }
	  }),
	  mounted: function mounted() {
	    this.scrollableWidth = this.getScrollableWidth();
	  },
	  updated: function updated() {
	    var _this4 = this;
	
	    this.$nextTick(function () {
	      _this4.scrollableWidth = _this4.getScrollableWidth();
	    });
	  },
	  beforeUpdate: function beforeUpdate() {
	    this.buttonCondtion();
	  },
	  created: function created() {
	    if (this.gettersAggInputData.storeLevel && this.gettersAggInputData.storeLevel.id) {
	      this.fetchApproveWithChangs({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id });
	    }
	  },
	
	  components: {
	    DataTable: _DataTable2.default,
	    PopUp: _Main2.default
	  }
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _tableStyles = __webpack_require__(77);
	
	var _mainContainerStyle = __webpack_require__(49);
	
	var _Constants = __webpack_require__(18);
	
	var CODE = _interopRequireWildcard(_Constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      scrollableChildrenWidth: 20,
	      scrollableWidth: 20,
	      tableStyles: _tableStyles.tableStyles,
	      mainContainerStyle: _mainContainerStyle.mainContainerStyle,
	      code: CODE,
	      count: 1
	    };
	  },
	
	  methods: {
	    cancel: function cancel() {
	      window.eventBus.$emit('cancelConfirm', false);
	    },
	    submit: function submit() {
	      if (this.data.code === this.code.APPROVE_WITH_CHANGES || this.data.code === this.code.APPROVE_WITH_NO_CHANGES) {
	        window.eventBus.$emit('acceptConfirm', { code: 'approveWithChanges' });
	      } else if (this.data.code === this.code.SET_ZONE) {
	        window.eventBus.$emit('acceptConfirm', { code: 'setZone' });
	      } else if (this.data.code === this.code.REJECT_OFFER) {
	        window.eventBus.$emit('acceptConfirm', { code: 'rejectOffer' });
	      }
	    }
	  },
	  created: function created() {
	    if (this.data && this.data.contents) {
	      if (this.data.contents.length >= 3) {
	        this.count = 3;
	      } else if (this.data.contents.length === 2) {
	        this.count = 2;
	      } else {
	        this.count = 1;
	      }
	    }
	  },
	
	  props: ['data', 'handleEvent'],
	  components: {
	    DataTable: _DataTable2.default
	  }
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(105);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(13);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _HorizontalTable = __webpack_require__(132);
	
	var _HorizontalTable2 = _interopRequireDefault(_HorizontalTable);
	
	var _tableStyles = __webpack_require__(77);
	
	var _mock = __webpack_require__(146);
	
	var _selectedOffersSchema = __webpack_require__(147);
	
	var _mainContainerStyle = __webpack_require__(49);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _ConfirmationPopUp = __webpack_require__(345);
	
	var _ConfirmationPopUp2 = _interopRequireDefault(_ConfirmationPopUp);
	
	var _ApproveWithChanges = __webpack_require__(344);
	
	var _ApproveWithChanges2 = _interopRequireDefault(_ApproveWithChanges);
	
	var _Constants = __webpack_require__(18);
	
	var CODE = _interopRequireWildcard(_Constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      tableStyles: _tableStyles.tableStyles,
	      approveMessage: 'The following message has been approved by you.\n This will now be due for Promo Council ratification.\n Promo Description: ' + this.approvedData,
	      approvedData: 'Brand X, Dog Toy, Sizes Small-Large',
	      offersListHeaders: null,
	      offersListData: null,
	      mainContainerStyle: _mainContainerStyle.mainContainerStyle,
	      scrollableChildrenWidth: '0px',
	      scrollableWidth: '0px',
	      rejectOfferReason: null,
	      showZonePrice: false,
	      zoneUpdatedData: [],
	      landingScreen: '/pending-offers',
	      originalZonePrice: null,
	      overrideType: null,
	      confirmOverride: null,
	      code: null,
	      approveWithLockUpdated: null,
	      isConfirmPopUp: false,
	      changedObjects: {},
	      isDefaultChecked: true,
	      notInDisplayId: null,
	      fixedNotInDisplayId: null,
	      displayCheckBoxArray: [],
	      selectedMegaList: [],
	      selectedDisplayList: [],
	      selectedGoalList: [],
	      selectedSignatureList: [],
	      selectedThemeList: [],
	      selectedDurationList: [],
	      MEGA: '4-Pager/Mega',
	      DISPLAY: 'Display',
	      GOAL: 'goal',
	      SIGNAGE: 'SIGNAGE TYPE',
	      THEME: 'Theme',
	      DURATION: 'Duration',
	      disabledCheckboxList: [],
	      buttonDisabled: false,
	      addTextVmodel: '',
	      addTextKeyId: '',
	      addTextKeyName: '',
	      disabledApprovedButton: false,
	      headerColumn: 1
	    };
	  },
	
	  props: ['closePopUp', 'type', 'styles', 'data'],
	  watch: {
	    gettersAprroveWithChangesNew: function gettersAprroveWithChangesNew() {
	      if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.success) {
	        if (this.gettersAprroveWithChangesNew.error) {
	          this.pop({
	            header: 'WARNINGS',
	            message: this.gettersAprroveWithChangesNew.error.map(function (e) {
	              var key = (0, _keys2.default)(e).pop();
	              return key + ': ' + e[key];
	            }),
	            buttons: {
	              accept: {
	                text: 'Ok'
	              }
	            },
	            type: 'SUCCESS'
	          });
	        }
	        this.setZonePrice(this.gettersAprroveWithChangesNew.result);
	      } else if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.result && this.gettersAprroveWithChangesNew.result.error) {
	        this.styles = _mainContainerStyle.mainContainerStyle.mainStyle.approveWithChanges;
	        this.popupType = 'approveWithChanges';
	        var errorMsg = void 0;
	        if (Array.isArray(this.gettersAprroveWithChangesNew.result.error)) {
	          errorMsg = this.gettersAprroveWithChangesNew.result.error.map(function (e) {
	            var key = (0, _keys2.default)(e).pop();
	            return key + ': ' + e[key];
	          });
	        } else {
	          errorMsg = this.gettersAprroveWithChangesNew.result.error;
	        }
	        this.pop({
	          header: 'ERROR',
	          message: errorMsg,
	          buttons: {
	            accept: {
	              text: 'Ok'
	            }
	          },
	          type: 'ERROR'
	        });
	      } else if (this.gettersAprroveWithChangesNew && !this.gettersAprroveWithChangesNew.success) {
	        this.pop({
	          header: 'Approve Offer',
	          message: 'Failed In Approve Offer',
	          buttons: {
	            accept: {
	              text: 'Try again?'
	            }
	          },
	          type: 'ERROR'
	        });
	      }
	    },
	    'gettersZoneSalePrice.showAgain': function gettersZoneSalePriceShowAgain(n, o) {
	      this.isConfirmPopUp = false;
	      if (this.gettersZoneSalePrice && this.gettersZoneSalePrice.showAgain) {
	        this.showZonePrice = true;
	      } else if (this.gettersZoneSalePrice.showModal) {
	        if (this.gettersZoneSalePrice.error) {
	          this.pop({
	            header: 'Approve Offer',
	            message: 'Failed To Update Zone Prices',
	            buttons: {
	              accept: {
	                text: 'Try Again'
	              }
	            },
	            type: 'ERROR'
	          });
	        } else {
	          this.zoneUpdatedData = [];
	          this.$router.push(this.landingScreen);
	          this.pop({
	            header: 'Approve Offer',
	            message: 'Successfully Updated Zone Prices',
	            buttons: {
	              accept: {
	                text: 'Ok'
	              }
	            },
	            type: 'SUCCESS'
	          });
	        }
	      }
	    },
	    gettersStatusApproveOffer: function gettersStatusApproveOffer() {
	      this.isConfirmPopUp = false;
	      if (this.gettersStatusApproveOffer && this.gettersStatusApproveOffer.success) {
	        this.setZonePrice(this.gettersStatusApproveOffer.result);
	      } else if (this.gettersStatusApproveOffer && !this.gettersStatusApproveOffer.success) {
	        this.close();
	        this.pop({
	          header: 'Approve Offer',
	          message: 'Failed In Approve Offer: ' + this.gettersStatusApproveOffer.result,
	          buttons: {
	            accept: {
	              text: 'Ok'
	            }
	          },
	          type: 'ERROR'
	        });
	      }
	    },
	    gettersRejectOfferResult: function gettersRejectOfferResult() {
	      if (this.gettersRejectOfferResult && this.gettersRejectOfferResult.rejectOfferResult) {
	        this.close();
	        this.rejectOfferReason = null;
	        this.$router.push(this.landingScreen);
	        this.pop({
	          header: 'Reject Offer',
	          message: 'Successfully rejected the offer: ' + this.gettersRejectOfferResult.rejectOfferResult.offerName,
	          buttons: {
	            accept: {
	              text: 'Ok'
	            }
	          },
	          type: 'SUCCESS'
	        });
	      } else if (this.gettersRejectOfferResult && this.gettersRejectOfferResult.error) {
	        this.pop({
	          header: 'Approve Offer',
	          message: 'Failed in rejecting the offer.',
	          buttons: {
	            accept: {
	              text: 'Ok'
	            }
	          },
	          type: 'ERROR'
	        });
	      }
	    },
	    updateZonePriceError: function updateZonePriceError() {}
	  },
	  mounted: function mounted() {
	    this.scrollableWidth = this.getScrollableWidth();
	    this.scrollableChildrenWidth = this.getScrollableChildrenWidth();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersSelectedOfferName: NameSpace.GET_SELECTED_OFFER_NAME,
	    gettersStatusApproveOffer: NameSpace.GET_APPROVE_OFFER_SUCCESS,
	    gettersRejectOfferResult: NameSpace.GET_REJECT_OFFER_RESULT,
	    gettersZoneSalePrice: NameSpace.GET_ZONE_SALE_PRICES,
	    gettersAprroveWithChangesNew: NameSpace.GET_APPROVE_WITH_CHANGES_RESULT,
	    gettersAprroveWithChanges: NameSpace.GET_APPROVE_WITH_CHANGES
	  }), {
	    itemRemoved: function itemRemoved() {
	      return this.gettersAprroveWithChanges.itemRemoved;
	    },
	    horizontalTableHeaders: function horizontalTableHeaders() {
	      return this.gettersZoneSalePrice.headers;
	    },
	    horizontalTableData: function horizontalTableData() {
	      if (!this.originalZonePrice) {
	        this.originalZonePrice = (0, _lodash.cloneDeep)(this.gettersZoneSalePrice.data);
	      }
	      return this.gettersZoneSalePrice.data;
	    },
	    updateZonePriceError: function updateZonePriceError() {
	      if (this.gettersZoneSalePrice.error) {
	        var payload = {
	          data: (0, _lodash.cloneDeep)(this.originalZonePrice),
	          headers: this.horizontalTableHeaders,
	          error: null,
	          showAgain: true,
	          showModal: false
	        };
	        this.setZonePrice(payload);
	        return true;
	      } else {
	        return false;
	      }
	    },
	    goalsAndDisplay: function goalsAndDisplay() {
	      if (this.isDefaultChecked) {
	        this.setUpGoalsAndDispalyCategories();
	      }
	      return this.data;
	    },
	    goalsAndDisplayCategories: function goalsAndDisplayCategories() {
	      var categories = this.data ? this.data.categories : null;
	      if (categories) {
	        var headerLength = void 0;
	        var arr = [];
	        if (categories) {
	          var cat = categories;
	          for (var cate in cat) {
	            arr.push(cat[cate].length);
	          }
	          this.headerColumn = arr.length;
	          headerLength = Math.max.apply(Math, arr);
	        }
	        this.styles.height = 10 * headerLength + '%';
	        return this.data.categories;
	      } else {
	        return {};
	      }
	    },
	
	    confirmData: {
	      get: function get() {
	        this.confirmOverride;
	        this.data;
	
	        return this.confirmOverride ? this.confirmOverride : this.data;
	      },
	      set: function set(val) {
	        this.confirmOverride = val;
	      }
	    },
	    popupType: {
	      get: function get() {
	        this.overrideType;
	        this.type;
	        return this.overrideType ? this.overrideType : this.type;
	      },
	      set: function set(val) {
	        this.overrideType = val;
	      }
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    actionApproveOffers: NameSpace.ACTION_APPROVE_OFFER,
	    actionRejectOffer: NameSpace.ACTION_REJECT_OFFER,
	    actionGetGoalsAndDisplay: NameSpace.ACTION_GOALS_AND_DISPLAY,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION,
	    setZonePrice: NameSpace.SET_ZONE_STATE,
	    updateZonePrice: NameSpace.UPDATE_ZONE_STATE,
	    submitOfferLock: NameSpace.SUBMIT_OFFER_LOCK
	  }), {
	    calcH: function calcH() {
	      if (this.headerColumn === 2) {
	        return 20;
	      } else if (this.headerColumn === 3) {
	        return 10;
	      } else if (this.headerColumn === 4) {
	        return 2;
	      } else {
	        return 0;
	      }
	    },
	    setUpGoalsAndDispalyCategories: function setUpGoalsAndDispalyCategories() {
	      var _this = this;
	
	      if ((0, _typeof3.default)(this.data) === 'object') {
	        var _data = this.data,
	            categories = _data.categories,
	            type = _data.type;
	
	        var mainKeys = (0, _keys2.default)(categories);
	        mainKeys.forEach(function (key) {
	          var array = categories[key];
	          for (var k = 0; k < array.length; k++) {
	            var object = array[k];
	            if (type[key] === 'Checkbox') {
	              if (object.default_selection) {
	                if (key === _this.MEGA) {
	                  _this.selectedMegaList.push(object.id);
	                }
	                if (key === _this.GOAL) {
	                  _this.selectedGoalList.push(object.id);
	                }
	                if (key === _this.DISPLAY) {
	                  _this.selectedDisplayList.push(object.id);
	                }
	                if (key === _this.SIGNAGE) {
	                  _this.selectedSignatureList.push(object.id);
	                }
	                if (key === _this.DURATION) {
	                  _this.selectedDurationList.push(object.id);
	                }
	              }
	            }
	            if (type[key] === 'RadioButton') {
	              if (object.default_selection) {
	                if (key === _this.MEGA) {
	                  _this.selectedMegaList = object.id;
	                }
	                if (key === _this.GOAL) {
	                  _this.selectedGoalList = object.id;
	                }
	                if (key === _this.DISPLAY) {
	                  _this.selectedDisplayList = object.id;
	                }
	                if (key === _this.SIGNAGE) {
	                  _this.selectedSignatureList = object.id;
	                }
	                if (key === _this.DURATION) {
	                  _this.selectedDurationList = object.id;
	                }
	                if (key === _this.THEME) {
	                  if (object.name.toLowerCase() === 'others') {
	                    _this.addTextKeyId = object.id;
	                    _this.addTextKeyName = object.name;
	                    _this.addTextVmodel = object.text;
	                  }
	                  _this.selectedThemeList = object.id;
	                }
	              } else {
	                if (key === _this.THEME) {
	                  if (object.name.toLowerCase() === 'others') {
	                    console.log('HDUVJBFDF');
	                    _this.addTextKeyId = object.id;
	                    _this.addTextKeyName = object.name;
	                    _this.addTextVmodel = object.text;
	                  }
	                }
	              }
	            }
	          }
	          _this.isDefaultChecked = false;
	        });
	      }
	    },
	    close: function close() {
	      this.setZonePrice(null);
	      if (this.itemRemoved && this.popupType === 'approveWithChanges') {
	        this.$router.push(this.landingScreen);
	      }
	      this.closePopUp(false);
	    },
	    approveMessages: function approveMessages() {
	      return this.approveMessage.split('.');
	    },
	    getTableDataFrom: function getTableDataFrom(offersListData) {
	      return offersListData.map(function (offer) {
	        return (0, _lodash.values)(offer);
	      });
	    },
	    getOffersListHeaders: function getOffersListHeaders(offersListSchema) {
	      var listHeaders = [];
	      for (var offer in offersListSchema) {
	        listHeaders.push(offersListSchema[offer].name);
	      }
	      return listHeaders;
	    },
	    getScrollableWidth: function getScrollableWidth() {
	      try {
	        if (document.getElementById('selectedOffersInnerDiv') && document.getElementById('selectedOffersHeaderContainer')) {
	          var selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth;
	          var selectedOffersHeaderContainer = document.getElementById('selectedOffersHeaderContainer').clientWidth;
	          var paddingOnInnerDiv = 40;
	          return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv + 'px';
	        }
	      } catch (e) {
	        return 0;
	      }
	    },
	    getScrollableChildrenWidth: function getScrollableChildrenWidth(n) {
	      return 100 / n + '%';
	    },
	    showTimeZone: function showTimeZone() {
	      var result = [];
	      if (Array.isArray(this.selectedMegaList)) {
	        result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(this.selectedMegaList));
	      } else {
	        result.push(this.selectedMegaList);
	      }
	      if (Array.isArray(this.selectedDisplayList)) {
	        result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(this.selectedDisplayList));
	      } else {
	        result.push(this.selectedDisplayList);
	      }
	      if (Array.isArray(this.selectedGoalList)) {
	        result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(this.selectedGoalList));
	      } else {
	        result.push(this.selectedGoalList);
	      }
	      if (Array.isArray(this.selectedDurationList)) {
	        result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(this.selectedDurationList));
	      } else {
	        result.push(this.selectedDurationList);
	      }
	      if (Array.isArray(this.selectedSignatureList)) {
	        result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(this.selectedSignatureList));
	      }
	      if (Array.isArray(this.selectedThemeList)) {
	        result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(this.selectedThemeList));
	      } else {
	        result.push(this.selectedThemeList);
	        this.disabledApprovedButton = false;
	        var addTextIdArray = this.goalsAndDisplayCategories[this.THEME];
	        var id = (0, _lodash.find)(addTextIdArray, { 'id': this.selectedThemeList, 'name': this.addTextKeyName });
	        if (id) {
	          if (this.addTextVmodel && this.addTextVmodel.trim().length > 0) {
	            this.disabledApprovedButton = false;
	            result.push((0, _defineProperty3.default)({}, this.selectedThemeList, this.addTextVmodel));
	          } else {
	            this.pop({
	              header: 'ERROR!!',
	              message: id.name + ' option cannot be blank for ' + this.THEME + '.',
	              type: 'ERROR'
	            });
	
	            this.disabledApprovedButton = true;
	          }
	        }
	      }
	
	      var approveData = {
	        offerId: this.gettersSelectedOfferName.id,
	        goalsAndDisplayDetails: result
	      };
	      if (this.approveWithLockUpdated && !this.disabledApprovedButton) {
	        this.submitOfferLock((0, _lodash.merge)(approveData, {
	          period: this.approveWithLockUpdated.period,
	          data: this.approveWithLockUpdated.data
	        }));
	      } else {
	        if (!this.disabledApprovedButton) {
	          this.actionApproveOffers(approveData);
	        }
	      }
	    },
	    rejectOffer: function rejectOffer() {
	      if (!this.rejectOfferReason || this.rejectOfferReason.trim().length === 0) {
	        this.pop({
	          header: 'Reject Offer',
	          message: 'You must give valid reason for your rejection.',
	          buttons: {
	            accept: {
	              text: 'Try Again'
	            }
	          },
	          type: 'ERROR'
	        });
	      } else {
	        this.isConfirmPopUp = true;
	        this.confirmOverride = {
	          code: CODE.REJECT_OFFER
	        };
	      }
	    },
	    populateData: function populateData() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.horizontalTableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var data = _step.value;
	
	          if (data) {
	            var obj = {};
	            for (var i = 0; i < data.length; i++) {
	              var index = data[i].index - 1;
	              var zoneObject = data[index];
	              obj.zoneItemId = zoneObject.id;
	              obj[this.horizontalTableHeaders[i].key] = zoneObject.value;
	            }
	            this.zoneUpdatedData.push(obj);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    updateZoneData: function updateZoneData() {
	      if (this.horizontalTableData.length) {
	        var msg = ['Values must meet the following:-', '1. Should only be numeric.', '2. Can either start by +, - or digits', '3. Can have max two digits before or after decimal point.'];
	        var noError = true;
	        if ((0, _keys2.default)(this.changedObjects).length > 0) {
	          for (var obj in this.changedObjects) {
	            var key = obj;
	            var value = this.changedObjects[key];
	            if (this.validateInputField(value)) {
	              noError = false;
	              var arr = key.split(',');
	              var row = Number(arr[0]);
	              var col = Number(arr[1]);
	              msg.push(this.horizontalTableHeaders[col].value + ' value is not satisfied the validation requirements at row ' + (row + 1));
	              this.pop({
	                header: 'Validation Failed!',
	                message: msg,
	                type: 'ERROR'
	              });
	            }
	          }
	          if (noError) {
	            this.changedObjects = {};
	            this.populateData();
	            this.isConfirmPopUp = true;
	            this.confirmOverride = {
	              code: CODE.SET_ZONE
	            };
	          }
	        } else {
	          this.populateData();
	          this.isConfirmPopUp = true;
	          this.confirmOverride = {
	            code: CODE.SET_ZONE
	          };
	        }
	      }
	    },
	    horizontalTableEvent: function horizontalTableEvent(originalZonePriceData, changedValue, row, col) {
	      originalZonePriceData[row][col].value = changedValue;
	      var key = row + ',' + col;
	      this.changedObjects[key] = changedValue;
	    },
	    approveWithChangesResponse: function approveWithChangesResponse(data) {
	      if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' && data.hasOwnProperty('goHome')) {
	        this.closePopUp(data);
	      } else {
	        this.setZonePrice(data);
	      }
	    },
	    confirmEventApproveWithChanges: function confirmEventApproveWithChanges(data) {
	      if (data) {
	        this.approveWithLockUpdated = data.submit;
	        this.confirmOverride = data.preview;
	        this.isConfirmPopUp = true;
	      }
	    },
	    validateInputField: function validateInputField(value) {
	      var regex = new RegExp(/^([+-])?\d{1,2}(\.\d{1,2})?$/);
	      if (!regex.test(value)) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }),
	  created: function created() {
	    var _this2 = this;
	
	    this.selectedGoalsAndDisplay = [];
	    window.eventBus.$on('acceptConfirm', function (data) {
	      _this2.popupType = '';
	      if (data.code === 'setZone') {
	        _this2.updateZonePrice({ data: _this2.zoneUpdatedData, original: _this2.originalZonePrice });
	      } else if (data.code === 'rejectOffer' && _this2.rejectOfferReason) {
	        _this2.actionRejectOffer({ offerId: _this2.gettersSelectedOfferName.id, reason: _this2.rejectOfferReason });
	      } else if (data && data.code === 'approveWithChanges') {
	        var offerObject = _this2.gettersSelectedOfferName;
	        if (offerObject && offerObject.id) {
	          _this2.disabledApprovedButton = false;
	          _this2.actionGetGoalsAndDisplay({ offerId: offerObject.id });
	        } else {
	          _this2.disabledApprovedButton = false;
	          _this2.actionGetGoalsAndDisplay();
	        }
	        _this2.selectedMegaList = [];
	        _this2.selectedDisplayList = [];
	        _this2.selectedGoalList = [];
	        _this2.selectedSignatureList = [];
	        _this2.popupType = 'goalsAndDisplayType';
	        _this2.isConfirmPopUp = false;
	        _this2.showZonePrice = false;
	        _this2.isDefaultChecked = true;
	      }
	    });
	    window.eventBus.$on('cancelConfirm', function (data) {
	      _this2.isConfirmPopUp = false;
	    });
	    this.offersListData = this.getTableDataFrom(_mock.mockSelectedOffers.data);
	    this.offersListHeaders = this.getOffersListHeaders(_selectedOffersSchema.selectedOffersSchema);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.eventBus.$off('acceptConfirm');
	    window.eventBus.$off('cancelConfirm');
	  },
	
	  components: {
	    DataTable: _DataTable2.default,
	    HorizontalTable: _HorizontalTable2.default,
	    ConfirmationPopUp: _ConfirmationPopUp2.default,
	    ApproveWithChanges: _ApproveWithChanges2.default
	  }
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectModifier = __webpack_require__(76);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _vuex = __webpack_require__(5);
	
	var _index = __webpack_require__(75);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      profile: {
	        manufacturer: '',
	        name: '',
	        phone: '',
	        email: ''
	      },
	      validationMessages: {
	        name: {
	          length: null,
	          format: null
	        },
	        phone: {
	          length: null,
	          format: null
	        },
	        email: {
	          length: null,
	          format: null
	        }
	      },
	      text: 'Edit to update',
	      buttonDisable: true,
	      existingProfileData: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    computedProfileObject: NameSpace.GET_PROFILE,
	    authState: NameSpace.AUTH_GETTER
	  }), {
	    user: function user() {
	      return this.authState.auth;
	    },
	    computedProfile: function computedProfile() {
	      return this.computedProfileObject.profile;
	    },
	    computedProfileErrors: function computedProfileErrors() {
	      return this.computedProfileObject.error;
	    }
	  }),
	  watch: {
	    computedProfileErrors: function computedProfileErrors() {
	      if (this.computedProfileObject.error) {
	        this.pop({
	          header: 'Request Failed',
	          message: this.computedProfileErrors,
	          type: 'ERROR'
	        });
	      }
	    },
	    computedProfile: function computedProfile() {
	      this.updateAuthUser();
	      this.pop({
	        header: 'Success',
	        message: 'Profile updated successfully',
	        type: 'success'
	      });
	    }
	  },
	  created: function created() {
	    this.profile = (0, _lodash.pick)((0, _objectModifier.clone)(this.user), ['manufacturer', 'email', 'phone', 'name']);
	    if (this.profile.name === undefined) {
	      this.profile.name = '';
	    }
	    if (this.profile.email === undefined) {
	      this.profile.email = '';
	    }
	    if (this.profile.phone === undefined) {
	      this.profile.phone = '';
	    }
	    this.existingProfileData = (0, _objectModifier.clone)(this.profile);
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    updateProfileData: NameSpace.ACTION_PROFILE,
	    updateAuthUser: NameSpace.UPDATE_AUTH_USER_FROM_PROFILE,
	    pop: NameSpace.SET_MODAL_CONFIG_ACTION
	  }), {
	    editDetails: function editDetails() {
	      this.updateProfileData(this.profile);
	    },
	    validator: function validator(input, type) {
	      this.validationMessages[type] = (0, _index.validateFields)(input, type);
	      this.processButton(type);
	    },
	    processButton: function processButton(type) {
	      if (type === 'name') {
	        if (!this.disableEditButton()) {
	          this.syncButton('name');
	        } else {
	          this.syncButtonText(true, 'Update Profile');
	        }
	      }
	      if (type === 'email') {
	        if (!this.disableEditButton()) {
	          this.syncButton('email');
	        } else {
	          this.syncButtonText(true, 'Update Profile');
	        }
	      }
	      if (type === 'phone') {
	        if (!this.disableEditButton()) {
	          this.syncButton('phone');
	        } else {
	          this.syncButtonText(true, 'Update Profile');
	        }
	      }
	    },
	    disableEditButton: function disableEditButton() {
	      for (var types in this.validationMessages) {
	        for (var error in this.validationMessages[types]) {
	          if (this.validationMessages[types][error]) {
	            return true;
	          }
	        }
	      }
	      return false;
	    },
	    syncButton: function syncButton(text) {
	      if (this.profile[text] !== this.existingProfileData[text]) {
	        this.syncButtonText(false, 'Update Profile');
	      } else {
	        this.syncButtonText(true, 'Edit to update');
	      }
	    },
	    syncButtonText: function syncButtonText(bool, text) {
	      this.buttonDisable = bool;
	      this.text = text;
	    }
	  })
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(13);
	
	var _DataTable = __webpack_require__(34);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _tableStyles = __webpack_require__(148);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Dropdown = __webpack_require__(98);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _height = __webpack_require__(39);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      pastOrPendingFlag: 'PENDING',
	      selectedStoreLevelValue: null,
	      tableStyles: _tableStyles.tableStyles,
	      scrollableWidth: '0px',
	      scrollableChildrenWidth: 15,
	      type: 'record',
	      nextRouterPath: '/pending-offers/offer-select',
	      previousRouterPath: '/pending-offers',
	      nextPastRouterPath: '/past-offers/offer-select',
	      previousPastRouterPath: '/past-offers',
	      hasDataToShow: true,
	      noDataFoundText: 'No Data Found, Please try some other offer.',
	      marginLeft: 0,
	      tableContainerWidth: 0,
	      offerNameStringPadding: {
	        length: 15
	      }
	    };
	  },
	
	  watch: {
	    offersListData: function offersListData() {
	      if ((0, _keys2.default)(this.table.data).length) {
	        this.hasDataToShow = true;
	      } else {
	        this.hasDataToShow = false;
	      }
	    },
	    selectedStoreLevelValue: function selectedStoreLevelValue() {
	      if (this.selectedStoreLevelValue && this.selectedStoreLevelValue && this.selectedStoreLevelValue.id !== this.gettersAggInputData.storeLevel.id) {
	        var clonedObject = (0, _lodash.cloneDeep)(this.gettersAggInputData);
	        clonedObject.storeLevel = this.selectedStoreLevelValue;
	        this.setAggInputData(clonedObject);
	        if (this.pastOrPendingFlag === 'PAST') {
	          this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: this.selectedStoreLevelValue.id, actual_calc: true });
	        } else {
	          this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: this.selectedStoreLevelValue.id });
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.pageSetup();
	    window.addEventListener('resize', function () {
	      _this.pageSetup();
	    });
	  },
	  beforeUpdate: function beforeUpdate() {
	    var _this2 = this;
	
	    this.$nextTick(function () {
	      _this2.pageSetup();
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    table: NameSpace.GET_SELECTED_PENDING_APPROVALS,
	    gettersLandingInfo: NameSpace.GET_LANDING_DATA,
	    gettersAggCellData: NameSpace.GET_SELECTED_AGG_DATA,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA
	  }), {
	    offersListHeaders: function offersListHeaders() {
	      return this.table.headers;
	    },
	    offersListData: function offersListData() {
	      if ((0, _keys2.default)(this.table.data).length) {
	        var orginalData = this.table.data;
	        if (this.pastOrPendingFlag === 'PAST') {
	          var array = [];
	          var data = void 0;
	          for (var i = 0; i < orginalData.length; i++) {
	            data = (0, _lodash.cloneDeep)(orginalData[i]);
	            if (i > 0 && i % 2 !== 0) {
	              data[0].type = 'past';
	            }
	
	            data.lock = orginalData[i].lock;
	            data.my_offer = orginalData[i].my_offer;
	            array.push(data);
	          }
	          return array;
	        } else {
	          return orginalData;
	        }
	      } else {
	        return [];
	      }
	    },
	    data: function data() {
	      return this.gettersLandingInfo.data;
	    },
	    storeLevels: function storeLevels() {
	      if (this.data) {
	        return this.data.storeLevel;
	      }
	    }
	  }),
	  beforeDestroy: function beforeDestroy() {
	    this.resetSelectedPendingOffer();
	  },
	  created: function created() {
	    if (this.$route.name === 'selectedPastOffers') this.pastOrPendingFlag = 'PAST';else this.pastOrPendingFlag = 'PENDING';
	
	    var storeData = this.gettersAggInputData.storeLevel;
	
	    if (storeData && storeData.id) {
	      if (this.pastOrPendingFlag === 'PAST') {
	        this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: storeData.id, actual_calc: true });
	      } else {
	        this.fetchSelectedPendingOffer({ itemToOfferMapping: this.gettersAggCellData.object, storeLevel: storeData.id });
	      }
	    } else {
	      if (this.pastOrPendingFlag === 'PAST') {
	        this.$router.push(this.previousPastRouterPath);
	      } else {
	        this.$router.push(this.previousRouterPath);
	      }
	    }
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    fetchSelectedPendingOffer: NameSpace.ACTION_SELECTED_PENDING_APPROVALS,
	    setSelectedOffer: NameSpace.ACTION_SELECT_OFFER_NAME,
	    setAggInputData: NameSpace.SET_AGG_INPUT_FILTER_DATA,
	    resetSelectedPendingOffer: NameSpace.RESET_SELECTED_PENDING_APPROVALS
	  }), {
	    topScrollContainer: function topScrollContainer() {
	      var scrollWrapper = document.getElementById('selectedOfferscrollWrapper');
	      var actualWrapper = document.getElementById('offersListScrollableX');
	      actualWrapper.scrollLeft = scrollWrapper.scrollLeft;
	    },
	    bottomScrollContainer: function bottomScrollContainer() {
	      var actualWrapper = document.getElementById('selectedOfferscrollWrapper');
	      var scrollWrapper = document.getElementById('offersListScrollableX');
	      actualWrapper.scrollLeft = scrollWrapper.scrollLeft;
	    },
	    getMarginLeft: function getMarginLeft() {
	      var headerTable = document.getElementById('selectedOffersHeaderContainer').getBoundingClientRect();
	      var scrollWrapper = document.getElementById('outer-div-min');
	      this.tableContainerWidth = scrollWrapper.clientWidth - (headerTable.width + headerTable.left + 20);
	
	      return headerTable.width + headerTable.left;
	    },
	    getTableDataFrom: function getTableDataFrom(offersListData) {
	      return offersListData.map(function (offer) {
	        return (0, _lodash.values)(offer);
	      });
	    },
	    pageSetup: function pageSetup() {
	      var selectedOffersHeaderContainer = document.querySelector('#selectedOffersHeaderContainer');
	      var dataContainer = document.querySelector('#offersListScrollableX .table-container .inline-block.margin-fix');
	      if (selectedOffersHeaderContainer && dataContainer && this.hasDataToShow) {
	        this.scrollableWidth = this.getScrollableWidth();
	        this.marginLeft = this.getMarginLeft();
	        this.modifyTableHeightByData('#selectedOffersHeaderContainer');
	        this.modifyTableHeightByData('#offersListScrollableX .table-container .inline-block.margin-fix');
	      }
	    },
	    modifyTableHeightByData: function modifyTableHeightByData(el) {
	      var tableHeightAdjustment = new _height.TableHeightByFixedWidth(this.offersListData, this.scrollableChildrenWidth, '1.5rem', '1rem');
	      if (this.offersListData && this.offersListData.length) tableHeightAdjustment.modifyTableRowHeight(el);
	    },
	    getOffersListHeaders: function getOffersListHeaders(offersListSchema) {
	      var listHeaders = [];
	      for (var offer in offersListSchema) {
	        listHeaders.push(offersListSchema[offer].name);
	      }
	      return listHeaders;
	    },
	    getScrollableWidth: function getScrollableWidth() {
	      if (document.getElementById('selectedOffersInnerDiv') && document.getElementById('selectedOffersHeaderContainer')) {
	        var selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth;
	        var selectedOffersHeaderContainer = document.getElementById('selectedOffersHeaderContainer').clientWidth;
	        var paddingOnInnerDiv = 90;
	
	        return selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv;
	      }
	    },
	    balanceTableHeight: function balanceTableHeight(reference, checkElWidth) {
	      if (this.hasScrollBars(reference, checkElWidth)) {
	        for (var _len = arguments.length, moveAbleEls = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          moveAbleEls[_key - 2] = arguments[_key];
	        }
	
	        moveAbleEls.forEach(function (el) {
	          el.childNodes[0].style.top = '-22px';
	        });
	      }
	    },
	    hasScrollBars: function hasScrollBars(el, width) {
	      return el.scrollWidth > width;
	    },
	    childEvent: function childEvent(record) {
	      if (record && record.clickable) {
	        this.setSelectedOffer({ name: record.value, id: record.id });
	        if (this.pastOrPendingFlag === 'PAST') {
	          this.$router.push(this.nextPastRouterPath);
	        } else {
	          this.$router.push(this.nextRouterPath);
	        }
	      }
	    },
	    goBack: function goBack() {
	      this.$router.push(this.previousRouterPath);
	    }
	  }),
	  components: {
	    DataTable: _DataTable2.default,
	    Dropdown: _Dropdown2.default
	  }
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      selectedItemProxy: null
	    };
	  },
	
	  props: {
	    'list': {
	      required: true
	    },
	    'id': {
	      required: true
	    },
	    'defaultValue': {
	      required: false
	    },
	    'defaultText': {
	      required: true
	    },
	    'selectedItem': {
	      required: false
	    }
	  },
	  watch: {
	    list: function list() {
	      this.$emit('input', this.findDefaultObject(this.selectedItemOverride || this.defaultText));
	    }
	  },
	  computed: {
	    values: function values() {
	      return this.list;
	    },
	
	    selectedItemOverride: {
	      get: function get() {
	        this.selectedItemProxy;
	        this.selectedItem;
	        return this.selectedItemProxy ? this.selectedItemProxy : this.selectedItem;
	      },
	      set: function set(value) {
	        this.selectedItemProxy = value;
	      }
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$emit('input', this.findDefaultObject(this.selectedItemOverride || this.defaultText));
	    window.eventBus.$on('strayClick', function (e) {
	      if (!_this.isDescendant(document.getElementById(_this.id), e.target)) _this.show = false;
	    });
	  },
	
	  methods: {
	    dropdownItemClick: function dropdownItemClick(e, item) {
	      this.show = false;
	
	      this.selectedItemProxy = item.name;
	      this.$emit('input', item);
	    },
	    isDescendant: function isDescendant(parent, child) {
	      var node = child.parentNode;
	      while (node !== null) {
	        if (node === parent) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    },
	    findDefaultObject: function findDefaultObject(defaultText) {
	      return (0, _lodash.find)(this.list, ['name', defaultText]);
	    }
	  }
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Constants = __webpack_require__(18);
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      filterText: null,
	      itemSelected: null
	    };
	  },
	
	  props: {
	    'list': {
	      required: true
	    },
	    'id': {
	      required: true
	    },
	    'defaultValue': {
	      required: false
	    },
	    'reset': {
	      required: false
	    },
	    'selectedItem': {
	      required: false
	    },
	    'screenName': {
	      required: false
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.clearFilters();
	    window.eventBus.$on('strayClick', function (e) {
	      if (!_this.isDescendant(document.getElementById(_this.id), e.target)) _this.show = false;
	    });
	  },
	  beforeUpdate: function beforeUpdate() {
	    this.clearFilters();
	  },
	
	  methods: {
	    setFocus: function setFocus() {},
	    dropdownItemClick: function dropdownItemClick(e, item) {
	      this.itemSelected = item;
	      this.show = false;
	      this.filterText = item === '(none)' ? null : item.name;
	      this.$emit('input', item);
	    },
	    checkInput: function checkInput(e) {
	      if (!this.filterText || !this.filterText.trim()) {
	        this.$emit('input', _Constants.CLEAR_FILTER);
	      } else {
	        var copy = {};
	
	        if (copy && this.filterText) {
	          copy.name = this.filterText;
	        } else {
	          copy = {};
	          copy.name = this.filterText;
	        }
	        this.$emit('input', copy);
	      }
	    },
	    clearFilters: function clearFilters() {},
	    isDescendant: function isDescendant(parent, child) {
	      var node = child.parentNode;
	      while (node !== null) {
	        if (node === parent) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    },
	    filterItems: function filterItems(query) {
	      var data = this.originalList.filter(function (el) {
	        if (el && el.name) {
	          return el.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
	        }
	      });
	      return data;
	    }
	  },
	  mounted: function mounted() {
	    this.setFocus();
	  },
	
	  computed: {
	    originalList: function originalList() {
	      return this.list;
	    },
	    modifiedList: function modifiedList() {
	      this.setFocus();
	      if (this.filterText) {
	        return this.filterItems(this.filterText);
	      }
	      return this.originalList;
	    },
	    placeHolder: function placeHolder() {
	      if (this.screenName !== 'ItemLevel') {
	        this.filterText = this.selectedItem;
	      }
	      return 'Search';
	    }
	  }
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(25);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(8);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SearchableDropDown = __webpack_require__(73);
	
	var _SearchableDropDown2 = _interopRequireDefault(_SearchableDropDown);
	
	var _Dropdown = __webpack_require__(98);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _superUser = __webpack_require__(40);
	
	var _Constants = __webpack_require__(18);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      filteredOfferNames: [],
	      brand: null,
	      department: null,
	      subDepartment: null,
	      textClass: null,
	      subClass: null,
	      reset: {
	        subDepartment: false,
	        _class: false,
	        subClass: false
	      },
	      selectedOffer: 'Expand here to select your offer.',
	      searchText: 'Search',
	      item: {
	        value: '',
	        text: ''
	      },
	      filterText: null,
	      selectedOfferId: null,
	      selectedPeriod: null,
	      selectedStoreLevel: null,
	      offerCompSelectedOfferId: null,
	      selectedOfferName: null,
	      defaultOfferName: '',
	      clearFlag: false,
	      defaultText: '',
	      selectedVendor: '',
	      selectedMerchant: '',
	      selectedItem: '',
	      selectedMerchantValue: '',
	      superUser: false,
	      buttonEnabled: true
	    };
	  },
	  created: function created() {
	    var vendor = (0, _superUser.getVendorId)();
	    if (vendor) {
	      this.selectedVendor = vendor;
	      this.selectedItem = vendor.name;
	    }
	  },
	  beforeMount: function beforeMount() {
	    if ((0, _superUser.isSuperUser)()) {
	      this.superUser = true;
	    }
	  },
	
	  props: {
	    'type': {
	      required: true
	    },
	    'sidebarHeader': {
	      required: false
	    },
	    'offerNames': {
	      required: false
	    },
	    'submitButtonPresent': {
	      required: false
	    },
	    'fetchAggregatedOffer': {
	      required: false
	    },
	    'handleEvent': {
	      required: false
	    },
	    'show': {
	      required: false
	    },
	    'screenName': {
	      required: false
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    gettersLandingInfo: NameSpace.GET_LANDING_DATA,
	    gettersAggInputDataName: NameSpace.GET_AGG_INPUT_FILTER_NAME,
	    gettersSelectedOfferData: NameSpace.GET_SELECTED_OFFER_NAME,
	    gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
	    gettersAllEmails: NameSpace.GETTER_ALL_EMAILS,
	    getSelectedMerchant: NameSpace.GET_SELECTED_MERCHANT
	  }), {
	    cloneOfferName: function cloneOfferName() {
	      if (this.gettersSelectedOfferData) {
	        return (0, _lodash.cloneDeep)(this.gettersSelectedOfferData.name);
	      } else {
	        return '';
	      }
	    },
	    emails: function emails() {
	      var emails = this.gettersAllEmails.manufacturers;
	      return emails.map(function (data) {
	        return { name: data.name, value: data.id };
	      });
	    },
	    data: function data() {
	      return this.gettersLandingInfo.data;
	    },
	    merchants: function merchants() {
	      var merchant = this.getSelectedMerchant;
	      this.selectedMerchant = merchant;
	      if (merchant && merchant.name) {
	        this.selectedMerchantValue = merchant.name;
	      }
	      var merchants = this.data.merchants;
	      if (merchants.length) {
	        return merchants.map(function (data) {
	          return { name: data.email, value: data.id };
	        });
	      } else {
	        return [];
	      }
	    },
	
	    selectedDepartment: {
	      get: function get() {
	        if (this.clearFlag) {
	          return null;
	        } else {
	          this.department = this.department || this.gettersAggInputDataName.department;
	          return this.department;
	        }
	      },
	      set: function set(value) {
	        if (value === _Constants.CLEAR_FILTER) {
	          this.clearFlag = true;
	          this.department = null;
	          this.removeFromStore();
	          this.subDepartment = null;
	          this.textClass = null;
	          this.subClass = null;
	        } else {
	          this.clearFlag = false;
	          this.department = value;
	          this.subDepartment = null;
	          if (this.department && this.department.id) {
	            this.fetchSubDepartments({ categoryId: this.department.id });
	          }
	        }
	      }
	    },
	    selectedSubDepartment: {
	      get: function get() {
	        if (this.clearFlag) {
	          return null;
	        } else {
	          this.subDepartment = this.subDepartment || this.gettersAggInputDataName.subDepartment;
	          return this.subDepartment;
	        }
	      },
	      set: function set(value) {
	        if (value === _Constants.CLEAR_FILTER) {
	          this.clearFlag = true;
	          this.subDepartment = null;
	          this.removeFromStore();
	          this.textClass = null;
	          this.subClass = null;
	        } else {
	          this.clearFlag = false;
	          this.subDepartment = value;
	          this.textClass = null;
	          if (this.subDepartment && this.subDepartment.id) {
	            this.fetchClasses({ categoryId: this.subDepartment.id });
	          }
	        }
	      }
	    },
	    selectedClass: {
	      get: function get() {
	        if (this.clearFlag) {
	          return null;
	        } else {
	          this.textClass = this.textClass || this.gettersAggInputDataName.class;
	          return this.textClass;
	        }
	      },
	      set: function set(value) {
	        if (value === _Constants.CLEAR_FILTER) {
	          this.clearFlag = true;
	          this.textClass = null;
	          this.removeFromStore();
	          this.subClass = null;
	        } else {
	          this.clearFlag = false;
	          this.textClass = value;
	          this.subClass = null;
	          if (this.textClass && this.textClass.id) {
	            this.fetchSubClasses({ categoryId: this.textClass.id });
	          }
	        }
	      }
	    },
	    selectedSubClass: {
	      get: function get() {
	        if (this.clearFlag) {
	          return null;
	        } else {
	          this.subClass = this.subClass || this.gettersAggInputDataName.subClass;
	          return this.subClass;
	        }
	      },
	      set: function set(value) {
	        if (value === _Constants.CLEAR_FILTER) {
	          this.clearFlag = true;
	          this.subClass = null;
	          this.removeFromStore();
	        } else {
	          this.clearFlag = false;
	          this.subClass = value;
	        }
	      }
	    },
	    selectedBrand: {
	      get: function get() {
	        if (this.clearFlag) {
	          return null;
	        } else {
	          this.brand = this.brand || this.gettersAggInputDataName.brand;
	          return this.brand;
	        }
	      },
	      set: function set(value) {
	        if (value === _Constants.CLEAR_FILTER) {
	          this.clearFlag = true;
	          this.brand = null;
	        } else {
	          this.clearFlag = false;
	          this.brand = value;
	        }
	      }
	    },
	    brands: function brands() {
	      if (this.data) {
	        return this.data.brands;
	      }
	    },
	    offers: function offers() {
	      if (this.data) {
	        this.defaultOfferName = 'All Offers';
	        var found = false;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.data.offers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var obj = _step.value;
	
	            if (obj.id === 'MyOffers') {
	              found = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (found) {
	          this.defaultOfferName = 'My Offers';
	        }
	        return this.data.offers;
	      }
	    },
	    periods: function periods() {
	      if (this.data && this.data.periods) {
	        return this.data.periods.map(function (e) {
	          var obj = {};
	          obj.id = e;
	          obj.name = e;
	          return obj;
	        });
	      } else {
	        return [];
	      }
	    },
	    departments: function departments() {
	      if (this.data) {
	        return this.data.departments;
	      }
	    },
	    subDepartments: function subDepartments() {
	      if (this.data) {
	        return this.data.subDepartments;
	      }
	    },
	    _class: function _class() {
	      if (this.data) {
	        return this.data.classes;
	      }
	    },
	    subClasses: function subClasses() {
	      if (this.data) {
	        return this.data.subClasses;
	      }
	    },
	    storeLevels: function storeLevels() {
	      if (this.data) {
	        if (this.data.storeLevel && this.data.storeLevel[0]) {
	          this.selectedStoreLevel = this.data.storeLevel[0].id;
	        }
	        return this.data.storeLevel;
	      }
	    },
	    sidebarToggle: function sidebarToggle() {
	      return this.show;
	    },
	    defaultPeriod: function defaultPeriod() {
	      return this.periods.length > 0 ? this.periods[0].name : '';
	    },
	    defaultStoreLevel: function defaultStoreLevel() {
	      return this.storeLevels.length > 0 ? this.storeLevels[0].name : '';
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    actionSelectOfferName: NameSpace.ACTION_SELECT_OFFER_NAME,
	    setDepartMent: NameSpace.SET_SELECTED_DEPARTMENT,
	    setSubDepartment: NameSpace.SET_SELECTED_SUB_DEPARTMENT,
	    setClass: NameSpace.SET_SELECTED_CLASS,
	    setSubClass: NameSpace.SET_SELECTED_SUB_CLASS,
	    fetchSubDepartments: NameSpace.FETCH_SUB_DEPARTMENTS,
	    fetchClasses: NameSpace.FETCH_CLASSES,
	    fetchSubClasses: NameSpace.FETCH_SUB_CLASSES,
	    setAggInputData: NameSpace.SET_AGG_INPUT_FILTER_DATA,
	    setSelectedOffer: NameSpace.ACTION_SELECT_OFFER_NAME,
	    storeSelectedVendor: NameSpace.SET_EMAIL_SELECTED_BY_SUPERUSER,
	    setSelectedMerchant: NameSpace.SET_SELECTED_MERCHANT
	  }), {
	    isSubmitButtonEnabled: function isSubmitButtonEnabled() {
	      return this.buttonEnabled && this.periods && this.periods.length && this.storeLevels && this.storeLevels.length;
	    },
	    checkVendorObject: function checkVendorObject() {
	      var vendor = this.selectedVendor;
	      if (vendor && this.selectedVendor !== _Constants.CLEAR_FILTER) {
	        this.isValidEmailChoosen(vendor);
	      } else {
	        this.buttonEnabled = true;
	      }
	    },
	    checkMerchantObject: function checkMerchantObject() {
	      if (this.selectedMerchant && this.selectedMerchant !== _Constants.CLEAR_FILTER) {
	        this.isValidMerchantChoosen(this.selectedMerchant);
	      } else {
	        this.buttonEnabled = true;
	      }
	    },
	    isValidEmailChoosen: function isValidEmailChoosen(email) {
	      var index = (0, _lodash.findIndex)(this.emails, email);
	      if (index >= 0) {
	        this.selectedVendor = this.emails[index];
	        this.selectedOfferName = this.selectedVendor.name;
	        this.buttonEnabled = true;
	      } else {
	        this.buttonEnabled = false;
	      }
	    },
	    isValidMerchantChoosen: function isValidMerchantChoosen(merchant) {
	      var index = (0, _lodash.findIndex)(this.merchants, merchant);
	      if (index >= 0) {
	        this.selectedMerchant = this.merchants[index];
	        this.selectedMerchantValue = this.selectedMerchant.name;
	        this.buttonEnabled = true;
	      } else {
	        this.buttonEnabled = false;
	      }
	    },
	    openSideBar: function openSideBar() {
	      this.sidebarToggle = true;
	    },
	    closeSideBar: function closeSideBar(e) {
	      this.$emit('sidebarInactive', function () {
	        return true;
	      });
	    },
	    change: function change() {
	      if (this.offerCompSelectedOfferId) {
	        this.selectedOffer = this.offerCompSelectedOfferId;
	        this.actionSelectOfferName(this.offerCompSelectedOfferId);
	        this.handleEvent(this.selectedOffer);
	      }
	    },
	    onSelect: function onSelect(item) {
	      this.item = item;
	    },
	    reset: function reset() {
	      this.item = {};
	    },
	    selectOption: function selectOption() {
	      this.item = this.options[0];
	    },
	    filterObjects: function filterObjects(text) {
	      return this.filteredOfferNames.filter(function (v) {
	        return (0, _keys2.default)(v).some(function (k) {
	          return v[k].toLowerCase().indexOf(text.toLowerCase()) > -1;
	        });
	      });
	    },
	    getPendingApprovals: function getPendingApprovals() {
	      if ((0, _superUser.isSuperUser)()) {
	        localStorage.setItem(_Constants.EMAIL_SELECTED_BY_SUPERUSER, (0, _stringify2.default)(this.selectedVendor));
	        this.storeSelectedVendor(this.selectedVendor);
	        localStorage.setItem(_Constants.MERCHANT_SELECTED_BY_SUPERUSER, (0, _stringify2.default)(this.selectedMerchant));
	        this.setSelectedMerchant(this.selectedMerchant);
	      }
	      this.closeSideBar();
	      var object = {};
	      var stateObject = {};
	      if (this.selectedOfferId) {
	        stateObject.offers = this.selectedOfferId;
	        object.offers = this.selectedOfferId.id;
	      }
	      if (this.selectedPeriod) {
	        stateObject.period = this.selectedPeriod;
	        object.period = this.selectedPeriod.id;
	      }
	      if (this.department) {
	        stateObject.department = this.department;
	        object.departmentId = this.department.id;
	      }
	      if (this.subDepartment) {
	        stateObject.subDepartment = this.subDepartment;
	        object.subDepartmentId = this.subDepartment.id;
	      }
	      if (this.textClass) {
	        stateObject.class = this.textClass;
	        object.classId = this.textClass.id;
	      }
	      if (this.subClass) {
	        stateObject.subClass = this.subClass;
	        object.subClassId = this.subClass.id;
	      }
	      if (this.brand) {
	        stateObject.brand = this.brand;
	        object.brandId = this.brand.id;
	      }
	      if (this.selectedStoreLevel) {
	        stateObject.storeLevel = this.selectedStoreLevel;
	        object.storeLevel = this.selectedStoreLevel.id;
	      }
	      console.log('In submit of sidebar:', stateObject);
	      this.setAggInputData(stateObject);
	      if ((0, _superUser.isSuperUser)()) {
	        object.manufacturerId = this.selectedVendor.value;
	        if (this.selectedMerchant) {
	          object.merchantId = this.selectedMerchant.value;
	        }
	      }
	      this.fetchAggregatedOffer(object);
	    },
	    removeFromStore: function removeFromStore() {
	      var object = this.gettersAggInputData;
	      if (!this.department) {
	        delete object.department;
	        delete object.subDepartment;
	        delete object.class;
	        delete object.subClass;
	      }
	      if (!this.subDepartment) {
	        delete object.subDepartment;
	        delete object.class;
	        delete object.subClass;
	      }
	      if (!this.textClass) {
	        delete object.class;
	        delete object.subClass;
	      }
	      if (!this.subClass) {
	        delete object.subClass;
	      }
	      this.setAggInputData(object);
	    },
	    removeFilter: function removeFilter() {
	      var object = this.gettersAggInputData;
	      var obj = {};
	      if (object.department) {
	        delete object.department;
	      }
	      if (object.subDepartment) {
	        delete object.subDepartment;
	      }
	      if (object.class) {
	        delete object.class;
	      }
	      if (object.subClass) {
	        delete object.subClass;
	      }
	      console.log('In see all categories of sidebar:', object);
	      this.department = null;
	      this.subDepartment = null;
	      this.textClass = null;
	      this.subClass = null;
	      if (object.offers) {
	        obj.offers = object.offers.id;
	      } else {
	        if (this.selectedOfferId) {
	          obj.offers = this.selectedOfferId.id;
	          object.offers = this.selectedOfferId;
	        }
	      }
	      if (object.period) {
	        obj.period = object.period.id;
	      } else {
	        if (this.selectedPeriod) {
	          obj.period = this.selectedPeriod.id;
	          object.period = this.selectedPeriod;
	        }
	      }
	      if (object.brand) {
	        obj.brandId = object.brand.id;
	      } else {
	        if (this.brand) {
	          obj.brandId = this.brand.id;
	          object.brand = this.brand;
	        }
	      }
	      if (object.storeLevel) {
	        obj.storeLevel = object.storeLevel.id;
	      } else {
	        if (this.selectedStoreLevel) {
	          obj.storeLevel = this.selectedStoreLevel.id;
	          object.storeLevel = this.selectedStoreLevel;
	        }
	      }
	      this.setAggInputData(object);
	      console.log('=========');
	      this.fetchAggregatedOffer(obj);
	    }
	  }),
	  components: {
	    SearchableDropdown: _SearchableDropDown2.default,
	    Dropdown: _Dropdown2.default
	  },
	  watch: {
	    selectedMerchant: function selectedMerchant() {
	      this.checkMerchantObject();
	    },
	    selectedVendor: function selectedVendor() {
	      this.checkVendorObject();
	    },
	    emails: function emails() {
	      if (!this.buttonEnabled) {
	        this.checkVendorObject();
	      }
	    },
	    merchants: function merchants() {
	      if (!this.buttonEnabled) {
	        this.checkMerchantObject();
	      }
	    },
	    offerNames: function offerNames() {
	      this.filteredOfferNames = this.offerNames.id;
	    },
	    filterText: function filterText() {
	      if (this.filterText === '') {
	        this.filteredOfferNames = this.offerNames.id;
	      } else {
	        this.filteredOfferNames = this.filterObjects(this.filterText);
	      }
	    },
	    selectedOfferName: function selectedOfferName() {
	      if (this.selectedOfferName !== _Constants.CLEAR_FILTER) {
	        if (this.selectedOfferName && this.selectedOfferName.hasOwnProperty('id') && this.selectedOfferName.id !== this.cloneOfferName.id) {
	          this.setSelectedOffer(this.selectedOfferName);
	          this.handleEvent(this.selectedOfferName);
	        }
	      }
	    }
	  }
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _styleHelper = __webpack_require__(140);
	
	exports.default = {
	  props: {
	    'buttonText': {
	      required: false
	    },
	    'value': {
	      required: false
	    },
	    'action': {
	      required: false
	    }
	  },
	  methods: {
	    positiveAction: function positiveAction() {
	      if (typeof this.action === 'function') {
	        this.action();
	      }
	      this.$emit('input', true);
	    },
	    negativeAction: function negativeAction() {
	      this.$emit('input', false);
	    }
	  },
	  computed: {
	    size: function size() {
	      return Math.max((0, _styleHelper.getContainerWidthFromText)(this.buttonText.accept.text || 'APPROVE', '1.3rem', '1.1rem 1.5rem'), (0, _styleHelper.getContainerWidthFromText)(this.buttonText.decline.text || 'DECLINE', '1.3rem', '1.1rem 1.5rem'));
	    }
	  },
	  watch: {
	    size: function size() {
	      console.log(this.size);
	    }
	  }
	};

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    'buttonText': {
	      required: false
	    },
	    'value': {
	      required: false
	    },
	    'error': {
	      required: false
	    },
	    'action': {
	      required: false
	    }
	  },
	  methods: {
	    buttonAction: function buttonAction() {
	      this.$emit('input', '');
	      if (typeof this.action === 'function') {
	        this.action();
	      }
	    }
	  }
	};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringLengthPadding = __webpack_require__(139);
	
	exports.default = {
	  props: {
	    'data': {
	      required: true
	    },
	    'styles': {
	      required: true
	    },
	    'type': {
	      required: false
	    },
	    'handleEvent': {
	      required: false
	    },
	    'stringPadding': {
	      required: false,
	      type: Object,
	      default: null
	    },
	    'functions': {
	      required: false
	    },
	    'pendingOrPast': {
	      required: false
	    }
	  },
	  data: function data() {
	    return {
	      lastTypeValue: null,
	      showPopKey: null
	    };
	  },
	
	  computed: {
	    displayData: function displayData() {
	      return this.data;
	    }
	  },
	  methods: {
	    showPopOver: function showPopOver(key) {
	      this.showPopKey = key;
	    },
	    hidePopOver: function hidePopOver(key) {
	      this.showPopKey = null;
	    },
	    removeItem: function removeItem(record) {
	      record.event = 'CLOSE_EVENT';
	      this.handleEvent(record);
	    },
	    getCellRecord: function getCellRecord(record) {
	      record = record && typeof record.value !== 'undefined' && record.value !== null ? record.value : typeof record !== 'undefined' && record !== null && record.toString().length > 0 ? record : '\xa0';
	      record = record.toString();
	
	      var splittedArray = record.split(' ');
	      var arrayResult = [];
	      for (var i = 0; i < splittedArray.length; i++) {
	        var text = splittedArray[i];
	        if (text.includes('-')) {
	          var indexOfMinus = text.indexOf('-');
	          var part1 = text.substring(0, indexOfMinus);
	          if (part1) {
	            arrayResult.push(part1);
	          }
	          var part2 = text.substring(indexOfMinus, text.length);
	          if (part2) {
	            var part2Index = part2.indexOf(')');
	            var first = part2.substring(0, part2Index);
	            if (first) {
	              arrayResult.push(first);
	            }
	            var second = part2.substring(part2Index, part2.length);
	            if (second) {
	              arrayResult.push(second);
	            }
	          } else {
	            arrayResult.push(part2);
	          }
	        } else {
	          arrayResult.push(text);
	        }
	      }
	      return arrayResult;
	    },
	    processRecord: function processRecord(record) {
	      if (this.type && this.type === 'record') {
	        this.handleEvent(record);
	      }
	    },
	    editRecord: function editRecord(record, id) {
	      var fn = this.functions;
	      fn(record, id);
	    },
	    addDotsToData: function addDotsToData(data) {
	      if (!this.stringPadding) return data;
	      var padLength = this.stringPadding.length;
	      if (typeof data === 'string') {
	        return (0, _stringLengthPadding.dotty)(data, padLength);
	      }
	      data.forEach(function (e, i, ctx) {
	        if (typeof e.value !== 'undefined') {
	          data[i].value = (0, _stringLengthPadding.dotty)(data[i].value, padLength);
	        } else {
	          data[i] = (0, _stringLengthPadding.dotty)(data[i], padLength);
	        }
	      });
	      return data;
	    },
	    processData: function processData(record) {
	      this.handleEvent(record);
	    }
	  }
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vueClickaway = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  directives: {
	    onClickaway: _vueClickaway.directive
	  },
	  props: ['data', 'headers', 'styles', 'handleEvent'],
	  data: function data() {
	    return {
	      edit: false,
	      away: _vueClickaway.directive,
	      dataProxy: null
	    };
	  },
	
	  computed: {
	    dataAsComputed: {
	      get: function get() {
	        var dataProxy = this.dataProxy;
	        this.dataProxy = null;
	        return dataProxy || this.data;
	      },
	      set: function set(value) {
	        this.dataProxy = value;
	      }
	    }
	  },
	  created: function created() {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(this.dataAsComputed), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var p = _step.value;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(p), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var c = _step2.value;
	
	            c.edit = false;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	
	  methods: {
	    editData: function editData(rowKey, fieldKey) {
	      this.dataAsComputed[rowKey][fieldKey].edit = true;
	      var data = this.dataAsComputed;
	      this.dataAsComputed = [];
	      this.dataAsComputed = data;
	    },
	    resetToFalse: function resetToFalse(rowKey, fieldKey) {
	      var _this = this;
	
	      return function () {
	        _this.dataAsComputed[rowKey][fieldKey].edit = false;
	        var data = _this.dataAsComputed;
	        _this.dataAsComputed = [];
	        _this.dataAsComputed = data;
	      };
	    },
	    updateData: function updateData(e, row, col) {
	      var newData = Number(e.target.value);
	      this.handleEvent(this.data, newData, row, col);
	    }
	  }
	};

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['data', 'styles'],
	  data: function data() {
	    return {
	      tableInstance: null,
	      table: null
	    };
	  }
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: 'Loading...'
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    show: NameSpace.GET_LOADER_STATE
	  }))
	};

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  }
	};

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  }
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(5);
	
	var _NameSpace = __webpack_require__(1);
	
	var NameSpace = _interopRequireWildcard(_NameSpace);
	
	var _Error = __webpack_require__(351);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _Success = __webpack_require__(352);
	
	var _Success2 = _interopRequireDefault(_Success);
	
	var _DualButtons = __webpack_require__(348);
	
	var _DualButtons2 = _interopRequireDefault(_DualButtons);
	
	var _SingleButton = __webpack_require__(349);
	
	var _SingleButton2 = _interopRequireDefault(_SingleButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['value'],
	  components: {
	    Error: _Error2.default,
	    Success: _Success2.default,
	    DualButtons: _DualButtons2.default,
	    SingleButton: _SingleButton2.default
	  },
	  data: function data() {
	    return {
	      result: null,
	      show: false
	    };
	  },
	
	  methods: (0, _extends3.default)({
	    close: function close() {
	      this.show = false;
	    },
	    setModalResponse: function setModalResponse(data) {
	      this.actionSetModalResponse(data);
	    }
	  }, (0, _vuex.mapActions)({
	    actionSetModalResponse: NameSpace.SET_MODAL_RESPONSE_ACTION
	  })),
	  watch: {
	    result: function result() {
	      if (this.result !== null) {
	        this.show = false;
	        this.setModalResponse(this.result);
	        this.$emit('input', this.result);
	      } else if (this.result === '') {
	        this.show = false;
	        this.$emit('input', this.result);
	      }
	      this.result = null;
	    },
	    config: function config() {
	      this.show = true;
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    config: NameSpace.MODAL_CONFIG_GETTER
	  }), {
	    error: function error() {
	      return this.config.type === 'ERROR';
	    },
	    messageIsArray: function messageIsArray() {
	      return Array.isArray(this.config.message);
	    }
	  })
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    position: {
	      required: false,
	      default: 'bottom-right'
	    }
	  },
	  methods: {
	    getPositionClass: function getPositionClass() {
	      return (0, _defineProperty3.default)({
	        'container': true
	      }, this.position, true);
	    }
	  }
	};

/***/ },
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 269 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 270 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 271 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 272 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 273 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 274 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 275 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 276 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 277 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 278 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 280 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 281 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 282 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 283 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 284 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 285 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 286 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 287 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 288 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 289 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 290 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 291 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 292 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 293 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 294 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 295 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 296 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 297 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 298 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 299 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 300 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(292)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(378),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(284)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(168),
	  /* template */
	  __webpack_require__(370),
	  /* scopeId */
	  "data-v-62d4a94d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(274)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(169),
	  /* template */
	  __webpack_require__(360),
	  /* scopeId */
	  "data-v-2c1eded0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(280)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(170),
	  /* template */
	  __webpack_require__(366),
	  /* scopeId */
	  "data-v-49d85fa2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(283)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(171),
	  /* template */
	  __webpack_require__(369),
	  /* scopeId */
	  "data-v-5d991d9a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(293)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(172),
	  /* template */
	  __webpack_require__(379),
	  /* scopeId */
	  "data-v-92959e7a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(273)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(173),
	  /* template */
	  __webpack_require__(359),
	  /* scopeId */
	  "data-v-27d9ac72",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(294)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(174),
	  /* template */
	  __webpack_require__(380),
	  /* scopeId */
	  "data-v-9ae42754",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(299)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(385),
	  /* scopeId */
	  "data-v-fb2f964a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(272)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(176),
	  /* template */
	  __webpack_require__(358),
	  /* scopeId */
	  "data-v-1f8290c7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(276)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(177),
	  /* template */
	  __webpack_require__(362),
	  /* scopeId */
	  "data-v-3b33d9ed",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(288)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(178),
	  /* template */
	  __webpack_require__(374),
	  /* scopeId */
	  "data-v-70560836",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(277)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(179),
	  /* template */
	  __webpack_require__(363),
	  /* scopeId */
	  "data-v-47298a5e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(289)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(180),
	  /* template */
	  __webpack_require__(375),
	  /* scopeId */
	  "data-v-770b927c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(296)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(181),
	  /* template */
	  __webpack_require__(382),
	  /* scopeId */
	  "data-v-cccf0740",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(286)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(182),
	  /* template */
	  __webpack_require__(372),
	  /* scopeId */
	  "data-v-65203d12",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(297)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(184),
	  /* template */
	  __webpack_require__(383),
	  /* scopeId */
	  "data-v-e07f5a4a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(290)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(185),
	  /* template */
	  __webpack_require__(376),
	  /* scopeId */
	  "data-v-796e16f5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(269)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(189),
	  /* template */
	  __webpack_require__(355),
	  /* scopeId */
	  "data-v-15b8e501",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(298)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(190),
	  /* template */
	  __webpack_require__(384),
	  /* scopeId */
	  "data-v-f30393a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(270)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(194),
	  /* template */
	  __webpack_require__(356),
	  /* scopeId */
	  "data-v-1883e206",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(287)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(195),
	  /* template */
	  __webpack_require__(373),
	  /* scopeId */
	  "data-v-688879e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(268)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(196),
	  /* template */
	  __webpack_require__(354),
	  /* scopeId */
	  "data-v-0467dbca",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(279)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(197),
	  /* template */
	  __webpack_require__(365),
	  /* scopeId */
	  "data-v-49c67979",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 354 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "success-container"
	  }, [_c('div', {
	    staticClass: "success-logo"
	  }, [_c('div', {
	    staticClass: "symbol"
	  }, [_vm._v("\n      ✓\n    ")])])])
	}]}

/***/ },
/* 355 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline-block absolute-children"
	  }, [_c('div', {
	    staticClass: "inline-block row",
	    style: ({
	      width: ((_vm.size / 10) * 2.5) + "rem"
	    })
	  }, [_c('div', {
	    staticClass: "grid-6"
	  }, [_c('button', {
	    staticClass: "primary-green-bg left",
	    style: ({
	      width: (_vm.size / 10) + "rem"
	    }),
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.positiveAction
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.buttonText.accept.text || 'PROCEED') + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid-6"
	  }, [_c('button', {
	    staticClass: "red-bg right",
	    style: ({
	      width: (_vm.size / 10) + "rem"
	    }),
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.negativeAction
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.buttonText.decline.text || 'DECLINE') + "\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 356 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loader-container",
	    class: {
	      "show": _vm.show, "hidden": !_vm.show
	    }
	  }, [_c('div', {
	    staticClass: "curved-div"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "loading"
	  }, [_vm._v("\n      " + _vm._s(_vm.loading) + "\n    ")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "colour-magic"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch rotate"
	  })])
	}]}

/***/ },
/* 357 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    style: (_vm.styles.headerTable)
	  }, _vm._l((_vm.data), function(record) {
	    return _c('tr', {
	      style: (_vm.styles.trStyle)
	    }, [(record.parent) ? _c('th', {
	      class: _vm.styles.headerTableTdClasses.primaryGreenBg,
	      style: (_vm.styles.thStyle),
	      attrs: {
	        "rowspan": record.parent_span
	      }
	    }, [_vm._v("\n    " + _vm._s(record.parent) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('th', {
	      class: _vm.styles.headerTableTdClasses.darkGreenBg,
	      style: (_vm.styles.thStyle)
	    }, [_vm._v("\n    " + _vm._s(record.name) + "\n    ")])])
	  }))
	},staticRenderFns: []}

/***/ },
/* 358 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "navbar-container primary-green-bg",
	    attrs: {
	      "id": "navbar"
	    }
	  }, [_c('div', {
	    class: {
	      "navbar-head": true, "padding-transition": _vm.hideHead
	    }
	  }, [_c('div', {
	    class: {
	      "logo-banner": true, "hide": _vm.hideHead, "fade-in": !_vm.hideHead
	    },
	    on: {
	      "click": _vm.goHome
	    }
	  }), _vm._v(" "), _c('userlogo', {
	    class: {
	      "hide": _vm.hideHead
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "dropdown-toggle primary-green-bg",
	    on: {
	      "click": _vm.toggleNavbar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-navicon fa-3x"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "nav-separator"
	  }, [_c('div', {
	    staticClass: "mobile-nav"
	  }, [_c('div', {
	    class: {
	      "dropdown": !_vm.navToggle
	    }
	  }, [_c('div', {
	    staticClass: "email-container"
	  }, [(_vm.merchant) ? _c('div', {
	    staticClass: "email-text-style"
	  }, [_vm._v("\n              " + _vm._s(_vm.merchant) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.email) ? _c('div', {
	    staticClass: "email-text-style"
	  }, [_vm._v("\n              " + _vm._s(_vm.email) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    class: {
	      "logo-banner-mini": true, "hide": !_vm.hideHead, "fade-in": _vm.hideHead
	    },
	    on: {
	      "click": _vm.goHome
	    }
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "inline-block"
	  }, [_c('router-link', {
	    attrs: {
	      "tag": "li",
	      "active-class": "active",
	      "to": {
	        name: "PendingApproval"
	      }
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.navToggle = !_vm.navToggle
	      }
	    }
	  }, [_vm._v("Pending Approval")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "active-class": "active",
	      "to": {
	        name: "FileUpload"
	      }
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.navToggle = !_vm.navToggle
	      }
	    }
	  }, [_vm._v("File Upload")])])], 1), _vm._v(" "), _c('ul', {
	    staticClass: "inline-block right"
	  }, [_c('router-link', {
	    staticClass: "right",
	    attrs: {
	      "tag": "li",
	      "active-class": "active",
	      "exact": true,
	      "to": "/profile"
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.navToggle = !_vm.navToggle
	      }
	    }
	  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', {
	    staticClass: "primary-green-bg uppercase",
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('span', [_vm._v("Logout")])])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "scroll",
	    style: ({
	      "height": (_vm.scrollHeight + "px")
	    }),
	    on: {
	      "resize": _vm.checkScrollAmount,
	      "scroll": _vm.checkScrollAmount
	    }
	  }, [_c('router-view')], 1)])
	},staticRenderFns: []}

/***/ },
/* 359 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-body"
	  }, [_c('div', {
	    staticClass: "outer-div outer-div-min"
	  }, [_c('div', {
	    staticClass: "inner-div"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "grid-4"
	  }, [_c('dropdown', {
	    attrs: {
	      "id": _vm.fileUploadId1,
	      "list": _vm.periods,
	      "defaultText": _vm.defaultText,
	      "selectedItem": (_vm.gettersAggInputDataName.period) ? _vm.gettersAggInputDataName.period.name : ""
	    },
	    model: {
	      value: (_vm.selectedPeriod),
	      callback: function($$v) {
	        _vm.selectedPeriod = $$v
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {}, [_c('upload', {
	    attrs: {
	      "disabled": !_vm.selectedPeriod,
	      "clearUploadButtonText": _vm.clearUploadButtonText,
	      "period": _vm.selectedPeriod,
	      "uploadFile": _vm.uploadFile
	    }
	  })], 1)])])]), _vm._v(" "), (_vm.uploadResult.mistake.length > 0) ? _c('error', {
	    attrs: {
	      "mistakes": _vm.uploadResult.mistake
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 360 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "upper-parent"
	  }, [_c('div', {
	    staticClass: "same-line itemsContainer inline-block upper-parent-child1"
	  }, [_c('div', {
	    staticClass: "offer-name"
	  }, [(_vm.gettersSelectedOffer && _vm.gettersSelectedOffer.name) ? _c('div', [_vm._v("\n        " + _vm._s(this.gettersSelectedOffer.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatedItemName && _vm.duplicatedItemName.name) ? _c('div', {
	    staticClass: "item-text"
	  }, [_vm._v("\n        " + _vm._s(_vm.duplicatedItemName.name) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": "simulation1",
	      "list": _vm.itemArrays,
	      "selectedItem": _vm.selectedItem ? this.selectedItem.name : ''
	    },
	    model: {
	      value: (_vm.selectedItem),
	      callback: function($$v) {
	        _vm.selectedItem = $$v
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block upper-parent-child2",
	    style: ({
	      'width': '80%',
	      'overflow-x': 'auto'
	    })
	  }, [_c('vue-chart', {
	    attrs: {
	      "chart-type": "ColumnChart",
	      "columns": _vm.columns,
	      "rows": _vm.rows,
	      "options": _vm.options
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "legends-wrapper"
	  }, _vm._l((_vm.barChartLegends), function(data) {
	    return _c('div', {
	      staticClass: "legend-marker"
	    }, [_c('div', {
	      staticClass: "legend-marker-color",
	      style: ({
	        'background-color': data.color
	      })
	    }), _vm._v(" "), _c('span', {
	      staticClass: "legend-label"
	    }, [_vm._v(_vm._s(data.label))])])
	  }))], 1)])
	},staticRenderFns: []}

/***/ },
/* 361 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    style: (_vm.styles.tableStyle)
	  }, _vm._l((_vm.displayData), function(record, key) {
	    return _c('tr', {
	      style: (_vm.styles.trStyle)
	    }, [(record && record.arrow_for_close) ? _c('td', {
	      staticClass: "relative text-center"
	    }, [_c('span', [_vm._v(_vm._s(record.value))]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-times",
	      style: ({
	        'float': 'right',
	        'margin-right': '0.5rem',
	        'cursor': 'pointer'
	      }),
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeItem(record)
	        }
	      }
	    })]) : (record && (record.isEditable && _vm.displayData.selfOffer) || (record.editable && record.clickAway)) ? _c('td', {
	      staticClass: "relative text-center"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (record.value),
	        expression: "record.value"
	      }],
	      style: (_vm.styles.editBoxWidthFull),
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (record.value)
	      },
	      on: {
	        "blur": function($event) {
	          $event.stopPropagation();
	          _vm.editRecord(record, _vm.displayData.itemId)
	        },
	        "keyup": function($event) {
	          if (_vm._k($event.keyCode, "enter", 13)) { return null; }
	          $event.stopPropagation();
	          _vm.editRecord(record, _vm.displayData.itemId)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          record.value = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-pencil edit-marker"
	    })]) : (record && record.editable) ? _c('td', {
	      staticClass: "relative text-center"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (record.value),
	        expression: "record.value"
	      }],
	      style: (_vm.styles.editBoxWidthFull),
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (record.value)
	      },
	      on: {
	        "keyup": function($event) {
	          _vm.processData(record)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          record.value = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-pencil edit-marker"
	    })]) : ((record && record.hasOwnProperty('makeLink') && record.makeLink) && record.hasOwnProperty('type') && record.type) ? _c('td', {
	      style: ((key === 0 && _vm.styles.topHeaderStyle) ? _vm.styles.topHeaderStyle : _vm.styles.tdStyle),
	      on: {
	        "click": function($event) {
	          _vm.processRecord(record)
	        }
	      }
	    }, [_c('a', {
	      style: (_vm.styles.aActualStyle)
	    }, [_vm._v(_vm._s(record.value))])]) : (record && record.hasOwnProperty('makeLink') && record.makeLink) ? _c('td', {
	      style: ((key === 0 && _vm.styles.topHeaderStyle) ? _vm.styles.topHeaderStyle : _vm.styles.tdStyle),
	      on: {
	        "click": function($event) {
	          _vm.processRecord(record)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "relative",
	      on: {
	        "mouseover": function($event) {
	          _vm.showPopOver(key)
	        },
	        "mouseout": function($event) {
	          _vm.hidePopOver(key)
	        }
	      }
	    }, [_c('div', {
	      class: {
	        'hover-detail': key === _vm.showPopKey, 'hide': key !== _vm.showPopKey
	      }
	    }, [_vm._v("\n          " + _vm._s(record.value) + "\n        ")]), _vm._v(" "), _c('div', {
	      staticClass: "null-height"
	    }, [_c('a', {
	      style: (_vm.styles.aStyle)
	    }, [_vm._v(_vm._s(_vm.addDotsToData(record.value)))])])])]) : (_vm.pendingOrPast === 'PAST') ? _c('td', {
	      style: (_vm.styles.actualStyle)
	    }, [_vm._v("\n      " + _vm._s((record && typeof record.value !== "undefined" && record.value !== null) ? record.value : (typeof record !== "undefined" && record !== null && record.toString().length > 0) ? record : " ") + "\n    ")]) : (_vm.pendingOrPast === 'PENDING') ? _c('td', {
	      style: (_vm.styles.estimatedStyle)
	    }, [_vm._v("\n      " + _vm._s((record && typeof record.value !== "undefined" && record.value !== null) ? record.value : (typeof record !== "undefined" && record !== null && record.toString().length > 0) ? record : " ") + "\n    ")]) : _c('td', {
	      style: ((key === 0 && _vm.styles.topHeaderStyle) ? _vm.styles.topHeaderStyle : _vm.styles.tdStyle)
	    }, [(record && record.length > 40) ? [_c('div', [_c('div', {
	      staticClass: "relative",
	      on: {
	        "mouseover": function($event) {
	          _vm.showPopOver(key)
	        },
	        "mouseout": function($event) {
	          _vm.hidePopOver(key)
	        }
	      }
	    }, [_c('div', {
	      class: {
	        'hover-detail': key === _vm.showPopKey, 'hide': key !== _vm.showPopKey
	      }
	    }, [_vm._v("\n              " + _vm._s(record) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "null-height"
	    }, [_vm._v("\n              " + _vm._s(_vm.addDotsToData(record)) + "\n            ")])])])] : (record && record.value && record.value.length > 40) ? [_c('div', {
	      staticClass: "relative",
	      on: {
	        "mouseover": function($event) {
	          _vm.showPopOver(key)
	        },
	        "mouseout": function($event) {
	          _vm.hidePopOver(key)
	        }
	      }
	    }, [_c('div', {
	      class: {
	        'hover-detail': key === _vm.showPopKey, 'hide': key !== _vm.showPopKey
	      }
	    }, [_vm._v("\n            " + _vm._s(record.value) + "\n          ")]), _vm._v(" "), _c('div', {
	      staticClass: "null-height"
	    }, [_vm._v("\n            " + _vm._s(_vm.addDotsToData(record.value)) + "\n          ")])])] : [_vm._l((_vm.getCellRecord(record)), function(value) {
	      return [_c('span', {
	        class: {
	          'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'
	        }
	      }, [_vm._v("\n            " + _vm._s(value) + "\n          ")])]
	    })]], 2)])
	  }))
	},staticRenderFns: []}

/***/ },
/* 362 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-logo-container"
	  }, [(_vm.imageLink) ? _c('img', {
	    attrs: {
	      "src": "",
	      "alt": ""
	    }
	  }) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "welcome-text"
	  }, [_vm._v("Hello , ")]), _vm._v(" "), _c('p', {
	    staticClass: "welcome-text"
	  }, [_vm._v(_vm._s('Pet Partner' || _vm.spriteText))])])
	},staticRenderFns: []}

/***/ },
/* 363 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: {
	      "sideBar": true, "fade-in": _vm.showToggleButton
	    },
	    attrs: {
	      "id": "pastSidebar"
	    },
	    on: {
	      "mouseenter": _vm.openSideBar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars primary-green-text left"
	  })]), _vm._v(" "), _c('side-bar', {
	    attrs: {
	      "show": _vm.sideBarToggle,
	      "fetchAggregatedOffer": _vm.fetchAggregatedOffer,
	      "submitButtonPresent": true,
	      "type": _vm.popUptype,
	      "sidebarHeader": _vm.sideBarTitle
	    },
	    on: {
	      "sidebarInactive": _vm.closeSideBar
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "outer-div-min",
	    attrs: {
	      "id": "outerDivMinId"
	    }
	  }, [_c('div', {
	    staticClass: "inner-div text-center",
	    attrs: {
	      "id": "selectedOffersInnerDiv"
	    }
	  }, [(this.fixedTableData.length > 0) ? _c('div', [_c('div', {
	    staticStyle: {
	      "table-layout": "fixed",
	      "overflow-y": "scroll"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "margin": "0 auto"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.fixedTableData), function(row) {
	    return _c('tr', _vm._l((row), function(column, i) {
	      return _c('td', {
	        class: {
	          'primary-green-text': column.data.others && column.data.others.clickable, 'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
	        },
	        on: {
	          "click": function($event) {
	            _vm.childEvent(column.data)
	          }
	        }
	      }, [_vm._v(_vm._s(column.data.value) + "\n              ")])
	    }))
	  })], 2)]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "actualParent"
	  }, [_c('div', {
	    staticClass: "primary-green-text",
	    on: {
	      "click": function($event) {
	        _vm.collapseEstimatedTable(_vm.showEstimated)
	      }
	    }
	  }, [_vm._v("Estimated (POS)")])]), _vm._v(" "), (!_vm.showEstimated) ? _c('div', {
	    class: {
	      'table-two-parent': true, 'beforeCollpaseHeight': !_vm.getterNavBarCollapse, 'afterCollapseHeight': _vm.getterNavBarCollapse
	    },
	    attrs: {
	      "id": "estimatedId"
	    },
	    on: {
	      "scroll": function($event) {
	        _vm.scrollSimulateByEstimated($event)
	      }
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "margin": "0 auto"
	    }
	  }, _vm._l((_vm.scrollableTablePendingData), function(row) {
	    return _c('tr', _vm._l((row), function(column, i) {
	      return _c('td', {
	        class: {
	          'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
	        }
	      }, [_vm._l((_vm.getCellRecord(column.data.value)), function(value) {
	        return [_c('span', {
	          class: {
	            'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'
	          }
	        }, [_vm._v("\n                      " + _vm._s(value) + "\n                    ")])]
	      })], 2)
	    }))
	  }))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "actualParent"
	  }, [_c('div', {
	    staticClass: "primary-green-text",
	    on: {
	      "click": function($event) {
	        _vm.collapseActualTable(_vm.showActual)
	      }
	    }
	  }, [_vm._v("Actual (POS)")])]), _vm._v(" "), (!_vm.showActual) ? _c('div', {
	    class: {
	      'table-two-parent': true, 'beforeCollpaseHeight': !_vm.getterNavBarCollapse, 'afterCollapseHeight': _vm.getterNavBarCollapse
	    },
	    attrs: {
	      "id": "actualId"
	    },
	    on: {
	      "scroll": function($event) {
	        _vm.scrollSimulateByActual($event)
	      }
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "margin": "0 auto"
	    }
	  }, _vm._l((_vm.scrollableTablePastData), function(row) {
	    return _c('tr', _vm._l((row), function(column, i) {
	      return _c('td', {
	        class: {
	          'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
	        }
	      }, [_vm._l((_vm.getCellRecord(column.data.value)), function(value) {
	        return [_c('span', {
	          class: {
	            'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'
	          }
	        }, [_vm._v("\n                      " + _vm._s(value) + "\n                    ")])]
	      })], 2)
	    }))
	  }))]) : _vm._e()])]) : _c('div', {
	    staticClass: "preview"
	  }, [_c('h2', {
	    staticClass: "grey-text"
	  }, [_vm._v(_vm._s(_vm.defaultNote))])]), _vm._v(" "), _c('div', {
	    staticClass: "text-center",
	    style: ({
	      'margin-top': '1rem'
	    })
	  }, [_c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': !_vm.buttonDisabled
	    },
	    attrs: {
	      "type": "button",
	      "disabled": _vm.buttonDisabled
	    },
	    on: {
	      "click": _vm.downloadAllDetails
	    }
	  }, [_vm._v("\n          Download Selected Period Data\n        ")]), _vm._v(" "), _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': false
	    },
	    attrs: {
	      "type": "button",
	      "disabled": true
	    },
	    on: {
	      "click": function($event) {}
	    }
	  }, [_vm._v("\n          Download Promo Items Sales Forecast\n        ")]), _vm._v(" "), _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': (!_vm.buttonDisabled && _vm.isLoginSuperUser)
	    },
	    attrs: {
	      "type": "button",
	      "disabled": _vm.buttonDisabled && _vm.isLoginSuperUser
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendMail()
	      }
	    }
	  }, [_vm._v("\n          Send Final Confirmation Mail\n        ")])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', [_vm._v("CLASSIFIED BY TOOL")]), _vm._v(" "), _c('th', [_vm._v("GREEN")]), _vm._v(" "), _c('th', [_vm._v("YELLOW")]), _vm._v(" "), _c('th', [_vm._v("RED")]), _vm._v(" "), _c('th', [_vm._v("TOTAL")])])
	}]}

/***/ },
/* 364 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    class: {
	      "sideBarStyle": true, "openSideBar": _vm.sidebarToggle
	    },
	    on: {
	      "mouseleave": _vm.closeSideBar
	    }
	  }, [_c('div', {
	    class: {
	      "hide": !_vm.sidebarToggle
	    }
	  }, [_c('label', {
	    staticClass: "headerForOffer"
	  }, [_vm._v(_vm._s(this.sidebarHeader))]), _vm._v(" "), (_vm.type === 'offerList') ? _c('div', {
	    staticClass: "width_full"
	  }, [_c('searchable-dropdown', {
	    attrs: {
	      "id": 10,
	      "list": _vm.offerNames,
	      "defaultText": _vm.selectedOfferId,
	      "selectedItem": _vm.cloneOfferName,
	      "screenName": _vm.screenName
	    },
	    model: {
	      value: (_vm.selectedOfferName),
	      callback: function($$v) {
	        _vm.selectedOfferName = $$v
	      }
	    }
	  })], 1) : (_vm.type === 'pendingApprovals') ? _c('div', {
	    staticClass: "margin-reset padding-reset grid-12"
	  }, [(_vm.superUser) ? _c('div', {}, [_c('label', {
	    staticClass: "ddHeaders"
	  }, [_vm._v("MERCHANTS:")]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": "vendorId1",
	      "list": _vm.merchants,
	      "defaultText": _vm.defaultText,
	      "selectedItem": _vm.selectedMerchantValue
	    },
	    model: {
	      value: (_vm.selectedMerchant),
	      callback: function($$v) {
	        _vm.selectedMerchant = $$v
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "ddHeaders"
	  }, [_vm._v("MANUFACTURERS:")]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": "superuser1",
	      "list": _vm.emails,
	      "defaultText": _vm.defaultText,
	      "selectedItem": _vm.selectedItem
	    },
	    model: {
	      value: (_vm.selectedVendor),
	      callback: function($$v) {
	        _vm.selectedVendor = $$v
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "ddHeaders"
	  }, [_vm._v("OFFERS:")]), _vm._v(" "), _c('dropdown', {
	    attrs: {
	      "id": 100,
	      "list": _vm.offers,
	      "defaultText": _vm.defaultOfferName,
	      "selectedItem": (_vm.gettersAggInputDataName.offers) ? _vm.gettersAggInputDataName.offers.name : ""
	    },
	    model: {
	      value: (_vm.selectedOfferId),
	      callback: function($$v) {
	        _vm.selectedOfferId = $$v
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "ddPeriods"
	  }, [_vm._v("PERIODS:")]), _vm._v(" "), _c('dropdown', {
	    attrs: {
	      "id": 200,
	      "list": _vm.periods,
	      "defaultText": _vm.defaultPeriod,
	      "selectedItem": (_vm.gettersAggInputDataName.period) ? _vm.gettersAggInputDataName.period.name : ""
	    },
	    model: {
	      value: (_vm.selectedPeriod),
	      callback: function($$v) {
	        _vm.selectedPeriod = $$v
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "ddCategory"
	  }, [_vm._v("CATEGORIES:")]), _vm._v(" "), _c('label', {
	    staticClass: "all-categories",
	    on: {
	      "click": _vm.removeFilter
	    }
	  }, [_vm._v("See All Categories")]), _vm._v(" "), _c('div', {
	    staticClass: "category-body"
	  }, [_c('label', {
	    staticClass: "ddSubHeaders"
	  }, [_vm._v("DEPARTMENTS:")]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": 1,
	      "list": _vm.departments,
	      "selectedItem": _vm.department ? _vm.department.name : null
	    },
	    model: {
	      value: (_vm.selectedDepartment),
	      callback: function($$v) {
	        _vm.selectedDepartment = $$v
	      }
	    }
	  }), _vm._v(" "), (_vm.department) ? _c('label', {
	    staticClass: "ddSubHeaders"
	  }, [_vm._v(" SUB-DEPARTMENTS:")]) : _vm._e(), _vm._v(" "), (_vm.department) ? _c('searchable-dropdown', {
	    attrs: {
	      "id": 2,
	      "list": _vm.subDepartments,
	      "selectedItem": _vm.subDepartment ? _vm.subDepartment.name : null
	    },
	    model: {
	      value: (_vm.selectedSubDepartment),
	      callback: function($$v) {
	        _vm.selectedSubDepartment = $$v
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.subDepartment && _vm.subDepartment !== null) ? _c('label', {
	    staticClass: "ddSubHeaders"
	  }, [_vm._v(" CLASSES:")]) : _vm._e(), _vm._v(" "), (_vm.subDepartment && _vm.subDepartment !== null) ? _c('searchable-dropdown', {
	    attrs: {
	      "reset": _vm.reset._class,
	      "id": 3,
	      "list": _vm._class,
	      "selectedItem": _vm.textClass ? _vm.textClass.name : null
	    },
	    model: {
	      value: (_vm.selectedClass),
	      callback: function($$v) {
	        _vm.selectedClass = $$v
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.textClass && _vm.textClass !== null) ? _c('label', {
	    staticClass: "ddSubHeaders"
	  }, [_vm._v("SUB-CLASSES:")]) : _vm._e(), _vm._v(" "), (_vm.textClass && _vm.textClass !== null) ? _c('searchable-dropdown', {
	    attrs: {
	      "reset": _vm.reset.subClass,
	      "id": 4,
	      "list": _vm.subClasses,
	      "selectedItem": _vm.subClass ? _vm.subClass.name : null
	    },
	    model: {
	      value: (_vm.selectedSubClass),
	      callback: function($$v) {
	        _vm.selectedSubClass = $$v
	      }
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
	    staticClass: "ddHeaders"
	  }, [_vm._v("BRANDS:")]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": 5,
	      "list": _vm.brands,
	      "selectedItem": (_vm.gettersAggInputDataName.brand) ? _vm.gettersAggInputDataName.brand.name : ""
	    },
	    model: {
	      value: (_vm.selectedBrand),
	      callback: function($$v) {
	        _vm.selectedBrand = $$v
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "ddHeaders"
	  }, [_vm._v("STORES:")]), _vm._v(" "), _c('dropdown', {
	    attrs: {
	      "id": 300,
	      "list": _vm.storeLevels,
	      "defaultText": _vm.defaultStoreLevel,
	      "selectedItem": (_vm.gettersAggInputDataName.storeLevel) ? _vm.gettersAggInputDataName.storeLevel.name : ""
	    },
	    model: {
	      value: (_vm.selectedStoreLevel),
	      callback: function($$v) {
	        _vm.selectedStoreLevel = $$v
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.submitButtonPresent) ? _c('div', {
	    staticClass: "submitButtonDiv"
	  }, [_c('button', {
	    class: {
	      'submitButton': true, 'width_full': true, 'primary-green-bg': _vm.isSubmitButtonEnabled(), 'grey-text': !_vm.isSubmitButtonEnabled()
	    },
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.isSubmitButtonEnabled()
	    },
	    on: {
	      "click": function($event) {
	        _vm.getPendingApprovals()
	      }
	    }
	  }, [_vm._v("\n          Submit\n        ")])]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 365 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      "modal": true, "show": _vm.show, "hidden": !_vm.show
	    },
	    attrs: {
	      "id": "myModal"
	    }
	  }, [_c('div', {
	    class: {
	      "modal-content": true, "fixed-width-modal": !_vm.config.buttons.decline.present
	    }
	  }, [_c('span', {
	    staticClass: "close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.config.header))]), _vm._v(" "), _c('main', [(_vm.config.type !== null) ? _c('div', [(_vm.config.type === "ERROR") ? _c('error') : _vm._e(), _vm._v(" "), (_vm.config.type === "SUCCESS") ? _c('success') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "modal-body fix-height"
	  }, [(_vm.messageIsArray) ? _c('ul', _vm._l((_vm.config.message), function(message) {
	    return _c('li', [_vm._v(" " + _vm._s(message) + " ")])
	  })) : _c('p', [_vm._v(_vm._s(_vm.config.message))])])]), _vm._v(" "), _c('footer', [(!_vm.config.buttons.decline.present) ? _c('single-button', {
	    attrs: {
	      "buttonText": _vm.config.buttons.accept.text,
	      "error": _vm.error,
	      "action": _vm.config.buttons.accept.action
	    },
	    model: {
	      value: (_vm.result),
	      callback: function($$v) {
	        _vm.result = $$v
	      }
	    }
	  }) : _c('dual-buttons', {
	    attrs: {
	      "buttonText": _vm.config.buttons,
	      "action": _vm.config.buttons.accept.action
	    },
	    model: {
	      value: (_vm.result),
	      callback: function($$v) {
	        _vm.result = $$v
	      }
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ },
/* 366 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {}, [_c('div', {
	    staticClass: "upper-parent"
	  }, [_c('div', {
	    staticClass: "upper-parent-child1"
	  }, [_c('div', {
	    staticClass: "same-line itemsContainer inline-block"
	  }, [_c('div', {
	    staticClass: "offer-name"
	  }, [(_vm.gettersSelectedOffer && _vm.gettersSelectedOffer.name) ? _c('div', [_vm._v("\n              " + _vm._s(this.gettersSelectedOffer.name) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatedItemName && _vm.duplicatedItemName.name) ? _c('div', {
	    staticClass: "item-text"
	  }, [_vm._v("\n              " + _vm._s(_vm.duplicatedItemName.name) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": "simulation1",
	      "list": _vm.itemArrays,
	      "selectedItem": _vm.selectedItem ? _vm.selectedItem.name : ''
	    },
	    model: {
	      value: (_vm.selectedItem),
	      callback: function($$v) {
	        _vm.selectedItem = $$v
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "upper-parent-child2"
	  }, [_c('div', {
	    staticClass: "marginLeft inline-block",
	    style: ({
	      'width': '90%'
	    })
	  }, [_c('div', {
	    staticClass: "margin-top-3"
	  }, [_c('span', {
	    staticClass: "slider-title"
	  }, [_vm._v("\n              Vendor Allowance\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "marginRight padding1"
	  }, [_c('vue-slider', {
	    style: (_vm.style),
	    attrs: {
	      "data": _vm.slider1Data,
	      "refresh": _vm.refresh,
	      "width": _vm.width,
	      "tooltip": true,
	      "disabled": _vm.slider1Disabled,
	      "piecewise": true,
	      "piecewiseLabel": true,
	      "piecewiseStyle": _vm.piecewiseStyle,
	      "piecewiseActiveStyle": _vm.piecewiseActiveStyle,
	      "labelActiveStyle": _vm.labelActiveStyle,
	      "processStyle": _vm.processStyle
	    },
	    model: {
	      value: (_vm.slider1Value),
	      callback: function($$v) {
	        _vm.slider1Value = $$v
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('span', [_c('span', {
	    staticClass: "slider-title"
	  }, [_vm._v("Retail Savings")]), _vm._v(" "), _c('div', {
	    staticClass: "marginRight padding1"
	  }, [_c('vue-slider', {
	    style: (_vm.style),
	    attrs: {
	      "data": _vm.slider2Data,
	      "width": _vm.width,
	      "tooltip": true,
	      "disabled": false,
	      "piecewise": true,
	      "piecewiseLabel": true,
	      "piecewiseStyle": _vm.piecewiseStyle,
	      "piecewiseActiveStyle": _vm.piecewiseActiveStyle,
	      "labelActiveStyle": _vm.labelActiveStyle,
	      "processStyle": _vm.processStyle
	    },
	    model: {
	      value: (_vm.slider2Value),
	      callback: function($$v) {
	        _vm.slider2Value = $$v
	      }
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "table1-space",
	    attrs: {
	      "id": "table1ContainerDiv"
	    }
	  }, [_c('div', {
	    staticClass: "inline-block v-top text-align-left",
	    attrs: {
	      "id": "table1HeaderContainer"
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "data": _vm.table1Header,
	      "styles": _vm.tableStyles.offersListHeaderStyles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block scrollable",
	    style: ({
	      width: _vm.scrollable1Width
	    }),
	    attrs: {
	      "id": "table1BodyContainer"
	    }
	  }, [_c('div', {
	    staticClass: "inline-block text-align-left",
	    style: ({
	      width: ((_vm.table1Data.length * _vm.table1BodyWidth) + "rem")
	    })
	  }, _vm._l((_vm.table1Data), function(data) {
	    return _c('div', {
	      staticClass: "inline-block",
	      style: ({
	        width: (_vm.table1BodyWidth + "rem"),
	        "vertical-align": "top"
	      })
	    }, [_c('data-table', {
	      attrs: {
	        "functions": _vm.updateChanges,
	        "data": data,
	        "styles": _vm.tableStyles.offersListDataStyle
	      }
	    })], 1)
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    class: {
	      'width_4': true, 'primary-green-bg': _vm.hasChanges, 'light-grey-text': !_vm.hasChanges
	    },
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.hasChanges
	    },
	    on: {
	      "click": _vm.submitChanges
	    }
	  }, [_vm._v("\n          Submit changes\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "change-header-title"
	  }, [_vm._v("\n    " + _vm._s('Impact Of Changing Retail Savings') + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "switch-parent"
	  }, [_c('span', {
	    class: {
	      "padding1": true, "color": !_vm.switchToggle
	    }
	  }, [_vm._v("Graph")]), _vm._v(" "), _c('label', {
	    staticClass: "switch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.switchToggle),
	      expression: "switchToggle"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.switchToggle) ? _vm._i(_vm.switchToggle, null) > -1 : (_vm.switchToggle)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.switchToggle,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.switchToggle = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.switchToggle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.switchToggle = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "slider"
	  })]), _vm._v(" "), _c('span', {
	    class: {
	      "padding1": true, "color": _vm.switchToggle
	    }
	  }, [_vm._v("Table")])]), _vm._v(" "), (_vm.switchToggle) ? _c('div', [_c('div', {
	    staticClass: "table1-space",
	    attrs: {
	      "id": "table2ContainerDiv"
	    }
	  }, [_c('div', {
	    staticClass: "inline-block v-top text-align-left",
	    attrs: {
	      "id": "table2HeaderContainer"
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "data": _vm.table2Headers,
	      "styles": _vm.tableStyles.offersListHeaderStyles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block scrollable text-align-left",
	    style: ({
	      width: _vm.scrollable2Width
	    }),
	    attrs: {
	      "id": "table2BodyContainer"
	    }
	  }, [_c('div', {
	    staticClass: "inline-block",
	    style: ({
	      width: ((_vm.table2Data.length * _vm.scrollableChildrenWidth) + "rem")
	    })
	  }, _vm._l((_vm.table2Data), function(data) {
	    return _c('div', {
	      staticClass: "inline-block",
	      style: ({
	        width: (_vm.scrollableChildrenWidth + "rem")
	      })
	    }, [_c('data-table', {
	      attrs: {
	        "data": data,
	        "styles": _vm.tableStyles.offersListDataStyle
	      }
	    })], 1)
	  }))])])]) : _vm._e(), _vm._v(" "), (!_vm.switchToggle) ? _c('div', {
	    staticClass: "graph-parent"
	  }, [_c('div', {
	    staticClass: "radio-container"
	  }, _vm._l((_vm.lineChartInputOptionArray), function(data) {
	    return _c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.picked),
	        expression: "picked"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": "data"
	      },
	      domProps: {
	        "value": data,
	        "checked": _vm._q(_vm.picked, data)
	      },
	      on: {
	        "__c": function($event) {
	          _vm.picked = data
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": data
	      }
	    }, [_vm._v(_vm._s(data))])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "graph-container"
	  }, [_c('vue-chart', {
	    attrs: {
	      "chart-type": "LineChart",
	      "columns": _vm.columns,
	      "rows": _vm.rows,
	      "options": _vm.options
	    }
	  })], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 367 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    style: (_vm.styles.tableContainerStyle)
	  }, [_c('table', {
	    staticClass: "headers",
	    style: (_vm.styles.headerTableStyle)
	  }, [_c('tr', {
	    style: (_vm.styles.trStyle)
	  }, _vm._l((_vm.headers), function(headerText) {
	    return _c('th', {
	      style: (_vm.styles.thStyle)
	    }, [_vm._v("\n        " + _vm._s(headerText.value) + "\n      ")])
	  }))]), _vm._v(" "), _c('table', {
	    staticClass: "data",
	    style: (_vm.styles.headerTableStyle)
	  }, _vm._l((_vm.dataAsComputed), function(row, rowKey) {
	    return _c('tr', {
	      style: (_vm.styles.trStyle)
	    }, _vm._l((row), function(field, fieldKey) {
	      return _c('td', {
	        staticClass: "row",
	        style: (_vm.styles.tdStyle)
	      }, [(field.editable) ? _c('div', [(field.edit) ? _c('div', [_c('input', {
	        directives: [{
	          name: "on-clickaway",
	          rawName: "v-on-clickaway",
	          value: (_vm.resetToFalse(rowKey, fieldKey)),
	          expression: "resetToFalse(rowKey, fieldKey)"
	        }],
	        style: (_vm.styles.editableLabel),
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (_vm.dataAsComputed[rowKey][fieldKey]).value
	        },
	        on: {
	          "keyup": function($event) {
	            _vm.updateData($event, rowKey, fieldKey)
	          }
	        }
	      }), _vm._v(" "), _c('i', {
	        staticClass: "fa fa-check",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      })]) : _vm._e(), _vm._v(" "), (!field.edit) ? _c('div', {
	        style: (_vm.styles.editableLabel)
	      }, [_vm._v("\n            " + _vm._s(field.value) + "\n          ")]) : _vm._e(), _vm._v(" "), (!field.edit) ? _c('div', {
	        style: (_vm.styles.editableEditBox),
	        on: {
	          "click": function($event) {
	            _vm.editData(rowKey, fieldKey)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-pencil",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!field.editable) ? _c('div', [_vm._v("\n          " + _vm._s(field.value) + "\n        ")]) : _vm._e()])
	    }))
	  }))])
	},staticRenderFns: []}

/***/ },
/* 368 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dropdown-container",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "dropdown padding-reset margin-reset grid-12"
	  }, [_c('button', {
	    staticClass: "width_full",
	    on: {
	      "click": function($event) {
	        _vm.show = !_vm.show
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.selectedItemOverride || _vm.defaultValue || _vm.defaultText) + " \n      "), _c('i', {
	    staticClass: "fa fa-caret-down",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), (_vm.show) ? _c('div', {
	    staticClass: "dropdown-content row",
	    attrs: {
	      "id": "myDropdown"
	    }
	  }, [_c('ul', {
	    staticClass: "grid-12"
	  }, _vm._l((_vm.values), function(value) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.dropdownItemClick($event, value)
	        }
	      }
	    }, [_vm._v(_vm._s(value.name))])
	  }))]) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 369 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "marginLeft upper-parent"
	  }, [_c('div', {
	    staticClass: "same-line itemsContainer inline-block upper-parent-child1"
	  }, [_c('div', {
	    staticClass: "offer-name"
	  }, [(_vm.gettersSelectedOffer && _vm.gettersSelectedOffer.name) ? _c('div', [_vm._v("\n        " + _vm._s(this.gettersSelectedOffer.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatedItemName && _vm.duplicatedItemName.name) ? _c('div', {
	    staticClass: "item-text"
	  }, [_vm._v("\n        " + _vm._s(_vm.duplicatedItemName.name) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('searchable-dropdown', {
	    attrs: {
	      "id": "waterfall1",
	      "list": _vm.itemArrays,
	      "selectedItem": _vm.selectedItem ? this.selectedItem.name : ''
	    },
	    model: {
	      value: (_vm.selectedItem),
	      callback: function($$v) {
	        _vm.selectedItem = $$v
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block upper-parent-child2",
	    style: ({
	      'width': '80%'
	    })
	  }, [_c('div', {
	    staticClass: "chart-container"
	  }, [_c('vue-chart', {
	    attrs: {
	      "chart-type": "CandlestickChart",
	      "columns": _vm.columns,
	      "rows": _vm.rows,
	      "version": 45,
	      "options": _vm.options
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "outer-div-min"
	  }, [_c('div', {
	    staticClass: "inner-div"
	  }, [_c('div', {
	    staticClass: "center"
	  }, [_c('ul', {
	    staticClass: "inline-block"
	  }, [_c('button', {
	    staticClass: "float-left",
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n            " + _vm._s('Back') + " \n          ")]), _vm._v(" "), (_vm.buttonEnabled) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "active-class": "active-router",
	      "to": "/chart-graph-simulation/simulation"
	    }
	  }, [_c('span', {
	    attrs: {
	      "onclick": ""
	    }
	  }, [_vm._v("Response Simulation")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "active-class": "active-router",
	      "to": "/chart-graph-simulation/past-trends"
	    }
	  }, [_c('span', {
	    attrs: {
	      "onclick": "",
	      "id": "defaultOpen"
	    }
	  }, [_vm._v("Past Trends")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "active-class": "active-router",
	      "to": "/chart-graph-simulation/waterfall"
	    }
	  }, [_c('span', {
	    attrs: {
	      "onclick": ""
	    }
	  }, [_vm._v("Waterfall")])])], 1)]), _vm._v(" "), _c('router-view')], 1)])
	},staticRenderFns: []}

/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.getPositionClass()
	  }, [_c('div', {
	    staticClass: "border"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },
/* 372 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay"
	  }, [_c('div', {
	    style: (_vm.mainContainerStyle.mainStyle.confirmationApproveWithChanges)
	  }, [_c('div', {
	    staticClass: "width_full",
	    style: (_vm.mainContainerStyle.mainStyle.tableButton)
	  }, [(_vm.data.code === _vm.code.APPROVE_WITH_CHANGES) ? _c('h5', [_vm._v(_vm._s(_vm.code.APPROVE_WITH_CHANGES_TEXT))]) : (_vm.data.code === _vm.code.APPROVE_WITH_NO_CHANGES) ? _c('h5', [_vm._v("\n        " + _vm._s(_vm.code.NO_CHANGES_TEXT) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.data.headers && _vm.data.headers.length) ? _c('div', {
	    attrs: {
	      "id": "confirmationInnerDiv"
	    }
	  }, [_c('div', {
	    staticClass: "center center-parent"
	  }, [_c('div', {
	    staticClass: "text-left inline-block",
	    attrs: {
	      "id": "selectedOffersHeaderContainer"
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "data": _vm.data.headers,
	      "styles": _vm.tableStyles.offersListHeaderStyles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block scrollable",
	    style: ({
	      width: ((_vm.count * _vm.scrollableWidth) + "rem")
	    })
	  }, [_c('div', {
	    staticClass: "inline-block",
	    style: ({
	      width: ((_vm.data.contents.length * _vm.scrollableChildrenWidth) + "rem")
	    })
	  }, _vm._l((_vm.data.contents), function(data) {
	    return _c('div', {
	      staticClass: "text-left inline-block",
	      style: ({
	        width: (_vm.scrollableChildrenWidth + "rem")
	      })
	    }, [_c('data-table', {
	      attrs: {
	        "data": data,
	        "styles": _vm.tableStyles.offersListDataStyle
	      }
	    })], 1)
	  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin_bottom width_full",
	    style: (_vm.mainContainerStyle.mainStyle.tableButton)
	  }, [(_vm.data.code === _vm.code.APPROVE_WITH_CHANGES || _vm.data.code === _vm.code.APPROVE_WITH_NO_CHANGES || _vm.data.code === _vm.code.SET_ZONE) ? _c('h5', [_vm._v("\n        " + _vm._s(_vm.code.SUBMIT_TEXT) + "\n      ")]) : (_vm.data.code === _vm.code.REJECT_OFFER) ? _c('h5', [_vm._v(_vm._s(_vm.code.REJECT_TEXT))]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "primary-green-bg width_8",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "primary-green-bg width_8",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("\n        Submit\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 373 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "error-logo"
	  }, [_c('div', {
	    staticClass: "symbol"
	  }, [_vm._v("\n      ×\n    ")])])])
	}]}

/***/ },
/* 374 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: {
	      "sideBar": true, "fade-in": _vm.showToggleButton
	    },
	    on: {
	      "mouseenter": _vm.openSideBar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars primary-green-text left"
	  })]), _vm._v(" "), _c('side-bar', {
	    attrs: {
	      "show": _vm.sideBarToggle,
	      "type": _vm.sideBarType,
	      "offerNames": _vm.filteredOffers,
	      "sidebarHeader": _vm.sideBarTitle,
	      "handleEvent": _vm.childEvent,
	      "screenName": _vm.screenName
	    },
	    on: {
	      "sidebarInactive": _vm.closeSideBar
	    }
	  }), _vm._v(" "), (_vm.headers) ? _c('div', {
	    class: {
	      'height-10': _vm.offerTypeFlag, 'height-12': !_vm.offerTypeFlag
	    },
	    style: ({
	      'z-index': '1',
	      'position': 'fixed',
	      'background': 'white',
	      'margin-left': '20px'
	    })
	  }, [_c('div', {}, [(_vm.pastOrPendingFlag === 'PAST') ? _c('div', {}, [_c('div', {
	    style: ({
	      'padding-top': '1rem',
	      'margin-left': '1.5rem',
	      'font-size': '1.5rem',
	      'vertical-align': 'sub'
	    })
	  }, [_vm._v("Estimated figures are marked with\n          "), _c('span', {
	    staticClass: "primary-green-text",
	    style: ({
	      'font-weight': 'bold'
	    })
	  }, [_vm._v("GREEN")]), _vm._v("\n          and Actual figures are marked with\n          "), _c('span', {
	    staticClass: "black-text",
	    style: ({
	      'font-weight': 'bold'
	    })
	  }, [_vm._v("BLACK")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "inline-block"
	  }, [_c('div', {
	    staticClass: "tooltip"
	  }, [_c('span', {
	    style: ({
	      'padding-left': '1.5rem',
	      'font-size': '1.3rem'
	    })
	  }, [_vm._v("Offer Name: ")]), _vm._v(" "), _c('span', {
	    style: ({
	      'padding-left': '0.5rem',
	      'font-size': '1.2rem',
	      'color': '#026937'
	    })
	  }, [_vm._v(_vm._s(_vm.offerName))]), _vm._v(" "), _c('span', {
	    staticClass: "tooltiptext"
	  }, [_vm._v(_vm._s(_vm.gettersSelectedOffer.name))])]), _vm._v(" "), _c('div', {}, [_c('span', {
	    style: ({
	      'padding-left': '1.5rem',
	      'font-size': '1.3rem'
	    })
	  }, [_vm._v("Campaign Period: ")]), _vm._v(" "), _c('span', {
	    style: ({
	      'padding-left': '0.5rem',
	      'font-size': '1.2rem',
	      'color': '#026937'
	    })
	  }, [_vm._v(_vm._s(_vm.gettersAggInputData.period.name))])]), _vm._v(" "), _c('div', {}, [_c('span', {
	    style: ({
	      'padding-left': '1.5rem',
	      'font-size': '1.3rem'
	    })
	  }, [_vm._v("Store: ")]), _vm._v(" "), _c('span', {
	    style: ({
	      'padding-left': '0.5rem',
	      'font-size': '1.2rem',
	      'color': '#026937'
	    })
	  }, [_vm._v(_vm._s(_vm.gettersAggInputData.storeLevel.name))])])]), _vm._v(" "), (_vm.detailedData && _vm.pastOrPendingFlag === 'PENDING') ? _c('div', {
	    staticClass: "inline-block position-relative row",
	    style: ({
	      'float': 'right',
	      'margin-top': '1rem'
	    })
	  }, [_c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': true
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.openChartsVue
	    }
	  }, [(!_vm.buttonEnabled) ? _c('span', [_vm._v("Analytics")]) : _c('span', [_vm._v("Chart And Simulation")])]), _vm._v(" "), (_vm.buttonEnabled) ? _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': _vm.buttonEnabled
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.rejectOffer
	    }
	  }, [_vm._v("\n          Reject offer\n        ")]) : _vm._e(), _vm._v(" "), (_vm.buttonEnabled) ? _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': _vm.buttonEnabled
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.approveWithChanges
	    }
	  }, [_vm._v("\n          Approve with changes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.buttonEnabled) ? _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': _vm.buttonEnabled
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showGoalsAndDisplay
	    }
	  }, [_vm._v("\n          Approve Offer\n        ")]) : _vm._e()]) : [(_vm.buttonEnabled) ? _c('button', {
	    class: {
	      'width_4': true, 'margin-left': true, 'primary-green-bg': _vm.buttonEnabled
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.openChartsVue
	    }
	  }, [_vm._v("\n          Chart And Simulation\n        ")]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
	    staticClass: "position-relative scrollWrapper",
	    style: ({
	      'margin-left': (_vm.marginLeft + "px"),
	      width: (_vm.scrollableWidth + "px"),
	      'min-width': (_vm.tableContainerWidth + "px")
	    }),
	    attrs: {
	      "id": "scrollWrapper"
	    },
	    on: {
	      "scroll": _vm.topScrollContainer
	    }
	  }, [_c('div', {
	    staticClass: "simulateScrollDiv",
	    style: ({
	      width: ((_vm.scrollableChildrenWidth * _vm.detailedData.length - (Math.floor(Number((_vm.detailedData.length.toString()).replace(/.$/,"0")) / 2))) + "rem")
	    })
	  })])]) : _vm._e(), _vm._v(" "), (_vm.headers !== null) ? _c('div', {
	    staticClass: "outer-div-min",
	    attrs: {
	      "id": "outer-div-min"
	    }
	  }, [_c('div', {
	    staticClass: "inner-div",
	    class: {
	      'padding-top-8': _vm.offerTypeFlag, 'padding-top-10': !_vm.offerTypeFlag
	    },
	    attrs: {
	      "id": "offersComponentInnerDiv"
	    }
	  }, [_c('div', {
	    staticClass: "inline-block margin-fix",
	    attrs: {
	      "id": "offersHeaderContainer"
	    }
	  }, [_c('vertical-header-table', {
	    attrs: {
	      "data": _vm.headers,
	      "styles": _vm.tableStyles.headerTableStyles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block margin-fix",
	    attrs: {
	      "id": "offersSummaryContainer"
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "data": _vm.aggregatedData,
	      "styles": _vm.tableStyles.summaryTableStyles,
	      "stringPadding": _vm.aggregatedTablePadding
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "scrollable-x inline-block margin-fix",
	    style: ({
	      width: (_vm.scrollableWidth + "px")
	    }),
	    attrs: {
	      "id": "offersDetailsScrollableX"
	    },
	    on: {
	      "scroll": _vm.bottomScrollContainer
	    }
	  }, [(_vm.detailedData !== null) ? _c('div', {
	    staticClass: "table-container",
	    style: ({
	      width: ((_vm.scrollableChildrenWidth * _vm.detailedData.length - (Math.floor(Number((_vm.detailedData.length.toString()).replace(/.$/,"0")) / 2))) + "rem")
	    })
	  }, _vm._l((_vm.detailedData), function(data, i) {
	    return _c('div', {
	      staticClass: "inline-block margin-fix",
	      style: ({
	        width: (_vm.scrollableChildrenWidth + "rem")
	      })
	    }, [(_vm.pastOrPendingFlag === 'PENDING') ? _c('data-table', {
	      attrs: {
	        "data": data,
	        "styles": _vm.tableStyles.detailsTableStyles,
	        "stringPadding": _vm.detailedDataPadding,
	        "functions": _vm.editPetDepotFunding
	      }
	    }) : (_vm.pastOrPendingFlag === 'PAST' && (i > 0 && i % 2 !== 0)) ? _c('data-table', {
	      attrs: {
	        "data": data,
	        "styles": _vm.tableStyles.detailsTableStyles,
	        "stringPadding": _vm.detailedDataPadding,
	        "functions": _vm.editPetDepotFunding,
	        "pendingOrPast": "PAST"
	      }
	    }) : (_vm.pastOrPendingFlag === 'PAST') ? _c('data-table', {
	      attrs: {
	        "data": data,
	        "styles": _vm.tableStyles.detailsTableStyles,
	        "stringPadding": _vm.detailedDataPadding,
	        "functions": _vm.editPetDepotFunding,
	        "pendingOrPast": "PENDING"
	      }
	    }) : _vm._e()], 1)
	  })) : _vm._e()])])]) : _c('div', {
	    staticClass: "preview"
	  }, [_c('h2', {
	    staticClass: "grey-text"
	  }, [_vm._v(_vm._s(_vm.defaultNote))])]), _vm._v(" "), (_vm.popUp) ? _c('pop-up', {
	    attrs: {
	      "closePopUp": _vm.closePopUp,
	      "type": _vm.popUpType,
	      "styles": _vm.mainContainerStyle,
	      "data": _vm.gettersGoalsAndDisplay.value
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 375 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: {
	      "sideBar": true, "fade-in": _vm.showToggleButton
	    },
	    attrs: {
	      "id": "pendingSidebar"
	    },
	    on: {
	      "mouseenter": _vm.openSideBar
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars primary-green-text left"
	  })]), _vm._v(" "), _c('side-bar', {
	    attrs: {
	      "show": _vm.sideBarToggle,
	      "fetchAggregatedOffer": _vm.fetchAggregatedOffer,
	      "submitButtonPresent": true,
	      "type": _vm.popUptype,
	      "sidebarHeader": _vm.sideBarTitle
	    },
	    on: {
	      "sidebarInactive": _vm.closeSideBar
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "outer-div-min",
	    attrs: {
	      "id": "outerDivMinId"
	    }
	  }, [_c('div', {
	    staticClass: "inner-div text-center",
	    attrs: {
	      "id": "selectedOffersInnerDiv"
	    }
	  }, [(this.fixedTableData.length > 0) ? _c('div', [_c('div', {
	    staticStyle: {
	      "table-layout": "fixed",
	      "overflow-y": "scroll"
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "margin": "0 auto"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.fixedTableData), function(row) {
	    return _c('tr', _vm._l((row), function(column, i) {
	      return _c('td', {
	        class: {
	          'primary-green-text': column.data.others && column.data.others.clickable, 'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
	        },
	        on: {
	          "click": function($event) {
	            _vm.childEvent(column.data)
	          }
	        }
	      }, [_vm._v(_vm._s(column.data.value) + "\n              ")])
	    }))
	  })], 2)]), _vm._v(" "), _c('div', {
	    class: {
	      'table-two-parent': true, 'beforeCollpaseHeight': !_vm.getterNavBarCollapse, 'afterCollapseHeight': _vm.getterNavBarCollapse
	    }
	  }, [_c('table', {
	    staticStyle: {
	      "margin": "0 auto"
	    }
	  }, _vm._l((_vm.scrollableTableData), function(row) {
	    return _c('tr', _vm._l((row), function(column, i) {
	      return _c('td', {
	        class: {
	          'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
	        }
	      }, [_vm._l((_vm.getCellRecord(column.data.value)), function(value) {
	        return [_c('span', {
	          class: {
	            'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'
	          }
	        }, [_vm._v("\n                    " + _vm._s(value) + "\n                  ")])]
	      })], 2)
	    }))
	  }))])]) : _c('div', {
	    staticClass: "preview"
	  }, [_c('h2', {
	    staticClass: "grey-text"
	  }, [_vm._v(_vm._s(_vm.defaultNote))])]), _vm._v(" "), _c('div', {
	    staticClass: "text-center",
	    style: ({
	      'margin-top': '1rem'
	    })
	  }, [_c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': true
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.downloadPortalGuide
	    }
	  }, [_vm._v("\n          Download Portal Guide\n        ")]), _vm._v(" "), _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': true
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.downloadManufacturerInfo
	    }
	  }, [_vm._v("\n          Download Manufacturer Info\n        ")]), _vm._v(" "), _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': true
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.downloadNegativeMarginItems
	    }
	  }, [_vm._v("\n          DOWNLOAD NEGATIVE MARGIN ITEMS\n        ")]), _vm._v(" "), _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': !_vm.buttonDisabled
	    },
	    attrs: {
	      "type": "button",
	      "disabled": _vm.buttonDisabled
	    },
	    on: {
	      "click": _vm.downloadAllDetails
	    }
	  }, [_vm._v("\n          Download Selected Period Data\n        ")]), _vm._v(" "), (_vm.isLoginSuperUser) ? _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': !_vm.buttonDisabled
	    },
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.isLoginSuperUser || _vm.buttonDisabled
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendMail()
	      }
	    }
	  }, [_vm._v("\n          Send Final Confirmation Mail\n        ")]) : _vm._e()])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', [_vm._v("CLASSIFIED BY TOOL")]), _vm._v(" "), _c('th', [_vm._v("GREEN")]), _vm._v(" "), _c('th', [_vm._v("YELLOW")]), _vm._v(" "), _c('th', [_vm._v("RED")]), _vm._v(" "), _c('th', [_vm._v("TOTAL")])])
	}]}

/***/ },
/* 376 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {}, [_c('div', {
	    staticClass: "ddContainer row"
	  }, [_c('div', {
	    staticClass: "ddHeaders grid-1"
	  }, [_vm._v("STORES:")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-reset padding-reset grid-3"
	  }, [_c('dropdown', {
	    attrs: {
	      "id": 400,
	      "list": _vm.storeLevels,
	      "defaultText": _vm.selectedStoreLevelValue,
	      "selectedItem": (_vm.gettersAggInputData.storeLevel) ? _vm.gettersAggInputData.storeLevel.name : ""
	    },
	    model: {
	      value: (_vm.selectedStoreLevelValue),
	      callback: function($$v) {
	        _vm.selectedStoreLevelValue = $$v
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.pastOrPendingFlag === 'PAST') ? _c('span', {
	    staticClass: "notification"
	  }, [_vm._v("\n        Estimated figures are marked with\n        "), _c('span', {
	    staticClass: "primary-green-text"
	  }, [_vm._v("Green")]), _vm._v("\n        and Actual figures are marked with\n        "), _c('span', {
	    staticClass: "black-text"
	  }, [_vm._v("Black")]), _vm._v(".\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('span', {
	    style: ({
	      'font-size': '1.3rem'
	    })
	  }, [_vm._v("Offer Name: ")]), _vm._v(" "), _c('span', {
	    style: ({
	      'padding-left': '0.5rem',
	      'font-size': '1.2rem',
	      'color': '#026937'
	    })
	  }, [_vm._v(_vm._s(_vm.gettersAggInputData.offers.name))]), _vm._v(" "), _c('span', {
	    style: ({
	      'padding-left': '0.5rem',
	      'font-size': '1.3rem'
	    })
	  }, [_vm._v("Campaign Period: ")]), _vm._v(" "), _c('span', {
	    style: ({
	      'padding-left': '0.5rem',
	      'font-size': '1.2rem',
	      'color': '#026937'
	    })
	  }, [_vm._v(_vm._s(_vm.gettersAggInputData.period.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "scrollWrapper",
	    style: ({
	      'margin-left': (_vm.marginLeft + "px"),
	      'width': (_vm.scrollableWidth + "px"),
	      'min-width': (_vm.tableContainerWidth + "px")
	    }),
	    attrs: {
	      "id": "selectedOfferscrollWrapper"
	    },
	    on: {
	      "scroll": _vm.topScrollContainer
	    }
	  }, [_c('div', {
	    staticClass: "simulateScrollDiv",
	    style: ({
	      width: ((_vm.scrollableChildrenWidth * _vm.offersListData.length) + "rem")
	    })
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "outer-div-min",
	    attrs: {
	      "id": "outer-div-min"
	    }
	  }, [_c('div', {
	    staticClass: "inner-div",
	    attrs: {
	      "id": "selectedOffersInnerDiv"
	    }
	  }, [(_vm.hasDataToShow) ? _c('div', [_c('div', {
	    staticClass: "inline-block margin-fix",
	    attrs: {
	      "id": "selectedOffersHeaderContainer"
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "data": _vm.offersListHeaders,
	      "styles": _vm.tableStyles.offersListHeaderStyles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "scrollable-x inline-block margin-fix",
	    style: ({
	      width: (_vm.scrollableWidth + "px")
	    }),
	    attrs: {
	      "id": "offersListScrollableX"
	    },
	    on: {
	      "scroll": _vm.bottomScrollContainer
	    }
	  }, [_c('div', {
	    staticClass: "table-container",
	    style: ({
	      width: ((_vm.scrollableChildrenWidth * _vm.offersListData.length - (Math.floor(Number((_vm.offersListData.length.toString()).replace(/.$/,"0")) / 2))) + "rem")
	    })
	  }, _vm._l((_vm.offersListData), function(data) {
	    return _c('div', {
	      staticClass: "inline-block margin-fix",
	      class: {
	        'myOfferStyle': data.my_offer, otherOfferStyle: !data.my_offer
	      },
	      style: ({
	        width: (_vm.scrollableChildrenWidth + "rem")
	      })
	    }, [_c('data-table', {
	      attrs: {
	        "type": _vm.type,
	        "handleEvent": _vm.childEvent,
	        "data": data,
	        "styles": _vm.tableStyles.offersListDataStyle,
	        "stringPadding": _vm.offerNameStringPadding
	      }
	    })], 1)
	  }))])]) : _c('div', {
	    staticClass: "notDataPreview"
	  }, [_c('h2', {
	    staticClass: "grey-text"
	  }, [_vm._v(_vm._s(_vm.noDataFoundText))]), _vm._v(" "), _c('button', {
	    class: {
	      'width_3': true, 'primary-green-bg': true
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.goBack
	    }
	  }, [_vm._v("\n          Back\n        ")])])])])])
	},staticRenderFns: []}

/***/ },
/* 377 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "overlay"
	  }, [_c('div', {
	    class: {
	      'scrollable': _vm.showZonePrice
	    },
	    style: (_vm.styles)
	  }, [(!_vm.showZonePrice) ? _c('span', {
	    staticClass: "close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.popupType === 'goalsAndDisplayType' && !_vm.showZonePrice) ? _c('div', [(_vm.goalsAndDisplayCategories) ? _c('div', {
	    staticClass: "row padding-fix"
	  }, _vm._l((Object.keys(_vm.goalsAndDisplayCategories).sort()), function(key) {
	    return _c('div', {
	      class: {
	        'header': true
	      },
	      style: ({
	        'padding-left': ((_vm.calcH()) + "%"),
	        'width': ((100 / Object.keys(_vm.goalsAndDisplayCategories).length) + "%")
	      })
	    }, [_c('label', [_vm._v("\n                " + _vm._s(key) + "\n              ")])])
	  })) : _vm._e(), _vm._v(" "), (!_vm.showZonePrice) ? _c('div', [_c('dd', {
	    staticClass: "scrollable"
	  }, _vm._l((Object.keys(_vm.goalsAndDisplayCategories).sort()), function(key) {
	    return _c('div', {
	      class: {
	        'inline-block': true
	      },
	      style: ({
	        'padding-top': '1rem',
	        'padding-left': ((_vm.calcH()) + "%"),
	        'width': ((100 / Object.keys(_vm.goalsAndDisplayCategories).length) + "%")
	      })
	    }, [(_vm.goalsAndDisplay.type[key] === 'RadioButton') ? _c('div', [_vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.MEGA) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedMegaList),
	          expression: "selectedMegaList"
	        }],
	        attrs: {
	          "id": value.id,
	          "type": "radio"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": _vm._q(_vm.selectedMegaList, value.id)
	        },
	        on: {
	          "__c": function($event) {
	            _vm.selectedMegaList = value.id
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.DISPLAY) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedDisplayList),
	          expression: "selectedDisplayList"
	        }],
	        attrs: {
	          "id": value.id,
	          "type": "radio"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": _vm._q(_vm.selectedDisplayList, value.id)
	        },
	        on: {
	          "__c": function($event) {
	            _vm.selectedDisplayList = value.id
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.GOAL) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedGoalList),
	          expression: "selectedGoalList"
	        }],
	        attrs: {
	          "id": value.id,
	          "type": "radio"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": _vm._q(_vm.selectedGoalList, value.id)
	        },
	        on: {
	          "__c": function($event) {
	            _vm.selectedGoalList = value.id
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.SIGNAGE) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedSignatureList),
	          expression: "selectedSignatureList"
	        }],
	        attrs: {
	          "id": value.id,
	          "type": "radio"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": _vm._q(_vm.selectedSignatureList, value.id)
	        },
	        on: {
	          "__c": function($event) {
	            _vm.selectedSignatureList = value.id
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value, i) {
	      return (key === _vm.THEME) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedThemeList),
	          expression: "selectedThemeList"
	        }],
	        attrs: {
	          "id": value.id,
	          "type": "radio"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": _vm._q(_vm.selectedThemeList, value.id)
	        },
	        on: {
	          "__c": function($event) {
	            _vm.selectedThemeList = value.id
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                    "), (i === (_vm.goalsAndDisplayCategories[key].length - 1) && _vm.selectedThemeList === _vm.addTextKeyId) ? _c('div', [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.addTextVmodel),
	          expression: "addTextVmodel"
	        }],
	        staticClass: "hover-detail",
	        style: (_vm.styles.editBoxWidthFull),
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (_vm.addTextVmodel)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.addTextVmodel = $event.target.value
	          }
	        }
	      })]) : _vm._e()]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.DURATION) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedDurationList),
	          expression: "selectedDurationList"
	        }],
	        attrs: {
	          "id": value.id,
	          "type": "radio"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": _vm._q(_vm.selectedDurationList, value.id)
	        },
	        on: {
	          "__c": function($event) {
	            _vm.selectedDurationList = value.id
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    })], 2) : _vm._e(), _vm._v(" "), (_vm.goalsAndDisplay.type[key] === 'Checkbox') ? _c('div', [_vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.MEGA) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedMegaList),
	          expression: "selectedMegaList"
	        }],
	        attrs: {
	          "id": value.id,
	          "disabled": false,
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": Array.isArray(_vm.selectedMegaList) ? _vm._i(_vm.selectedMegaList, value.id) > -1 : (_vm.selectedMegaList)
	        },
	        on: {
	          "__c": function($event) {
	            var $$a = _vm.selectedMegaList,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = value.id,
	                $$i = _vm._i($$a, $$v);
	              if ($$c) {
	                $$i < 0 && (_vm.selectedMegaList = $$a.concat($$v))
	              } else {
	                $$i > -1 && (_vm.selectedMegaList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.selectedMegaList = $$c
	            }
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.DISPLAY) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedDisplayList),
	          expression: "selectedDisplayList"
	        }],
	        attrs: {
	          "id": value.id,
	          "disabled": false,
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": Array.isArray(_vm.selectedDisplayList) ? _vm._i(_vm.selectedDisplayList, value.id) > -1 : (_vm.selectedDisplayList)
	        },
	        on: {
	          "__c": function($event) {
	            var $$a = _vm.selectedDisplayList,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = value.id,
	                $$i = _vm._i($$a, $$v);
	              if ($$c) {
	                $$i < 0 && (_vm.selectedDisplayList = $$a.concat($$v))
	              } else {
	                $$i > -1 && (_vm.selectedDisplayList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.selectedDisplayList = $$c
	            }
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.GOAL) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedGoalList),
	          expression: "selectedGoalList"
	        }],
	        attrs: {
	          "id": value.id,
	          "disabled": false,
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": Array.isArray(_vm.selectedGoalList) ? _vm._i(_vm.selectedGoalList, value.id) > -1 : (_vm.selectedGoalList)
	        },
	        on: {
	          "__c": function($event) {
	            var $$a = _vm.selectedGoalList,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = value.id,
	                $$i = _vm._i($$a, $$v);
	              if ($$c) {
	                $$i < 0 && (_vm.selectedGoalList = $$a.concat($$v))
	              } else {
	                $$i > -1 && (_vm.selectedGoalList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.selectedGoalList = $$c
	            }
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.SIGNAGE) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedSignatureList),
	          expression: "selectedSignatureList"
	        }],
	        attrs: {
	          "id": value.id,
	          "disabled": false,
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": Array.isArray(_vm.selectedSignatureList) ? _vm._i(_vm.selectedSignatureList, value.id) > -1 : (_vm.selectedSignatureList)
	        },
	        on: {
	          "__c": function($event) {
	            var $$a = _vm.selectedSignatureList,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = value.id,
	                $$i = _vm._i($$a, $$v);
	              if ($$c) {
	                $$i < 0 && (_vm.selectedSignatureList = $$a.concat($$v))
	              } else {
	                $$i > -1 && (_vm.selectedSignatureList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.selectedSignatureList = $$c
	            }
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.THEME) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedThemeList),
	          expression: "selectedThemeList"
	        }],
	        attrs: {
	          "id": value.id,
	          "disabled": false,
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": Array.isArray(_vm.selectedThemeList) ? _vm._i(_vm.selectedThemeList, value.id) > -1 : (_vm.selectedThemeList)
	        },
	        on: {
	          "__c": function($event) {
	            var $$a = _vm.selectedThemeList,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = value.id,
	                $$i = _vm._i($$a, $$v);
	              if ($$c) {
	                $$i < 0 && (_vm.selectedThemeList = $$a.concat($$v))
	              } else {
	                $$i > -1 && (_vm.selectedThemeList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.selectedThemeList = $$c
	            }
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                    ")]) : _vm._e()
	    }), _vm._v(" "), _vm._l(((_vm.goalsAndDisplayCategories[key])), function(value) {
	      return (key === _vm.DURATION) ? _c('div', {
	        staticClass: "checkbox"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selectedDurationList),
	          expression: "selectedDurationList"
	        }],
	        attrs: {
	          "id": value.id,
	          "disabled": false,
	          "type": "checkbox"
	        },
	        domProps: {
	          "value": value.id,
	          "checked": Array.isArray(_vm.selectedDurationList) ? _vm._i(_vm.selectedDurationList, value.id) > -1 : (_vm.selectedDurationList)
	        },
	        on: {
	          "__c": function($event) {
	            var $$a = _vm.selectedDurationList,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = value.id,
	                $$i = _vm._i($$a, $$v);
	              if ($$c) {
	                $$i < 0 && (_vm.selectedDurationList = $$a.concat($$v))
	              } else {
	                $$i > -1 && (_vm.selectedDurationList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              _vm.selectedDurationList = $$c
	            }
	          }
	        }
	      }), _vm._v(_vm._s(value.name) + "\n                  ")]) : _vm._e()
	    })], 2) : _vm._e()])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "text-center bottom grid-full"
	  }, [_c('button', {
	    class: {
	      'width_4': true, 'primary-green-bg': !_vm.buttonDisabled
	    },
	    attrs: {
	      "disabled": _vm.buttonDisabled
	    },
	    on: {
	      "click": _vm.showTimeZone
	    }
	  }, [_vm._v("\n                Approve And Lock Offer\n              ")])])]) : _vm._e()]) : (_vm.popupType === 'approveWithChanges' && !_vm.showZonePrice) ? _c('div', {
	    style: (_vm.mainContainerStyle.mainStyle.scrollable)
	  }, [_c('approve-with-changes', {
	    attrs: {
	      "handleEvent": _vm.approveWithChangesResponse,
	      "confirmEventApproveWithChanges": _vm.confirmEventApproveWithChanges
	    }
	  })], 1) : (_vm.popupType === 'text') ? _c('div', [_c('div', {
	    staticClass: "header width_full",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('label', [_vm._v("\n              " + _vm._s('Offer Approval Confirmation') + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "field approveMessage"
	  }, [_c('ul', _vm._l((_vm.approveMessages()), function(statement) {
	    return _c('li', [_vm._v(_vm._s(statement) + ".")])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "text-center bottom grid-full"
	  }, [_c('button', {
	    staticClass: "primary-green-bg width_5"
	  }, [_vm._v("Back to pending decisions")])])]) : (_vm.popupType === 'rejectOffer') ? _c('div', [_c('div', {
	    staticClass: "header width_full",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('label', [_vm._v("\n              " + _vm._s('Type your reason in the following for offer rejection') + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rejectOfferReason),
	      expression: "rejectOfferReason"
	    }],
	    staticClass: "width_full",
	    attrs: {
	      "rows": "15"
	    },
	    domProps: {
	      "value": (_vm.rejectOfferReason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.rejectOfferReason = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "text-center bottom grid-full"
	  }, [_c('button', {
	    staticClass: "primary-green-bg width_4",
	    on: {
	      "click": _vm.rejectOffer
	    }
	  }, [_vm._v("Reject And Lock Offer")])])]) : (_vm.showZonePrice) ? _c('div', {
	    style: (_vm.mainContainerStyle.mainStyle.zoneScrollable)
	  }, [_c('div', {
	    style: (_vm.mainContainerStyle.mainStyle.tableZonePriceChangeTitleStyle)
	  }, [_c('label', {
	    style: (_vm.mainContainerStyle.mainStyle.tableZonePriceChangeTitleStyle)
	  }, [_vm._v("\n               " + _vm._s('Change Zone Sale Retail Prices For This Offer ') + "\n             ")])]), _vm._v(" "), _c('div', {
	    style: (_vm.mainContainerStyle.mainStyle.tableZonePriceChangeMinHeight),
	    attrs: {
	      "id": "selectedOffersInnerDiv"
	    }
	  }, [_c('div', {
	    staticClass: "full_width inline-block",
	    attrs: {
	      "id": "zonePriceHeaderContainer"
	    }
	  }, [_c('horizontal-table', {
	    attrs: {
	      "handleEvent": _vm.horizontalTableEvent,
	      "data": _vm.horizontalTableData,
	      "headers": _vm.horizontalTableHeaders,
	      "styles": _vm.tableStyles.offerZoneListHeaderStyle
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "width_full",
	    style: (_vm.mainContainerStyle.mainStyle.tableButton)
	  }, [_c('button', {
	    staticClass: "primary-green-bg width_4",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.updateZoneData
	    }
	  }, [_vm._v("\n               Set Zone Prices\n             ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isConfirmPopUp) ? _c('div', [_c('confirmation-pop-up', {
	    attrs: {
	      "data": _vm.confirmData
	    }
	  })], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 378 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    },
	    on: {
	      "click": _vm.generateStrayClick
	    }
	  }, [_c('loader'), _vm._v(" "), _c('modal'), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 379 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "overlay"
	  }, [_c('div', {
	    staticClass: "error-container"
	  }, [_c('div', {
	    staticClass: "tableHeader"
	  }, [_c('p', [_vm._v("We have found error(s) in the document you have uploaded. Please look at the following message(s) and upload again.")]), _vm._v(" "), _c('span', {
	    staticClass: "close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
	    staticClass: "scrollable"
	  }, _vm._l((_vm.mistakes), function(offerMistake) {
	    return _c('div', [_c('h3', [_vm._v("UPC: " + _vm._s(offerMistake.UPC))]), _vm._v(" "), _c('div', {
	      staticClass: "inline-block"
	    }, [(offerMistake.mistakes.error) ? _c('ul', {
	      staticClass: "menu-list"
	    }, _vm._l((offerMistake.mistakes.error), function(error) {
	      return _c('li', {
	        class: {
	          "error-text": error
	        }
	      }, [_vm._v("\n              " + _vm._s(error) + "\n              ")])
	    })) : _vm._e(), _vm._v(" "), (offerMistake.mistakes.warn) ? _c('ul', {
	      staticClass: "menu-list"
	    }, _vm._l((offerMistake.mistakes.warn), function(warn) {
	      return _c('li', {
	        class: {
	          "warnings-text": warn
	        }
	      }, [_vm._v("\n                " + _vm._s(warn) + "\n              ")])
	    })) : _vm._e()])])
	  }))])])])
	},staticRenderFns: []}

/***/ },
/* 380 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', [_c('input', {
	    staticClass: "width_full no-render",
	    attrs: {
	      "id": "uploadInput",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.uploadStart
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "grid-4"
	  }, [_c('button', {
	    staticClass: "width_full upload-button",
	    class: _vm.uploadButtonClass,
	    attrs: {
	      "disabled": _vm.disabled
	    },
	    on: {
	      "click": _vm.uploadInit
	    }
	  }, [_vm._v("\n        " + _vm._s((_vm.file) ? ("Upload File: " + (_vm.file.name)) : 'Select Excel Document') + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid-4"
	  }, [_c('button', {
	    staticClass: "width_full primary-green-bg",
	    on: {
	      "click": _vm.downloadTemplateMerchant
	    }
	  }, [_vm._v("\n        Download Template\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 381 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dropdown-container",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "dropdown width_full"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filterText),
	      expression: "filterText"
	    }],
	    staticClass: "grid-12",
	    attrs: {
	      "id": "searchBox",
	      "type": "text",
	      "placeholder": _vm.placeHolder
	    },
	    domProps: {
	      "value": (_vm.filterText)
	    },
	    on: {
	      "click": function($event) {
	        _vm.show = !_vm.show
	      },
	      "keyup": _vm.checkInput,
	      "keydown": function($event) {
	        _vm.show = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filterText = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.screenName === 'ItemLevel') ? _c('div', [_c('div', {
	    staticClass: "dropdown-content",
	    attrs: {
	      "id": "myDropdown"
	    }
	  }, [_c('ul', {
	    staticClass: "grid-12"
	  }, _vm._l((_vm.modifiedList), function(data) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.dropdownItemClick($event, data)
	        }
	      }
	    }, [_vm._v(_vm._s(data.name))])
	  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "else": ""
	    }
	  }, [(_vm.show && _vm.screenName !== 'ItemLevel') ? _c('div', {
	    staticClass: "dropdown-content",
	    attrs: {
	      "id": "myDropdown"
	    }
	  }, [_c('ul', {
	    staticClass: "grid-12"
	  }, _vm._l((_vm.modifiedList), function(data) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.dropdownItemClick($event, data)
	        }
	      }
	    }, [_vm._v(_vm._s(data.name))])
	  }))]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 382 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_c('div', {
	    attrs: {
	      "id": "selectedOffersInnerDiv"
	    }
	  }, [_c('div', {
	    staticClass: "scrollWrapper",
	    style: ({
	      width: ("" + _vm.scrollableWidth)
	    }),
	    attrs: {
	      "id": "changesApproveScrollWrapper"
	    },
	    on: {
	      "scroll": function($event) {
	        _vm.topScroll($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "simulateScrollDiv",
	    style: ({
	      width: ((_vm.scrollableChildrenWidth * _vm.information.length) + "rem")
	    }),
	    attrs: {
	      "id": "simScrollbar"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline-block",
	    attrs: {
	      "id": "selectedOffersHeaderContainer"
	    }
	  }, [_c('data-table', {
	    attrs: {
	      "data": _vm.headers,
	      "styles": _vm.tableStyles.offersListHeaderStyles
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inline-block scrollable",
	    style: ({
	      width: _vm.scrollableWidth
	    }),
	    attrs: {
	      "id": "selectedOffersDataContainer"
	    },
	    on: {
	      "scroll": function($event) {
	        _vm.bottomScroll($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "inline-block",
	    style: ({
	      width: ((_vm.information.length * _vm.scrollableChildrenWidth) + "rem")
	    })
	  }, _vm._l((_vm.information), function(data) {
	    return _c('div', {
	      staticClass: "inline-block",
	      style: ({
	        width: (_vm.scrollableChildrenWidth + "rem")
	      })
	    }, [_c('data-table', {
	      attrs: {
	        "handleEvent": _vm.childEvent,
	        "data": data,
	        "stringPadding": _vm.detailedDataPadding,
	        "styles": _vm.tableStyles.offersListDataStyle,
	        "functions": _vm.childEvent
	      }
	    })], 1)
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "width_full",
	    style: (_vm.mainContainerStyle.mainStyle.tableButton)
	  }, [_c('button', {
	    class: {
	      'primary-green-bg': _vm.hasChanges, 'light-grey-text': !_vm.hasChanges, 'width_half': true
	    },
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.hasChanges
	    },
	    on: {
	      "click": _vm.submitApproveLock
	    }
	  }, [_vm._v("\n        Approve with changes and lock offer\n      ")])])])])
	},staticRenderFns: []}

/***/ },
/* 383 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "outer-div outer-div-heavy"
	  }, [_c('div', {
	    staticClass: "inner-div"
	  }, [_c('div', {
	    staticClass: "center width_full"
	  }, [_c('h3', {
	    staticClass: "black-text"
	  }, [_vm._v("Profile Details")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "manufacture"
	    }
	  }, [_vm._v("Manufacturer:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.manufacturer),
	      expression: "profile.manufacturer"
	    }],
	    staticClass: "dark-grey-text",
	    attrs: {
	      "type": "text",
	      "readonly": true
	    },
	    domProps: {
	      "value": (_vm.profile.manufacturer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.profile.manufacturer = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "refName"
	    }
	  }, [_vm._v("Representative Name:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.name),
	      expression: "profile.name"
	    }],
	    staticClass: "dark-grey-text",
	    class: {
	      error: _vm.validationMessages.name.length || _vm.validationMessages.name.format
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.profile.name)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.validator(_vm.profile.name, "name")
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.profile.name = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.validationMessages.name.length) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.validationMessages.name.length))]) : _vm._e(), _vm._v(" "), (!_vm.validationMessages.name.length && _vm.validationMessages.name.format) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.validationMessages.name.format))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "repPhone"
	    }
	  }, [_vm._v("Representative Phone:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.phone),
	      expression: "profile.phone"
	    }],
	    staticClass: "dark-grey-text",
	    class: {
	      error: _vm.validationMessages.phone.length || _vm.validationMessages.phone.format
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.profile.phone)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.validator(_vm.profile.phone, "phone")
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.profile.phone = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.validationMessages.phone.length) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.validationMessages.phone.length))]) : _vm._e(), _vm._v(" "), (!_vm.validationMessages.phone.length && _vm.validationMessages.phone.format) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.validationMessages.phone.format))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "refEmail"
	    }
	  }, [_vm._v("Representative Email:")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.profile.email),
	      expression: "profile.email"
	    }],
	    staticClass: "dark-grey-text",
	    class: {
	      error: _vm.validationMessages.email.length || _vm.validationMessages.email.format
	    },
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.profile.email)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.validator(_vm.profile.email, "email")
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.profile.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.validationMessages.email.length) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.validationMessages.email.length))]) : _vm._e(), _vm._v(" "), (!_vm.validationMessages.email.length && _vm.validationMessages.email.format) ? _c('div', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.validationMessages.email.format))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "submit-pane"
	  }, [_c('button', {
	    staticClass: "dark-grey-bg width_full",
	    attrs: {
	      "disabled": _vm.buttonDisable
	    },
	    on: {
	      "click": _vm.editDetails
	    }
	  }, [_vm._v(_vm._s(_vm.text) + "\n          ")])])])])])])
	},staticRenderFns: []}

/***/ },
/* 384 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline-block width_full"
	  }, [_c('button', {
	    class: {
	      "width_full": true, "primary-green-bg": !_vm.error, "red-bg": _vm.error
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.buttonAction
	    }
	  }, [_vm._v("\n   " + _vm._s(_vm.buttonText || 'PROCEED') + "\n ")])])
	},staticRenderFns: []}

/***/ },
/* 385 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-container"
	  }, [_c('div', {
	    staticClass: "login-bg"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "login-image-logo"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "login-bg-input-area"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submitByMode(_vm.username.trim(), _vm.password)
	      },
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.submitByMode(_vm.username.trim(), _vm.password)
	      }
	    }
	  }, [_c('div', {}, [_c('label', {
	    staticClass: "login-label",
	    attrs: {
	      "for": "username"
	    }
	  }, [_vm._v("\n              " + _vm._s((_vm.forgotPasswordMode) ? "Email" : "Username") + "\n            "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "login-input-field",
	    attrs: {
	      "type": "text",
	      "name": "username"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (!_vm.forgotPasswordMode) ? _c('div', {
	    staticStyle: {
	      "margin-top": "1rem"
	    }
	  }, [_c('label', {
	    staticClass: "login-label",
	    staticStyle: {},
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Password\n              "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "login-input-field",
	    attrs: {
	      "type": "password",
	      "name": "username"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.forgotPasswordMode) ? _c('div', [_c('button', {
	    staticClass: "login-submit-btn primary-green-bg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.login(_vm.username.trim(), _vm.password)
	      }
	    }
	  }, [_vm._v("Login")])]) : _c('div', [_c('button', {
	    staticClass: "login-submit-btn primary-green-bg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.forgotPassword(_vm.username.trim())
	      }
	    }
	  }, [_vm._v("Reset password")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(!_vm.forgotPasswordMode) ? _c('div', {
	    staticClass: "login-links"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.forgotPasswordModeActivate()
	      }
	    }
	  }, [_vm._v("Reset/Forgot Password?")])]) : _c('div', {
	    staticClass: "login-links"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.forgotPasswordModeDeactivate()
	      }
	    }
	  }, [_vm._v("Back to login")])])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 393 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.584b1ed14ce325ca1ac6.js